export const dataVN = [
	{
		name: "Thành phố Hà Nội",
		districts: [
			{
				name: "Quận Ba Đình",
				wards: [
					{
						name: "Phường Phúc Xá",
					},
					{
						name: "Phường Trúc Bạch",
					},
					{
						name: "Phường Vĩnh Phúc",
					},
					{
						name: "Phường Cống Vị",
					},
					{
						name: "Phường Liễu Giai",
					},
					{
						name: "Phường Nguyễn Trung Trực",
					},
					{
						name: "Phường Quán Thánh",
					},
					{
						name: "Phường Ngọc Hà",
					},
					{
						name: "Phường Điện Biên",
					},
					{
						name: "Phường Đội Cấn",
					},
					{
						name: "Phường Ngọc Khánh",
					},
					{
						name: "Phường Kim Mã",
					},
					{
						name: "Phường Giảng Võ",
					},
					{
						name: "Phường Thành Công",
					},
				],
			},
			{
				name: "Quận Hoàn Kiếm",
				wards: [
					{
						name: "Phường Phúc Tân",
					},
					{
						name: "Phường Đồng Xuân",
					},
					{
						name: "Phường Hàng Mã",
					},
					{
						name: "Phường Hàng Buồm",
					},
					{
						name: "Phường Hàng Đào",
					},
					{
						name: "Phường Hàng Bồ",
					},
					{
						name: "Phường Cửa Đông",
					},
					{
						name: "Phường Lý Thái Tổ",
					},
					{
						name: "Phường Hàng Bạc",
					},
					{
						name: "Phường Hàng Gai",
					},
					{
						name: "Phường Chương Dương",
					},
					{
						name: "Phường Hàng Trống",
					},
					{
						name: "Phường Cửa Nam",
					},
					{
						name: "Phường Hàng Bông",
					},
					{
						name: "Phường Tràng Tiền",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Phan Chu Trinh",
					},
					{
						name: "Phường Hàng Bài",
					},
				],
			},
			{
				name: "Quận Tây Hồ",
				wards: [
					{
						name: "Phường Phú Thượng",
					},
					{
						name: "Phường Nhật Tân",
					},
					{
						name: "Phường Tứ Liên",
					},
					{
						name: "Phường Quảng An",
					},
					{
						name: "Phường Xuân La",
					},
					{
						name: "Phường Yên Phụ",
					},
					{
						name: "Phường Bưởi",
					},
					{
						name: "Phường Thụy Khuê",
					},
				],
			},
			{
				name: "Quận Long Biên",
				wards: [
					{
						name: "Phường Thượng Thanh",
					},
					{
						name: "Phường Ngọc Thụy",
					},
					{
						name: "Phường Giang Biên",
					},
					{
						name: "Phường Đức Giang",
					},
					{
						name: "Phường Việt Hưng",
					},
					{
						name: "Phường Gia Thụy",
					},
					{
						name: "Phường Ngọc Lâm",
					},
					{
						name: "Phường Phúc Lợi",
					},
					{
						name: "Phường Bồ Đề",
					},
					{
						name: "Phường Sài Đồng",
					},
					{
						name: "Phường Long Biên",
					},
					{
						name: "Phường Thạch Bàn",
					},
					{
						name: "Phường Phúc Đồng",
					},
					{
						name: "Phường Cự Khối",
					},
				],
			},
			{
				name: "Quận Cầu Giấy",
				wards: [
					{
						name: "Phường Nghĩa Đô",
					},
					{
						name: "Phường Nghĩa Tân",
					},
					{
						name: "Phường Mai Dịch",
					},
					{
						name: "Phường Dịch Vọng",
					},
					{
						name: "Phường Dịch Vọng Hậu",
					},
					{
						name: "Phường Quan Hoa",
					},
					{
						name: "Phường Yên Hoà",
					},
					{
						name: "Phường Trung Hoà",
					},
				],
			},
			{
				name: "Quận Đống Đa",
				wards: [
					{
						name: "Phường Cát Linh",
					},
					{
						name: "Phường Văn Miếu",
					},
					{
						name: "Phường Quốc Tử Giám",
					},
					{
						name: "Phường Láng Thượng",
					},
					{
						name: "Phường Ô Chợ Dừa",
					},
					{
						name: "Phường Văn Chương",
					},
					{
						name: "Phường Hàng Bột",
					},
					{
						name: "Phường Láng Hạ",
					},
					{
						name: "Phường Khâm Thiên",
					},
					{
						name: "Phường Thổ Quan",
					},
					{
						name: "Phường Nam Đồng",
					},
					{
						name: "Phường Trung Phụng",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Trung Liệt",
					},
					{
						name: "Phường Phương Liên",
					},
					{
						name: "Phường Thịnh Quang",
					},
					{
						name: "Phường Trung Tự",
					},
					{
						name: "Phường Kim Liên",
					},
					{
						name: "Phường Phương Mai",
					},
					{
						name: "Phường Ngã Tư Sở",
					},
					{
						name: "Phường Khương Thượng",
					},
				],
			},
			{
				name: "Quận Hai Bà Trưng",
				wards: [
					{
						name: "Phường Nguyễn Du",
					},
					{
						name: "Phường Bạch Đằng",
					},
					{
						name: "Phường Phạm Đình Hổ",
					},
					{
						name: "Phường Lê Đại Hành",
					},
					{
						name: "Phường Đồng Nhân",
					},
					{
						name: "Phường Phố Huế",
					},
					{
						name: "Phường Đống Mác",
					},
					{
						name: "Phường Thanh Lương",
					},
					{
						name: "Phường Thanh Nhàn",
					},
					{
						name: "Phường Cầu Dền",
					},
					{
						name: "Phường Bách Khoa",
					},
					{
						name: "Phường Đồng Tâm",
					},
					{
						name: "Phường Vĩnh Tuy",
					},
					{
						name: "Phường Bạch Mai",
					},
					{
						name: "Phường Quỳnh Mai",
					},
					{
						name: "Phường Quỳnh Lôi",
					},
					{
						name: "Phường Minh Khai",
					},
					{
						name: "Phường Trương Định",
					},
				],
			},
			{
				name: "Quận Hoàng Mai",
				wards: [
					{
						name: "Phường Thanh Trì",
					},
					{
						name: "Phường Vĩnh Hưng",
					},
					{
						name: "Phường Định Công",
					},
					{
						name: "Phường Mai Động",
					},
					{
						name: "Phường Tương Mai",
					},
					{
						name: "Phường Đại Kim",
					},
					{
						name: "Phường Tân Mai",
					},
					{
						name: "Phường Hoàng Văn Thụ",
					},
					{
						name: "Phường Giáp Bát",
					},
					{
						name: "Phường Lĩnh Nam",
					},
					{
						name: "Phường Thịnh Liệt",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Hoàng Liệt",
					},
					{
						name: "Phường Yên Sở",
					},
				],
			},
			{
				name: "Quận Thanh Xuân",
				wards: [
					{
						name: "Phường Nhân Chính",
					},
					{
						name: "Phường Thượng Đình",
					},
					{
						name: "Phường Khương Trung",
					},
					{
						name: "Phường Khương Mai",
					},
					{
						name: "Phường Thanh Xuân Trung",
					},
					{
						name: "Phường Phương Liệt",
					},
					{
						name: "Phường Hạ Đình",
					},
					{
						name: "Phường Khương Đình",
					},
					{
						name: "Phường Thanh Xuân Bắc",
					},
					{
						name: "Phường Thanh Xuân Nam",
					},
					{
						name: "Phường Kim Giang",
					},
				],
			},
			{
				name: "Huyện Sóc Sơn",
				wards: [
					{
						name: "Thị trấn Sóc Sơn",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Minh Trí",
					},
					{
						name: "Xã Hồng Kỳ",
					},
					{
						name: "Xã Nam Sơn",
					},
					{
						name: "Xã Trung Giã",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Minh Phú",
					},
					{
						name: "Xã Phù Linh",
					},
					{
						name: "Xã Bắc Phú",
					},
					{
						name: "Xã Tân Minh",
					},
					{
						name: "Xã Quang Tiến",
					},
					{
						name: "Xã Hiền Ninh",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã Tiên Dược",
					},
					{
						name: "Xã Việt Long",
					},
					{
						name: "Xã Xuân Giang",
					},
					{
						name: "Xã Mai Đình",
					},
					{
						name: "Xã Đức Hoà",
					},
					{
						name: "Xã Thanh Xuân",
					},
					{
						name: "Xã Đông Xuân",
					},
					{
						name: "Xã Kim Lũ",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Phú Minh",
					},
					{
						name: "Xã Phù Lỗ",
					},
					{
						name: "Xã Xuân Thu",
					},
				],
			},
			{
				name: "Huyện Đông Anh",
				wards: [
					{
						name: "Thị trấn Đông Anh",
					},
					{
						name: "Xã Xuân Nộn",
					},
					{
						name: "Xã Thuỵ Lâm",
					},
					{
						name: "Xã Bắc Hồng",
					},
					{
						name: "Xã Nguyên Khê",
					},
					{
						name: "Xã Nam Hồng",
					},
					{
						name: "Xã Tiên Dương",
					},
					{
						name: "Xã Vân Hà",
					},
					{
						name: "Xã Uy Nỗ",
					},
					{
						name: "Xã Vân Nội",
					},
					{
						name: "Xã Liên Hà",
					},
					{
						name: "Xã Việt Hùng",
					},
					{
						name: "Xã Kim Nỗ",
					},
					{
						name: "Xã Kim Chung",
					},
					{
						name: "Xã Dục Tú",
					},
					{
						name: "Xã Đại Mạch",
					},
					{
						name: "Xã Vĩnh Ngọc",
					},
					{
						name: "Xã Cổ Loa",
					},
					{
						name: "Xã Hải Bối",
					},
					{
						name: "Xã Xuân Canh",
					},
					{
						name: "Xã Võng La",
					},
					{
						name: "Xã Tàm Xá",
					},
					{
						name: "Xã Mai Lâm",
					},
					{
						name: "Xã Đông Hội",
					},
				],
			},
			{
				name: "Huyện Gia Lâm",
				wards: [
					{
						name: "Thị trấn Yên Viên",
					},
					{
						name: "Xã Yên Thường",
					},
					{
						name: "Xã Yên Viên",
					},
					{
						name: "Xã Ninh Hiệp",
					},
					{
						name: "Xã Đình Xuyên",
					},
					{
						name: "Xã Dương Hà",
					},
					{
						name: "Xã Phù Đổng",
					},
					{
						name: "Xã Trung Mầu",
					},
					{
						name: "Xã Lệ Chi",
					},
					{
						name: "Xã Cổ Bi",
					},
					{
						name: "Xã Đặng Xá",
					},
					{
						name: "Xã Phú Thị",
					},
					{
						name: "Xã Kim Sơn",
					},
					{
						name: "Thị trấn Trâu Quỳ",
					},
					{
						name: "Xã Dương Quang",
					},
					{
						name: "Xã Dương Xá",
					},
					{
						name: "Xã Đông Dư",
					},
					{
						name: "Xã Đa Tốn",
					},
					{
						name: "Xã Kiêu Kỵ",
					},
					{
						name: "Xã Bát Tràng",
					},
					{
						name: "Xã Kim Lan",
					},
					{
						name: "Xã Văn Đức",
					},
				],
			},
			{
				name: "Quận Nam Từ Liêm",
				wards: [
					{
						name: "Phường Cầu Diễn",
					},
					{
						name: "Phường Xuân Phương",
					},
					{
						name: "Phường Phương Canh",
					},
					{
						name: "Phường Mỹ Đình 1",
					},
					{
						name: "Phường Mỹ Đình 2",
					},
					{
						name: "Phường Tây Mỗ",
					},
					{
						name: "Phường Mễ Trì",
					},
					{
						name: "Phường Phú Đô",
					},
					{
						name: "Phường Đại Mỗ",
					},
					{
						name: "Phường Trung Văn",
					},
				],
			},
			{
				name: "Huyện Thanh Trì",
				wards: [
					{
						name: "Thị trấn Văn Điển",
					},
					{
						name: "Xã Tân Triều",
					},
					{
						name: "Xã Thanh Liệt",
					},
					{
						name: "Xã Tả Thanh Oai",
					},
					{
						name: "Xã Hữu Hoà",
					},
					{
						name: "Xã Tam Hiệp",
					},
					{
						name: "Xã Tứ Hiệp",
					},
					{
						name: "Xã Yên Mỹ",
					},
					{
						name: "Xã Vĩnh Quỳnh",
					},
					{
						name: "Xã Ngũ Hiệp",
					},
					{
						name: "Xã Duyên Hà",
					},
					{
						name: "Xã Ngọc Hồi",
					},
					{
						name: "Xã Vạn Phúc",
					},
					{
						name: "Xã Đại áng",
					},
					{
						name: "Xã Liên Ninh",
					},
					{
						name: "Xã Đông Mỹ",
					},
				],
			},
			{
				name: "Quận Bắc Từ Liêm",
				wards: [
					{
						name: "Phường Thượng Cát",
					},
					{
						name: "Phường Liên Mạc",
					},
					{
						name: "Phường Đông Ngạc",
					},
					{
						name: "Phường Đức Thắng",
					},
					{
						name: "Phường Thụy Phương",
					},
					{
						name: "Phường Tây Tựu",
					},
					{
						name: "Phường Xuân Đỉnh",
					},
					{
						name: "Phường Xuân Tảo",
					},
					{
						name: "Phường Minh Khai",
					},
					{
						name: "Phường Cổ Nhuế 1",
					},
					{
						name: "Phường Cổ Nhuế 2",
					},
					{
						name: "Phường Phú Diễn",
					},
					{
						name: "Phường Phúc Diễn",
					},
				],
			},
			{
				name: "Huyện Mê Linh",
				wards: [
					{
						name: "Thị trấn Chi Đông",
					},
					{
						name: "Xã Đại Thịnh",
					},
					{
						name: "Xã Kim Hoa",
					},
					{
						name: "Xã Thạch Đà",
					},
					{
						name: "Xã Tiến Thắng",
					},
					{
						name: "Xã Tự Lập",
					},
					{
						name: "Thị trấn Quang Minh",
					},
					{
						name: "Xã Thanh Lâm",
					},
					{
						name: "Xã Tam Đồng",
					},
					{
						name: "Xã Liên Mạc",
					},
					{
						name: "Xã Vạn Yên",
					},
					{
						name: "Xã Chu Phan",
					},
					{
						name: "Xã Tiến Thịnh",
					},
					{
						name: "Xã Mê Linh",
					},
					{
						name: "Xã Văn Khê",
					},
					{
						name: "Xã Hoàng Kim",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Tráng Việt",
					},
				],
			},
			{
				name: "Quận Hà Đông",
				wards: [
					{
						name: "Phường Nguyễn Trãi",
					},
					{
						name: "Phường Mộ Lao",
					},
					{
						name: "Phường Văn Quán",
					},
					{
						name: "Phường Vạn Phúc",
					},
					{
						name: "Phường Yết Kiêu",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường La Khê",
					},
					{
						name: "Phường Phú La",
					},
					{
						name: "Phường Phúc La",
					},
					{
						name: "Phường Hà Cầu",
					},
					{
						name: "Phường Yên Nghĩa",
					},
					{
						name: "Phường Kiến Hưng",
					},
					{
						name: "Phường Phú Lãm",
					},
					{
						name: "Phường Phú Lương",
					},
					{
						name: "Phường Dương Nội",
					},
					{
						name: "Phường Đồng Mai",
					},
					{
						name: "Phường Biên Giang",
					},
				],
			},
			{
				name: "Thị xã Sơn Tây",
				wards: [
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Phường Phú Thịnh",
					},
					{
						name: "Phường Ngô Quyền",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Sơn Lộc",
					},
					{
						name: "Phường Xuân Khanh",
					},
					{
						name: "Xã Đường Lâm",
					},
					{
						name: "Phường Viên Sơn",
					},
					{
						name: "Xã Xuân Sơn",
					},
					{
						name: "Phường Trung Hưng",
					},
					{
						name: "Xã Thanh Mỹ",
					},
					{
						name: "Phường Trung Sơn Trầm",
					},
					{
						name: "Xã Kim Sơn",
					},
					{
						name: "Xã Sơn Đông",
					},
					{
						name: "Xã Cổ Đông",
					},
				],
			},
			{
				name: "Huyện Ba Vì",
				wards: [
					{
						name: "Thị trấn Tây Đằng",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Cổ Đô",
					},
					{
						name: "Xã Tản Hồng",
					},
					{
						name: "Xã Vạn Thắng",
					},
					{
						name: "Xã Châu Sơn",
					},
					{
						name: "Xã Phong Vân",
					},
					{
						name: "Xã Phú Đông",
					},
					{
						name: "Xã Phú Phương",
					},
					{
						name: "Xã Phú Châu",
					},
					{
						name: "Xã Thái Hòa",
					},
					{
						name: "Xã Đồng Thái",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Minh Châu",
					},
					{
						name: "Xã Vật Lại",
					},
					{
						name: "Xã Chu Minh",
					},
					{
						name: "Xã Tòng Bạt",
					},
					{
						name: "Xã Cẩm Lĩnh",
					},
					{
						name: "Xã Sơn Đà",
					},
					{
						name: "Xã Đông Quang",
					},
					{
						name: "Xã Tiên Phong",
					},
					{
						name: "Xã Thụy An",
					},
					{
						name: "Xã Cam Thượng",
					},
					{
						name: "Xã Thuần Mỹ",
					},
					{
						name: "Xã Tản Lĩnh",
					},
					{
						name: "Xã Ba Trại",
					},
					{
						name: "Xã Minh Quang",
					},
					{
						name: "Xã Ba Vì",
					},
					{
						name: "Xã Vân Hòa",
					},
					{
						name: "Xã Yên Bài",
					},
					{
						name: "Xã Khánh Thượng",
					},
				],
			},
			{
				name: "Huyện Phúc Thọ",
				wards: [
					{
						name: "Thị trấn Phúc Thọ",
					},
					{
						name: "Xã Vân Hà",
					},
					{
						name: "Xã Vân Phúc",
					},
					{
						name: "Xã Vân Nam",
					},
					{
						name: "Xã Xuân Đình",
					},
					{
						name: "Xã Sen Phương",
					},
					{
						name: "Xã Võng Xuyên",
					},
					{
						name: "Xã Thọ Lộc",
					},
					{
						name: "Xã Long Xuyên",
					},
					{
						name: "Xã Thượng Cốc",
					},
					{
						name: "Xã Hát Môn",
					},
					{
						name: "Xã Tích Giang",
					},
					{
						name: "Xã Thanh Đa",
					},
					{
						name: "Xã Trạch Mỹ Lộc",
					},
					{
						name: "Xã Phúc Hòa",
					},
					{
						name: "Xã Ngọc Tảo",
					},
					{
						name: "Xã Phụng Thượng",
					},
					{
						name: "Xã Tam Thuấn",
					},
					{
						name: "Xã Tam Hiệp",
					},
					{
						name: "Xã Hiệp Thuận",
					},
					{
						name: "Xã Liên Hiệp",
					},
				],
			},
			{
				name: "Huyện Đan Phượng",
				wards: [
					{
						name: "Thị trấn Phùng",
					},
					{
						name: "Xã Trung Châu",
					},
					{
						name: "Xã Thọ An",
					},
					{
						name: "Xã Thọ Xuân",
					},
					{
						name: "Xã Hồng Hà",
					},
					{
						name: "Xã Liên Hồng",
					},
					{
						name: "Xã Liên Hà",
					},
					{
						name: "Xã Hạ Mỗ",
					},
					{
						name: "Xã Liên Trung",
					},
					{
						name: "Xã Phương Đình",
					},
					{
						name: "Xã Thượng Mỗ",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Đan Phượng",
					},
					{
						name: "Xã Đồng Tháp",
					},
					{
						name: "Xã Song Phượng",
					},
				],
			},
			{
				name: "Huyện Hoài Đức",
				wards: [
					{
						name: "Thị trấn Trạm Trôi",
					},
					{
						name: "Xã Đức Thượng",
					},
					{
						name: "Xã Minh Khai",
					},
					{
						name: "Xã Dương Liễu",
					},
					{
						name: "Xã Di Trạch",
					},
					{
						name: "Xã Đức Giang",
					},
					{
						name: "Xã Cát Quế",
					},
					{
						name: "Xã Kim Chung",
					},
					{
						name: "Xã Yên Sở",
					},
					{
						name: "Xã Sơn Đồng",
					},
					{
						name: "Xã Vân Canh",
					},
					{
						name: "Xã Đắc Sở",
					},
					{
						name: "Xã Lại Yên",
					},
					{
						name: "Xã Tiền Yên",
					},
					{
						name: "Xã Song Phương",
					},
					{
						name: "Xã An Khánh",
					},
					{
						name: "Xã An Thượng",
					},
					{
						name: "Xã Vân Côn",
					},
					{
						name: "Xã La Phù",
					},
					{
						name: "Xã Đông La",
					},
				],
			},
			{
				name: "Huyện Quốc Oai",
				wards: [
					{
						name: "Xã Đông Xuân",
					},
					{
						name: "Thị trấn Quốc Oai",
					},
					{
						name: "Xã Sài Sơn",
					},
					{
						name: "Xã Phượng Cách",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Ngọc Liệp",
					},
					{
						name: "Xã Ngọc Mỹ",
					},
					{
						name: "Xã Liệp Tuyết",
					},
					{
						name: "Xã Thạch Thán",
					},
					{
						name: "Xã Đồng Quang",
					},
					{
						name: "Xã Phú Cát",
					},
					{
						name: "Xã Tuyết Nghĩa",
					},
					{
						name: "Xã Nghĩa Hương",
					},
					{
						name: "Xã Cộng Hòa",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Đại Thành",
					},
					{
						name: "Xã Phú Mãn",
					},
					{
						name: "Xã Cấn Hữu",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Hòa Thạch",
					},
					{
						name: "Xã Đông Yên",
					},
				],
			},
			{
				name: "Huyện Thạch Thất",
				wards: [
					{
						name: "Xã Yên Trung",
					},
					{
						name: "Xã Yên Bình",
					},
					{
						name: "Xã Tiến Xuân",
					},
					{
						name: "Thị trấn Liên Quan",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Cẩm Yên",
					},
					{
						name: "Xã Lại Thượng",
					},
					{
						name: "Xã Phú Kim",
					},
					{
						name: "Xã Hương Ngải",
					},
					{
						name: "Xã Canh Nậu",
					},
					{
						name: "Xã Kim Quan",
					},
					{
						name: "Xã Dị Nậu",
					},
					{
						name: "Xã Bình Yên",
					},
					{
						name: "Xã Chàng Sơn",
					},
					{
						name: "Xã Thạch Hoà",
					},
					{
						name: "Xã Cần Kiệm",
					},
					{
						name: "Xã Hữu Bằng",
					},
					{
						name: "Xã Phùng Xá",
					},
					{
						name: "Xã Tân Xã",
					},
					{
						name: "Xã Thạch Xá",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Hạ Bằng",
					},
					{
						name: "Xã Đồng Trúc",
					},
				],
			},
			{
				name: "Huyện Chương Mỹ",
				wards: [
					{
						name: "Thị trấn Chúc Sơn",
					},
					{
						name: "Thị trấn Xuân Mai",
					},
					{
						name: "Xã Phụng Châu",
					},
					{
						name: "Xã Tiên Phương",
					},
					{
						name: "Xã Đông Sơn",
					},
					{
						name: "Xã Đông Phương Yên",
					},
					{
						name: "Xã Phú Nghĩa",
					},
					{
						name: "Xã Trường Yên",
					},
					{
						name: "Xã Ngọc Hòa",
					},
					{
						name: "Xã Thủy Xuân Tiên",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Xã Trung Hòa",
					},
					{
						name: "Xã Đại Yên",
					},
					{
						name: "Xã Thụy Hương",
					},
					{
						name: "Xã Tốt Động",
					},
					{
						name: "Xã Lam Điền",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Nam Phương Tiến",
					},
					{
						name: "Xã Hợp Đồng",
					},
					{
						name: "Xã Hoàng Văn Thụ",
					},
					{
						name: "Xã Hoàng Diệu",
					},
					{
						name: "Xã Hữu Văn",
					},
					{
						name: "Xã Quảng Bị",
					},
					{
						name: "Xã Mỹ Lương",
					},
					{
						name: "Xã Thượng Vực",
					},
					{
						name: "Xã Hồng Phong",
					},
					{
						name: "Xã Đồng Phú",
					},
					{
						name: "Xã Trần Phú",
					},
					{
						name: "Xã Văn Võ",
					},
					{
						name: "Xã Đồng Lạc",
					},
					{
						name: "Xã Hòa Chính",
					},
					{
						name: "Xã Phú Nam An",
					},
				],
			},
			{
				name: "Huyện Thanh Oai",
				wards: [
					{
						name: "Thị trấn Kim Bài",
					},
					{
						name: "Xã Cự Khê",
					},
					{
						name: "Xã Bích Hòa",
					},
					{
						name: "Xã Mỹ Hưng",
					},
					{
						name: "Xã Cao Viên",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Tam Hưng",
					},
					{
						name: "Xã Thanh Cao",
					},
					{
						name: "Xã Thanh Thùy",
					},
					{
						name: "Xã Thanh Mai",
					},
					{
						name: "Xã Thanh Văn",
					},
					{
						name: "Xã Đỗ Động",
					},
					{
						name: "Xã Kim An",
					},
					{
						name: "Xã Kim Thư",
					},
					{
						name: "Xã Phương Trung",
					},
					{
						name: "Xã Tân Ước",
					},
					{
						name: "Xã Dân Hòa",
					},
					{
						name: "Xã Liên Châu",
					},
					{
						name: "Xã Cao Dương",
					},
					{
						name: "Xã Xuân Dương",
					},
					{
						name: "Xã Hồng Dương",
					},
				],
			},
			{
				name: "Huyện Thường Tín",
				wards: [
					{
						name: "Thị trấn Thường Tín",
					},
					{
						name: "Xã Ninh Sở",
					},
					{
						name: "Xã Nhị Khê",
					},
					{
						name: "Xã Duyên Thái",
					},
					{
						name: "Xã Khánh Hà",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Văn Bình",
					},
					{
						name: "Xã Hiền Giang",
					},
					{
						name: "Xã Hồng Vân",
					},
					{
						name: "Xã Vân Tảo",
					},
					{
						name: "Xã Liên Phương",
					},
					{
						name: "Xã Văn Phú",
					},
					{
						name: "Xã Tự Nhiên",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Hà Hồi",
					},
					{
						name: "Xã Thư Phú",
					},
					{
						name: "Xã Nguyễn Trãi",
					},
					{
						name: "Xã Quất Động",
					},
					{
						name: "Xã Chương Dương",
					},
					{
						name: "Xã Tân Minh",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Xã Thắng Lợi",
					},
					{
						name: "Xã Dũng Tiến",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Nghiêm Xuyên",
					},
					{
						name: "Xã Tô Hiệu",
					},
					{
						name: "Xã Văn Tự",
					},
					{
						name: "Xã Vạn Điểm",
					},
					{
						name: "Xã Minh Cường",
					},
				],
			},
			{
				name: "Huyện Phú Xuyên",
				wards: [
					{
						name: "Thị trấn Phú Minh",
					},
					{
						name: "Thị trấn Phú Xuyên",
					},
					{
						name: "Xã Hồng Minh",
					},
					{
						name: "Xã Phượng Dực",
					},
					{
						name: "Xã Nam Tiến",
					},
					{
						name: "Xã Tri Trung",
					},
					{
						name: "Xã Đại Thắng",
					},
					{
						name: "Xã Phú Túc",
					},
					{
						name: "Xã Văn Hoàng",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Hoàng Long",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Nam Phong",
					},
					{
						name: "Xã Nam Triều",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Chuyên Mỹ",
					},
					{
						name: "Xã Khai Thái",
					},
					{
						name: "Xã Phúc Tiến",
					},
					{
						name: "Xã Vân Từ",
					},
					{
						name: "Xã Tri Thủy",
					},
					{
						name: "Xã Đại Xuyên",
					},
					{
						name: "Xã Phú Yên",
					},
					{
						name: "Xã Bạch Hạ",
					},
					{
						name: "Xã Quang Lãng",
					},
					{
						name: "Xã Châu Can",
					},
					{
						name: "Xã Minh Tân",
					},
				],
			},
			{
				name: "Huyện Ứng Hòa",
				wards: [
					{
						name: "Thị trấn Vân Đình",
					},
					{
						name: "Xã Viên An",
					},
					{
						name: "Xã Viên Nội",
					},
					{
						name: "Xã Hoa Sơn",
					},
					{
						name: "Xã Quảng Phú Cầu",
					},
					{
						name: "Xã Trường Thịnh",
					},
					{
						name: "Xã Cao Thành",
					},
					{
						name: "Xã Liên Bạt",
					},
					{
						name: "Xã Sơn Công",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Phương Tú",
					},
					{
						name: "Xã Trung Tú",
					},
					{
						name: "Xã Đồng Tân",
					},
					{
						name: "Xã Tảo Dương Văn",
					},
					{
						name: "Xã Vạn Thái",
					},
					{
						name: "Xã Minh Đức",
					},
					{
						name: "Xã Hòa Lâm",
					},
					{
						name: "Xã Hòa Xá",
					},
					{
						name: "Xã Trầm Lộng",
					},
					{
						name: "Xã Kim Đường",
					},
					{
						name: "Xã Hòa Nam",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Đội Bình",
					},
					{
						name: "Xã Đại Hùng",
					},
					{
						name: "Xã Đông Lỗ",
					},
					{
						name: "Xã Phù Lưu",
					},
					{
						name: "Xã Đại Cường",
					},
					{
						name: "Xã Lưu Hoàng",
					},
					{
						name: "Xã Hồng Quang",
					},
				],
			},
			{
				name: "Huyện Mỹ Đức",
				wards: [
					{
						name: "Thị trấn Đại Nghĩa",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Thượng Lâm",
					},
					{
						name: "Xã Tuy Lai",
					},
					{
						name: "Xã Phúc Lâm",
					},
					{
						name: "Xã Mỹ Thành",
					},
					{
						name: "Xã Bột Xuyên",
					},
					{
						name: "Xã An Mỹ",
					},
					{
						name: "Xã Hồng Sơn",
					},
					{
						name: "Xã Lê Thanh",
					},
					{
						name: "Xã Xuy Xá",
					},
					{
						name: "Xã Phùng Xá",
					},
					{
						name: "Xã Phù Lưu Tế",
					},
					{
						name: "Xã Đại Hưng",
					},
					{
						name: "Xã Vạn Kim",
					},
					{
						name: "Xã Đốc Tín",
					},
					{
						name: "Xã Hương Sơn",
					},
					{
						name: "Xã Hùng Tiến",
					},
					{
						name: "Xã An Tiến",
					},
					{
						name: "Xã Hợp Tiến",
					},
					{
						name: "Xã Hợp Thanh",
					},
					{
						name: "Xã An Phú",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Hà Giang",
		districts: [
			{
				name: "Thành phố Hà Giang",
				wards: [
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Ngọc Hà",
					},
					{
						name: "Phường Nguyễn Trãi",
					},
					{
						name: "Phường Minh Khai",
					},
					{
						name: "Xã Ngọc Đường",
					},
					{
						name: "Xã Phương Độ",
					},
					{
						name: "Xã Phương Thiện",
					},
				],
			},
			{
				name: "Huyện Đồng Văn",
				wards: [
					{
						name: "Thị trấn Phó Bảng",
					},
					{
						name: "Xã Lũng Cú",
					},
					{
						name: "Xã Má Lé",
					},
					{
						name: "Thị trấn Đồng Văn",
					},
					{
						name: "Xã Lũng Táo",
					},
					{
						name: "Xã Phố Là",
					},
					{
						name: "Xã Thài Phìn Tủng",
					},
					{
						name: "Xã Sủng Là",
					},
					{
						name: "Xã Xà Phìn",
					},
					{
						name: "Xã Tả Phìn",
					},
					{
						name: "Xã Tả Lủng",
					},
					{
						name: "Xã Phố Cáo",
					},
					{
						name: "Xã Sính Lủng",
					},
					{
						name: "Xã Sảng Tủng",
					},
					{
						name: "Xã Lũng Thầu",
					},
					{
						name: "Xã Hố Quáng Phìn",
					},
					{
						name: "Xã Vần Chải",
					},
					{
						name: "Xã Lũng Phìn",
					},
					{
						name: "Xã Sủng Trái",
					},
				],
			},
			{
				name: "Huyện Mèo Vạc",
				wards: [
					{
						name: "Thị trấn Mèo Vạc",
					},
					{
						name: "Xã Thượng Phùng",
					},
					{
						name: "Xã Pải Lủng",
					},
					{
						name: "Xã Xín Cái",
					},
					{
						name: "Xã Pả Vi",
					},
					{
						name: "Xã Giàng Chu Phìn",
					},
					{
						name: "Xã Sủng Trà",
					},
					{
						name: "Xã Sủng Máng",
					},
					{
						name: "Xã Sơn Vĩ",
					},
					{
						name: "Xã Tả Lủng",
					},
					{
						name: "Xã Cán Chu Phìn",
					},
					{
						name: "Xã Lũng Pù",
					},
					{
						name: "Xã Lũng Chinh",
					},
					{
						name: "Xã Tát Ngà",
					},
					{
						name: "Xã Nậm Ban",
					},
					{
						name: "Xã Khâu Vai",
					},
					{
						name: "Xã Niêm Tòng",
					},
					{
						name: "Xã Niêm Sơn",
					},
				],
			},
			{
				name: "Huyện Yên Minh",
				wards: [
					{
						name: "Thị trấn Yên Minh",
					},
					{
						name: "Xã Thắng Mố",
					},
					{
						name: "Xã Phú Lũng",
					},
					{
						name: "Xã Sủng Tráng",
					},
					{
						name: "Xã Bạch Đích",
					},
					{
						name: "Xã Na Khê",
					},
					{
						name: "Xã Sủng Thài",
					},
					{
						name: "Xã Hữu Vinh",
					},
					{
						name: "Xã Lao Và Chải",
					},
					{
						name: "Xã Mậu Duệ",
					},
					{
						name: "Xã Đông Minh",
					},
					{
						name: "Xã Mậu Long",
					},
					{
						name: "Xã Ngam La",
					},
					{
						name: "Xã Ngọc Long",
					},
					{
						name: "Xã Đường Thượng",
					},
					{
						name: "Xã Lũng Hồ",
					},
					{
						name: "Xã Du Tiến",
					},
					{
						name: "Xã Du Già",
					},
				],
			},
			{
				name: "Huyện Quản Bạ",
				wards: [
					{
						name: "Thị trấn Tam Sơn",
					},
					{
						name: "Xã Bát Đại Sơn",
					},
					{
						name: "Xã Nghĩa Thuận",
					},
					{
						name: "Xã Cán Tỷ",
					},
					{
						name: "Xã Cao Mã Pờ",
					},
					{
						name: "Xã Thanh Vân",
					},
					{
						name: "Xã Tùng Vài",
					},
					{
						name: "Xã Đông Hà",
					},
					{
						name: "Xã Quản Bạ",
					},
					{
						name: "Xã Lùng Tám",
					},
					{
						name: "Xã Quyết Tiến",
					},
					{
						name: "Xã Tả Ván",
					},
					{
						name: "Xã Thái An",
					},
				],
			},
			{
				name: "Huyện Vị Xuyên",
				wards: [
					{
						name: "Xã Kim Thạch",
					},
					{
						name: "Xã Phú Linh",
					},
					{
						name: "Xã Kim Linh",
					},
					{
						name: "Thị trấn Vị Xuyên",
					},
					{
						name: "Thị trấn Nông Trường Việt Lâm",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Thuận Hoà",
					},
					{
						name: "Xã Tùng Bá",
					},
					{
						name: "Xã Thanh Thủy",
					},
					{
						name: "Xã Thanh Đức",
					},
					{
						name: "Xã Phong Quang",
					},
					{
						name: "Xã Xín Chải",
					},
					{
						name: "Xã Phương Tiến",
					},
					{
						name: "Xã Lao Chải",
					},
					{
						name: "Xã Cao Bồ",
					},
					{
						name: "Xã Đạo Đức",
					},
					{
						name: "Xã Thượng Sơn",
					},
					{
						name: "Xã Linh Hồ",
					},
					{
						name: "Xã Quảng Ngần",
					},
					{
						name: "Xã Việt Lâm",
					},
					{
						name: "Xã Ngọc Linh",
					},
					{
						name: "Xã Ngọc Minh",
					},
					{
						name: "Xã Bạch Ngọc",
					},
					{
						name: "Xã Trung Thành",
					},
				],
			},
			{
				name: "Huyện Bắc Mê",
				wards: [
					{
						name: "Xã Minh Sơn",
					},
					{
						name: "Xã Giáp Trung",
					},
					{
						name: "Xã Yên Định",
					},
					{
						name: "Thị trấn Yên Phú",
					},
					{
						name: "Xã Minh Ngọc",
					},
					{
						name: "Xã Yên Phong",
					},
					{
						name: "Xã Lạc Nông",
					},
					{
						name: "Xã Phú Nam",
					},
					{
						name: "Xã Yên Cường",
					},
					{
						name: "Xã Thượng Tân",
					},
					{
						name: "Xã Đường Âm",
					},
					{
						name: "Xã Đường Hồng",
					},
					{
						name: "Xã Phiêng Luông",
					},
				],
			},
			{
				name: "Huyện Hoàng Su Phì",
				wards: [
					{
						name: "Thị trấn Vinh Quang",
					},
					{
						name: "Xã Bản Máy",
					},
					{
						name: "Xã Thàng Tín",
					},
					{
						name: "Xã Thèn Chu Phìn",
					},
					{
						name: "Xã Pố Lồ",
					},
					{
						name: "Xã Bản Phùng",
					},
					{
						name: "Xã Túng Sán",
					},
					{
						name: "Xã Chiến Phố",
					},
					{
						name: "Xã Đản Ván",
					},
					{
						name: "Xã Tụ Nhân",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Nàng Đôn",
					},
					{
						name: "Xã Pờ Ly Ngài",
					},
					{
						name: "Xã Sán Xả Hồ",
					},
					{
						name: "Xã Bản Luốc",
					},
					{
						name: "Xã Ngàm Đăng Vài",
					},
					{
						name: "Xã Bản Nhùng",
					},
					{
						name: "Xã Tả Sử Choóng",
					},
					{
						name: "Xã Nậm Dịch",
					},
					{
						name: "Xã Hồ Thầu",
					},
					{
						name: "Xã Nam Sơn",
					},
					{
						name: "Xã Nậm Tỵ",
					},
					{
						name: "Xã Thông Nguyên",
					},
					{
						name: "Xã Nậm Khòa",
					},
				],
			},
			{
				name: "Huyện Xín Mần",
				wards: [
					{
						name: "Thị trấn Cốc Pài",
					},
					{
						name: "Xã Nàn Xỉn",
					},
					{
						name: "Xã Bản Díu",
					},
					{
						name: "Xã Chí Cà",
					},
					{
						name: "Xã Xín Mần",
					},
					{
						name: "Xã Thèn Phàng",
					},
					{
						name: "Xã Trung Thịnh",
					},
					{
						name: "Xã Pà Vầy Sủ",
					},
					{
						name: "Xã Cốc Rế",
					},
					{
						name: "Xã Thu Tà",
					},
					{
						name: "Xã Nàn Ma",
					},
					{
						name: "Xã Tả Nhìu",
					},
					{
						name: "Xã Bản Ngò",
					},
					{
						name: "Xã Chế Là",
					},
					{
						name: "Xã Nấm Dẩn",
					},
					{
						name: "Xã Quảng Nguyên",
					},
					{
						name: "Xã Nà Chì",
					},
					{
						name: "Xã Khuôn Lùng",
					},
				],
			},
			{
				name: "Huyện Bắc Quang",
				wards: [
					{
						name: "Thị trấn Việt Quang",
					},
					{
						name: "Thị trấn Vĩnh Tuy",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Tân Quang",
					},
					{
						name: "Xã Thượng Bình",
					},
					{
						name: "Xã Hữu Sản",
					},
					{
						name: "Xã Kim Ngọc",
					},
					{
						name: "Xã Việt Vinh",
					},
					{
						name: "Xã Bằng Hành",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Liên Hiệp",
					},
					{
						name: "Xã Vô Điếm",
					},
					{
						name: "Xã Việt Hồng",
					},
					{
						name: "Xã Hùng An",
					},
					{
						name: "Xã Đức Xuân",
					},
					{
						name: "Xã Tiên Kiều",
					},
					{
						name: "Xã Vĩnh Hảo",
					},
					{
						name: "Xã Vĩnh Phúc",
					},
					{
						name: "Xã Đồng Yên",
					},
					{
						name: "Xã Đông Thành",
					},
				],
			},
			{
				name: "Huyện Quang Bình",
				wards: [
					{
						name: "Xã Xuân Minh",
					},
					{
						name: "Xã Tiên Nguyên",
					},
					{
						name: "Xã Tân Nam",
					},
					{
						name: "Xã Bản Rịa",
					},
					{
						name: "Xã Yên Thành",
					},
					{
						name: "Thị trấn Yên Bình",
					},
					{
						name: "Xã Tân Trịnh",
					},
					{
						name: "Xã Tân Bắc",
					},
					{
						name: "Xã Bằng Lang",
					},
					{
						name: "Xã Yên Hà",
					},
					{
						name: "Xã Hương Sơn",
					},
					{
						name: "Xã Xuân Giang",
					},
					{
						name: "Xã Nà Khương",
					},
					{
						name: "Xã Tiên Yên",
					},
					{
						name: "Xã Vĩ Thượng",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Cao Bằng",
		districts: [
			{
				name: "Thành phố Cao Bằng",
				wards: [
					{
						name: "Phường Sông Hiến",
					},
					{
						name: "Phường Sông Bằng",
					},
					{
						name: "Phường Hợp Giang",
					},
					{
						name: "Phường Tân Giang",
					},
					{
						name: "Phường Ngọc Xuân",
					},
					{
						name: "Phường Đề Thám",
					},
					{
						name: "Phường Hoà Chung",
					},
					{
						name: "Phường Duyệt Trung",
					},
					{
						name: "Xã Vĩnh Quang",
					},
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Chu Trinh",
					},
				],
			},
			{
				name: "Huyện Bảo Lâm",
				wards: [
					{
						name: "Thị trấn Pác Miầu",
					},
					{
						name: "Xã Đức Hạnh",
					},
					{
						name: "Xã Lý Bôn",
					},
					{
						name: "Xã Nam Cao",
					},
					{
						name: "Xã Nam Quang",
					},
					{
						name: "Xã Vĩnh Quang",
					},
					{
						name: "Xã Quảng Lâm",
					},
					{
						name: "Xã Thạch Lâm",
					},
					{
						name: "Xã Vĩnh Phong",
					},
					{
						name: "Xã Mông Ân",
					},
					{
						name: "Xã Thái Học",
					},
					{
						name: "Xã Thái Sơn",
					},
					{
						name: "Xã Yên Thổ",
					},
				],
			},
			{
				name: "Huyện Bảo Lạc",
				wards: [
					{
						name: "Thị trấn Bảo Lạc",
					},
					{
						name: "Xã Cốc Pàng",
					},
					{
						name: "Xã Thượng Hà",
					},
					{
						name: "Xã Cô Ba",
					},
					{
						name: "Xã Bảo Toàn",
					},
					{
						name: "Xã Khánh Xuân",
					},
					{
						name: "Xã Xuân Trường",
					},
					{
						name: "Xã Hồng Trị",
					},
					{
						name: "Xã Kim Cúc",
					},
					{
						name: "Xã Phan Thanh",
					},
					{
						name: "Xã Hồng An",
					},
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Hưng Thịnh",
					},
					{
						name: "Xã Huy Giáp",
					},
					{
						name: "Xã Đình Phùng",
					},
					{
						name: "Xã Sơn Lập",
					},
					{
						name: "Xã Sơn Lộ",
					},
				],
			},
			{
				name: "Huyện Hà Quảng",
				wards: [
					{
						name: "Thị trấn Thông Nông",
					},
					{
						name: "Xã Cần Yên",
					},
					{
						name: "Xã Cần Nông",
					},
					{
						name: "Xã Lương Thông",
					},
					{
						name: "Xã Đa Thông",
					},
					{
						name: "Xã Ngọc Động",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Lương Can",
					},
					{
						name: "Xã Thanh Long",
					},
					{
						name: "Thị trấn Xuân Hòa",
					},
					{
						name: "Xã Lũng Nặm",
					},
					{
						name: "Xã Trường Hà",
					},
					{
						name: "Xã Cải Viên",
					},
					{
						name: "Xã Nội Thôn",
					},
					{
						name: "Xã Tổng Cọt",
					},
					{
						name: "Xã Sóc Hà",
					},
					{
						name: "Xã Thượng Thôn",
					},
					{
						name: "Xã Hồng Sỹ",
					},
					{
						name: "Xã Quý Quân",
					},
					{
						name: "Xã Mã Ba",
					},
					{
						name: "Xã Ngọc Đào",
					},
				],
			},
			{
				name: "Huyện Trùng Khánh",
				wards: [
					{
						name: "Thị trấn Trà Lĩnh",
					},
					{
						name: "Xã Tri Phương",
					},
					{
						name: "Xã Quang Hán",
					},
					{
						name: "Xã Xuân Nội",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Quang Vinh",
					},
					{
						name: "Xã Cao Chương",
					},
					{
						name: "Thị trấn Trùng Khánh",
					},
					{
						name: "Xã Ngọc Khê",
					},
					{
						name: "Xã Ngọc Côn",
					},
					{
						name: "Xã Phong Nậm",
					},
					{
						name: "Xã Đình Phong",
					},
					{
						name: "Xã Đàm Thuỷ",
					},
					{
						name: "Xã Khâm Thành",
					},
					{
						name: "Xã Chí Viễn",
					},
					{
						name: "Xã Lăng Hiếu",
					},
					{
						name: "Xã Phong Châu",
					},
					{
						name: "Xã Trung Phúc",
					},
					{
						name: "Xã Cao Thăng",
					},
					{
						name: "Xã Đức Hồng",
					},
					{
						name: "Xã Đoài Dương",
					},
				],
			},
			{
				name: "Huyện Hạ Lang",
				wards: [
					{
						name: "Xã Minh Long",
					},
					{
						name: "Xã Lý Quốc",
					},
					{
						name: "Xã Thắng Lợi",
					},
					{
						name: "Xã Đồng Loan",
					},
					{
						name: "Xã Đức Quang",
					},
					{
						name: "Xã Kim Loan",
					},
					{
						name: "Xã Quang Long",
					},
					{
						name: "Xã An Lạc",
					},
					{
						name: "Thị trấn Thanh Nhật",
					},
					{
						name: "Xã Vinh Quý",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Cô Ngân",
					},
					{
						name: "Xã Thị Hoa",
					},
				],
			},
			{
				name: "Huyện Quảng Hòa",
				wards: [
					{
						name: "Xã Quốc Toản",
					},
					{
						name: "Thị trấn Quảng Uyên",
					},
					{
						name: "Xã Phi Hải",
					},
					{
						name: "Xã Quảng Hưng",
					},
					{
						name: "Xã Độc Lập",
					},
					{
						name: "Xã Cai Bộ",
					},
					{
						name: "Xã Phúc Sen",
					},
					{
						name: "Xã Chí Thảo",
					},
					{
						name: "Xã Tự Do",
					},
					{
						name: "Xã Hồng Quang",
					},
					{
						name: "Xã Ngọc Động",
					},
					{
						name: "Xã Hạnh Phúc",
					},
					{
						name: "Thị trấn Tà Lùng",
					},
					{
						name: "Xã Bế Văn Đàn",
					},
					{
						name: "Xã Cách Linh",
					},
					{
						name: "Xã Đại Sơn",
					},
					{
						name: "Xã Tiên Thành",
					},
					{
						name: "Thị trấn Hoà Thuận",
					},
					{
						name: "Xã Mỹ Hưng",
					},
				],
			},
			{
				name: "Huyện Hoà An",
				wards: [
					{
						name: "Thị trấn Nước Hai",
					},
					{
						name: "Xã Dân Chủ",
					},
					{
						name: "Xã Nam Tuấn",
					},
					{
						name: "Xã Đại Tiến",
					},
					{
						name: "Xã Đức Long",
					},
					{
						name: "Xã Ngũ Lão",
					},
					{
						name: "Xã Trương Lương",
					},
					{
						name: "Xã Hồng Việt",
					},
					{
						name: "Xã Hoàng Tung",
					},
					{
						name: "Xã Nguyễn Huệ",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Bạch Đằng",
					},
					{
						name: "Xã Bình Dương",
					},
					{
						name: "Xã Lê Chung",
					},
					{
						name: "Xã Hồng Nam",
					},
				],
			},
			{
				name: "Huyện Nguyên Bình",
				wards: [
					{
						name: "Thị trấn Nguyên Bình",
					},
					{
						name: "Thị trấn Tĩnh Túc",
					},
					{
						name: "Xã Yên Lạc",
					},
					{
						name: "Xã Triệu Nguyên",
					},
					{
						name: "Xã Ca Thành",
					},
					{
						name: "Xã Vũ Nông",
					},
					{
						name: "Xã Minh Tâm",
					},
					{
						name: "Xã Thể Dục",
					},
					{
						name: "Xã Mai Long",
					},
					{
						name: "Xã Vũ Minh",
					},
					{
						name: "Xã Hoa Thám",
					},
					{
						name: "Xã Phan Thanh",
					},
					{
						name: "Xã Quang Thành",
					},
					{
						name: "Xã Tam Kim",
					},
					{
						name: "Xã Thành Công",
					},
					{
						name: "Xã Thịnh Vượng",
					},
					{
						name: "Xã Hưng Đạo",
					},
				],
			},
			{
				name: "Huyện Thạch An",
				wards: [
					{
						name: "Thị trấn Đông Khê",
					},
					{
						name: "Xã Canh Tân",
					},
					{
						name: "Xã Kim Đồng",
					},
					{
						name: "Xã Minh Khai",
					},
					{
						name: "Xã Đức Thông",
					},
					{
						name: "Xã Thái Cường",
					},
					{
						name: "Xã Vân Trình",
					},
					{
						name: "Xã Thụy Hùng",
					},
					{
						name: "Xã Quang Trọng",
					},
					{
						name: "Xã Trọng Con",
					},
					{
						name: "Xã Lê Lai",
					},
					{
						name: "Xã Đức Long",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Xã Đức Xuân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bắc Kạn",
		districts: [
			{
				name: "Thành Phố Bắc Kạn",
				wards: [
					{
						name: "Phường Nguyễn Thị Minh Khai",
					},
					{
						name: "Phường Sông Cầu",
					},
					{
						name: "Phường Đức Xuân",
					},
					{
						name: "Phường Phùng Chí Kiên",
					},
					{
						name: "Phường Huyền Tụng",
					},
					{
						name: "Xã Dương Quang",
					},
					{
						name: "Xã Nông Thượng",
					},
					{
						name: "Phường Xuất Hóa",
					},
				],
			},
			{
				name: "Huyện Pác Nặm",
				wards: [
					{
						name: "Xã Bằng Thành",
					},
					{
						name: "Xã Nhạn Môn",
					},
					{
						name: "Xã Bộc Bố",
					},
					{
						name: "Xã Công Bằng",
					},
					{
						name: "Xã Giáo Hiệu",
					},
					{
						name: "Xã Xuân La",
					},
					{
						name: "Xã An Thắng",
					},
					{
						name: "Xã Cổ Linh",
					},
					{
						name: "Xã Nghiên Loan",
					},
					{
						name: "Xã Cao Tân",
					},
				],
			},
			{
				name: "Huyện Ba Bể",
				wards: [
					{
						name: "Thị trấn Chợ Rã",
					},
					{
						name: "Xã Bành Trạch",
					},
					{
						name: "Xã Phúc Lộc",
					},
					{
						name: "Xã Hà Hiệu",
					},
					{
						name: "Xã Cao Thượng",
					},
					{
						name: "Xã Khang Ninh",
					},
					{
						name: "Xã Nam Mẫu",
					},
					{
						name: "Xã Thượng Giáo",
					},
					{
						name: "Xã Địa Linh",
					},
					{
						name: "Xã Yến Dương",
					},
					{
						name: "Xã Chu Hương",
					},
					{
						name: "Xã Quảng Khê",
					},
					{
						name: "Xã Mỹ Phương",
					},
					{
						name: "Xã Hoàng Trĩ",
					},
					{
						name: "Xã Đồng Phúc",
					},
				],
			},
			{
				name: "Huyện Ngân Sơn",
				wards: [
					{
						name: "Thị trấn Nà Phặc",
					},
					{
						name: "Xã Thượng Ân",
					},
					{
						name: "Xã Bằng Vân",
					},
					{
						name: "Xã Cốc Đán",
					},
					{
						name: "Xã Trung Hoà",
					},
					{
						name: "Xã Đức Vân",
					},
					{
						name: "Xã Vân Tùng",
					},
					{
						name: "Xã Thượng Quan",
					},
					{
						name: "Xã Hiệp Lực",
					},
					{
						name: "Xã Thuần Mang",
					},
				],
			},
			{
				name: "Huyện Bạch Thông",
				wards: [
					{
						name: "Thị trấn Phủ Thông",
					},
					{
						name: "Xã Vi Hương",
					},
					{
						name: "Xã Sĩ Bình",
					},
					{
						name: "Xã Vũ Muộn",
					},
					{
						name: "Xã Đôn Phong",
					},
					{
						name: "Xã Lục Bình",
					},
					{
						name: "Xã Tân Tú",
					},
					{
						name: "Xã Nguyên Phúc",
					},
					{
						name: "Xã Cao Sơn",
					},
					{
						name: "Xã Quân Hà",
					},
					{
						name: "Xã Cẩm Giàng",
					},
					{
						name: "Xã Mỹ Thanh",
					},
					{
						name: "Xã Dương Phong",
					},
					{
						name: "Xã Quang Thuận",
					},
				],
			},
			{
				name: "Huyện Chợ Đồn",
				wards: [
					{
						name: "Thị trấn Bằng Lũng",
					},
					{
						name: "Xã Xuân Lạc",
					},
					{
						name: "Xã Nam Cường",
					},
					{
						name: "Xã Đồng Lạc",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Bản Thi",
					},
					{
						name: "Xã Quảng Bạch",
					},
					{
						name: "Xã Bằng Phúc",
					},
					{
						name: "Xã Yên Thịnh",
					},
					{
						name: "Xã Yên Thượng",
					},
					{
						name: "Xã Phương Viên",
					},
					{
						name: "Xã Ngọc Phái",
					},
					{
						name: "Xã Đồng Thắng",
					},
					{
						name: "Xã Lương Bằng",
					},
					{
						name: "Xã Bằng Lãng",
					},
					{
						name: "Xã Đại Sảo",
					},
					{
						name: "Xã Nghĩa Tá",
					},
					{
						name: "Xã Yên Mỹ",
					},
					{
						name: "Xã Bình Trung",
					},
					{
						name: "Xã Yên Phong",
					},
				],
			},
			{
				name: "Huyện Chợ Mới",
				wards: [
					{
						name: "Thị trấn Đồng Tâm",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Thanh Vận",
					},
					{
						name: "Xã Mai Lạp",
					},
					{
						name: "Xã Hoà Mục",
					},
					{
						name: "Xã Thanh Mai",
					},
					{
						name: "Xã Cao Kỳ",
					},
					{
						name: "Xã Nông Hạ",
					},
					{
						name: "Xã Yên Cư",
					},
					{
						name: "Xã Thanh Thịnh",
					},
					{
						name: "Xã Yên Hân",
					},
					{
						name: "Xã Như Cố",
					},
					{
						name: "Xã Bình Văn",
					},
					{
						name: "Xã Quảng Chu",
					},
				],
			},
			{
				name: "Huyện Na Rì",
				wards: [
					{
						name: "Xã Văn Vũ",
					},
					{
						name: "Xã Văn Lang",
					},
					{
						name: "Xã Lương Thượng",
					},
					{
						name: "Xã Kim Hỷ",
					},
					{
						name: "Xã Cường Lợi",
					},
					{
						name: "Thị trấn Yến Lạc",
					},
					{
						name: "Xã Kim Lư",
					},
					{
						name: "Xã Sơn Thành",
					},
					{
						name: "Xã Văn Minh",
					},
					{
						name: "Xã Côn Minh",
					},
					{
						name: "Xã Cư Lễ",
					},
					{
						name: "Xã Trần Phú",
					},
					{
						name: "Xã Quang Phong",
					},
					{
						name: "Xã Dương Sơn",
					},
					{
						name: "Xã Xuân Dương",
					},
					{
						name: "Xã Đổng Xá",
					},
					{
						name: "Xã Liêm Thuỷ",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Tuyên Quang",
		districts: [
			{
				name: "Thành phố Tuyên Quang",
				wards: [
					{
						name: "Phường Phan Thiết",
					},
					{
						name: "Phường Minh Xuân",
					},
					{
						name: "Phường Tân Quang",
					},
					{
						name: "Xã Tràng Đà",
					},
					{
						name: "Phường Nông Tiến",
					},
					{
						name: "Phường Ỷ La",
					},
					{
						name: "Phường Tân Hà",
					},
					{
						name: "Phường Hưng Thành",
					},
					{
						name: "Xã Kim Phú",
					},
					{
						name: "Xã An Khang",
					},
					{
						name: "Phường Mỹ Lâm",
					},
					{
						name: "Phường An Tường",
					},
					{
						name: "Xã Lưỡng Vượng",
					},
					{
						name: "Xã Thái Long",
					},
					{
						name: "Phường Đội Cấn",
					},
				],
			},
			{
				name: "Huyện Lâm Bình",
				wards: [
					{
						name: "Xã Phúc Yên",
					},
					{
						name: "Xã Xuân Lập",
					},
					{
						name: "Xã Khuôn Hà",
					},
					{
						name: "Xã Lăng Can",
					},
					{
						name: "Xã Thượng Lâm",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Hồng Quang",
					},
					{
						name: "Xã Thổ Bình",
					},
				],
			},
			{
				name: "Huyện Na Hang",
				wards: [
					{
						name: "Thị trấn Na Hang",
					},
					{
						name: "Xã Sinh Long",
					},
					{
						name: "Xã Thượng Giáp",
					},
					{
						name: "Xã Thượng Nông",
					},
					{
						name: "Xã Côn Lôn",
					},
					{
						name: "Xã Yên Hoa",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Đà Vị",
					},
					{
						name: "Xã Khau Tinh",
					},
					{
						name: "Xã Sơn Phú",
					},
					{
						name: "Xã Năng Khả",
					},
					{
						name: "Xã Thanh Tương",
					},
				],
			},
			{
				name: "Huyện Chiêm Hóa",
				wards: [
					{
						name: "Thị trấn Vĩnh Lộc",
					},
					{
						name: "Xã Phúc Sơn",
					},
					{
						name: "Xã Minh Quang",
					},
					{
						name: "Xã Trung Hà",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Hà Lang",
					},
					{
						name: "Xã Hùng Mỹ",
					},
					{
						name: "Xã Yên Lập",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Xuân Quang",
					},
					{
						name: "Xã Ngọc Hội",
					},
					{
						name: "Xã Phú Bình",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Phúc Thịnh",
					},
					{
						name: "Xã Kiên Đài",
					},
					{
						name: "Xã Tân Thịnh",
					},
					{
						name: "Xã Trung Hòa",
					},
					{
						name: "Xã Kim Bình",
					},
					{
						name: "Xã Hòa An",
					},
					{
						name: "Xã Vinh Quang",
					},
					{
						name: "Xã Tri Phú",
					},
					{
						name: "Xã Nhân Lý",
					},
					{
						name: "Xã Yên Nguyên",
					},
					{
						name: "Xã Linh Phú",
					},
					{
						name: "Xã Bình Nhân",
					},
				],
			},
			{
				name: "Huyện Hàm Yên",
				wards: [
					{
						name: "Thị trấn Tân Yên",
					},
					{
						name: "Xã Yên Thuận",
					},
					{
						name: "Xã Bạch Xa",
					},
					{
						name: "Xã Minh Khương",
					},
					{
						name: "Xã Yên Lâm",
					},
					{
						name: "Xã Minh Dân",
					},
					{
						name: "Xã Phù Lưu",
					},
					{
						name: "Xã Minh Hương",
					},
					{
						name: "Xã Yên Phú",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Bình Xa",
					},
					{
						name: "Xã Thái Sơn",
					},
					{
						name: "Xã Nhân Mục",
					},
					{
						name: "Xã Thành Long",
					},
					{
						name: "Xã Bằng Cốc",
					},
					{
						name: "Xã Thái Hòa",
					},
					{
						name: "Xã Đức Ninh",
					},
					{
						name: "Xã Hùng Đức",
					},
				],
			},
			{
				name: "Huyện Yên Sơn",
				wards: [
					{
						name: "Xã Quí Quân",
					},
					{
						name: "Xã Lực Hành",
					},
					{
						name: "Xã Kiến Thiết",
					},
					{
						name: "Xã Trung Minh",
					},
					{
						name: "Xã Chiêu Yên",
					},
					{
						name: "Xã Trung Trực",
					},
					{
						name: "Xã Xuân Vân",
					},
					{
						name: "Xã Phúc Ninh",
					},
					{
						name: "Xã Hùng Lợi",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Tứ Quận",
					},
					{
						name: "Xã Đạo Viện",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Thắng Quân",
					},
					{
						name: "Xã Kim Quan",
					},
					{
						name: "Xã Lang Quán",
					},
					{
						name: "Xã Phú Thịnh",
					},
					{
						name: "Xã Công Đa",
					},
					{
						name: "Xã Trung Môn",
					},
					{
						name: "Xã Chân Sơn",
					},
					{
						name: "Xã Thái Bình",
					},
					{
						name: "Xã Tiến Bộ",
					},
					{
						name: "Xã Mỹ Bằng",
					},
					{
						name: "Xã Hoàng Khai",
					},
					{
						name: "Xã Nhữ Hán",
					},
					{
						name: "Xã Nhữ Khê",
					},
					{
						name: "Xã Đội Bình",
					},
				],
			},
			{
				name: "Huyện Sơn Dương",
				wards: [
					{
						name: "Thị trấn Sơn Dương",
					},
					{
						name: "Xã Trung Yên",
					},
					{
						name: "Xã Minh Thanh",
					},
					{
						name: "Xã Tân Trào",
					},
					{
						name: "Xã Vĩnh Lợi",
					},
					{
						name: "Xã Thượng Ấm",
					},
					{
						name: "Xã Bình Yên",
					},
					{
						name: "Xã Lương Thiện",
					},
					{
						name: "Xã Tú Thịnh",
					},
					{
						name: "Xã Cấp Tiến",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Phúc Ứng",
					},
					{
						name: "Xã Đông Thọ",
					},
					{
						name: "Xã Kháng Nhật",
					},
					{
						name: "Xã Hợp Hòa",
					},
					{
						name: "Xã Quyết Thắng",
					},
					{
						name: "Xã Đồng Quý",
					},
					{
						name: "Xã Tân Thanh",
					},
					{
						name: "Xã Vân Sơn",
					},
					{
						name: "Xã Văn Phú",
					},
					{
						name: "Xã Chi Thiết",
					},
					{
						name: "Xã Đông Lợi",
					},
					{
						name: "Xã Thiện Kế",
					},
					{
						name: "Xã Hồng Lạc",
					},
					{
						name: "Xã Phú Lương",
					},
					{
						name: "Xã Ninh Lai",
					},
					{
						name: "Xã Đại Phú",
					},
					{
						name: "Xã Sơn Nam",
					},
					{
						name: "Xã Hào Phú",
					},
					{
						name: "Xã Tam Đa",
					},
					{
						name: "Xã Trường Sinh",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Lào Cai",
		districts: [
			{
				name: "Thành phố Lào Cai",
				wards: [
					{
						name: "Phường Duyên Hải",
					},
					{
						name: "Phường Lào Cai",
					},
					{
						name: "Phường Cốc Lếu",
					},
					{
						name: "Phường Kim Tân",
					},
					{
						name: "Phường Bắc Lệnh",
					},
					{
						name: "Phường Pom Hán",
					},
					{
						name: "Phường Xuân Tăng",
					},
					{
						name: "Phường Bình Minh",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Đồng Tuyển",
					},
					{
						name: "Xã Vạn Hoà",
					},
					{
						name: "Phường Bắc Cường",
					},
					{
						name: "Phường Nam Cường",
					},
					{
						name: "Xã Cam Đường",
					},
					{
						name: "Xã Tả Phời",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Cốc San",
					},
				],
			},
			{
				name: "Huyện Bát Xát",
				wards: [
					{
						name: "Thị trấn Bát Xát",
					},
					{
						name: "Xã A Mú Sung",
					},
					{
						name: "Xã Nậm Chạc",
					},
					{
						name: "Xã A Lù",
					},
					{
						name: "Xã Trịnh Tường",
					},
					{
						name: "Xã Y Tý",
					},
					{
						name: "Xã Cốc Mỳ",
					},
					{
						name: "Xã Dền Sáng",
					},
					{
						name: "Xã Bản Vược",
					},
					{
						name: "Xã Sàng Ma Sáo",
					},
					{
						name: "Xã Bản Qua",
					},
					{
						name: "Xã Mường Vi",
					},
					{
						name: "Xã Dền Thàng",
					},
					{
						name: "Xã Bản Xèo",
					},
					{
						name: "Xã Mường Hum",
					},
					{
						name: "Xã Trung Lèng Hồ",
					},
					{
						name: "Xã Quang Kim",
					},
					{
						name: "Xã Pa Cheo",
					},
					{
						name: "Xã Nậm Pung",
					},
					{
						name: "Xã Phìn Ngan",
					},
					{
						name: "Xã Tòng Sành",
					},
				],
			},
			{
				name: "Huyện Mường Khương",
				wards: [
					{
						name: "Xã Pha Long",
					},
					{
						name: "Xã Tả Ngải Chồ",
					},
					{
						name: "Xã Tung Chung Phố",
					},
					{
						name: "Thị trấn Mường Khương",
					},
					{
						name: "Xã Dìn Chin",
					},
					{
						name: "Xã Tả Gia Khâu",
					},
					{
						name: "Xã Nậm Chảy",
					},
					{
						name: "Xã Nấm Lư",
					},
					{
						name: "Xã Lùng Khấu Nhin",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Xã Cao Sơn",
					},
					{
						name: "Xã Lùng Vai",
					},
					{
						name: "Xã Bản Lầu",
					},
					{
						name: "Xã La Pan Tẩn",
					},
					{
						name: "Xã Tả Thàng",
					},
					{
						name: "Xã Bản Sen",
					},
				],
			},
			{
				name: "Huyện Si Ma Cai",
				wards: [
					{
						name: "Xã Nàn Sán",
					},
					{
						name: "Xã Thào Chư Phìn",
					},
					{
						name: "Xã Bản Mế",
					},
					{
						name: "Thị trấn Si Ma Cai",
					},
					{
						name: "Xã Sán Chải",
					},
					{
						name: "Xã Lùng Thẩn",
					},
					{
						name: "Xã Cán Cấu",
					},
					{
						name: "Xã Sín Chéng",
					},
					{
						name: "Xã Quan Hồ Thẩn",
					},
					{
						name: "Xã Nàn Xín",
					},
				],
			},
			{
				name: "Huyện Bắc Hà",
				wards: [
					{
						name: "Thị trấn Bắc Hà",
					},
					{
						name: "Xã Lùng Cải",
					},
					{
						name: "Xã Lùng Phình",
					},
					{
						name: "Xã Tả Van Chư",
					},
					{
						name: "Xã Tả Củ Tỷ",
					},
					{
						name: "Xã Thải Giàng Phố",
					},
					{
						name: "Xã Hoàng Thu Phố",
					},
					{
						name: "Xã Bản Phố",
					},
					{
						name: "Xã Bản Liền",
					},
					{
						name: "Xã Tà Chải",
					},
					{
						name: "Xã Na Hối",
					},
					{
						name: "Xã Cốc Ly",
					},
					{
						name: "Xã Nậm Mòn",
					},
					{
						name: "Xã Nậm Đét",
					},
					{
						name: "Xã Nậm Khánh",
					},
					{
						name: "Xã Bảo Nhai",
					},
					{
						name: "Xã Nậm Lúc",
					},
					{
						name: "Xã Cốc Lầu",
					},
					{
						name: "Xã Bản Cái",
					},
				],
			},
			{
				name: "Huyện Bảo Thắng",
				wards: [
					{
						name: "Thị trấn N.T Phong Hải",
					},
					{
						name: "Thị trấn Phố Lu",
					},
					{
						name: "Thị trấn Tằng Loỏng",
					},
					{
						name: "Xã Bản Phiệt",
					},
					{
						name: "Xã Bản Cầm",
					},
					{
						name: "Xã Thái Niên",
					},
					{
						name: "Xã Phong Niên",
					},
					{
						name: "Xã Gia Phú",
					},
					{
						name: "Xã Xuân Quang",
					},
					{
						name: "Xã Sơn Hải",
					},
					{
						name: "Xã Xuân Giao",
					},
					{
						name: "Xã Trì Quang",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Phú Nhuận",
					},
				],
			},
			{
				name: "Huyện Bảo Yên",
				wards: [
					{
						name: "Thị trấn Phố Ràng",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Nghĩa Đô",
					},
					{
						name: "Xã Vĩnh Yên",
					},
					{
						name: "Xã Điện Quan",
					},
					{
						name: "Xã Xuân Hoà",
					},
					{
						name: "Xã Tân Dương",
					},
					{
						name: "Xã Thượng Hà",
					},
					{
						name: "Xã Kim Sơn",
					},
					{
						name: "Xã Cam Cọn",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Xuân Thượng",
					},
					{
						name: "Xã Việt Tiến",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Bảo Hà",
					},
					{
						name: "Xã Lương Sơn",
					},
					{
						name: "Xã Phúc Khánh",
					},
				],
			},
			{
				name: "Thị xã Sa Pa",
				wards: [
					{
						name: "Phường Sa Pa",
					},
					{
						name: "Phường Sa Pả",
					},
					{
						name: "Phường Ô Quý Hồ",
					},
					{
						name: "Xã Ngũ Chỉ Sơn",
					},
					{
						name: "Phường Phan Si Păng",
					},
					{
						name: "Xã Trung Chải",
					},
					{
						name: "Xã Tả Phìn",
					},
					{
						name: "Phường Hàm Rồng",
					},
					{
						name: "Xã Hoàng Liên",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Phường Cầu Mây",
					},
					{
						name: "Xã Mường Hoa",
					},
					{
						name: "Xã Tả Van",
					},
					{
						name: "Xã Mường Bo",
					},
					{
						name: "Xã Bản Hồ",
					},
					{
						name: "Xã Liên Minh",
					},
				],
			},
			{
				name: "Huyện Văn Bàn",
				wards: [
					{
						name: "Thị trấn Khánh Yên",
					},
					{
						name: "Xã Võ Lao",
					},
					{
						name: "Xã Sơn Thuỷ",
					},
					{
						name: "Xã Nậm Mả",
					},
					{
						name: "Xã Tân Thượng",
					},
					{
						name: "Xã Nậm Rạng",
					},
					{
						name: "Xã Nậm Chầy",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Khánh Yên Thượng",
					},
					{
						name: "Xã Nậm Xé",
					},
					{
						name: "Xã Dần Thàng",
					},
					{
						name: "Xã Chiềng Ken",
					},
					{
						name: "Xã Làng Giàng",
					},
					{
						name: "Xã Hoà Mạc",
					},
					{
						name: "Xã Khánh Yên Trung",
					},
					{
						name: "Xã Khánh Yên Hạ",
					},
					{
						name: "Xã Dương Quỳ",
					},
					{
						name: "Xã Nậm Tha",
					},
					{
						name: "Xã Minh Lương",
					},
					{
						name: "Xã Thẩm Dương",
					},
					{
						name: "Xã Liêm Phú",
					},
					{
						name: "Xã Nậm Xây",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Điện Biên",
		districts: [
			{
				name: "Thành phố Điện Biên Phủ",
				wards: [
					{
						name: "Phường Noong Bua",
					},
					{
						name: "Phường Him Lam",
					},
					{
						name: "Phường Thanh Bình",
					},
					{
						name: "Phường Tân Thanh",
					},
					{
						name: "Phường Mường Thanh",
					},
					{
						name: "Phường Nam Thanh",
					},
					{
						name: "Phường Thanh Trường",
					},
					{
						name: "Xã Thanh Minh",
					},
					{
						name: "Xã Nà Tấu",
					},
					{
						name: "Xã Nà Nhạn",
					},
					{
						name: "Xã Mường Phăng",
					},
					{
						name: "Xã Pá Khoang",
					},
				],
			},
			{
				name: "Thị Xã Mường Lay",
				wards: [
					{
						name: "Phường Sông Đà",
					},
					{
						name: "Phường Na Lay",
					},
					{
						name: "Xã Lay Nưa",
					},
				],
			},
			{
				name: "Huyện Mường Nhé",
				wards: [
					{
						name: "Xã Sín Thầu",
					},
					{
						name: "Xã Sen Thượng",
					},
					{
						name: "Xã Chung Chải",
					},
					{
						name: "Xã Leng Su Sìn",
					},
					{
						name: "Xã Pá Mỳ",
					},
					{
						name: "Xã Mường Nhé",
					},
					{
						name: "Xã Nậm Vì",
					},
					{
						name: "Xã Nậm Kè",
					},
					{
						name: "Xã Mường Toong",
					},
					{
						name: "Xã Quảng Lâm",
					},
					{
						name: "Xã Huổi Lếnh",
					},
				],
			},
			{
				name: "Huyện Mường Chà",
				wards: [
					{
						name: "Thị Trấn Mường Chà",
					},
					{
						name: "Xã Xá Tổng",
					},
					{
						name: "Xã Mường Tùng",
					},
					{
						name: "Xã Hừa Ngài",
					},
					{
						name: "Xã Huổi Mí",
					},
					{
						name: "Xã Pa Ham",
					},
					{
						name: "Xã Nậm Nèn",
					},
					{
						name: "Xã Huổi Lèng",
					},
					{
						name: "Xã Sa Lông",
					},
					{
						name: "Xã Ma Thì Hồ",
					},
					{
						name: "Xã Na Sang",
					},
					{
						name: "Xã Mường Mươn",
					},
				],
			},
			{
				name: "Huyện Tủa Chùa",
				wards: [
					{
						name: "Thị trấn Tủa Chùa",
					},
					{
						name: "Xã Huổi Só",
					},
					{
						name: "Xã Xín Chải",
					},
					{
						name: "Xã Tả Sìn Thàng",
					},
					{
						name: "Xã Lao Xả Phình",
					},
					{
						name: "Xã Tả Phìn",
					},
					{
						name: "Xã Tủa Thàng",
					},
					{
						name: "Xã Trung Thu",
					},
					{
						name: "Xã Sính Phình",
					},
					{
						name: "Xã Sáng Nhè",
					},
					{
						name: "Xã Mường Đun",
					},
					{
						name: "Xã Mường Báng",
					},
				],
			},
			{
				name: "Huyện Tuần Giáo",
				wards: [
					{
						name: "Thị trấn Tuần Giáo",
					},
					{
						name: "Xã Phình Sáng",
					},
					{
						name: "Xã Rạng Đông",
					},
					{
						name: "Xã Mùn Chung",
					},
					{
						name: "Xã Nà Tòng",
					},
					{
						name: "Xã Ta Ma",
					},
					{
						name: "Xã Mường Mùn",
					},
					{
						name: "Xã Pú Xi",
					},
					{
						name: "Xã Pú Nhung",
					},
					{
						name: "Xã Quài Nưa",
					},
					{
						name: "Xã Mường Thín",
					},
					{
						name: "Xã Tỏa Tình",
					},
					{
						name: "Xã Nà Sáy",
					},
					{
						name: "Xã Mường Khong",
					},
					{
						name: "Xã Quài Cang",
					},
					{
						name: "Xã Quài Tở",
					},
					{
						name: "Xã Chiềng Sinh",
					},
					{
						name: "Xã Chiềng Đông",
					},
					{
						name: "Xã Tênh Phông",
					},
				],
			},
			{
				name: "Huyện Điện Biên",
				wards: [
					{
						name: "Xã Mường Pồn",
					},
					{
						name: "Xã Thanh Nưa",
					},
					{
						name: "Xã Hua Thanh",
					},
					{
						name: "Xã Thanh Luông",
					},
					{
						name: "Xã Thanh Hưng",
					},
					{
						name: "Xã Thanh Xương",
					},
					{
						name: "Xã Thanh Chăn",
					},
					{
						name: "Xã Pa Thơm",
					},
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã Thanh Yên",
					},
					{
						name: "Xã Noong Luống",
					},
					{
						name: "Xã Noọng Hẹt",
					},
					{
						name: "Xã Sam Mứn",
					},
					{
						name: "Xã Pom Lót",
					},
					{
						name: "Xã Núa Ngam",
					},
					{
						name: "Xã Hẹ Muông",
					},
					{
						name: "Xã Na Ư",
					},
					{
						name: "Xã Mường Nhà",
					},
					{
						name: "Xã Na Tông",
					},
					{
						name: "Xã Mường Lói",
					},
					{
						name: "Xã Phu Luông",
					},
				],
			},
			{
				name: "Huyện Điện Biên Đông",
				wards: [
					{
						name: "Thị trấn Điện Biên Đông",
					},
					{
						name: "Xã Na Son",
					},
					{
						name: "Xã Phì Nhừ",
					},
					{
						name: "Xã Chiềng Sơ",
					},
					{
						name: "Xã Mường Luân",
					},
					{
						name: "Xã Pú Nhi",
					},
					{
						name: "Xã Nong U",
					},
					{
						name: "Xã Xa Dung",
					},
					{
						name: "Xã Keo Lôm",
					},
					{
						name: "Xã Luân Giới",
					},
					{
						name: "Xã Phình Giàng",
					},
					{
						name: "Xã Pú Hồng",
					},
					{
						name: "Xã Tìa Dình",
					},
					{
						name: "Xã Háng Lìa",
					},
				],
			},
			{
				name: "Huyện Mường Ảng",
				wards: [
					{
						name: "Thị trấn Mường Ảng",
					},
					{
						name: "Xã Mường Đăng",
					},
					{
						name: "Xã Ngối Cáy",
					},
					{
						name: "Xã Ẳng Tở",
					},
					{
						name: "Xã Búng Lao",
					},
					{
						name: "Xã Xuân Lao",
					},
					{
						name: "Xã Ẳng Nưa",
					},
					{
						name: "Xã Ẳng Cang",
					},
					{
						name: "Xã Nặm Lịch",
					},
					{
						name: "Xã Mường Lạn",
					},
				],
			},
			{
				name: "Huyện Nậm Pồ",
				wards: [
					{
						name: "Xã Nậm Tin",
					},
					{
						name: "Xã Pa Tần",
					},
					{
						name: "Xã Chà Cang",
					},
					{
						name: "Xã Na Cô Sa",
					},
					{
						name: "Xã Nà Khoa",
					},
					{
						name: "Xã Nà Hỳ",
					},
					{
						name: "Xã Nà Bủng",
					},
					{
						name: "Xã Nậm Nhừ",
					},
					{
						name: "Xã Nậm Chua",
					},
					{
						name: "Xã Nậm Khăn",
					},
					{
						name: "Xã Chà Tở",
					},
					{
						name: "Xã Vàng Đán",
					},
					{
						name: "Xã Chà Nưa",
					},
					{
						name: "Xã Phìn Hồ",
					},
					{
						name: "Xã Si Pa Phìn",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Lai Châu",
		districts: [
			{
				name: "Thành phố Lai Châu",
				wards: [
					{
						name: "Phường Quyết Thắng",
					},
					{
						name: "Phường Tân Phong",
					},
					{
						name: "Phường Quyết Tiến",
					},
					{
						name: "Phường Đoàn Kết",
					},
					{
						name: "Xã Sùng Phài",
					},
					{
						name: "Phường Đông Phong",
					},
					{
						name: "Xã San Thàng",
					},
				],
			},
			{
				name: "Huyện Tam Đường",
				wards: [
					{
						name: "Thị trấn Tam Đường",
					},
					{
						name: "Xã Thèn Sin",
					},
					{
						name: "Xã Tả Lèng",
					},
					{
						name: "Xã Giang Ma",
					},
					{
						name: "Xã Hồ Thầu",
					},
					{
						name: "Xã Bình Lư",
					},
					{
						name: "Xã Sơn Bình",
					},
					{
						name: "Xã Nùng Nàng",
					},
					{
						name: "Xã Bản Giang",
					},
					{
						name: "Xã Bản Hon",
					},
					{
						name: "Xã Bản Bo",
					},
					{
						name: "Xã Nà Tăm",
					},
					{
						name: "Xã Khun Há",
					},
				],
			},
			{
				name: "Huyện Mường Tè",
				wards: [
					{
						name: "Thị trấn Mường Tè",
					},
					{
						name: "Xã Thu Lũm",
					},
					{
						name: "Xã Ka Lăng",
					},
					{
						name: "Xã Tá Bạ",
					},
					{
						name: "Xã Pa ủ",
					},
					{
						name: "Xã Mường Tè",
					},
					{
						name: "Xã Pa Vệ Sử",
					},
					{
						name: "Xã Mù Cả",
					},
					{
						name: "Xã Bum Tở",
					},
					{
						name: "Xã Nậm Khao",
					},
					{
						name: "Xã Tà Tổng",
					},
					{
						name: "Xã Bum Nưa",
					},
					{
						name: "Xã Vàng San",
					},
					{
						name: "Xã Kan Hồ",
					},
				],
			},
			{
				name: "Huyện Sìn Hồ",
				wards: [
					{
						name: "Thị trấn Sìn Hồ",
					},
					{
						name: "Xã Chăn Nưa",
					},
					{
						name: "Xã Pa Tần",
					},
					{
						name: "Xã Phìn Hồ",
					},
					{
						name: "Xã Hồng Thu",
					},
					{
						name: "Xã Phăng Sô Lin",
					},
					{
						name: "Xã Ma Quai",
					},
					{
						name: "Xã Lùng Thàng",
					},
					{
						name: "Xã Tả Phìn",
					},
					{
						name: "Xã Sà Dề Phìn",
					},
					{
						name: "Xã Nậm Tăm",
					},
					{
						name: "Xã Tả Ngảo",
					},
					{
						name: "Xã Pu Sam Cáp",
					},
					{
						name: "Xã Nậm Cha",
					},
					{
						name: "Xã Pa Khoá",
					},
					{
						name: "Xã Làng Mô",
					},
					{
						name: "Xã Noong Hẻo",
					},
					{
						name: "Xã Nậm Mạ",
					},
					{
						name: "Xã Căn Co",
					},
					{
						name: "Xã Tủa Sín Chải",
					},
					{
						name: "Xã Nậm Cuổi",
					},
					{
						name: "Xã Nậm Hăn",
					},
				],
			},
			{
				name: "Huyện Phong Thổ",
				wards: [
					{
						name: "Xã Lả Nhì Thàng",
					},
					{
						name: "Xã Huổi Luông",
					},
					{
						name: "Thị trấn Phong Thổ",
					},
					{
						name: "Xã Sì Lở Lầu",
					},
					{
						name: "Xã Mồ Sì San",
					},
					{
						name: "Xã Pa Vây Sử",
					},
					{
						name: "Xã Vàng Ma Chải",
					},
					{
						name: "Xã Tông Qua Lìn",
					},
					{
						name: "Xã Mù Sang",
					},
					{
						name: "Xã Dào San",
					},
					{
						name: "Xã Ma Ly Pho",
					},
					{
						name: "Xã Bản Lang",
					},
					{
						name: "Xã Hoang Thèn",
					},
					{
						name: "Xã Khổng Lào",
					},
					{
						name: "Xã Nậm Xe",
					},
					{
						name: "Xã Mường So",
					},
					{
						name: "Xã Sin Suối Hồ",
					},
				],
			},
			{
				name: "Huyện Than Uyên",
				wards: [
					{
						name: "Thị trấn Than Uyên",
					},
					{
						name: "Xã Phúc Than",
					},
					{
						name: "Xã Mường Than",
					},
					{
						name: "Xã Mường Mít",
					},
					{
						name: "Xã Pha Mu",
					},
					{
						name: "Xã Mường Cang",
					},
					{
						name: "Xã Hua Nà",
					},
					{
						name: "Xã Tà Hừa",
					},
					{
						name: "Xã Mường Kim",
					},
					{
						name: "Xã Tà Mung",
					},
					{
						name: "Xã Tà Gia",
					},
					{
						name: "Xã Khoen On",
					},
				],
			},
			{
				name: "Huyện Tân Uyên",
				wards: [
					{
						name: "Thị trấn Tân Uyên",
					},
					{
						name: "Xã Mường Khoa",
					},
					{
						name: "Xã Phúc Khoa",
					},
					{
						name: "Xã Thân Thuộc",
					},
					{
						name: "Xã Trung Đồng",
					},
					{
						name: "Xã Hố Mít",
					},
					{
						name: "Xã Nậm Cần",
					},
					{
						name: "Xã Nậm Sỏ",
					},
					{
						name: "Xã Pắc Ta",
					},
					{
						name: "Xã Tà Mít",
					},
				],
			},
			{
				name: "Huyện Nậm Nhùn",
				wards: [
					{
						name: "Thị trấn Nậm Nhùn",
					},
					{
						name: "Xã Hua Bun",
					},
					{
						name: "Xã Mường Mô",
					},
					{
						name: "Xã Nậm Chà",
					},
					{
						name: "Xã Nậm Manh",
					},
					{
						name: "Xã Nậm Hàng",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Xã Pú Đao",
					},
					{
						name: "Xã Nậm Pì",
					},
					{
						name: "Xã Nậm Ban",
					},
					{
						name: "Xã Trung Chải",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Sơn La",
		districts: [
			{
				name: "Thành phố Sơn La",
				wards: [
					{
						name: "Phường Chiềng Lề",
					},
					{
						name: "Phường Tô Hiệu",
					},
					{
						name: "Phường Quyết Thắng",
					},
					{
						name: "Phường Quyết Tâm",
					},
					{
						name: "Xã Chiềng Cọ",
					},
					{
						name: "Xã Chiềng Đen",
					},
					{
						name: "Xã Chiềng Xôm",
					},
					{
						name: "Phường Chiềng An",
					},
					{
						name: "Phường Chiềng Cơi",
					},
					{
						name: "Xã Chiềng Ngần",
					},
					{
						name: "Xã Hua La",
					},
					{
						name: "Phường Chiềng Sinh",
					},
				],
			},
			{
				name: "Huyện Quỳnh Nhai",
				wards: [
					{
						name: "Xã Mường Chiên",
					},
					{
						name: "Xã Cà Nàng",
					},
					{
						name: "Xã Chiềng Khay",
					},
					{
						name: "Xã Mường Giôn",
					},
					{
						name: "Xã Pá Ma Pha Khinh",
					},
					{
						name: "Xã Chiềng Ơn",
					},
					{
						name: "Xã Mường Giàng",
					},
					{
						name: "Xã Chiềng Bằng",
					},
					{
						name: "Xã Mường Sại",
					},
					{
						name: "Xã Nậm ét",
					},
					{
						name: "Xã Chiềng Khoang",
					},
				],
			},
			{
				name: "Huyện Thuận Châu",
				wards: [
					{
						name: "Thị trấn Thuận Châu",
					},
					{
						name: "Xã Phổng Lái",
					},
					{
						name: "Xã Mường é",
					},
					{
						name: "Xã Chiềng Pha",
					},
					{
						name: "Xã Chiềng La",
					},
					{
						name: "Xã Chiềng Ngàm",
					},
					{
						name: "Xã Liệp Tè",
					},
					{
						name: "Xã é Tòng",
					},
					{
						name: "Xã Phổng Lập",
					},
					{
						name: "Xã Phổng Lăng",
					},
					{
						name: "Xã Chiềng Ly",
					},
					{
						name: "Xã Noong Lay",
					},
					{
						name: "Xã Mường Khiêng",
					},
					{
						name: "Xã Mường Bám",
					},
					{
						name: "Xã Long Hẹ",
					},
					{
						name: "Xã Chiềng Bôm",
					},
					{
						name: "Xã Thôm Mòn",
					},
					{
						name: "Xã Tông Lạnh",
					},
					{
						name: "Xã Tông Cọ",
					},
					{
						name: "Xã Bó Mười",
					},
					{
						name: "Xã Co Mạ",
					},
					{
						name: "Xã Púng Tra",
					},
					{
						name: "Xã Chiềng Pấc",
					},
					{
						name: "Xã Nậm Lầu",
					},
					{
						name: "Xã Bon Phặng",
					},
					{
						name: "Xã Co Tòng",
					},
					{
						name: "Xã Muổi Nọi",
					},
					{
						name: "Xã Pá Lông",
					},
					{
						name: "Xã Bản Lầm",
					},
				],
			},
			{
				name: "Huyện Mường La",
				wards: [
					{
						name: "Thị trấn Ít Ong",
					},
					{
						name: "Xã Nậm Giôn",
					},
					{
						name: "Xã Chiềng Lao",
					},
					{
						name: "Xã Hua Trai",
					},
					{
						name: "Xã Ngọc Chiến",
					},
					{
						name: "Xã Mường Trai",
					},
					{
						name: "Xã Nậm Păm",
					},
					{
						name: "Xã Chiềng Muôn",
					},
					{
						name: "Xã Chiềng Ân",
					},
					{
						name: "Xã Pi Toong",
					},
					{
						name: "Xã Chiềng Công",
					},
					{
						name: "Xã Tạ Bú",
					},
					{
						name: "Xã Chiềng San",
					},
					{
						name: "Xã Mường Bú",
					},
					{
						name: "Xã Chiềng Hoa",
					},
					{
						name: "Xã Mường Chùm",
					},
				],
			},
			{
				name: "Huyện Bắc Yên",
				wards: [
					{
						name: "Thị trấn Bắc Yên",
					},
					{
						name: "Xã Phiêng Ban",
					},
					{
						name: "Xã Hang Chú",
					},
					{
						name: "Xã Xím Vàng",
					},
					{
						name: "Xã Tà Xùa",
					},
					{
						name: "Xã Háng Đồng",
					},
					{
						name: "Xã Pắc Ngà",
					},
					{
						name: "Xã Làng Chếu",
					},
					{
						name: "Xã Chim Vàn",
					},
					{
						name: "Xã Mường Khoa",
					},
					{
						name: "Xã Song Pe",
					},
					{
						name: "Xã Hồng Ngài",
					},
					{
						name: "Xã Tạ Khoa",
					},
					{
						name: "Xã Hua Nhàn",
					},
					{
						name: "Xã Phiêng Côn",
					},
					{
						name: "Xã Chiềng Sại",
					},
				],
			},
			{
				name: "Huyện Phù Yên",
				wards: [
					{
						name: "Thị trấn Phù Yên",
					},
					{
						name: "Xã Suối Tọ",
					},
					{
						name: "Xã Mường Thải",
					},
					{
						name: "Xã Mường Cơi",
					},
					{
						name: "Xã Quang Huy",
					},
					{
						name: "Xã Huy Bắc",
					},
					{
						name: "Xã Huy Thượng",
					},
					{
						name: "Xã Tân Lang",
					},
					{
						name: "Xã Gia Phù",
					},
					{
						name: "Xã Tường Phù",
					},
					{
						name: "Xã Huy Hạ",
					},
					{
						name: "Xã Huy Tân",
					},
					{
						name: "Xã Mường Lang",
					},
					{
						name: "Xã Suối Bau",
					},
					{
						name: "Xã Huy Tường",
					},
					{
						name: "Xã Mường Do",
					},
					{
						name: "Xã Sập Xa",
					},
					{
						name: "Xã Tường Thượng",
					},
					{
						name: "Xã Tường Tiến",
					},
					{
						name: "Xã Tường Phong",
					},
					{
						name: "Xã Tường Hạ",
					},
					{
						name: "Xã Kim Bon",
					},
					{
						name: "Xã Mường Bang",
					},
					{
						name: "Xã Đá Đỏ",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Nam Phong",
					},
					{
						name: "Xã Bắc Phong",
					},
				],
			},
			{
				name: "Huyện Mộc Châu",
				wards: [
					{
						name: "Thị trấn Mộc Châu",
					},
					{
						name: "Thị trấn NT Mộc Châu",
					},
					{
						name: "Xã Chiềng Sơn",
					},
					{
						name: "Xã Tân Hợp",
					},
					{
						name: "Xã Qui Hướng",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Nà Mường",
					},
					{
						name: "Xã Tà Lai",
					},
					{
						name: "Xã Chiềng Hắc",
					},
					{
						name: "Xã Hua Păng",
					},
					{
						name: "Xã Chiềng Khừa",
					},
					{
						name: "Xã Mường Sang",
					},
					{
						name: "Xã Đông Sang",
					},
					{
						name: "Xã Phiêng Luông",
					},
					{
						name: "Xã Lóng Sập",
					},
				],
			},
			{
				name: "Huyện Yên Châu",
				wards: [
					{
						name: "Thị trấn Yên Châu",
					},
					{
						name: "Xã Chiềng Đông",
					},
					{
						name: "Xã Sập Vạt",
					},
					{
						name: "Xã Chiềng Sàng",
					},
					{
						name: "Xã Chiềng Pằn",
					},
					{
						name: "Xã Viêng Lán",
					},
					{
						name: "Xã Chiềng Hặc",
					},
					{
						name: "Xã Mường Lựm",
					},
					{
						name: "Xã Chiềng On",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Chiềng Khoi",
					},
					{
						name: "Xã Tú Nang",
					},
					{
						name: "Xã Lóng Phiêng",
					},
					{
						name: "Xã Phiêng Khoài",
					},
					{
						name: "Xã Chiềng Tương",
					},
				],
			},
			{
				name: "Huyện Mai Sơn",
				wards: [
					{
						name: "Thị trấn Hát Lót",
					},
					{
						name: "Xã Chiềng Sung",
					},
					{
						name: "Xã Mường Bằng",
					},
					{
						name: "Xã Chiềng Chăn",
					},
					{
						name: "Xã Mương Chanh",
					},
					{
						name: "Xã Chiềng Ban",
					},
					{
						name: "Xã Chiềng Mung",
					},
					{
						name: "Xã Mường Bon",
					},
					{
						name: "Xã Chiềng Chung",
					},
					{
						name: "Xã Chiềng Mai",
					},
					{
						name: "Xã Hát Lót",
					},
					{
						name: "Xã Nà Pó",
					},
					{
						name: "Xã Cò Nòi",
					},
					{
						name: "Xã Chiềng Nơi",
					},
					{
						name: "Xã Phiêng Cằm",
					},
					{
						name: "Xã Chiềng Dong",
					},
					{
						name: "Xã Chiềng Kheo",
					},
					{
						name: "Xã Chiềng Ve",
					},
					{
						name: "Xã Chiềng Lương",
					},
					{
						name: "Xã Phiêng Pằn",
					},
					{
						name: "Xã Nà Ơt",
					},
					{
						name: "Xã Tà Hộc",
					},
				],
			},
			{
				name: "Huyện Sông Mã",
				wards: [
					{
						name: "Thị trấn Sông Mã",
					},
					{
						name: "Xã Bó Sinh",
					},
					{
						name: "Xã Pú Pẩu",
					},
					{
						name: "Xã Chiềng Phung",
					},
					{
						name: "Xã Chiềng En",
					},
					{
						name: "Xã Mường Lầm",
					},
					{
						name: "Xã Nậm Ty",
					},
					{
						name: "Xã Đứa Mòn",
					},
					{
						name: "Xã Yên Hưng",
					},
					{
						name: "Xã Chiềng Sơ",
					},
					{
						name: "Xã Nà Nghịu",
					},
					{
						name: "Xã Nậm Mằn",
					},
					{
						name: "Xã Chiềng Khoong",
					},
					{
						name: "Xã Chiềng Cang",
					},
					{
						name: "Xã Huổi Một",
					},
					{
						name: "Xã Mường Sai",
					},
					{
						name: "Xã Mường Cai",
					},
					{
						name: "Xã Mường Hung",
					},
					{
						name: "Xã Chiềng Khương",
					},
				],
			},
			{
				name: "Huyện Sốp Cộp",
				wards: [
					{
						name: "Xã Sam Kha",
					},
					{
						name: "Xã Púng Bánh",
					},
					{
						name: "Xã Sốp Cộp",
					},
					{
						name: "Xã Dồm Cang",
					},
					{
						name: "Xã Nậm Lạnh",
					},
					{
						name: "Xã Mường Lèo",
					},
					{
						name: "Xã Mường Và",
					},
					{
						name: "Xã Mường Lạn",
					},
				],
			},
			{
				name: "Huyện Vân Hồ",
				wards: [
					{
						name: "Xã Suối Bàng",
					},
					{
						name: "Xã Song Khủa",
					},
					{
						name: "Xã Liên Hoà",
					},
					{
						name: "Xã Tô Múa",
					},
					{
						name: "Xã Mường Tè",
					},
					{
						name: "Xã Chiềng Khoa",
					},
					{
						name: "Xã Mường Men",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Vân Hồ",
					},
					{
						name: "Xã Lóng Luông",
					},
					{
						name: "Xã Chiềng Yên",
					},
					{
						name: "Xã Chiềng Xuân",
					},
					{
						name: "Xã Xuân Nha",
					},
					{
						name: "Xã Tân Xuân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Yên Bái",
		districts: [
			{
				name: "Thành phố Yên Bái",
				wards: [
					{
						name: "Phường Yên Thịnh",
					},
					{
						name: "Phường Yên Ninh",
					},
					{
						name: "Phường Minh Tân",
					},
					{
						name: "Phường Nguyễn Thái Học",
					},
					{
						name: "Phường Đồng Tâm",
					},
					{
						name: "Phường Nguyễn Phúc",
					},
					{
						name: "Phường Hồng Hà",
					},
					{
						name: "Xã Minh Bảo",
					},
					{
						name: "Phường Nam Cường",
					},
					{
						name: "Xã Tuy Lộc",
					},
					{
						name: "Xã Tân Thịnh",
					},
					{
						name: "Xã Âu Lâu",
					},
					{
						name: "Xã Giới Phiên",
					},
					{
						name: "Phường Hợp Minh",
					},
					{
						name: "Xã Văn Phú",
					},
				],
			},
			{
				name: "Thị xã Nghĩa Lộ",
				wards: [
					{
						name: "Phường Pú Trạng",
					},
					{
						name: "Phường Trung Tâm",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường Cầu Thia",
					},
					{
						name: "Xã Nghĩa Lợi",
					},
					{
						name: "Xã Nghĩa Phúc",
					},
					{
						name: "Xã Nghĩa An",
					},
					{
						name: "Xã Nghĩa Lộ",
					},
					{
						name: "Xã Sơn A",
					},
					{
						name: "Xã Phù Nham",
					},
					{
						name: "Xã Thanh Lương",
					},
					{
						name: "Xã Hạnh Sơn",
					},
					{
						name: "Xã Phúc Sơn",
					},
					{
						name: "Xã Thạch Lương",
					},
				],
			},
			{
				name: "Huyện Lục Yên",
				wards: [
					{
						name: "Thị trấn Yên Thế",
					},
					{
						name: "Xã Tân Phượng",
					},
					{
						name: "Xã Lâm Thượng",
					},
					{
						name: "Xã Khánh Thiện",
					},
					{
						name: "Xã Minh Chuẩn",
					},
					{
						name: "Xã Mai Sơn",
					},
					{
						name: "Xã Khai Trung",
					},
					{
						name: "Xã Mường Lai",
					},
					{
						name: "Xã An Lạc",
					},
					{
						name: "Xã Minh Xuân",
					},
					{
						name: "Xã Tô Mậu",
					},
					{
						name: "Xã Tân Lĩnh",
					},
					{
						name: "Xã Yên Thắng",
					},
					{
						name: "Xã Khánh Hoà",
					},
					{
						name: "Xã Vĩnh Lạc",
					},
					{
						name: "Xã Liễu Đô",
					},
					{
						name: "Xã Động Quan",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Minh Tiến",
					},
					{
						name: "Xã Trúc Lâu",
					},
					{
						name: "Xã Phúc Lợi",
					},
					{
						name: "Xã Phan Thanh",
					},
					{
						name: "Xã An Phú",
					},
					{
						name: "Xã Trung Tâm",
					},
				],
			},
			{
				name: "Huyện Văn Yên",
				wards: [
					{
						name: "Thị trấn Mậu A",
					},
					{
						name: "Xã Lang Thíp",
					},
					{
						name: "Xã Lâm Giang",
					},
					{
						name: "Xã Châu Quế Thượng",
					},
					{
						name: "Xã Châu Quế Hạ",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Đông An",
					},
					{
						name: "Xã Đông Cuông",
					},
					{
						name: "Xã Phong Dụ Hạ",
					},
					{
						name: "Xã Mậu Đông",
					},
					{
						name: "Xã Ngòi A",
					},
					{
						name: "Xã Xuân Tầm",
					},
					{
						name: "Xã Tân Hợp",
					},
					{
						name: "Xã An Thịnh",
					},
					{
						name: "Xã Yên Thái",
					},
					{
						name: "Xã Phong Dụ Thượng",
					},
					{
						name: "Xã Yên Hợp",
					},
					{
						name: "Xã Đại Sơn",
					},
					{
						name: "Xã Đại Phác",
					},
					{
						name: "Xã Yên Phú",
					},
					{
						name: "Xã Xuân Ái",
					},
					{
						name: "Xã Viễn Sơn",
					},
					{
						name: "Xã Mỏ Vàng",
					},
					{
						name: "Xã Nà Hẩu",
					},
				],
			},
			{
				name: "Huyện Mù Căng Chải",
				wards: [
					{
						name: "Thị trấn Mù Căng Chải",
					},
					{
						name: "Xã Hồ Bốn",
					},
					{
						name: "Xã Nậm Có",
					},
					{
						name: "Xã Khao Mang",
					},
					{
						name: "Xã Mồ Dề",
					},
					{
						name: "Xã Chế Cu Nha",
					},
					{
						name: "Xã Lao Chải",
					},
					{
						name: "Xã Kim Nọi",
					},
					{
						name: "Xã Cao Phạ",
					},
					{
						name: "Xã La Pán Tẩn",
					},
					{
						name: "Xã Dế Su Phình",
					},
					{
						name: "Xã Chế Tạo",
					},
					{
						name: "Xã Púng Luông",
					},
					{
						name: "Xã Nậm Khắt",
					},
				],
			},
			{
				name: "Huyện Trấn Yên",
				wards: [
					{
						name: "Thị trấn Cổ Phúc",
					},
					{
						name: "Xã Tân Đồng",
					},
					{
						name: "Xã Báo Đáp",
					},
					{
						name: "Xã Đào Thịnh",
					},
					{
						name: "Xã Việt Thành",
					},
					{
						name: "Xã Hòa Cuông",
					},
					{
						name: "Xã Minh Quán",
					},
					{
						name: "Xã Quy Mông",
					},
					{
						name: "Xã Cường Thịnh",
					},
					{
						name: "Xã Kiên Thành",
					},
					{
						name: "Xã Nga Quán",
					},
					{
						name: "Xã Y Can",
					},
					{
						name: "Xã Lương Thịnh",
					},
					{
						name: "Xã Bảo Hưng",
					},
					{
						name: "Xã Việt Cường",
					},
					{
						name: "Xã Minh Quân",
					},
					{
						name: "Xã Hồng Ca",
					},
					{
						name: "Xã Hưng Thịnh",
					},
					{
						name: "Xã Hưng Khánh",
					},
					{
						name: "Xã Việt Hồng",
					},
					{
						name: "Xã Vân Hội",
					},
				],
			},
			{
				name: "Huyện Trạm Tấu",
				wards: [
					{
						name: "Thị trấn Trạm Tấu",
					},
					{
						name: "Xã Túc Đán",
					},
					{
						name: "Xã Pá Lau",
					},
					{
						name: "Xã Xà Hồ",
					},
					{
						name: "Xã Phình Hồ",
					},
					{
						name: "Xã Trạm Tấu",
					},
					{
						name: "Xã Tà Si Láng",
					},
					{
						name: "Xã Pá Hu",
					},
					{
						name: "Xã Làng Nhì",
					},
					{
						name: "Xã Bản Công",
					},
					{
						name: "Xã Bản Mù",
					},
					{
						name: "Xã Hát Lìu",
					},
				],
			},
			{
				name: "Huyện Văn Chấn",
				wards: [
					{
						name: "Thị trấn NT Liên Sơn",
					},
					{
						name: "Thị trấn NT Trần Phú",
					},
					{
						name: "Xã Tú Lệ",
					},
					{
						name: "Xã Nậm Búng",
					},
					{
						name: "Xã Gia Hội",
					},
					{
						name: "Xã Sùng Đô",
					},
					{
						name: "Xã Nậm Mười",
					},
					{
						name: "Xã An Lương",
					},
					{
						name: "Xã Nậm Lành",
					},
					{
						name: "Xã Sơn Lương",
					},
					{
						name: "Xã Suối Quyền",
					},
					{
						name: "Xã Suối Giàng",
					},
					{
						name: "Xã Nghĩa Sơn",
					},
					{
						name: "Xã Suối Bu",
					},
					{
						name: "Thị trấn Sơn Thịnh",
					},
					{
						name: "Xã Đại Lịch",
					},
					{
						name: "Xã Đồng Khê",
					},
					{
						name: "Xã Cát Thịnh",
					},
					{
						name: "Xã Tân Thịnh",
					},
					{
						name: "Xã Chấn Thịnh",
					},
					{
						name: "Xã Bình Thuận",
					},
					{
						name: "Xã Thượng Bằng La",
					},
					{
						name: "Xã Minh An",
					},
					{
						name: "Xã Nghĩa Tâm",
					},
				],
			},
			{
				name: "Huyện Yên Bình",
				wards: [
					{
						name: "Thị trấn Yên Bình",
					},
					{
						name: "Thị trấn Thác Bà",
					},
					{
						name: "Xã Xuân Long",
					},
					{
						name: "Xã Cảm Nhân",
					},
					{
						name: "Xã Ngọc Chấn",
					},
					{
						name: "Xã Tân Nguyên",
					},
					{
						name: "Xã Phúc Ninh",
					},
					{
						name: "Xã Bảo Ái",
					},
					{
						name: "Xã Mỹ Gia",
					},
					{
						name: "Xã Xuân Lai",
					},
					{
						name: "Xã Mông Sơn",
					},
					{
						name: "Xã Cảm Ân",
					},
					{
						name: "Xã Yên Thành",
					},
					{
						name: "Xã Tân Hương",
					},
					{
						name: "Xã Phúc An",
					},
					{
						name: "Xã Bạch Hà",
					},
					{
						name: "Xã Vũ Linh",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Vĩnh Kiên",
					},
					{
						name: "Xã Yên Bình",
					},
					{
						name: "Xã Thịnh Hưng",
					},
					{
						name: "Xã Hán Đà",
					},
					{
						name: "Xã Phú Thịnh",
					},
					{
						name: "Xã Đại Minh",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Hoà Bình",
		districts: [
			{
				name: "Thành phố Hòa Bình",
				wards: [
					{
						name: "Phường Thái Bình",
					},
					{
						name: "Phường Tân Hòa",
					},
					{
						name: "Phường Thịnh Lang",
					},
					{
						name: "Phường Hữu Nghị",
					},
					{
						name: "Phường Tân Thịnh",
					},
					{
						name: "Phường Đồng Tiến",
					},
					{
						name: "Phường Phương Lâm",
					},
					{
						name: "Xã Yên Mông",
					},
					{
						name: "Phường Quỳnh Lâm",
					},
					{
						name: "Phường Dân Chủ",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Kỳ Sơn",
					},
					{
						name: "Xã Thịnh Minh",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Quang Tiến",
					},
					{
						name: "Xã Mông Hóa",
					},
					{
						name: "Phường Trung Minh",
					},
					{
						name: "Xã Độc Lập",
					},
				],
			},
			{
				name: "Huyện Đà Bắc",
				wards: [
					{
						name: "Thị trấn Đà Bắc",
					},
					{
						name: "Xã Nánh Nghê",
					},
					{
						name: "Xã Giáp Đắt",
					},
					{
						name: "Xã Mường Chiềng",
					},
					{
						name: "Xã Tân Pheo",
					},
					{
						name: "Xã Đồng Chum",
					},
					{
						name: "Xã Tân Minh",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Đồng Ruộng",
					},
					{
						name: "Xã Tú Lý",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Yên Hòa",
					},
					{
						name: "Xã Cao Sơn",
					},
					{
						name: "Xã Toàn Sơn",
					},
					{
						name: "Xã Hiền Lương",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Vầy Nưa",
					},
				],
			},
			{
				name: "Huyện Lương Sơn",
				wards: [
					{
						name: "Thị trấn Lương Sơn",
					},
					{
						name: "Xã Lâm Sơn",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Xã Tân Vinh",
					},
					{
						name: "Xã Nhuận Trạch",
					},
					{
						name: "Xã Cao Sơn",
					},
					{
						name: "Xã Cư Yên",
					},
					{
						name: "Xã Liên Sơn",
					},
					{
						name: "Xã Cao Dương",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Thanh Cao",
					},
				],
			},
			{
				name: "Huyện Kim Bôi",
				wards: [
					{
						name: "Thị trấn Bo",
					},
					{
						name: "Xã Đú Sáng",
					},
					{
						name: "Xã Hùng Sơn",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Tú Sơn",
					},
					{
						name: "Xã Vĩnh Tiến",
					},
					{
						name: "Xã Đông Bắc",
					},
					{
						name: "Xã Xuân Thủy",
					},
					{
						name: "Xã Vĩnh Đồng",
					},
					{
						name: "Xã Kim Lập",
					},
					{
						name: "Xã Hợp Tiến",
					},
					{
						name: "Xã Kim Bôi",
					},
					{
						name: "Xã Nam Thượng",
					},
					{
						name: "Xã Cuối Hạ",
					},
					{
						name: "Xã Sào Báy",
					},
					{
						name: "Xã Mi Hòa",
					},
					{
						name: "Xã Nuông Dăm",
					},
				],
			},
			{
				name: "Huyện Cao Phong",
				wards: [
					{
						name: "Thị trấn Cao Phong",
					},
					{
						name: "Xã Bình Thanh",
					},
					{
						name: "Xã Thung Nai",
					},
					{
						name: "Xã Bắc Phong",
					},
					{
						name: "Xã Thu Phong",
					},
					{
						name: "Xã Hợp Phong",
					},
					{
						name: "Xã Tây Phong",
					},
					{
						name: "Xã Dũng Phong",
					},
					{
						name: "Xã Nam Phong",
					},
					{
						name: "Xã Thạch Yên",
					},
				],
			},
			{
				name: "Huyện Tân Lạc",
				wards: [
					{
						name: "Thị trấn Mãn Đức",
					},
					{
						name: "Xã Suối Hoa",
					},
					{
						name: "Xã Phú Vinh",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Mỹ Hòa",
					},
					{
						name: "Xã Quyết Chiến",
					},
					{
						name: "Xã Phong Phú",
					},
					{
						name: "Xã Tử Nê",
					},
					{
						name: "Xã Thanh Hối",
					},
					{
						name: "Xã Ngọc Mỹ",
					},
					{
						name: "Xã Đông Lai",
					},
					{
						name: "Xã Vân Sơn",
					},
					{
						name: "Xã Nhân Mỹ",
					},
					{
						name: "Xã Lỗ Sơn",
					},
					{
						name: "Xã Ngổ Luông",
					},
					{
						name: "Xã Gia Mô",
					},
				],
			},
			{
				name: "Huyện Mai Châu",
				wards: [
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Thị trấn Mai Châu",
					},
					{
						name: "Xã Sơn Thủy",
					},
					{
						name: "Xã Pà Cò",
					},
					{
						name: "Xã Hang Kia",
					},
					{
						name: "Xã Đồng Tân",
					},
					{
						name: "Xã Cun Pheo",
					},
					{
						name: "Xã Bao La",
					},
					{
						name: "Xã Tòng Đậu",
					},
					{
						name: "Xã Nà Phòn",
					},
					{
						name: "Xã Săm Khóe",
					},
					{
						name: "Xã Chiềng Châu",
					},
					{
						name: "Xã Mai Hạ",
					},
					{
						name: "Xã Thành Sơn",
					},
					{
						name: "Xã Mai Hịch",
					},
					{
						name: "Xã Vạn Mai",
					},
				],
			},
			{
				name: "Huyện Lạc Sơn",
				wards: [
					{
						name: "Thị trấn Vụ Bản",
					},
					{
						name: "Xã Quý Hòa",
					},
					{
						name: "Xã Miền Đồi",
					},
					{
						name: "Xã Mỹ Thành",
					},
					{
						name: "Xã Tuân Đạo",
					},
					{
						name: "Xã Văn Nghĩa",
					},
					{
						name: "Xã Văn Sơn",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Nhân Nghĩa",
					},
					{
						name: "Xã Thượng Cốc",
					},
					{
						name: "Xã Quyết Thắng",
					},
					{
						name: "Xã Xuất Hóa",
					},
					{
						name: "Xã Yên Phú",
					},
					{
						name: "Xã Bình Hẻm",
					},
					{
						name: "Xã Định Cư",
					},
					{
						name: "Xã Chí Đạo",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Hương Nhượng",
					},
					{
						name: "Xã Vũ Bình",
					},
					{
						name: "Xã Tự Do",
					},
					{
						name: "Xã Yên Nghiệp",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Ân Nghĩa",
					},
					{
						name: "Xã Ngọc Lâu",
					},
				],
			},
			{
				name: "Huyện Yên Thủy",
				wards: [
					{
						name: "Thị trấn Hàng Trạm",
					},
					{
						name: "Xã Lạc Sỹ",
					},
					{
						name: "Xã Lạc Lương",
					},
					{
						name: "Xã Bảo Hiệu",
					},
					{
						name: "Xã Đa Phúc",
					},
					{
						name: "Xã Hữu Lợi",
					},
					{
						name: "Xã Lạc Thịnh",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Phú Lai",
					},
					{
						name: "Xã Yên Trị",
					},
					{
						name: "Xã Ngọc Lương",
					},
				],
			},
			{
				name: "Huyện Lạc Thủy",
				wards: [
					{
						name: "Thị trấn Ba Hàng Đồi",
					},
					{
						name: "Thị trấn Chi Nê",
					},
					{
						name: "Xã Phú Nghĩa",
					},
					{
						name: "Xã Phú Thành",
					},
					{
						name: "Xã Hưng Thi",
					},
					{
						name: "Xã Khoan Dụ",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Yên Bồng",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã An Bình",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Thái Nguyên",
		districts: [
			{
				name: "Thành phố Thái Nguyên",
				wards: [
					{
						name: "Phường Quán Triều",
					},
					{
						name: "Phường Quang Vinh",
					},
					{
						name: "Phường Túc Duyên",
					},
					{
						name: "Phường Hoàng Văn Thụ",
					},
					{
						name: "Phường Trưng Vương",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Phan Đình Phùng",
					},
					{
						name: "Phường Tân Thịnh",
					},
					{
						name: "Phường Thịnh Đán",
					},
					{
						name: "Phường Đồng Quang",
					},
					{
						name: "Phường Gia Sàng",
					},
					{
						name: "Phường Tân Lập",
					},
					{
						name: "Phường Cam Giá",
					},
					{
						name: "Phường Phú Xá",
					},
					{
						name: "Phường Hương Sơn",
					},
					{
						name: "Phường Trung Thành",
					},
					{
						name: "Phường Tân Thành",
					},
					{
						name: "Phường Tân Long",
					},
					{
						name: "Xã Phúc Hà",
					},
					{
						name: "Xã Phúc Xuân",
					},
					{
						name: "Xã Quyết Thắng",
					},
					{
						name: "Xã Phúc Trìu",
					},
					{
						name: "Xã Thịnh Đức",
					},
					{
						name: "Phường Tích Lương",
					},
					{
						name: "Xã Tân Cương",
					},
					{
						name: "Xã Sơn Cẩm",
					},
					{
						name: "Phường Chùa Hang",
					},
					{
						name: "Xã Cao Ngạn",
					},
					{
						name: "Xã Linh Sơn",
					},
					{
						name: "Phường Đồng Bẩm",
					},
					{
						name: "Xã Huống Thượng",
					},
					{
						name: "Xã Đồng Liên",
					},
				],
			},
			{
				name: "Thành phố Sông Công",
				wards: [
					{
						name: "Phường Lương Sơn",
					},
					{
						name: "Phường Châu Sơn",
					},
					{
						name: "Phường Mỏ Chè",
					},
					{
						name: "Phường Cải Đan",
					},
					{
						name: "Phường Thắng Lợi",
					},
					{
						name: "Phường Phố Cò",
					},
					{
						name: "Xã Tân Quang",
					},
					{
						name: "Phường Bách Quang",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Bá Xuyên",
					},
				],
			},
			{
				name: "Huyện Định Hóa",
				wards: [
					{
						name: "Thị trấn Chợ Chu",
					},
					{
						name: "Xã Linh Thông",
					},
					{
						name: "Xã Lam Vỹ",
					},
					{
						name: "Xã Quy Kỳ",
					},
					{
						name: "Xã Tân Thịnh",
					},
					{
						name: "Xã Kim Phượng",
					},
					{
						name: "Xã Bảo Linh",
					},
					{
						name: "Xã Phúc Chu",
					},
					{
						name: "Xã Tân Dương",
					},
					{
						name: "Xã Phượng Tiến",
					},
					{
						name: "Xã Bảo Cường",
					},
					{
						name: "Xã Đồng Thịnh",
					},
					{
						name: "Xã Định Biên",
					},
					{
						name: "Xã Thanh Định",
					},
					{
						name: "Xã Trung Hội",
					},
					{
						name: "Xã Trung Lương",
					},
					{
						name: "Xã Bình Yên",
					},
					{
						name: "Xã Điềm Mặc",
					},
					{
						name: "Xã Phú Tiến",
					},
					{
						name: "Xã Bộc Nhiêu",
					},
					{
						name: "Xã Sơn Phú",
					},
					{
						name: "Xã Phú Đình",
					},
					{
						name: "Xã Bình Thành",
					},
				],
			},
			{
				name: "Huyện Phú Lương",
				wards: [
					{
						name: "Thị trấn Giang Tiên",
					},
					{
						name: "Thị trấn Đu",
					},
					{
						name: "Xã Yên Ninh",
					},
					{
						name: "Xã Yên Trạch",
					},
					{
						name: "Xã Yên Đổ",
					},
					{
						name: "Xã Yên Lạc",
					},
					{
						name: "Xã Ôn Lương",
					},
					{
						name: "Xã Động Đạt",
					},
					{
						name: "Xã Phủ Lý",
					},
					{
						name: "Xã Phú Đô",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Tức Tranh",
					},
					{
						name: "Xã Phấn Mễ",
					},
					{
						name: "Xã Vô Tranh",
					},
					{
						name: "Xã Cổ Lũng",
					},
				],
			},
			{
				name: "Huyện Đồng Hỷ",
				wards: [
					{
						name: "Thị trấn Sông Cầu",
					},
					{
						name: "Thị trấn Trại Cau",
					},
					{
						name: "Xã Văn Lăng",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Quang Sơn",
					},
					{
						name: "Xã Minh Lập",
					},
					{
						name: "Xã Văn Hán",
					},
					{
						name: "Xã Hóa Trung",
					},
					{
						name: "Xã Khe Mo",
					},
					{
						name: "Xã Cây Thị",
					},
					{
						name: "Xã Hóa Thượng",
					},
					{
						name: "Xã Hợp Tiến",
					},
					{
						name: "Xã Tân Lợi",
					},
					{
						name: "Xã Nam Hòa",
					},
				],
			},
			{
				name: "Huyện Võ Nhai",
				wards: [
					{
						name: "Thị trấn Đình Cả",
					},
					{
						name: "Xã Sảng Mộc",
					},
					{
						name: "Xã Nghinh Tường",
					},
					{
						name: "Xã Thần Xa",
					},
					{
						name: "Xã Vũ Chấn",
					},
					{
						name: "Xã Thượng Nung",
					},
					{
						name: "Xã Phú Thượng",
					},
					{
						name: "Xã Cúc Đường",
					},
					{
						name: "Xã La Hiên",
					},
					{
						name: "Xã Lâu Thượng",
					},
					{
						name: "Xã Tràng Xá",
					},
					{
						name: "Xã Phương Giao",
					},
					{
						name: "Xã Liên Minh",
					},
					{
						name: "Xã Dân Tiến",
					},
					{
						name: "Xã Bình Long",
					},
				],
			},
			{
				name: "Huyện Đại Từ",
				wards: [
					{
						name: "Thị trấn Hùng Sơn",
					},
					{
						name: "Thị trấn Quân Chu",
					},
					{
						name: "Xã Phúc Lương",
					},
					{
						name: "Xã Minh Tiến",
					},
					{
						name: "Xã Yên Lãng",
					},
					{
						name: "Xã Đức Lương",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Na Mao",
					},
					{
						name: "Xã Phú Lạc",
					},
					{
						name: "Xã Tân Linh",
					},
					{
						name: "Xã Phú Thịnh",
					},
					{
						name: "Xã Phục Linh",
					},
					{
						name: "Xã Phú Xuyên",
					},
					{
						name: "Xã Bản Ngoại",
					},
					{
						name: "Xã Tiên Hội",
					},
					{
						name: "Xã Cù Vân",
					},
					{
						name: "Xã Hà Thượng",
					},
					{
						name: "Xã La Bằng",
					},
					{
						name: "Xã Hoàng Nông",
					},
					{
						name: "Xã Khôi Kỳ",
					},
					{
						name: "Xã An Khánh",
					},
					{
						name: "Xã Tân Thái",
					},
					{
						name: "Xã Bình Thuận",
					},
					{
						name: "Xã Lục Ba",
					},
					{
						name: "Xã Mỹ Yên",
					},
					{
						name: "Xã Vạn Thọ",
					},
					{
						name: "Xã Văn Yên",
					},
					{
						name: "Xã Ký Phú",
					},
					{
						name: "Xã Cát Nê",
					},
					{
						name: "Xã Quân Chu",
					},
				],
			},
			{
				name: "Thị xã Phổ Yên",
				wards: [
					{
						name: "Phường Bãi Bông",
					},
					{
						name: "Phường Bắc Sơn",
					},
					{
						name: "Phường Ba Hàng",
					},
					{
						name: "Xã Phúc Tân",
					},
					{
						name: "Xã Phúc Thuận",
					},
					{
						name: "Xã Hồng Tiến",
					},
					{
						name: "Xã Minh Đức",
					},
					{
						name: "Xã Đắc Sơn",
					},
					{
						name: "Phường Đồng Tiến",
					},
					{
						name: "Xã Thành Công",
					},
					{
						name: "Xã Tiên Phong",
					},
					{
						name: "Xã Vạn Phái",
					},
					{
						name: "Xã Nam Tiến",
					},
					{
						name: "Xã Tân Hương",
					},
					{
						name: "Xã Đông Cao",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Thuận Thành",
					},
				],
			},
			{
				name: "Huyện Phú Bình",
				wards: [
					{
						name: "Thị trấn Hương Sơn",
					},
					{
						name: "Xã Bàn Đạt",
					},
					{
						name: "Xã Tân Khánh",
					},
					{
						name: "Xã Tân Kim",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Đào Xá",
					},
					{
						name: "Xã Bảo Lý",
					},
					{
						name: "Xã Thượng Đình",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Nhã Lộng",
					},
					{
						name: "Xã Điềm Thụy",
					},
					{
						name: "Xã Xuân Phương",
					},
					{
						name: "Xã Tân Đức",
					},
					{
						name: "Xã Úc Kỳ",
					},
					{
						name: "Xã Lương Phú",
					},
					{
						name: "Xã Nga My",
					},
					{
						name: "Xã Kha Sơn",
					},
					{
						name: "Xã Thanh Ninh",
					},
					{
						name: "Xã Dương Thành",
					},
					{
						name: "Xã Hà Châu",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Lạng Sơn",
		districts: [
			{
				name: "Thành phố Lạng Sơn",
				wards: [
					{
						name: "Phường Hoàng Văn Thụ",
					},
					{
						name: "Phường Tam Thanh",
					},
					{
						name: "Phường Vĩnh Trại",
					},
					{
						name: "Phường Đông Kinh",
					},
					{
						name: "Phường Chi Lăng",
					},
					{
						name: "Xã Hoàng Đồng",
					},
					{
						name: "Xã Quảng Lạc",
					},
					{
						name: "Xã Mai Pha",
					},
				],
			},
			{
				name: "Huyện Tràng Định",
				wards: [
					{
						name: "Thị trấn Thất Khê",
					},
					{
						name: "Xã Khánh Long",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Quốc Khánh",
					},
					{
						name: "Xã Vĩnh Tiến",
					},
					{
						name: "Xã Cao Minh",
					},
					{
						name: "Xã Chí Minh",
					},
					{
						name: "Xã Tri Phương",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Tân Yên",
					},
					{
						name: "Xã Đội Cấn",
					},
					{
						name: "Xã Tân Minh",
					},
					{
						name: "Xã Kim Đồng",
					},
					{
						name: "Xã Chi Lăng",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Đào Viên",
					},
					{
						name: "Xã Đề Thám",
					},
					{
						name: "Xã Kháng Chiến",
					},
					{
						name: "Xã Hùng Sơn",
					},
					{
						name: "Xã Quốc Việt",
					},
					{
						name: "Xã Hùng Việt",
					},
				],
			},
			{
				name: "Huyện Bình Gia",
				wards: [
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Vĩnh Yên",
					},
					{
						name: "Xã Hoa Thám",
					},
					{
						name: "Xã Quý Hòa",
					},
					{
						name: "Xã Hồng Phong",
					},
					{
						name: "Xã Yên Lỗ",
					},
					{
						name: "Xã Thiện Hòa",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Thiện Thuật",
					},
					{
						name: "Xã Minh Khai",
					},
					{
						name: "Xã Thiện Long",
					},
					{
						name: "Xã Hoàng Văn Thụ",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Mông Ân",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Thị trấn Bình Gia",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Bình La",
					},
					{
						name: "Xã Tân Văn",
					},
				],
			},
			{
				name: "Huyện Văn Lãng",
				wards: [
					{
						name: "Thị trấn Na Sầm",
					},
					{
						name: "Xã Trùng Khánh",
					},
					{
						name: "Xã Bắc La",
					},
					{
						name: "Xã Thụy Hùng",
					},
					{
						name: "Xã Bắc Hùng",
					},
					{
						name: "Xã Tân Tác",
					},
					{
						name: "Xã Thanh Long",
					},
					{
						name: "Xã Hội Hoan",
					},
					{
						name: "Xã Bắc Việt",
					},
					{
						name: "Xã Hoàng Việt",
					},
					{
						name: "Xã Gia Miễn",
					},
					{
						name: "Xã Thành Hòa",
					},
					{
						name: "Xã Tân Thanh",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Hoàng Văn Thụ",
					},
					{
						name: "Xã Nhạc Kỳ",
					},
				],
			},
			{
				name: "Huyện Cao Lộc",
				wards: [
					{
						name: "Thị trấn Đồng Đăng",
					},
					{
						name: "Thị trấn Cao Lộc",
					},
					{
						name: "Xã Bảo Lâm",
					},
					{
						name: "Xã Thanh Lòa",
					},
					{
						name: "Xã Cao Lâu",
					},
					{
						name: "Xã Thạch Đạn",
					},
					{
						name: "Xã Xuất Lễ",
					},
					{
						name: "Xã Hồng Phong",
					},
					{
						name: "Xã Thụy Hùng",
					},
					{
						name: "Xã Lộc Yên",
					},
					{
						name: "Xã Phú Xá",
					},
					{
						name: "Xã Bình Trung",
					},
					{
						name: "Xã Hải Yến",
					},
					{
						name: "Xã Hòa Cư",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Công Sơn",
					},
					{
						name: "Xã Gia Cát",
					},
					{
						name: "Xã Mẫu Sơn",
					},
					{
						name: "Xã Xuân Long",
					},
					{
						name: "Xã Tân Liên",
					},
					{
						name: "Xã Yên Trạch",
					},
					{
						name: "Xã Tân Thành",
					},
				],
			},
			{
				name: "Huyện Văn Quan",
				wards: [
					{
						name: "Thị trấn Văn Quan",
					},
					{
						name: "Xã Trấn Ninh",
					},
					{
						name: "Xã Liên Hội",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Tú Xuyên",
					},
					{
						name: "Xã Điềm He",
					},
					{
						name: "Xã An Sơn",
					},
					{
						name: "Xã Khánh Khê",
					},
					{
						name: "Xã Lương Năng",
					},
					{
						name: "Xã Đồng Giáp",
					},
					{
						name: "Xã Bình Phúc",
					},
					{
						name: "Xã Tràng Các",
					},
					{
						name: "Xã Tân Đoàn",
					},
					{
						name: "Xã Tri Lễ",
					},
					{
						name: "Xã Tràng Phái",
					},
					{
						name: "Xã Yên Phúc",
					},
					{
						name: "Xã Hữu Lễ",
					},
				],
			},
			{
				name: "Huyện Bắc Sơn",
				wards: [
					{
						name: "Thị trấn Bắc Sơn",
					},
					{
						name: "Xã Long Đống",
					},
					{
						name: "Xã Vạn Thủy",
					},
					{
						name: "Xã Đồng ý",
					},
					{
						name: "Xã Tân Tri",
					},
					{
						name: "Xã Bắc Quỳnh",
					},
					{
						name: "Xã Hưng Vũ",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Vũ Sơn",
					},
					{
						name: "Xã Chiêu Vũ",
					},
					{
						name: "Xã Tân Hương",
					},
					{
						name: "Xã Chiến Thắng",
					},
					{
						name: "Xã Vũ Lăng",
					},
					{
						name: "Xã Trấn Yên",
					},
					{
						name: "Xã Vũ Lễ",
					},
					{
						name: "Xã Nhất Hòa",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Nhất Tiến",
					},
				],
			},
			{
				name: "Huyện Hữu Lũng",
				wards: [
					{
						name: "Thị trấn Hữu Lũng",
					},
					{
						name: "Xã Hữu Liên",
					},
					{
						name: "Xã Yên Bình",
					},
					{
						name: "Xã Quyết Thắng",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Yên Thịnh",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Thiện Tân",
					},
					{
						name: "Xã Yên Vượng",
					},
					{
						name: "Xã Minh Tiến",
					},
					{
						name: "Xã Nhật Tiến",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Đồng Tân",
					},
					{
						name: "Xã Cai Kinh",
					},
					{
						name: "Xã Hòa Lạc",
					},
					{
						name: "Xã Vân Nham",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Xã Minh Sơn",
					},
					{
						name: "Xã Hồ Sơn",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Minh Hòa",
					},
					{
						name: "Xã Hòa Thắng",
					},
				],
			},
			{
				name: "Huyện Chi Lăng",
				wards: [
					{
						name: "Thị trấn Đồng Mỏ",
					},
					{
						name: "Thị trấn Chi Lăng",
					},
					{
						name: "Xã Vân An",
					},
					{
						name: "Xã Vân Thủy",
					},
					{
						name: "Xã Gia Lộc",
					},
					{
						name: "Xã Bắc Thủy",
					},
					{
						name: "Xã Chiến Thắng",
					},
					{
						name: "Xã Mai Sao",
					},
					{
						name: "Xã Bằng Hữu",
					},
					{
						name: "Xã Thượng Cường",
					},
					{
						name: "Xã Bằng Mạc",
					},
					{
						name: "Xã Nhân Lý",
					},
					{
						name: "Xã Lâm Sơn",
					},
					{
						name: "Xã Liên Sơn",
					},
					{
						name: "Xã Vạn Linh",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Hữu Kiên",
					},
					{
						name: "Xã Quan Sơn",
					},
					{
						name: "Xã Y Tịch",
					},
					{
						name: "Xã Chi Lăng",
					},
				],
			},
			{
				name: "Huyện Lộc Bình",
				wards: [
					{
						name: "Thị trấn Na Dương",
					},
					{
						name: "Thị trấn Lộc Bình",
					},
					{
						name: "Xã Mẫu Sơn",
					},
					{
						name: "Xã Yên Khoái",
					},
					{
						name: "Xã Khánh Xuân",
					},
					{
						name: "Xã Tú Mịch",
					},
					{
						name: "Xã Hữu Khánh",
					},
					{
						name: "Xã Đồng Bục",
					},
					{
						name: "Xã Tam Gia",
					},
					{
						name: "Xã Tú Đoạn",
					},
					{
						name: "Xã Khuất Xá",
					},
					{
						name: "Xã Tĩnh Bắc",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Sàn Viên",
					},
					{
						name: "Xã Đông Quan",
					},
					{
						name: "Xã Minh Hiệp",
					},
					{
						name: "Xã Hữu Lân",
					},
					{
						name: "Xã Lợi Bác",
					},
					{
						name: "Xã Nam Quan",
					},
					{
						name: "Xã Xuân Dương",
					},
					{
						name: "Xã Ái Quốc",
					},
				],
			},
			{
				name: "Huyện Đình Lập",
				wards: [
					{
						name: "Thị trấn Đình Lập",
					},
					{
						name: "Thị trấn NT Thái Bình",
					},
					{
						name: "Xã Bắc Xa",
					},
					{
						name: "Xã Bính Xá",
					},
					{
						name: "Xã Kiên Mộc",
					},
					{
						name: "Xã Đình Lập",
					},
					{
						name: "Xã Thái Bình",
					},
					{
						name: "Xã Cường Lợi",
					},
					{
						name: "Xã Châu Sơn",
					},
					{
						name: "Xã Lâm Ca",
					},
					{
						name: "Xã Đồng Thắng",
					},
					{
						name: "Xã Bắc Lãng",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Quảng Ninh",
		districts: [
			{
				name: "Thành phố Hạ Long",
				wards: [
					{
						name: "Phường Hà Khánh",
					},
					{
						name: "Phường Hà Phong",
					},
					{
						name: "Phường Hà Khẩu",
					},
					{
						name: "Phường Cao Xanh",
					},
					{
						name: "Phường Giếng Đáy",
					},
					{
						name: "Phường Hà Tu",
					},
					{
						name: "Phường Hà Trung",
					},
					{
						name: "Phường Hà Lầm",
					},
					{
						name: "Phường Bãi Cháy",
					},
					{
						name: "Phường Cao Thắng",
					},
					{
						name: "Phường Hùng Thắng",
					},
					{
						name: "Phường Yết Kiêu",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Hồng Hải",
					},
					{
						name: "Phường Hồng Gai",
					},
					{
						name: "Phường Bạch Đằng",
					},
					{
						name: "Phường Hồng Hà",
					},
					{
						name: "Phường Tuần Châu",
					},
					{
						name: "Phường Việt Hưng",
					},
					{
						name: "Phường Đại Yên",
					},
					{
						name: "Phường Hoành Bồ",
					},
					{
						name: "Xã Kỳ Thượng",
					},
					{
						name: "Xã Đồng Sơn",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã Đồng Lâm",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Vũ Oai",
					},
					{
						name: "Xã Dân Chủ",
					},
					{
						name: "Xã Quảng La",
					},
					{
						name: "Xã Bằng Cả",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Sơn Dương",
					},
					{
						name: "Xã Lê Lợi",
					},
				],
			},
			{
				name: "Thành phố Móng Cái",
				wards: [
					{
						name: "Phường Ka Long",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Ninh Dương",
					},
					{
						name: "Phường Hoà Lạc",
					},
					{
						name: "Phường Trà Cổ",
					},
					{
						name: "Xã Hải Sơn",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Hải Đông",
					},
					{
						name: "Xã Hải Tiến",
					},
					{
						name: "Phường Hải Yên",
					},
					{
						name: "Xã Quảng Nghĩa",
					},
					{
						name: "Phường Hải Hoà",
					},
					{
						name: "Xã Hải Xuân",
					},
					{
						name: "Xã Vạn Ninh",
					},
					{
						name: "Phường Bình Ngọc",
					},
					{
						name: "Xã Vĩnh Trung",
					},
					{
						name: "Xã Vĩnh Thực",
					},
				],
			},
			{
				name: "Thành phố Cẩm Phả",
				wards: [
					{
						name: "Phường Mông Dương",
					},
					{
						name: "Phường Cửa Ông",
					},
					{
						name: "Phường Cẩm Sơn",
					},
					{
						name: "Phường Cẩm Đông",
					},
					{
						name: "Phường Cẩm Phú",
					},
					{
						name: "Phường Cẩm Tây",
					},
					{
						name: "Phường Quang Hanh",
					},
					{
						name: "Phường Cẩm Thịnh",
					},
					{
						name: "Phường Cẩm Thủy",
					},
					{
						name: "Phường Cẩm Thạch",
					},
					{
						name: "Phường Cẩm Thành",
					},
					{
						name: "Phường Cẩm Trung",
					},
					{
						name: "Phường Cẩm Bình",
					},
					{
						name: "Xã Cộng Hòa",
					},
					{
						name: "Xã Cẩm Hải",
					},
					{
						name: "Xã Dương Huy",
					},
				],
			},
			{
				name: "Thành phố Uông Bí",
				wards: [
					{
						name: "Phường Vàng Danh",
					},
					{
						name: "Phường Thanh Sơn",
					},
					{
						name: "Phường Bắc Sơn",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Trưng Vương",
					},
					{
						name: "Phường Nam Khê",
					},
					{
						name: "Phường Yên Thanh",
					},
					{
						name: "Xã Thượng Yên Công",
					},
					{
						name: "Phường Phương Đông",
					},
					{
						name: "Phường Phương Nam",
					},
				],
			},
			{
				name: "Huyện Bình Liêu",
				wards: [
					{
						name: "Thị trấn Bình Liêu",
					},
					{
						name: "Xã Hoành Mô",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Đồng Văn",
					},
					{
						name: "Xã Vô Ngại",
					},
					{
						name: "Xã Lục Hồn",
					},
					{
						name: "Xã Húc Động",
					},
				],
			},
			{
				name: "Huyện Tiên Yên",
				wards: [
					{
						name: "Thị trấn Tiên Yên",
					},
					{
						name: "Xã Hà Lâu",
					},
					{
						name: "Xã Đại Dực",
					},
					{
						name: "Xã Phong Dụ",
					},
					{
						name: "Xã Điền Xá",
					},
					{
						name: "Xã Đông Ngũ",
					},
					{
						name: "Xã Yên Than",
					},
					{
						name: "Xã Đông Hải",
					},
					{
						name: "Xã Hải Lạng",
					},
					{
						name: "Xã Tiên Lãng",
					},
					{
						name: "Xã Đồng Rui",
					},
				],
			},
			{
				name: "Huyện Đầm Hà",
				wards: [
					{
						name: "Thị trấn Đầm Hà",
					},
					{
						name: "Xã Quảng Lâm",
					},
					{
						name: "Xã Quảng An",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Dực Yên",
					},
					{
						name: "Xã Quảng Tân",
					},
					{
						name: "Xã Đầm Hà",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Đại Bình",
					},
				],
			},
			{
				name: "Huyện Hải Hà",
				wards: [
					{
						name: "Thị trấn Quảng Hà",
					},
					{
						name: "Xã Quảng Đức",
					},
					{
						name: "Xã Quảng Sơn",
					},
					{
						name: "Xã Quảng Thành",
					},
					{
						name: "Xã Quảng Thịnh",
					},
					{
						name: "Xã Quảng Minh",
					},
					{
						name: "Xã Quảng Chính",
					},
					{
						name: "Xã Quảng Long",
					},
					{
						name: "Xã Đường Hoa",
					},
					{
						name: "Xã Quảng Phong",
					},
					{
						name: "Xã Cái Chiên",
					},
				],
			},
			{
				name: "Huyện Ba Chẽ",
				wards: [
					{
						name: "Thị trấn Ba Chẽ",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Thanh Lâm",
					},
					{
						name: "Xã Đạp Thanh",
					},
					{
						name: "Xã Nam Sơn",
					},
					{
						name: "Xã Lương Mông",
					},
					{
						name: "Xã Đồn Đạc",
					},
					{
						name: "Xã Minh Cầm",
					},
				],
			},
			{
				name: "Huyện Vân Đồn",
				wards: [
					{
						name: "Thị trấn Cái Rồng",
					},
					{
						name: "Xã Đài Xuyên",
					},
					{
						name: "Xã Bình Dân",
					},
					{
						name: "Xã Vạn Yên",
					},
					{
						name: "Xã Minh Châu",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Hạ Long",
					},
					{
						name: "Xã Đông Xá",
					},
					{
						name: "Xã Bản Sen",
					},
					{
						name: "Xã Thắng Lợi",
					},
					{
						name: "Xã Quan Lạn",
					},
					{
						name: "Xã Ngọc Vừng",
					},
				],
			},
			{
				name: "Thị xã Đông Triều",
				wards: [
					{
						name: "Phường Mạo Khê",
					},
					{
						name: "Phường Đông Triều",
					},
					{
						name: "Xã An Sinh",
					},
					{
						name: "Xã Tràng Lương",
					},
					{
						name: "Xã Bình Khê",
					},
					{
						name: "Xã Việt Dân",
					},
					{
						name: "Xã Tân Việt",
					},
					{
						name: "Xã Bình Dương",
					},
					{
						name: "Phường Đức Chính",
					},
					{
						name: "Phường Tràng An",
					},
					{
						name: "Xã Nguyễn Huệ",
					},
					{
						name: "Xã Thủy An",
					},
					{
						name: "Phường Xuân Sơn",
					},
					{
						name: "Xã Hồng Thái Tây",
					},
					{
						name: "Xã Hồng Thái Đông",
					},
					{
						name: "Phường Hoàng Quế",
					},
					{
						name: "Phường Yên Thọ",
					},
					{
						name: "Phường Hồng Phong",
					},
					{
						name: "Phường Kim Sơn",
					},
					{
						name: "Phường Hưng Đạo",
					},
					{
						name: "Xã Yên Đức",
					},
				],
			},
			{
				name: "Thị xã Quảng Yên",
				wards: [
					{
						name: "Phường Quảng Yên",
					},
					{
						name: "Phường Đông Mai",
					},
					{
						name: "Phường Minh Thành",
					},
					{
						name: "Xã Sông Khoai",
					},
					{
						name: "Xã Hiệp Hòa",
					},
					{
						name: "Phường Cộng Hòa",
					},
					{
						name: "Xã Tiền An",
					},
					{
						name: "Xã Hoàng Tân",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường Yên Giang",
					},
					{
						name: "Phường Nam Hoà",
					},
					{
						name: "Phường Hà An",
					},
					{
						name: "Xã Cẩm La",
					},
					{
						name: "Phường Phong Hải",
					},
					{
						name: "Phường Yên Hải",
					},
					{
						name: "Xã Liên Hòa",
					},
					{
						name: "Phường Phong Cốc",
					},
					{
						name: "Xã Liên Vị",
					},
					{
						name: "Xã Tiền Phong",
					},
				],
			},
			{
				name: "Huyện Cô Tô",
				wards: [
					{
						name: "Thị trấn Cô Tô",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Thanh Lân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bắc Giang",
		districts: [
			{
				name: "Thành phố Bắc Giang",
				wards: [
					{
						name: "Phường Thọ Xương",
					},
					{
						name: "Phường Trần Nguyên Hãn",
					},
					{
						name: "Phường Ngô Quyền",
					},
					{
						name: "Phường Hoàng Văn Thụ",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Mỹ Độ",
					},
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Xã Song Mai",
					},
					{
						name: "Phường Xương Giang",
					},
					{
						name: "Phường Đa Mai",
					},
					{
						name: "Phường Dĩnh Kế",
					},
					{
						name: "Xã Dĩnh Trì",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Đồng Sơn",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Song Khê",
					},
				],
			},
			{
				name: "Huyện Yên Thế",
				wards: [
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Canh Nậu",
					},
					{
						name: "Xã Xuân Lương",
					},
					{
						name: "Xã Tam Tiến",
					},
					{
						name: "Xã Đồng Vương",
					},
					{
						name: "Xã Đồng Hưu",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Tam Hiệp",
					},
					{
						name: "Xã Tiến Thắng",
					},
					{
						name: "Xã Hồng Kỳ",
					},
					{
						name: "Xã Đồng Lạc",
					},
					{
						name: "Xã Đông Sơn",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Hương Vĩ",
					},
					{
						name: "Xã Đồng Kỳ",
					},
					{
						name: "Xã An Thượng",
					},
					{
						name: "Thị trấn Phồn Xương",
					},
					{
						name: "Xã Tân Sỏi",
					},
					{
						name: "Thị trấn Bố Hạ",
					},
				],
			},
			{
				name: "Huyện Tân Yên",
				wards: [
					{
						name: "Xã Lan Giới",
					},
					{
						name: "Thị trấn Nhã Nam",
					},
					{
						name: "Xã Tân Trung",
					},
					{
						name: "Xã Đại Hóa",
					},
					{
						name: "Xã Quang Tiến",
					},
					{
						name: "Xã Phúc Sơn",
					},
					{
						name: "Xã An Dương",
					},
					{
						name: "Xã Phúc Hòa",
					},
					{
						name: "Xã Liên Sơn",
					},
					{
						name: "Xã Hợp Đức",
					},
					{
						name: "Xã Lam Cốt",
					},
					{
						name: "Xã Cao Xá",
					},
					{
						name: "Thị trấn Cao Thượng",
					},
					{
						name: "Xã Việt Ngọc",
					},
					{
						name: "Xã Song Vân",
					},
					{
						name: "Xã Ngọc Châu",
					},
					{
						name: "Xã Ngọc Vân",
					},
					{
						name: "Xã Việt Lập",
					},
					{
						name: "Xã Liên Chung",
					},
					{
						name: "Xã Ngọc Thiện",
					},
					{
						name: "Xã Ngọc Lý",
					},
					{
						name: "Xã Quế Nham",
					},
				],
			},
			{
				name: "Huyện Lạng Giang",
				wards: [
					{
						name: "Thị trấn Vôi",
					},
					{
						name: "Xã Nghĩa Hòa",
					},
					{
						name: "Xã Nghĩa Hưng",
					},
					{
						name: "Xã Quang Thịnh",
					},
					{
						name: "Xã Hương Sơn",
					},
					{
						name: "Xã Đào Mỹ",
					},
					{
						name: "Xã Tiên Lục",
					},
					{
						name: "Xã An Hà",
					},
					{
						name: "Thị trấn Kép",
					},
					{
						name: "Xã Mỹ Hà",
					},
					{
						name: "Xã Hương Lạc",
					},
					{
						name: "Xã Dương Đức",
					},
					{
						name: "Xã Tân Thanh",
					},
					{
						name: "Xã Yên Mỹ",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Mỹ Thái",
					},
					{
						name: "Xã Xương Lâm",
					},
					{
						name: "Xã Xuân Hương",
					},
					{
						name: "Xã Tân Dĩnh",
					},
					{
						name: "Xã Đại Lâm",
					},
					{
						name: "Xã Thái Đào",
					},
				],
			},
			{
				name: "Huyện Lục Nam",
				wards: [
					{
						name: "Thị trấn Đồi Ngô",
					},
					{
						name: "Xã Đông Hưng",
					},
					{
						name: "Xã Đông Phú",
					},
					{
						name: "Xã Tam Dị",
					},
					{
						name: "Xã Bảo Sơn",
					},
					{
						name: "Xã Bảo Đài",
					},
					{
						name: "Xã Thanh Lâm",
					},
					{
						name: "Xã Tiên Nha",
					},
					{
						name: "Xã Trường Giang",
					},
					{
						name: "Xã Phương Sơn",
					},
					{
						name: "Xã Chu Điện",
					},
					{
						name: "Xã Cương Sơn",
					},
					{
						name: "Xã Nghĩa Phương",
					},
					{
						name: "Xã Vô Tranh",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Lan Mẫu",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Khám Lạng",
					},
					{
						name: "Xã Huyền Sơn",
					},
					{
						name: "Xã Trường Sơn",
					},
					{
						name: "Xã Lục Sơn",
					},
					{
						name: "Xã Bắc Lũng",
					},
					{
						name: "Xã Vũ Xá",
					},
					{
						name: "Xã Cẩm Lý",
					},
					{
						name: "Xã Đan Hội",
					},
				],
			},
			{
				name: "Huyện Lục Ngạn",
				wards: [
					{
						name: "Thị trấn Chũ",
					},
					{
						name: "Xã Cấm Sơn",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Phong Minh",
					},
					{
						name: "Xã Phong Vân",
					},
					{
						name: "Xã Xa Lý",
					},
					{
						name: "Xã Hộ Đáp",
					},
					{
						name: "Xã Sơn Hải",
					},
					{
						name: "Xã Thanh Hải",
					},
					{
						name: "Xã Kiên Lao",
					},
					{
						name: "Xã Biên Sơn",
					},
					{
						name: "Xã Kiên Thành",
					},
					{
						name: "Xã Hồng Giang",
					},
					{
						name: "Xã Kim Sơn",
					},
					{
						name: "Xã Tân Hoa",
					},
					{
						name: "Xã Giáp Sơn",
					},
					{
						name: "Xã Biển Động",
					},
					{
						name: "Xã Quý Sơn",
					},
					{
						name: "Xã Trù Hựu",
					},
					{
						name: "Xã Phì Điền",
					},
					{
						name: "Xã Tân Quang",
					},
					{
						name: "Xã Đồng Cốc",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Phú Nhuận",
					},
					{
						name: "Xã Mỹ An",
					},
					{
						name: "Xã Nam Dương",
					},
					{
						name: "Xã Tân Mộc",
					},
					{
						name: "Xã Đèo Gia",
					},
					{
						name: "Xã Phượng Sơn",
					},
				],
			},
			{
				name: "Huyện Sơn Động",
				wards: [
					{
						name: "Thị trấn An Châu",
					},
					{
						name: "Thị trấn Tây Yên Tử",
					},
					{
						name: "Xã Vân Sơn",
					},
					{
						name: "Xã Hữu Sản",
					},
					{
						name: "Xã Đại Sơn",
					},
					{
						name: "Xã Phúc Sơn",
					},
					{
						name: "Xã Giáo Liêm",
					},
					{
						name: "Xã Cẩm Đàn",
					},
					{
						name: "Xã An Lạc",
					},
					{
						name: "Xã Vĩnh An",
					},
					{
						name: "Xã Yên Định",
					},
					{
						name: "Xã Lệ Viễn",
					},
					{
						name: "Xã An Bá",
					},
					{
						name: "Xã Tuấn Đạo",
					},
					{
						name: "Xã Dương Hưu",
					},
					{
						name: "Xã Long Sơn",
					},
					{
						name: "Xã Thanh Luận",
					},
				],
			},
			{
				name: "Huyện Yên Dũng",
				wards: [
					{
						name: "Thị trấn Nham Biền",
					},
					{
						name: "Thị trấn Tân An",
					},
					{
						name: "Xã Lão Hộ",
					},
					{
						name: "Xã Hương Gián",
					},
					{
						name: "Xã Quỳnh Sơn",
					},
					{
						name: "Xã Nội Hoàng",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Xuân Phú",
					},
					{
						name: "Xã Tân Liễu",
					},
					{
						name: "Xã Trí Yên",
					},
					{
						name: "Xã Lãng Sơn",
					},
					{
						name: "Xã Yên Lư",
					},
					{
						name: "Xã Tiến Dũng",
					},
					{
						name: "Xã Đức Giang",
					},
					{
						name: "Xã Cảnh Thụy",
					},
					{
						name: "Xã Tư Mại",
					},
					{
						name: "Xã Đồng Việt",
					},
					{
						name: "Xã Đồng Phúc",
					},
				],
			},
			{
				name: "Huyện Việt Yên",
				wards: [
					{
						name: "Xã Thượng Lan",
					},
					{
						name: "Xã Việt Tiến",
					},
					{
						name: "Xã Nghĩa Trung",
					},
					{
						name: "Xã Minh Đức",
					},
					{
						name: "Xã Hương Mai",
					},
					{
						name: "Xã Tự Lạn",
					},
					{
						name: "Thị trấn Bích Động",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Tiên Sơn",
					},
					{
						name: "Xã Tăng Tiến",
					},
					{
						name: "Xã Quảng Minh",
					},
					{
						name: "Thị trấn Nếnh",
					},
					{
						name: "Xã Ninh Sơn",
					},
					{
						name: "Xã Vân Trung",
					},
					{
						name: "Xã Vân Hà",
					},
					{
						name: "Xã Quang Châu",
					},
				],
			},
			{
				name: "Huyện Hiệp Hòa",
				wards: [
					{
						name: "Xã Đồng Tân",
					},
					{
						name: "Xã Thanh Vân",
					},
					{
						name: "Xã Hoàng Lương",
					},
					{
						name: "Xã Hoàng Vân",
					},
					{
						name: "Xã Hoàng Thanh",
					},
					{
						name: "Xã Hoàng An",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Thái Sơn",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Thị trấn Thắng",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Lương Phong",
					},
					{
						name: "Xã Hùng Sơn",
					},
					{
						name: "Xã Đại Thành",
					},
					{
						name: "Xã Thường Thắng",
					},
					{
						name: "Xã Hợp Thịnh",
					},
					{
						name: "Xã Danh Thắng",
					},
					{
						name: "Xã Mai Trung",
					},
					{
						name: "Xã Đoan Bái",
					},
					{
						name: "Xã Bắc Lý",
					},
					{
						name: "Xã Xuân Cẩm",
					},
					{
						name: "Xã Hương Lâm",
					},
					{
						name: "Xã Đông Lỗ",
					},
					{
						name: "Xã Châu Minh",
					},
					{
						name: "Xã Mai Đình",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Phú Thọ",
		districts: [
			{
				name: "Thành phố Việt Trì",
				wards: [
					{
						name: "Phường Dữu Lâu",
					},
					{
						name: "Phường Vân Cơ",
					},
					{
						name: "Phường Nông Trang",
					},
					{
						name: "Phường Tân Dân",
					},
					{
						name: "Phường Gia Cẩm",
					},
					{
						name: "Phường Tiên Cát",
					},
					{
						name: "Phường Thọ Sơn",
					},
					{
						name: "Phường Thanh Miếu",
					},
					{
						name: "Phường Bạch Hạc",
					},
					{
						name: "Phường Bến Gót",
					},
					{
						name: "Phường Vân Phú",
					},
					{
						name: "Xã Phượng Lâu",
					},
					{
						name: "Xã Thụy Vân",
					},
					{
						name: "Phường Minh Phương",
					},
					{
						name: "Xã Trưng Vương",
					},
					{
						name: "Phường Minh Nông",
					},
					{
						name: "Xã Sông Lô",
					},
					{
						name: "Xã Kim Đức",
					},
					{
						name: "Xã Hùng Lô",
					},
					{
						name: "Xã Hy Cương",
					},
					{
						name: "Xã Chu Hóa",
					},
					{
						name: "Xã Thanh Đình",
					},
				],
			},
			{
				name: "Thị xã Phú Thọ",
				wards: [
					{
						name: "Phường Hùng Vương",
					},
					{
						name: "Phường Phong Châu",
					},
					{
						name: "Phường Âu Cơ",
					},
					{
						name: "Xã Hà Lộc",
					},
					{
						name: "Xã Phú Hộ",
					},
					{
						name: "Xã Văn Lung",
					},
					{
						name: "Xã Thanh Minh",
					},
					{
						name: "Xã Hà Thạch",
					},
					{
						name: "Phường Thanh Vinh",
					},
				],
			},
			{
				name: "Huyện Đoan Hùng",
				wards: [
					{
						name: "Thị trấn Đoan Hùng",
					},
					{
						name: "Xã Hùng Xuyên",
					},
					{
						name: "Xã Bằng Luân",
					},
					{
						name: "Xã Vân Du",
					},
					{
						name: "Xã Phú Lâm",
					},
					{
						name: "Xã Minh Lương",
					},
					{
						name: "Xã Bằng Doãn",
					},
					{
						name: "Xã Chí Đám",
					},
					{
						name: "Xã Phúc Lai",
					},
					{
						name: "Xã Ngọc Quan",
					},
					{
						name: "Xã Hợp Nhất",
					},
					{
						name: "Xã Sóc Đăng",
					},
					{
						name: "Xã Tây Cốc",
					},
					{
						name: "Xã Yên Kiện",
					},
					{
						name: "Xã Hùng Long",
					},
					{
						name: "Xã Vụ Quang",
					},
					{
						name: "Xã Vân Đồn",
					},
					{
						name: "Xã Tiêu Sơn",
					},
					{
						name: "Xã Minh Tiến",
					},
					{
						name: "Xã Minh Phú",
					},
					{
						name: "Xã Chân Mộng",
					},
					{
						name: "Xã Ca Đình",
					},
				],
			},
			{
				name: "Huyện Hạ Hoà",
				wards: [
					{
						name: "Thị trấn Hạ Hoà",
					},
					{
						name: "Xã Đại Phạm",
					},
					{
						name: "Xã Đan Thượng",
					},
					{
						name: "Xã Hà Lương",
					},
					{
						name: "Xã Tứ Hiệp",
					},
					{
						name: "Xã Hiền Lương",
					},
					{
						name: "Xã Phương Viên",
					},
					{
						name: "Xã Gia Điền",
					},
					{
						name: "Xã Ấm Hạ",
					},
					{
						name: "Xã Hương Xạ",
					},
					{
						name: "Xã Xuân Áng",
					},
					{
						name: "Xã Yên Kỳ",
					},
					{
						name: "Xã Minh Hạc",
					},
					{
						name: "Xã Lang Sơn",
					},
					{
						name: "Xã Bằng Giã",
					},
					{
						name: "Xã Yên Luật",
					},
					{
						name: "Xã Vô Tranh",
					},
					{
						name: "Xã Văn Lang",
					},
					{
						name: "Xã Minh Côi",
					},
					{
						name: "Xã Vĩnh Chân",
					},
				],
			},
			{
				name: "Huyện Thanh Ba",
				wards: [
					{
						name: "Thị trấn Thanh Ba",
					},
					{
						name: "Xã Vân Lĩnh",
					},
					{
						name: "Xã Đông Lĩnh",
					},
					{
						name: "Xã Đại An",
					},
					{
						name: "Xã Hanh Cù",
					},
					{
						name: "Xã Đồng Xuân",
					},
					{
						name: "Xã Quảng Yên",
					},
					{
						name: "Xã Ninh Dân",
					},
					{
						name: "Xã Võ Lao",
					},
					{
						name: "Xã Khải Xuân",
					},
					{
						name: "Xã Mạn Lạn",
					},
					{
						name: "Xã Hoàng Cương",
					},
					{
						name: "Xã Chí Tiên",
					},
					{
						name: "Xã Đông Thành",
					},
					{
						name: "Xã Sơn Cương",
					},
					{
						name: "Xã Thanh Hà",
					},
					{
						name: "Xã Đỗ Sơn",
					},
					{
						name: "Xã Đỗ Xuyên",
					},
					{
						name: "Xã Lương Lỗ",
					},
				],
			},
			{
				name: "Huyện Phù Ninh",
				wards: [
					{
						name: "Thị trấn Phong Châu",
					},
					{
						name: "Xã Phú Mỹ",
					},
					{
						name: "Xã Lệ Mỹ",
					},
					{
						name: "Xã Liên Hoa",
					},
					{
						name: "Xã Trạm Thản",
					},
					{
						name: "Xã Trị Quận",
					},
					{
						name: "Xã Trung Giáp",
					},
					{
						name: "Xã Tiên Phú",
					},
					{
						name: "Xã Hạ Giáp",
					},
					{
						name: "Xã Bảo Thanh",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Gia Thanh",
					},
					{
						name: "Xã Tiên Du",
					},
					{
						name: "Xã Phú Nham",
					},
					{
						name: "Xã An Đạo",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Phù Ninh",
					},
				],
			},
			{
				name: "Huyện Yên Lập",
				wards: [
					{
						name: "Thị trấn Yên Lập",
					},
					{
						name: "Xã Mỹ Lung",
					},
					{
						name: "Xã Mỹ Lương",
					},
					{
						name: "Xã Lương Sơn",
					},
					{
						name: "Xã Xuân An",
					},
					{
						name: "Xã Xuân Viên",
					},
					{
						name: "Xã Xuân Thủy",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Hưng Long",
					},
					{
						name: "Xã Nga Hoàng",
					},
					{
						name: "Xã Đồng Lạc",
					},
					{
						name: "Xã Thượng Long",
					},
					{
						name: "Xã Đồng Thịnh",
					},
					{
						name: "Xã Phúc Khánh",
					},
					{
						name: "Xã Minh Hòa",
					},
					{
						name: "Xã Ngọc Lập",
					},
					{
						name: "Xã Ngọc Đồng",
					},
				],
			},
			{
				name: "Huyện Cẩm Khê",
				wards: [
					{
						name: "Thị trấn Cẩm Khê",
					},
					{
						name: "Xã Tiên Lương",
					},
					{
						name: "Xã Tuy Lộc",
					},
					{
						name: "Xã Ngô Xá",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Phượng Vĩ",
					},
					{
						name: "Xã Thụy Liễu",
					},
					{
						name: "Xã Tùng Khê",
					},
					{
						name: "Xã Tam Sơn",
					},
					{
						name: "Xã Văn Bán",
					},
					{
						name: "Xã Cấp Dẫn",
					},
					{
						name: "Xã Xương Thịnh",
					},
					{
						name: "Xã Phú Khê",
					},
					{
						name: "Xã Sơn Tình",
					},
					{
						name: "Xã Yên Tập",
					},
					{
						name: "Xã Hương Lung",
					},
					{
						name: "Xã Tạ Xá",
					},
					{
						name: "Xã Phú Lạc",
					},
					{
						name: "Xã Chương Xá",
					},
					{
						name: "Xã Hùng Việt",
					},
					{
						name: "Xã Văn Khúc",
					},
					{
						name: "Xã Yên Dưỡng",
					},
					{
						name: "Xã Điêu Lương",
					},
					{
						name: "Xã Đồng Lương",
					},
				],
			},
			{
				name: "Huyện Tam Nông",
				wards: [
					{
						name: "Thị trấn Hưng Hoá",
					},
					{
						name: "Xã Hiền Quan",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Thanh Uyên",
					},
					{
						name: "Xã Lam Sơn",
					},
					{
						name: "Xã Vạn Xuân",
					},
					{
						name: "Xã Quang Húc",
					},
					{
						name: "Xã Hương Nộn",
					},
					{
						name: "Xã Tề Lễ",
					},
					{
						name: "Xã Thọ Văn",
					},
					{
						name: "Xã Dị Nậu",
					},
					{
						name: "Xã Dân Quyền",
					},
				],
			},
			{
				name: "Huyện Lâm Thao",
				wards: [
					{
						name: "Thị trấn Lâm Thao",
					},
					{
						name: "Xã Tiên Kiên",
					},
					{
						name: "Thị trấn Hùng Sơn",
					},
					{
						name: "Xã Xuân Lũng",
					},
					{
						name: "Xã Xuân Huy",
					},
					{
						name: "Xã Thạch Sơn",
					},
					{
						name: "Xã Sơn Vi",
					},
					{
						name: "Xã Phùng Nguyên",
					},
					{
						name: "Xã Cao Xá",
					},
					{
						name: "Xã Vĩnh Lại",
					},
					{
						name: "Xã Tứ Xã",
					},
					{
						name: "Xã Bản Nguyên",
					},
				],
			},
			{
				name: "Huyện Thanh Sơn",
				wards: [
					{
						name: "Thị trấn Thanh Sơn",
					},
					{
						name: "Xã Sơn Hùng",
					},
					{
						name: "Xã Địch Quả",
					},
					{
						name: "Xã Giáp Lai",
					},
					{
						name: "Xã Thục Luyện",
					},
					{
						name: "Xã Võ Miếu",
					},
					{
						name: "Xã Thạch Khoán",
					},
					{
						name: "Xã Cự Thắng",
					},
					{
						name: "Xã Tất Thắng",
					},
					{
						name: "Xã Văn Miếu",
					},
					{
						name: "Xã Cự Đồng",
					},
					{
						name: "Xã Thắng Sơn",
					},
					{
						name: "Xã Tân Minh",
					},
					{
						name: "Xã Hương Cần",
					},
					{
						name: "Xã Khả Cửu",
					},
					{
						name: "Xã Đông Cửu",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Yên Lãng",
					},
					{
						name: "Xã Yên Lương",
					},
					{
						name: "Xã Thượng Cửu",
					},
					{
						name: "Xã Lương Nha",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Tinh Nhuệ",
					},
				],
			},
			{
				name: "Huyện Thanh Thuỷ",
				wards: [
					{
						name: "Xã Đào Xá",
					},
					{
						name: "Xã Thạch Đồng",
					},
					{
						name: "Xã Xuân Lộc",
					},
					{
						name: "Xã Tân Phương",
					},
					{
						name: "Thị trấn Thanh Thủy",
					},
					{
						name: "Xã Sơn Thủy",
					},
					{
						name: "Xã Bảo Yên",
					},
					{
						name: "Xã Đoan Hạ",
					},
					{
						name: "Xã Đồng Trung",
					},
					{
						name: "Xã Hoàng Xá",
					},
					{
						name: "Xã Tu Vũ",
					},
				],
			},
			{
				name: "Huyện Tân Sơn",
				wards: [
					{
						name: "Xã Thu Cúc",
					},
					{
						name: "Xã Thạch Kiệt",
					},
					{
						name: "Xã Thu Ngạc",
					},
					{
						name: "Xã Kiệt Sơn",
					},
					{
						name: "Xã Đồng Sơn",
					},
					{
						name: "Xã Lai Đồng",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Mỹ Thuận",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Xuân Đài",
					},
					{
						name: "Xã Minh Đài",
					},
					{
						name: "Xã Văn Luông",
					},
					{
						name: "Xã Xuân Sơn",
					},
					{
						name: "Xã Long Cốc",
					},
					{
						name: "Xã Kim Thượng",
					},
					{
						name: "Xã Tam Thanh",
					},
					{
						name: "Xã Vinh Tiền",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Vĩnh Phúc",
		districts: [
			{
				name: "Thành phố Vĩnh Yên",
				wards: [
					{
						name: "Phường Tích Sơn",
					},
					{
						name: "Phường Liên Bảo",
					},
					{
						name: "Phường Hội Hợp",
					},
					{
						name: "Phường Đống Đa",
					},
					{
						name: "Phường Ngô Quyền",
					},
					{
						name: "Phường Đồng Tâm",
					},
					{
						name: "Xã Định Trung",
					},
					{
						name: "Phường Khai Quang",
					},
					{
						name: "Xã Thanh Trù",
					},
				],
			},
			{
				name: "Thành phố Phúc Yên",
				wards: [
					{
						name: "Phường Trưng Trắc",
					},
					{
						name: "Phường Hùng Vương",
					},
					{
						name: "Phường Trưng Nhị",
					},
					{
						name: "Phường Phúc Thắng",
					},
					{
						name: "Phường Xuân Hoà",
					},
					{
						name: "Phường Đồng Xuân",
					},
					{
						name: "Xã Ngọc Thanh",
					},
					{
						name: "Xã Cao Minh",
					},
					{
						name: "Phường Nam Viêm",
					},
					{
						name: "Phường Tiền Châu",
					},
				],
			},
			{
				name: "Huyện Lập Thạch",
				wards: [
					{
						name: "Thị trấn Lập Thạch",
					},
					{
						name: "Xã Quang Sơn",
					},
					{
						name: "Xã Ngọc Mỹ",
					},
					{
						name: "Xã Hợp Lý",
					},
					{
						name: "Xã Bắc Bình",
					},
					{
						name: "Xã Thái Hòa",
					},
					{
						name: "Thị trấn Hoa Sơn",
					},
					{
						name: "Xã Liễn Sơn",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Vân Trục",
					},
					{
						name: "Xã Liên Hòa",
					},
					{
						name: "Xã Tử Du",
					},
					{
						name: "Xã Bàn Giản",
					},
					{
						name: "Xã Xuân Lôi",
					},
					{
						name: "Xã Đồng Ích",
					},
					{
						name: "Xã Tiên Lữ",
					},
					{
						name: "Xã Văn Quán",
					},
					{
						name: "Xã Đình Chu",
					},
					{
						name: "Xã Triệu Đề",
					},
					{
						name: "Xã Sơn Đông",
					},
				],
			},
			{
				name: "Huyện Tam Dương",
				wards: [
					{
						name: "Thị trấn Hợp Hòa",
					},
					{
						name: "Xã Hoàng Hoa",
					},
					{
						name: "Xã Đồng Tĩnh",
					},
					{
						name: "Xã Kim Long",
					},
					{
						name: "Xã Hướng Đạo",
					},
					{
						name: "Xã Đạo Tú",
					},
					{
						name: "Xã An Hòa",
					},
					{
						name: "Xã Thanh Vân",
					},
					{
						name: "Xã Duy Phiên",
					},
					{
						name: "Xã Hoàng Đan",
					},
					{
						name: "Xã Hoàng Lâu",
					},
					{
						name: "Xã Vân Hội",
					},
					{
						name: "Xã Hợp Thịnh",
					},
				],
			},
			{
				name: "Huyện Tam Đảo",
				wards: [
					{
						name: "Thị trấn Tam Đảo",
					},
					{
						name: "Thị trấn Hợp Châu",
					},
					{
						name: "Xã Đạo Trù",
					},
					{
						name: "Xã Yên Dương",
					},
					{
						name: "Xã Bồ Lý",
					},
					{
						name: "Thị trấn Đại Đình",
					},
					{
						name: "Xã Tam Quan",
					},
					{
						name: "Xã Hồ Sơn",
					},
					{
						name: "Xã Minh Quang",
					},
				],
			},
			{
				name: "Huyện Bình Xuyên",
				wards: [
					{
						name: "Thị trấn Hương Canh",
					},
					{
						name: "Thị trấn Gia Khánh",
					},
					{
						name: "Xã Trung Mỹ",
					},
					{
						name: "Thị trấn Bá Hiến",
					},
					{
						name: "Xã Thiện Kế",
					},
					{
						name: "Xã Hương Sơn",
					},
					{
						name: "Xã Tam Hợp",
					},
					{
						name: "Xã Quất Lưu",
					},
					{
						name: "Xã Sơn Lôi",
					},
					{
						name: "Thị trấn Đạo Đức",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Thị trấn Thanh Lãng",
					},
					{
						name: "Xã Phú Xuân",
					},
				],
			},
			{
				name: "Huyện Yên Lạc",
				wards: [
					{
						name: "Thị trấn Yên Lạc",
					},
					{
						name: "Xã Đồng Cương",
					},
					{
						name: "Xã Đồng Văn",
					},
					{
						name: "Xã Bình Định",
					},
					{
						name: "Xã Trung Nguyên",
					},
					{
						name: "Xã Tề Lỗ",
					},
					{
						name: "Xã Tam Hồng",
					},
					{
						name: "Xã Yên Đồng",
					},
					{
						name: "Xã Văn Tiến",
					},
					{
						name: "Xã Nguyệt Đức",
					},
					{
						name: "Xã Yên Phương",
					},
					{
						name: "Xã Hồng Phương",
					},
					{
						name: "Xã Trung Kiên",
					},
					{
						name: "Xã Liên Châu",
					},
					{
						name: "Xã Đại Tự",
					},
					{
						name: "Xã Hồng Châu",
					},
					{
						name: "Xã Trung Hà",
					},
				],
			},
			{
				name: "Huyện Vĩnh Tường",
				wards: [
					{
						name: "Thị trấn Vĩnh Tường",
					},
					{
						name: "Xã Kim Xá",
					},
					{
						name: "Xã Yên Bình",
					},
					{
						name: "Xã Chấn Hưng",
					},
					{
						name: "Xã Nghĩa Hưng",
					},
					{
						name: "Xã Yên Lập",
					},
					{
						name: "Xã Việt Xuân",
					},
					{
						name: "Xã Bồ Sao",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Lũng Hoà",
					},
					{
						name: "Xã Cao Đại",
					},
					{
						name: "Thị Trấn Thổ Tang",
					},
					{
						name: "Xã Vĩnh Sơn",
					},
					{
						name: "Xã Bình Dương",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Thượng Trưng",
					},
					{
						name: "Xã Vũ Di",
					},
					{
						name: "Xã Lý Nhân",
					},
					{
						name: "Xã Tuân Chính",
					},
					{
						name: "Xã Vân Xuân",
					},
					{
						name: "Xã Tam Phúc",
					},
					{
						name: "Thị trấn Tứ Trưng",
					},
					{
						name: "Xã Ngũ Kiên",
					},
					{
						name: "Xã An Tường",
					},
					{
						name: "Xã Vĩnh Thịnh",
					},
					{
						name: "Xã Phú Đa",
					},
					{
						name: "Xã Vĩnh Ninh",
					},
				],
			},
			{
				name: "Huyện Sông Lô",
				wards: [
					{
						name: "Xã Lãng Công",
					},
					{
						name: "Xã Quang Yên",
					},
					{
						name: "Xã Bạch Lưu",
					},
					{
						name: "Xã Hải Lựu",
					},
					{
						name: "Xã Đồng Quế",
					},
					{
						name: "Xã Nhân Đạo",
					},
					{
						name: "Xã Đôn Nhân",
					},
					{
						name: "Xã Phương Khoan",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Nhạo Sơn",
					},
					{
						name: "Thị trấn Tam Sơn",
					},
					{
						name: "Xã Như Thụy",
					},
					{
						name: "Xã Yên Thạch",
					},
					{
						name: "Xã Đồng Thịnh",
					},
					{
						name: "Xã Tứ Yên",
					},
					{
						name: "Xã Đức Bác",
					},
					{
						name: "Xã Cao Phong",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bắc Ninh",
		districts: [
			{
				name: "Thành phố Bắc Ninh",
				wards: [
					{
						name: "Phường Vũ Ninh",
					},
					{
						name: "Phường Đáp Cầu",
					},
					{
						name: "Phường Thị Cầu",
					},
					{
						name: "Phường Kinh Bắc",
					},
					{
						name: "Phường Vệ An",
					},
					{
						name: "Phường Tiền An",
					},
					{
						name: "Phường Đại Phúc",
					},
					{
						name: "Phường Ninh Xá",
					},
					{
						name: "Phường Suối Hoa",
					},
					{
						name: "Phường Võ Cường",
					},
					{
						name: "Phường Hòa Long",
					},
					{
						name: "Phường Vạn An",
					},
					{
						name: "Phường Khúc Xuyên",
					},
					{
						name: "Phường Phong Khê",
					},
					{
						name: "Phường Kim Chân",
					},
					{
						name: "Phường Vân Dương",
					},
					{
						name: "Phường Nam Sơn",
					},
					{
						name: "Phường Khắc Niệm",
					},
					{
						name: "Phường Hạp Lĩnh",
					},
				],
			},
			{
				name: "Huyện Yên Phong",
				wards: [
					{
						name: "Thị trấn Chờ",
					},
					{
						name: "Xã Dũng Liệt",
					},
					{
						name: "Xã Tam Đa",
					},
					{
						name: "Xã Tam Giang",
					},
					{
						name: "Xã Yên Trung",
					},
					{
						name: "Xã Thụy Hòa",
					},
					{
						name: "Xã Hòa Tiến",
					},
					{
						name: "Xã Đông Tiến",
					},
					{
						name: "Xã Yên Phụ",
					},
					{
						name: "Xã Trung Nghĩa",
					},
					{
						name: "Xã Đông Phong",
					},
					{
						name: "Xã Long Châu",
					},
					{
						name: "Xã Văn Môn",
					},
					{
						name: "Xã Đông Thọ",
					},
				],
			},
			{
				name: "Huyện Quế Võ",
				wards: [
					{
						name: "Thị trấn Phố Mới",
					},
					{
						name: "Xã Việt Thống",
					},
					{
						name: "Xã Đại Xuân",
					},
					{
						name: "Xã Nhân Hòa",
					},
					{
						name: "Xã Bằng An",
					},
					{
						name: "Xã Phương Liễu",
					},
					{
						name: "Xã Quế Tân",
					},
					{
						name: "Xã Phù Lương",
					},
					{
						name: "Xã Phù Lãng",
					},
					{
						name: "Xã Phượng Mao",
					},
					{
						name: "Xã Việt Hùng",
					},
					{
						name: "Xã Ngọc Xá",
					},
					{
						name: "Xã Châu Phong",
					},
					{
						name: "Xã Bồng Lai",
					},
					{
						name: "Xã Cách Bi",
					},
					{
						name: "Xã Đào Viên",
					},
					{
						name: "Xã Yên Giả",
					},
					{
						name: "Xã Mộ Đạo",
					},
					{
						name: "Xã Đức Long",
					},
					{
						name: "Xã Chi Lăng",
					},
					{
						name: "Xã Hán Quảng",
					},
				],
			},
			{
				name: "Huyện Tiên Du",
				wards: [
					{
						name: "Thị trấn Lim",
					},
					{
						name: "Xã Phú Lâm",
					},
					{
						name: "Xã Nội Duệ",
					},
					{
						name: "Xã Liên Bão",
					},
					{
						name: "Xã Hiên Vân",
					},
					{
						name: "Xã Hoàn Sơn",
					},
					{
						name: "Xã Lạc Vệ",
					},
					{
						name: "Xã Việt Đoàn",
					},
					{
						name: "Xã Phật Tích",
					},
					{
						name: "Xã Tân Chi",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Tri Phương",
					},
					{
						name: "Xã Minh Đạo",
					},
					{
						name: "Xã Cảnh Hưng",
					},
				],
			},
			{
				name: "Thị xã Từ Sơn",
				wards: [
					{
						name: "Phường Đông Ngàn",
					},
					{
						name: "Phường Tam Sơn",
					},
					{
						name: "Phường Hương Mạc",
					},
					{
						name: "Phường Tương Giang",
					},
					{
						name: "Phường Phù Khê",
					},
					{
						name: "Phường Đồng Kỵ",
					},
					{
						name: "Phường Trang Hạ",
					},
					{
						name: "Phường Đồng Nguyên",
					},
					{
						name: "Phường Châu Khê",
					},
					{
						name: "Phường Tân Hồng",
					},
					{
						name: "Phường Đình Bảng",
					},
					{
						name: "Phường Phù Chẩn",
					},
				],
			},
			{
				name: "Huyện Thuận Thành",
				wards: [
					{
						name: "Thị trấn Hồ",
					},
					{
						name: "Xã Hoài Thượng",
					},
					{
						name: "Xã Đại Đồng Thành",
					},
					{
						name: "Xã Mão Điền",
					},
					{
						name: "Xã Song Hồ",
					},
					{
						name: "Xã Đình Tổ",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Trí Quả",
					},
					{
						name: "Xã Gia Đông",
					},
					{
						name: "Xã Thanh Khương",
					},
					{
						name: "Xã Trạm Lộ",
					},
					{
						name: "Xã Xuân Lâm",
					},
					{
						name: "Xã Hà Mãn",
					},
					{
						name: "Xã Ngũ Thái",
					},
					{
						name: "Xã Nguyệt Đức",
					},
					{
						name: "Xã Ninh Xá",
					},
					{
						name: "Xã Nghĩa Đạo",
					},
					{
						name: "Xã Song Liễu",
					},
				],
			},
			{
				name: "Huyện Gia Bình",
				wards: [
					{
						name: "Thị trấn Gia Bình",
					},
					{
						name: "Xã Vạn Ninh",
					},
					{
						name: "Xã Thái Bảo",
					},
					{
						name: "Xã Giang Sơn",
					},
					{
						name: "Xã Cao Đức",
					},
					{
						name: "Xã Đại Lai",
					},
					{
						name: "Xã Song Giang",
					},
					{
						name: "Xã Bình Dương",
					},
					{
						name: "Xã Lãng Ngâm",
					},
					{
						name: "Xã Nhân Thắng",
					},
					{
						name: "Xã Xuân Lai",
					},
					{
						name: "Xã Đông Cứu",
					},
					{
						name: "Xã Đại Bái",
					},
					{
						name: "Xã Quỳnh Phú",
					},
				],
			},
			{
				name: "Huyện Lương Tài",
				wards: [
					{
						name: "Thị trấn Thứa",
					},
					{
						name: "Xã An Thịnh",
					},
					{
						name: "Xã Trung Kênh",
					},
					{
						name: "Xã Phú Hòa",
					},
					{
						name: "Xã Mỹ Hương",
					},
					{
						name: "Xã Tân Lãng",
					},
					{
						name: "Xã Quảng Phú",
					},
					{
						name: "Xã Trừng Xá",
					},
					{
						name: "Xã Lai Hạ",
					},
					{
						name: "Xã Trung Chính",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Bình Định",
					},
					{
						name: "Xã Phú Lương",
					},
					{
						name: "Xã Lâm Thao",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Hải Dương",
		districts: [
			{
				name: "Thành phố Hải Dương",
				wards: [
					{
						name: "Phường Cẩm Thượng",
					},
					{
						name: "Phường Bình Hàn",
					},
					{
						name: "Phường Ngọc Châu",
					},
					{
						name: "Phường Nhị Châu",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Nguyễn Trãi",
					},
					{
						name: "Phường Phạm Ngũ Lão",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Thanh Bình",
					},
					{
						name: "Phường Tân Bình",
					},
					{
						name: "Phường Lê Thanh Nghị",
					},
					{
						name: "Phường Hải Tân",
					},
					{
						name: "Phường Tứ Minh",
					},
					{
						name: "Phường Việt Hoà",
					},
					{
						name: "Phường Ái Quốc",
					},
					{
						name: "Xã An Thượng",
					},
					{
						name: "Phường Nam Đồng",
					},
					{
						name: "Xã Quyết Thắng",
					},
					{
						name: "Xã Tiền Tiến",
					},
					{
						name: "Phường Thạch Khôi",
					},
					{
						name: "Xã Liên Hồng",
					},
					{
						name: "Phường Tân Hưng",
					},
					{
						name: "Xã Gia Xuyên",
					},
					{
						name: "Xã Ngọc Sơn",
					},
				],
			},
			{
				name: "Thành phố Chí Linh",
				wards: [
					{
						name: "Phường Phả Lại",
					},
					{
						name: "Phường Sao Đỏ",
					},
					{
						name: "Phường Bến Tắm",
					},
					{
						name: "Xã Hoàng Hoa Thám",
					},
					{
						name: "Xã Bắc An",
					},
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Phường Hoàng Tiến",
					},
					{
						name: "Phường Cộng Hoà",
					},
					{
						name: "Phường Hoàng Tân",
					},
					{
						name: "Phường Cổ Thành",
					},
					{
						name: "Phường Văn An",
					},
					{
						name: "Phường Chí Minh",
					},
					{
						name: "Phường Văn Đức",
					},
					{
						name: "Phường Thái Học",
					},
					{
						name: "Xã Nhân Huệ",
					},
					{
						name: "Phường An Lạc",
					},
					{
						name: "Phường Đồng Lạc",
					},
					{
						name: "Phường Tân Dân",
					},
				],
			},
			{
				name: "Huyện Nam Sách",
				wards: [
					{
						name: "Thị trấn Nam Sách",
					},
					{
						name: "Xã Nam Hưng",
					},
					{
						name: "Xã Nam Tân",
					},
					{
						name: "Xã Hợp Tiến",
					},
					{
						name: "Xã Hiệp Cát",
					},
					{
						name: "Xã Thanh Quang",
					},
					{
						name: "Xã Quốc Tuấn",
					},
					{
						name: "Xã Nam Chính",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Nam Trung",
					},
					{
						name: "Xã An Sơn",
					},
					{
						name: "Xã Cộng Hòa",
					},
					{
						name: "Xã Thái Tân",
					},
					{
						name: "Xã An Lâm",
					},
					{
						name: "Xã Phú Điền",
					},
					{
						name: "Xã Nam Hồng",
					},
					{
						name: "Xã Hồng Phong",
					},
					{
						name: "Xã Đồng Lạc",
					},
					{
						name: "Xã Minh Tân",
					},
				],
			},
			{
				name: "Thị xã Kinh Môn",
				wards: [
					{
						name: "Phường An Lưu",
					},
					{
						name: "Xã Bạch Đằng",
					},
					{
						name: "Phường Thất Hùng",
					},
					{
						name: "Xã Lê Ninh",
					},
					{
						name: "Xã Hoành Sơn",
					},
					{
						name: "Phường Phạm Thái",
					},
					{
						name: "Phường Duy Tân",
					},
					{
						name: "Phường Tân Dân",
					},
					{
						name: "Phường Minh Tân",
					},
					{
						name: "Xã Quang Thành",
					},
					{
						name: "Xã Hiệp Hòa",
					},
					{
						name: "Phường Phú Thứ",
					},
					{
						name: "Xã Thăng Long",
					},
					{
						name: "Xã Lạc Long",
					},
					{
						name: "Phường An Sinh",
					},
					{
						name: "Phường Hiệp Sơn",
					},
					{
						name: "Xã Thượng Quận",
					},
					{
						name: "Phường An Phụ",
					},
					{
						name: "Phường Hiệp An",
					},
					{
						name: "Phường Long Xuyên",
					},
					{
						name: "Phường Thái Thịnh",
					},
					{
						name: "Phường Hiến Thành",
					},
					{
						name: "Xã Minh Hòa",
					},
				],
			},
			{
				name: "Huyện Kim Thành",
				wards: [
					{
						name: "Thị trấn Phú Thái",
					},
					{
						name: "Xã Lai Vu",
					},
					{
						name: "Xã Cộng Hòa",
					},
					{
						name: "Xã Thượng Vũ",
					},
					{
						name: "Xã Cổ Dũng",
					},
					{
						name: "Xã Tuấn Việt",
					},
					{
						name: "Xã Kim Xuyên",
					},
					{
						name: "Xã Phúc Thành A",
					},
					{
						name: "Xã Ngũ Phúc",
					},
					{
						name: "Xã Kim Anh",
					},
					{
						name: "Xã Kim Liên",
					},
					{
						name: "Xã Kim Tân",
					},
					{
						name: "Xã Kim Đính",
					},
					{
						name: "Xã Bình Dân",
					},
					{
						name: "Xã Tam Kỳ",
					},
					{
						name: "Xã Đồng Cẩm",
					},
					{
						name: "Xã Liên Hòa",
					},
					{
						name: "Xã Đại Đức",
					},
				],
			},
			{
				name: "Huyện Thanh Hà",
				wards: [
					{
						name: "Thị trấn Thanh Hà",
					},
					{
						name: "Xã Hồng Lạc",
					},
					{
						name: "Xã Việt Hồng",
					},
					{
						name: "Xã Tân Việt",
					},
					{
						name: "Xã Cẩm Chế",
					},
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã Thanh Lang",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Liên Mạc",
					},
					{
						name: "Xã Thanh Hải",
					},
					{
						name: "Xã Thanh Khê",
					},
					{
						name: "Xã Thanh Xá",
					},
					{
						name: "Xã Thanh Xuân",
					},
					{
						name: "Xã Thanh Thủy",
					},
					{
						name: "Xã An Phượng",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Thanh Quang",
					},
					{
						name: "Xã Thanh Hồng",
					},
					{
						name: "Xã Thanh Cường",
					},
					{
						name: "Xã Vĩnh Lập",
					},
				],
			},
			{
				name: "Huyện Cẩm Giàng",
				wards: [
					{
						name: "Thị trấn Cẩm Giang",
					},
					{
						name: "Thị trấn Lai Cách",
					},
					{
						name: "Xã Cẩm Hưng",
					},
					{
						name: "Xã Cẩm Hoàng",
					},
					{
						name: "Xã Cẩm Văn",
					},
					{
						name: "Xã Ngọc Liên",
					},
					{
						name: "Xã Thạch Lỗi",
					},
					{
						name: "Xã Cẩm Vũ",
					},
					{
						name: "Xã Đức Chính",
					},
					{
						name: "Xã Định Sơn",
					},
					{
						name: "Xã Lương Điền",
					},
					{
						name: "Xã Cao An",
					},
					{
						name: "Xã Tân Trường",
					},
					{
						name: "Xã Cẩm Phúc",
					},
					{
						name: "Xã Cẩm Điền",
					},
					{
						name: "Xã Cẩm Đông",
					},
					{
						name: "Xã Cẩm Đoài",
					},
				],
			},
			{
				name: "Huyện Bình Giang",
				wards: [
					{
						name: "Thị trấn Kẻ Sặt",
					},
					{
						name: "Xã Vĩnh Hưng",
					},
					{
						name: "Xã Hùng Thắng",
					},
					{
						name: "Xã Vĩnh Hồng",
					},
					{
						name: "Xã Long Xuyên",
					},
					{
						name: "Xã Tân Việt",
					},
					{
						name: "Xã Thúc Kháng",
					},
					{
						name: "Xã Tân Hồng",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Hồng Khê",
					},
					{
						name: "Xã Thái Học",
					},
					{
						name: "Xã Cổ Bì",
					},
					{
						name: "Xã Nhân Quyền",
					},
					{
						name: "Xã Thái Dương",
					},
					{
						name: "Xã Thái Hòa",
					},
					{
						name: "Xã Bình Xuyên",
					},
				],
			},
			{
				name: "Huyện Gia Lộc",
				wards: [
					{
						name: "Thị trấn Gia Lộc",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Yết Kiêu",
					},
					{
						name: "Xã Gia Tân",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Gia Khánh",
					},
					{
						name: "Xã Gia Lương",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Xã Toàn Thắng",
					},
					{
						name: "Xã Hoàng Diệu",
					},
					{
						name: "Xã Hồng Hưng",
					},
					{
						name: "Xã Phạm Trấn",
					},
					{
						name: "Xã Đoàn Thượng",
					},
					{
						name: "Xã Thống Kênh",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Đồng Quang",
					},
					{
						name: "Xã Nhật Tân",
					},
					{
						name: "Xã Đức Xương",
					},
				],
			},
			{
				name: "Huyện Tứ Kỳ",
				wards: [
					{
						name: "Thị trấn Tứ Kỳ",
					},
					{
						name: "Xã Đại Sơn",
					},
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Ngọc Kỳ",
					},
					{
						name: "Xã Bình Lăng",
					},
					{
						name: "Xã Chí Minh",
					},
					{
						name: "Xã Tái Sơn",
					},
					{
						name: "Xã Quang Phục",
					},
					{
						name: "Xã Dân Chủ",
					},
					{
						name: "Xã Tân Kỳ",
					},
					{
						name: "Xã Quang Khải",
					},
					{
						name: "Xã Đại Hợp",
					},
					{
						name: "Xã Quảng Nghiệp",
					},
					{
						name: "Xã An Thanh",
					},
					{
						name: "Xã Minh Đức",
					},
					{
						name: "Xã Văn Tố",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Phượng Kỳ",
					},
					{
						name: "Xã Cộng Lạc",
					},
					{
						name: "Xã Tiên Động",
					},
					{
						name: "Xã Nguyên Giáp",
					},
					{
						name: "Xã Hà Kỳ",
					},
					{
						name: "Xã Hà Thanh",
					},
				],
			},
			{
				name: "Huyện Ninh Giang",
				wards: [
					{
						name: "Thị trấn Ninh Giang",
					},
					{
						name: "Xã Ứng Hoè",
					},
					{
						name: "Xã Nghĩa An",
					},
					{
						name: "Xã Hồng Đức",
					},
					{
						name: "Xã An Đức",
					},
					{
						name: "Xã Vạn Phúc",
					},
					{
						name: "Xã Tân Hương",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Đông Xuyên",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Ninh Hải",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Tân Quang",
					},
					{
						name: "Xã Kiến Quốc",
					},
					{
						name: "Xã Hồng Dụ",
					},
					{
						name: "Xã Văn Hội",
					},
					{
						name: "Xã Hồng Phong",
					},
					{
						name: "Xã Hiệp Lực",
					},
					{
						name: "Xã Hồng Phúc",
					},
					{
						name: "Xã Hưng Long",
					},
				],
			},
			{
				name: "Huyện Thanh Miện",
				wards: [
					{
						name: "Thị trấn Thanh Miện",
					},
					{
						name: "Xã Thanh Tùng",
					},
					{
						name: "Xã Phạm Kha",
					},
					{
						name: "Xã Ngô Quyền",
					},
					{
						name: "Xã Đoàn Tùng",
					},
					{
						name: "Xã Hồng Quang",
					},
					{
						name: "Xã Tân Trào",
					},
					{
						name: "Xã Lam Sơn",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Lê Hồng",
					},
					{
						name: "Xã Tứ Cường",
					},
					{
						name: "Xã Ngũ Hùng",
					},
					{
						name: "Xã Cao Thắng",
					},
					{
						name: "Xã Chi Lăng Bắc",
					},
					{
						name: "Xã Chi Lăng Nam",
					},
					{
						name: "Xã Thanh Giang",
					},
					{
						name: "Xã Hồng Phong",
					},
				],
			},
		],
	},
	{
		name: "Thành phố Hải Phòng",
		districts: [
			{
				name: "Quận Hồng Bàng",
				wards: [
					{
						name: "Phường Quán Toan",
					},
					{
						name: "Phường Hùng Vương",
					},
					{
						name: "Phường Sở Dầu",
					},
					{
						name: "Phường Thượng Lý",
					},
					{
						name: "Phường Hạ Lý",
					},
					{
						name: "Phường Minh Khai",
					},
					{
						name: "Phường Trại Chuối",
					},
					{
						name: "Phường Hoàng Văn Thụ",
					},
					{
						name: "Phường Phan Bội Châu",
					},
				],
			},
			{
				name: "Quận Ngô Quyền",
				wards: [
					{
						name: "Phường Máy Chai",
					},
					{
						name: "Phường Máy Tơ",
					},
					{
						name: "Phường Vạn Mỹ",
					},
					{
						name: "Phường Cầu Tre",
					},
					{
						name: "Phường Lạc Viên",
					},
					{
						name: "Phường Gia Viên",
					},
					{
						name: "Phường Đông Khê",
					},
					{
						name: "Phường Cầu Đất",
					},
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Phường Đằng Giang",
					},
					{
						name: "Phường Lạch Tray",
					},
					{
						name: "Phường Đổng Quốc Bình",
					},
				],
			},
			{
				name: "Quận Lê Chân",
				wards: [
					{
						name: "Phường Cát Dài",
					},
					{
						name: "Phường An Biên",
					},
					{
						name: "Phường Lam Sơn",
					},
					{
						name: "Phường An Dương",
					},
					{
						name: "Phường Trần Nguyên Hãn",
					},
					{
						name: "Phường Hồ Nam",
					},
					{
						name: "Phường Trại Cau",
					},
					{
						name: "Phường Dư Hàng",
					},
					{
						name: "Phường Hàng Kênh",
					},
					{
						name: "Phường Đông Hải",
					},
					{
						name: "Phường Niệm Nghĩa",
					},
					{
						name: "Phường Nghĩa Xá",
					},
					{
						name: "Phường Dư Hàng Kênh",
					},
					{
						name: "Phường Kênh Dương",
					},
					{
						name: "Phường Vĩnh Niệm",
					},
				],
			},
			{
				name: "Quận Hải An",
				wards: [
					{
						name: "Phường Đông Hải 1",
					},
					{
						name: "Phường Đông Hải 2",
					},
					{
						name: "Phường Đằng Lâm",
					},
					{
						name: "Phường Thành Tô",
					},
					{
						name: "Phường Đằng Hải",
					},
					{
						name: "Phường Nam Hải",
					},
					{
						name: "Phường Cát Bi",
					},
					{
						name: "Phường Tràng Cát",
					},
				],
			},
			{
				name: "Quận Kiến An",
				wards: [
					{
						name: "Phường Quán Trữ",
					},
					{
						name: "Phường Lãm Hà",
					},
					{
						name: "Phường Đồng Hoà",
					},
					{
						name: "Phường Bắc Sơn",
					},
					{
						name: "Phường Nam Sơn",
					},
					{
						name: "Phường Ngọc Sơn",
					},
					{
						name: "Phường Trần Thành Ngọ",
					},
					{
						name: "Phường Văn Đẩu",
					},
					{
						name: "Phường Phù Liễn",
					},
					{
						name: "Phường Tràng Minh",
					},
				],
			},
			{
				name: "Quận Đồ Sơn",
				wards: [
					{
						name: "Phường Ngọc Xuyên",
					},
					{
						name: "Phường Hải Sơn",
					},
					{
						name: "Phường Vạn Hương",
					},
					{
						name: "Phường Minh Đức",
					},
					{
						name: "Phường Bàng La",
					},
					{
						name: "Phường Hợp Đức",
					},
				],
			},
			{
				name: "Quận Dương Kinh",
				wards: [
					{
						name: "Phường Đa Phúc",
					},
					{
						name: "Phường Hưng Đạo",
					},
					{
						name: "Phường Anh Dũng",
					},
					{
						name: "Phường Hải Thành",
					},
					{
						name: "Phường Hoà Nghĩa",
					},
					{
						name: "Phường Tân Thành",
					},
				],
			},
			{
				name: "Huyện Thuỷ Nguyên",
				wards: [
					{
						name: "Thị trấn Núi Đèo",
					},
					{
						name: "Thị trấn Minh Đức",
					},
					{
						name: "Xã Lại Xuân",
					},
					{
						name: "Xã An Sơn",
					},
					{
						name: "Xã Kỳ Sơn",
					},
					{
						name: "Xã Liên Khê",
					},
					{
						name: "Xã Lưu Kiếm",
					},
					{
						name: "Xã Lưu Kỳ",
					},
					{
						name: "Xã Gia Minh",
					},
					{
						name: "Xã Gia Đức",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Phù Ninh",
					},
					{
						name: "Xã Quảng Thanh",
					},
					{
						name: "Xã Chính Mỹ",
					},
					{
						name: "Xã Kênh Giang",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Cao Nhân",
					},
					{
						name: "Xã Mỹ Đồng",
					},
					{
						name: "Xã Đông Sơn",
					},
					{
						name: "Xã Hoà Bình",
					},
					{
						name: "Xã Trung Hà",
					},
					{
						name: "Xã An Lư",
					},
					{
						name: "Xã Thuỷ Triều",
					},
					{
						name: "Xã Ngũ Lão",
					},
					{
						name: "Xã Phục Lễ",
					},
					{
						name: "Xã Tam Hưng",
					},
					{
						name: "Xã Phả Lễ",
					},
					{
						name: "Xã Lập Lễ",
					},
					{
						name: "Xã Kiền Bái",
					},
					{
						name: "Xã Thiên Hương",
					},
					{
						name: "Xã Thuỷ Sơn",
					},
					{
						name: "Xã Thuỷ Đường",
					},
					{
						name: "Xã Hoàng Động",
					},
					{
						name: "Xã Lâm Động",
					},
					{
						name: "Xã Hoa Động",
					},
					{
						name: "Xã Tân Dương",
					},
					{
						name: "Xã Dương Quan",
					},
				],
			},
			{
				name: "Huyện An Dương",
				wards: [
					{
						name: "Thị trấn An Dương",
					},
					{
						name: "Xã Lê Thiện",
					},
					{
						name: "Xã Đại Bản",
					},
					{
						name: "Xã An Hoà",
					},
					{
						name: "Xã Hồng Phong",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã An Hưng",
					},
					{
						name: "Xã An Hồng",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Nam Sơn",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Xã Đặng Cương",
					},
					{
						name: "Xã Đồng Thái",
					},
					{
						name: "Xã Quốc Tuấn",
					},
					{
						name: "Xã An Đồng",
					},
					{
						name: "Xã Hồng Thái",
					},
				],
			},
			{
				name: "Huyện An Lão",
				wards: [
					{
						name: "Thị trấn An Lão",
					},
					{
						name: "Xã Bát Trang",
					},
					{
						name: "Xã Trường Thọ",
					},
					{
						name: "Xã Trường Thành",
					},
					{
						name: "Xã An Tiến",
					},
					{
						name: "Xã Quang Hưng",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Quốc Tuấn",
					},
					{
						name: "Xã An Thắng",
					},
					{
						name: "Thị trấn Trường Sơn",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã Thái Sơn",
					},
					{
						name: "Xã Tân Viên",
					},
					{
						name: "Xã Mỹ Đức",
					},
					{
						name: "Xã Chiến Thắng",
					},
					{
						name: "Xã An Thọ",
					},
					{
						name: "Xã An Thái",
					},
				],
			},
			{
				name: "Huyện Kiến Thuỵ",
				wards: [
					{
						name: "Thị trấn Núi Đối",
					},
					{
						name: "Xã Đông Phương",
					},
					{
						name: "Xã Thuận Thiên",
					},
					{
						name: "Xã Hữu Bằng",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Ngũ Phúc",
					},
					{
						name: "Xã Kiến Quốc",
					},
					{
						name: "Xã Du Lễ",
					},
					{
						name: "Xã Thuỵ Hương",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Đại Hà",
					},
					{
						name: "Xã Ngũ Đoan",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Tân Trào",
					},
					{
						name: "Xã Đoàn Xá",
					},
					{
						name: "Xã Tú Sơn",
					},
					{
						name: "Xã Đại Hợp",
					},
				],
			},
			{
				name: "Huyện Tiên Lãng",
				wards: [
					{
						name: "Thị trấn Tiên Lãng",
					},
					{
						name: "Xã Đại Thắng",
					},
					{
						name: "Xã Tiên Cường",
					},
					{
						name: "Xã Tự Cường",
					},
					{
						name: "Xã Quyết Tiến",
					},
					{
						name: "Xã Khởi Nghĩa",
					},
					{
						name: "Xã Tiên Thanh",
					},
					{
						name: "Xã Cấp Tiến",
					},
					{
						name: "Xã Kiến Thiết",
					},
					{
						name: "Xã Đoàn Lập",
					},
					{
						name: "Xã Bạch Đằng",
					},
					{
						name: "Xã Quang Phục",
					},
					{
						name: "Xã Toàn Thắng",
					},
					{
						name: "Xã Tiên Thắng",
					},
					{
						name: "Xã Tiên Minh",
					},
					{
						name: "Xã Bắc Hưng",
					},
					{
						name: "Xã Nam Hưng",
					},
					{
						name: "Xã Hùng Thắng",
					},
					{
						name: "Xã Tây Hưng",
					},
					{
						name: "Xã Đông Hưng",
					},
					{
						name: "Xã Vinh Quang",
					},
				],
			},
			{
				name: "Huyện Vĩnh Bảo",
				wards: [
					{
						name: "Thị trấn Vĩnh Bảo",
					},
					{
						name: "Xã Dũng Tiến",
					},
					{
						name: "Xã Giang Biên",
					},
					{
						name: "Xã Thắng Thuỷ",
					},
					{
						name: "Xã Trung Lập",
					},
					{
						name: "Xã Việt Tiến",
					},
					{
						name: "Xã Vĩnh An",
					},
					{
						name: "Xã Vĩnh Long",
					},
					{
						name: "Xã Hiệp Hoà",
					},
					{
						name: "Xã Hùng Tiến",
					},
					{
						name: "Xã An Hoà",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Tân Liên",
					},
					{
						name: "Xã Nhân Hoà",
					},
					{
						name: "Xã Tam Đa",
					},
					{
						name: "Xã Hưng Nhân",
					},
					{
						name: "Xã Vinh Quang",
					},
					{
						name: "Xã Đồng Minh",
					},
					{
						name: "Xã Thanh Lương",
					},
					{
						name: "Xã Liên Am",
					},
					{
						name: "Xã Lý Học",
					},
					{
						name: "Xã Tam Cường",
					},
					{
						name: "Xã Hoà Bình",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Vĩnh Phong",
					},
					{
						name: "Xã Cộng Hiền",
					},
					{
						name: "Xã Cao Minh",
					},
					{
						name: "Xã Cổ Am",
					},
					{
						name: "Xã Vĩnh Tiến",
					},
					{
						name: "Xã Trấn Dương",
					},
				],
			},
			{
				name: "Huyện Cát Hải",
				wards: [
					{
						name: "Thị trấn Cát Bà",
					},
					{
						name: "Thị trấn Cát Hải",
					},
					{
						name: "Xã Nghĩa Lộ",
					},
					{
						name: "Xã Đồng Bài",
					},
					{
						name: "Xã Hoàng Châu",
					},
					{
						name: "Xã Văn Phong",
					},
					{
						name: "Xã Phù Long",
					},
					{
						name: "Xã Gia Luận",
					},
					{
						name: "Xã Hiền Hào",
					},
					{
						name: "Xã Trân Châu",
					},
					{
						name: "Xã Việt Hải",
					},
					{
						name: "Xã Xuân Đám",
					},
				],
			},
			{
				name: "Huyện Bạch Long Vĩ",
				wards: [],
			},
		],
	},
	{
		name: "Tỉnh Hưng Yên",
		districts: [
			{
				name: "Thành phố Hưng Yên",
				wards: [
					{
						name: "Phường Lam Sơn",
					},
					{
						name: "Phường Hiến Nam",
					},
					{
						name: "Phường An Tảo",
					},
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Phường Minh Khai",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Hồng Châu",
					},
					{
						name: "Xã Trung Nghĩa",
					},
					{
						name: "Xã Liên Phương",
					},
					{
						name: "Xã Hồng Nam",
					},
					{
						name: "Xã Quảng Châu",
					},
					{
						name: "Xã Bảo Khê",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Hùng Cường",
					},
					{
						name: "Xã Phương Chiểu",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Hoàng Hanh",
					},
				],
			},
			{
				name: "Huyện Văn Lâm",
				wards: [
					{
						name: "Thị trấn Như Quỳnh",
					},
					{
						name: "Xã Lạc Đạo",
					},
					{
						name: "Xã Chỉ Đạo",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Việt Hưng",
					},
					{
						name: "Xã Tân Quang",
					},
					{
						name: "Xã Đình Dù",
					},
					{
						name: "Xã Minh Hải",
					},
					{
						name: "Xã Lương Tài",
					},
					{
						name: "Xã Trưng Trắc",
					},
					{
						name: "Xã Lạc Hồng",
					},
				],
			},
			{
				name: "Huyện Văn Giang",
				wards: [
					{
						name: "Thị trấn Văn Giang",
					},
					{
						name: "Xã Xuân Quan",
					},
					{
						name: "Xã Cửu Cao",
					},
					{
						name: "Xã Phụng Công",
					},
					{
						name: "Xã Nghĩa Trụ",
					},
					{
						name: "Xã Long Hưng",
					},
					{
						name: "Xã Vĩnh Khúc",
					},
					{
						name: "Xã Liên Nghĩa",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Thắng Lợi",
					},
					{
						name: "Xã Mễ Sở",
					},
				],
			},
			{
				name: "Huyện Yên Mỹ",
				wards: [
					{
						name: "Thị trấn Yên Mỹ",
					},
					{
						name: "Xã Giai Phạm",
					},
					{
						name: "Xã Nghĩa Hiệp",
					},
					{
						name: "Xã Đồng Than",
					},
					{
						name: "Xã Ngọc Long",
					},
					{
						name: "Xã Liêu Xá",
					},
					{
						name: "Xã Hoàn Long",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Thanh Long",
					},
					{
						name: "Xã Yên Phú",
					},
					{
						name: "Xã Việt Cường",
					},
					{
						name: "Xã Trung Hòa",
					},
					{
						name: "Xã Yên Hòa",
					},
					{
						name: "Xã Minh Châu",
					},
					{
						name: "Xã Trung Hưng",
					},
					{
						name: "Xã Lý Thường Kiệt",
					},
					{
						name: "Xã Tân Việt",
					},
				],
			},
			{
				name: "Thị xã Mỹ Hào",
				wards: [
					{
						name: "Phường Bần Yên Nhân",
					},
					{
						name: "Phường Phan Đình Phùng",
					},
					{
						name: "Xã Cẩm Xá",
					},
					{
						name: "Xã Dương Quang",
					},
					{
						name: "Xã Hòa Phong",
					},
					{
						name: "Phường Nhân Hòa",
					},
					{
						name: "Phường Dị Sử",
					},
					{
						name: "Phường Bạch Sam",
					},
					{
						name: "Phường Minh Đức",
					},
					{
						name: "Phường Phùng Chí Kiên",
					},
					{
						name: "Xã Xuân Dục",
					},
					{
						name: "Xã Ngọc Lâm",
					},
					{
						name: "Xã Hưng Long",
					},
				],
			},
			{
				name: "Huyện Ân Thi",
				wards: [
					{
						name: "Thị trấn Ân Thi",
					},
					{
						name: "Xã Phù Ủng",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Bãi Sậy",
					},
					{
						name: "Xã Đào Dương",
					},
					{
						name: "Xã Tân Phúc",
					},
					{
						name: "Xã Vân Du",
					},
					{
						name: "Xã Quang Vinh",
					},
					{
						name: "Xã Xuân Trúc",
					},
					{
						name: "Xã Hoàng Hoa Thám",
					},
					{
						name: "Xã Quảng Lãng",
					},
					{
						name: "Xã Văn Nhuệ",
					},
					{
						name: "Xã Đặng Lễ",
					},
					{
						name: "Xã Cẩm Ninh",
					},
					{
						name: "Xã Nguyễn Trãi",
					},
					{
						name: "Xã Đa Lộc",
					},
					{
						name: "Xã Hồ Tùng Mậu",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Hồng Vân",
					},
					{
						name: "Xã Hồng Quang",
					},
					{
						name: "Xã Hạ Lễ",
					},
				],
			},
			{
				name: "Huyện Khoái Châu",
				wards: [
					{
						name: "Thị trấn Khoái Châu",
					},
					{
						name: "Xã Đông Tảo",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Dạ Trạch",
					},
					{
						name: "Xã Hàm Tử",
					},
					{
						name: "Xã Ông Đình",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã Tứ Dân",
					},
					{
						name: "Xã An Vĩ",
					},
					{
						name: "Xã Đông Kết",
					},
					{
						name: "Xã Bình Kiều",
					},
					{
						name: "Xã Dân Tiến",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Hồng Tiến",
					},
					{
						name: "Xã Tân Châu",
					},
					{
						name: "Xã Liên Khê",
					},
					{
						name: "Xã Phùng Hưng",
					},
					{
						name: "Xã Việt Hòa",
					},
					{
						name: "Xã Đông Ninh",
					},
					{
						name: "Xã Đại Tập",
					},
					{
						name: "Xã Chí Tân",
					},
					{
						name: "Xã Đại Hưng",
					},
					{
						name: "Xã Thuần Hưng",
					},
					{
						name: "Xã Thành Công",
					},
					{
						name: "Xã Nhuế Dương",
					},
				],
			},
			{
				name: "Huyện Kim Động",
				wards: [
					{
						name: "Thị trấn Lương Bằng",
					},
					{
						name: "Xã Nghĩa Dân",
					},
					{
						name: "Xã Toàn Thắng",
					},
					{
						name: "Xã Vĩnh Xá",
					},
					{
						name: "Xã Phạm Ngũ Lão",
					},
					{
						name: "Xã Thọ Vinh",
					},
					{
						name: "Xã Đồng Thanh",
					},
					{
						name: "Xã Song Mai",
					},
					{
						name: "Xã Chính Nghĩa",
					},
					{
						name: "Xã Nhân La",
					},
					{
						name: "Xã Phú Thịnh",
					},
					{
						name: "Xã Mai Động",
					},
					{
						name: "Xã Đức Hợp",
					},
					{
						name: "Xã Hùng An",
					},
					{
						name: "Xã Ngọc Thanh",
					},
					{
						name: "Xã Vũ Xá",
					},
					{
						name: "Xã Hiệp Cường",
					},
				],
			},
			{
				name: "Huyện Tiên Lữ",
				wards: [
					{
						name: "Thị trấn Vương",
					},
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Ngô Quyền",
					},
					{
						name: "Xã Nhật Tân",
					},
					{
						name: "Xã Dị Chế",
					},
					{
						name: "Xã Lệ Xá",
					},
					{
						name: "Xã An Viên",
					},
					{
						name: "Xã Đức Thắng",
					},
					{
						name: "Xã Trung Dũng",
					},
					{
						name: "Xã Hải Triều",
					},
					{
						name: "Xã Thủ Sỹ",
					},
					{
						name: "Xã Thiện Phiến",
					},
					{
						name: "Xã Thụy Lôi",
					},
					{
						name: "Xã Cương Chính",
					},
					{
						name: "Xã Minh Phượng",
					},
				],
			},
			{
				name: "Huyện Phù Cừ",
				wards: [
					{
						name: "Thị trấn Trần Cao",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Phan Sào Nam",
					},
					{
						name: "Xã Quang Hưng",
					},
					{
						name: "Xã Minh Hoàng",
					},
					{
						name: "Xã Đoàn Đào",
					},
					{
						name: "Xã Tống Phan",
					},
					{
						name: "Xã Đình Cao",
					},
					{
						name: "Xã Nhật Quang",
					},
					{
						name: "Xã Tiền Tiến",
					},
					{
						name: "Xã Tam Đa",
					},
					{
						name: "Xã Minh Tiến",
					},
					{
						name: "Xã Nguyên Hòa",
					},
					{
						name: "Xã Tống Trân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Thái Bình",
		districts: [
			{
				name: "Thành phố Thái Bình",
				wards: [
					{
						name: "Phường Lê Hồng Phong",
					},
					{
						name: "Phường Bồ Xuyên",
					},
					{
						name: "Phường Đề Thám",
					},
					{
						name: "Phường Kỳ Bá",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Phú Khánh",
					},
					{
						name: "Phường Tiền Phong",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Trần Lãm",
					},
					{
						name: "Xã Đông Hòa",
					},
					{
						name: "Phường Hoàng Diệu",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Vũ Phúc",
					},
					{
						name: "Xã Vũ Chính",
					},
					{
						name: "Xã Đông Mỹ",
					},
					{
						name: "Xã Đông Thọ",
					},
					{
						name: "Xã Vũ Đông",
					},
					{
						name: "Xã Vũ Lạc",
					},
					{
						name: "Xã Tân Bình",
					},
				],
			},
			{
				name: "Huyện Quỳnh Phụ",
				wards: [
					{
						name: "Thị trấn Quỳnh Côi",
					},
					{
						name: "Xã An Khê",
					},
					{
						name: "Xã An Đồng",
					},
					{
						name: "Xã Quỳnh Hoa",
					},
					{
						name: "Xã Quỳnh Lâm",
					},
					{
						name: "Xã Quỳnh Thọ",
					},
					{
						name: "Xã An Hiệp",
					},
					{
						name: "Xã Quỳnh Hoàng",
					},
					{
						name: "Xã Quỳnh Giao",
					},
					{
						name: "Xã An Thái",
					},
					{
						name: "Xã An Cầu",
					},
					{
						name: "Xã Quỳnh Hồng",
					},
					{
						name: "Xã Quỳnh Khê",
					},
					{
						name: "Xã Quỳnh Minh",
					},
					{
						name: "Xã An Ninh",
					},
					{
						name: "Xã Quỳnh Ngọc",
					},
					{
						name: "Xã Quỳnh Hải",
					},
					{
						name: "Thị trấn An Bài",
					},
					{
						name: "Xã An Ấp",
					},
					{
						name: "Xã Quỳnh Hội",
					},
					{
						name: "Xã Châu Sơn",
					},
					{
						name: "Xã Quỳnh Mỹ",
					},
					{
						name: "Xã An Quí",
					},
					{
						name: "Xã An Thanh",
					},
					{
						name: "Xã An Vũ",
					},
					{
						name: "Xã An Lễ",
					},
					{
						name: "Xã Quỳnh Hưng",
					},
					{
						name: "Xã Quỳnh Bảo",
					},
					{
						name: "Xã An Mỹ",
					},
					{
						name: "Xã Quỳnh Nguyên",
					},
					{
						name: "Xã An Vinh",
					},
					{
						name: "Xã Quỳnh Xá",
					},
					{
						name: "Xã An Dục",
					},
					{
						name: "Xã Đông Hải",
					},
					{
						name: "Xã Quỳnh Trang",
					},
					{
						name: "Xã An Tràng",
					},
					{
						name: "Xã Đồng Tiến",
					},
				],
			},
			{
				name: "Huyện Hưng Hà",
				wards: [
					{
						name: "Thị trấn Hưng Hà",
					},
					{
						name: "Xã Điệp Nông",
					},
					{
						name: "Xã Tân Lễ",
					},
					{
						name: "Xã Cộng Hòa",
					},
					{
						name: "Xã Dân Chủ",
					},
					{
						name: "Xã Canh Tân",
					},
					{
						name: "Xã Hòa Tiến",
					},
					{
						name: "Xã Hùng Dũng",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Thị trấn Hưng Nhân",
					},
					{
						name: "Xã Đoan Hùng",
					},
					{
						name: "Xã Duyên Hải",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Văn Cẩm",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Đông Đô",
					},
					{
						name: "Xã Phúc Khánh",
					},
					{
						name: "Xã Liên Hiệp",
					},
					{
						name: "Xã Tây Đô",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Tiến Đức",
					},
					{
						name: "Xã Thái Hưng",
					},
					{
						name: "Xã Thái Phương",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Chi Lăng",
					},
					{
						name: "Xã Minh Khai",
					},
					{
						name: "Xã Hồng An",
					},
					{
						name: "Xã Kim Chung",
					},
					{
						name: "Xã Hồng Lĩnh",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Văn Lang",
					},
					{
						name: "Xã Độc Lập",
					},
					{
						name: "Xã Chí Hòa",
					},
					{
						name: "Xã Minh Hòa",
					},
					{
						name: "Xã Hồng Minh",
					},
				],
			},
			{
				name: "Huyện Đông Hưng",
				wards: [
					{
						name: "Thị trấn Đông Hưng",
					},
					{
						name: "Xã Đô Lương",
					},
					{
						name: "Xã Đông Phương",
					},
					{
						name: "Xã Liên Giang",
					},
					{
						name: "Xã An Châu",
					},
					{
						name: "Xã Đông Sơn",
					},
					{
						name: "Xã Đông Cường",
					},
					{
						name: "Xã Phú Lương",
					},
					{
						name: "Xã Mê Linh",
					},
					{
						name: "Xã Lô Giang",
					},
					{
						name: "Xã Đông La",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Đông Xá",
					},
					{
						name: "Xã Chương Dương",
					},
					{
						name: "Xã Nguyên Xá",
					},
					{
						name: "Xã Phong Châu",
					},
					{
						name: "Xã Hợp Tiến",
					},
					{
						name: "Xã Hồng Việt",
					},
					{
						name: "Xã Hà Giang",
					},
					{
						name: "Xã Đông Kinh",
					},
					{
						name: "Xã Đông Hợp",
					},
					{
						name: "Xã Thăng Long",
					},
					{
						name: "Xã Đông Các",
					},
					{
						name: "Xã Phú Châu",
					},
					{
						name: "Xã Liên Hoa",
					},
					{
						name: "Xã Đông Tân",
					},
					{
						name: "Xã Đông Vinh",
					},
					{
						name: "Xã Đông Động",
					},
					{
						name: "Xã Hồng Bạch",
					},
					{
						name: "Xã Trọng Quan",
					},
					{
						name: "Xã Hồng Giang",
					},
					{
						name: "Xã Đông Quan",
					},
					{
						name: "Xã Đông Quang",
					},
					{
						name: "Xã Đông Xuân",
					},
					{
						name: "Xã Đông Á",
					},
					{
						name: "Xã Đông Hoàng",
					},
					{
						name: "Xã Đông Dương",
					},
					{
						name: "Xã Minh Phú",
					},
				],
			},
			{
				name: "Huyện Thái Thụy",
				wards: [
					{
						name: "Thị trấn Diêm Điền",
					},
					{
						name: "Xã Thụy Trường",
					},
					{
						name: "Xã Hồng Dũng",
					},
					{
						name: "Xã Thụy Quỳnh",
					},
					{
						name: "Xã An Tân",
					},
					{
						name: "Xã Thụy Ninh",
					},
					{
						name: "Xã Thụy Hưng",
					},
					{
						name: "Xã Thụy Việt",
					},
					{
						name: "Xã Thụy Văn",
					},
					{
						name: "Xã Thụy Xuân",
					},
					{
						name: "Xã Dương Phúc",
					},
					{
						name: "Xã Thụy Trình",
					},
					{
						name: "Xã Thụy Bình",
					},
					{
						name: "Xã Thụy Chính",
					},
					{
						name: "Xã Thụy Dân",
					},
					{
						name: "Xã Thụy Hải",
					},
					{
						name: "Xã Thụy Liên",
					},
					{
						name: "Xã Thụy Duyên",
					},
					{
						name: "Xã Thụy Thanh",
					},
					{
						name: "Xã Thụy Sơn",
					},
					{
						name: "Xã Thụy Phong",
					},
					{
						name: "Xã Thái Thượng",
					},
					{
						name: "Xã Thái Nguyên",
					},
					{
						name: "Xã Dương Hồng Thủy",
					},
					{
						name: "Xã Thái Giang",
					},
					{
						name: "Xã Hòa An",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Thái Phúc",
					},
					{
						name: "Xã Thái Hưng",
					},
					{
						name: "Xã Thái Đô",
					},
					{
						name: "Xã Thái Xuyên",
					},
					{
						name: "Xã Mỹ Lộc",
					},
					{
						name: "Xã Tân Học",
					},
					{
						name: "Xã Thái Thịnh",
					},
					{
						name: "Xã Thuần Thành",
					},
					{
						name: "Xã Thái Thọ",
					},
				],
			},
			{
				name: "Huyện Tiền Hải",
				wards: [
					{
						name: "Thị trấn Tiền Hải",
					},
					{
						name: "Xã Đông Trà",
					},
					{
						name: "Xã Đông Long",
					},
					{
						name: "Xã Đông Quí",
					},
					{
						name: "Xã Vũ Lăng",
					},
					{
						name: "Xã Đông Xuyên",
					},
					{
						name: "Xã Tây Lương",
					},
					{
						name: "Xã Tây Ninh",
					},
					{
						name: "Xã Đông Trung",
					},
					{
						name: "Xã Đông Hoàng",
					},
					{
						name: "Xã Đông Minh",
					},
					{
						name: "Xã Đông Phong",
					},
					{
						name: "Xã An Ninh",
					},
					{
						name: "Xã Đông Cơ",
					},
					{
						name: "Xã Tây Giang",
					},
					{
						name: "Xã Đông Lâm",
					},
					{
						name: "Xã Phương Công",
					},
					{
						name: "Xã Tây Phong",
					},
					{
						name: "Xã Tây Tiến",
					},
					{
						name: "Xã Nam Cường",
					},
					{
						name: "Xã Vân Trường",
					},
					{
						name: "Xã Nam Thắng",
					},
					{
						name: "Xã Nam Chính",
					},
					{
						name: "Xã Bắc Hải",
					},
					{
						name: "Xã Nam Thịnh",
					},
					{
						name: "Xã Nam Hà",
					},
					{
						name: "Xã Nam Thanh",
					},
					{
						name: "Xã Nam Trung",
					},
					{
						name: "Xã Nam Hồng",
					},
					{
						name: "Xã Nam Hưng",
					},
					{
						name: "Xã Nam Hải",
					},
					{
						name: "Xã Nam Phú",
					},
				],
			},
			{
				name: "Huyện Kiến Xương",
				wards: [
					{
						name: "Thị trấn Kiến Xương",
					},
					{
						name: "Xã Trà Giang",
					},
					{
						name: "Xã Quốc Tuấn",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Tây Sơn",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Bình Nguyên",
					},
					{
						name: "Xã Lê Lợi",
					},
					{
						name: "Xã Vũ Lễ",
					},
					{
						name: "Xã Thanh Tân",
					},
					{
						name: "Xã Thượng Hiền",
					},
					{
						name: "Xã Nam Cao",
					},
					{
						name: "Xã Đình Phùng",
					},
					{
						name: "Xã Vũ Ninh",
					},
					{
						name: "Xã Vũ An",
					},
					{
						name: "Xã Quang Lịch",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Vũ Quí",
					},
					{
						name: "Xã Quang Bình",
					},
					{
						name: "Xã Vũ Trung",
					},
					{
						name: "Xã Vũ Thắng",
					},
					{
						name: "Xã Vũ Công",
					},
					{
						name: "Xã Vũ Hòa",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Minh Quang",
					},
					{
						name: "Xã Vũ Bình",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Nam Bình",
					},
					{
						name: "Xã Bình Thanh",
					},
					{
						name: "Xã Bình Định",
					},
					{
						name: "Xã Hồng Tiến",
					},
				],
			},
			{
				name: "Huyện Vũ Thư",
				wards: [
					{
						name: "Thị trấn Vũ Thư",
					},
					{
						name: "Xã Hồng Lý",
					},
					{
						name: "Xã Đồng Thanh",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Hiệp Hòa",
					},
					{
						name: "Xã Phúc Thành",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Song Lãng",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Việt Hùng",
					},
					{
						name: "Xã Minh Lãng",
					},
					{
						name: "Xã Minh Khai",
					},
					{
						name: "Xã Dũng Nghĩa",
					},
					{
						name: "Xã Minh Quang",
					},
					{
						name: "Xã Tam Quang",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Bách Thuận",
					},
					{
						name: "Xã Tự Tân",
					},
					{
						name: "Xã Song An",
					},
					{
						name: "Xã Trung An",
					},
					{
						name: "Xã Vũ Hội",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Nguyên Xá",
					},
					{
						name: "Xã Việt Thuận",
					},
					{
						name: "Xã Vũ Vinh",
					},
					{
						name: "Xã Vũ Đoài",
					},
					{
						name: "Xã Vũ Tiến",
					},
					{
						name: "Xã Vũ Vân",
					},
					{
						name: "Xã Duy Nhất",
					},
					{
						name: "Xã Hồng Phong",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Hà Nam",
		districts: [
			{
				name: "Thành phố Phủ Lý",
				wards: [
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Lương Khánh Thiện",
					},
					{
						name: "Phường Lê Hồng Phong",
					},
					{
						name: "Phường Minh Khai",
					},
					{
						name: "Phường Hai Bà Trưng",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Lam Hạ",
					},
					{
						name: "Xã Phù Vân",
					},
					{
						name: "Phường Liêm Chính",
					},
					{
						name: "Xã Liêm Chung",
					},
					{
						name: "Phường Thanh Châu",
					},
					{
						name: "Phường Châu Sơn",
					},
					{
						name: "Xã Tiên Tân",
					},
					{
						name: "Xã Tiên Hiệp",
					},
					{
						name: "Xã Tiên Hải",
					},
					{
						name: "Xã Kim Bình",
					},
					{
						name: "Xã Liêm Tuyền",
					},
					{
						name: "Xã Liêm Tiết",
					},
					{
						name: "Phường Thanh Tuyền",
					},
					{
						name: "Xã Đinh Xá",
					},
					{
						name: "Xã Trịnh Xá",
					},
				],
			},
			{
				name: "Thị xã Duy Tiên",
				wards: [
					{
						name: "Phường Đồng Văn",
					},
					{
						name: "Phường Hòa Mạc",
					},
					{
						name: "Xã Mộc Bắc",
					},
					{
						name: "Phường Châu Giang",
					},
					{
						name: "Phường Bạch Thượng",
					},
					{
						name: "Phường Duy Minh",
					},
					{
						name: "Xã Mộc Nam",
					},
					{
						name: "Phường Duy Hải",
					},
					{
						name: "Xã Chuyên Ngoại",
					},
					{
						name: "Phường Yên Bắc",
					},
					{
						name: "Xã Trác Văn",
					},
					{
						name: "Phường Tiên Nội",
					},
					{
						name: "Phường Hoàng Đông",
					},
					{
						name: "Xã Yên Nam",
					},
					{
						name: "Xã Tiên Ngoại",
					},
					{
						name: "Xã Tiên Sơn",
					},
				],
			},
			{
				name: "Huyện Kim Bảng",
				wards: [
					{
						name: "Thị trấn Quế",
					},
					{
						name: "Xã Nguyễn Úy",
					},
					{
						name: "Xã Đại Cương",
					},
					{
						name: "Xã Lê Hồ",
					},
					{
						name: "Xã Tượng Lĩnh",
					},
					{
						name: "Xã Nhật Tựu",
					},
					{
						name: "Xã Nhật Tân",
					},
					{
						name: "Xã Đồng Hóa",
					},
					{
						name: "Xã Hoàng Tây",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Thụy Lôi",
					},
					{
						name: "Xã Văn Xá",
					},
					{
						name: "Xã Khả Phong",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Thị trấn Ba Sao",
					},
					{
						name: "Xã Liên Sơn",
					},
					{
						name: "Xã Thi Sơn",
					},
					{
						name: "Xã Thanh Sơn",
					},
				],
			},
			{
				name: "Huyện Thanh Liêm",
				wards: [
					{
						name: "Thị trấn Kiện Khê",
					},
					{
						name: "Xã Liêm Phong",
					},
					{
						name: "Xã Thanh Hà",
					},
					{
						name: "Xã Liêm Cần",
					},
					{
						name: "Xã Liêm Thuận",
					},
					{
						name: "Xã Thanh Thủy",
					},
					{
						name: "Xã Thanh Phong",
					},
					{
						name: "Thị trấn Tân Thanh",
					},
					{
						name: "Xã Thanh Tân",
					},
					{
						name: "Xã Liêm Túc",
					},
					{
						name: "Xã Liêm Sơn",
					},
					{
						name: "Xã Thanh Hương",
					},
					{
						name: "Xã Thanh Nghị",
					},
					{
						name: "Xã Thanh Tâm",
					},
					{
						name: "Xã Thanh Nguyên",
					},
					{
						name: "Xã Thanh Hải",
					},
				],
			},
			{
				name: "Huyện Bình Lục",
				wards: [
					{
						name: "Thị trấn Bình Mỹ",
					},
					{
						name: "Xã Bình Nghĩa",
					},
					{
						name: "Xã Tràng An",
					},
					{
						name: "Xã Đồng Du",
					},
					{
						name: "Xã Ngọc Lũ",
					},
					{
						name: "Xã Hưng Công",
					},
					{
						name: "Xã Đồn Xá",
					},
					{
						name: "Xã An Ninh",
					},
					{
						name: "Xã Bồ Đề",
					},
					{
						name: "Xã Bối Cầu",
					},
					{
						name: "Xã An Nội",
					},
					{
						name: "Xã Vũ Bản",
					},
					{
						name: "Xã Trung Lương",
					},
					{
						name: "Xã An Đổ",
					},
					{
						name: "Xã La Sơn",
					},
					{
						name: "Xã Tiêu Động",
					},
					{
						name: "Xã An Lão",
					},
				],
			},
			{
				name: "Huyện Lý Nhân",
				wards: [
					{
						name: "Xã Hợp Lý",
					},
					{
						name: "Xã Nguyên Lý",
					},
					{
						name: "Xã Chính Lý",
					},
					{
						name: "Xã Chân Lý",
					},
					{
						name: "Xã Đạo Lý",
					},
					{
						name: "Xã Công Lý",
					},
					{
						name: "Xã Văn Lý",
					},
					{
						name: "Xã Bắc Lý",
					},
					{
						name: "Xã Đức Lý",
					},
					{
						name: "Xã Trần Hưng Đạo",
					},
					{
						name: "Thị trấn Vĩnh Trụ",
					},
					{
						name: "Xã Nhân Thịnh",
					},
					{
						name: "Xã Nhân Khang",
					},
					{
						name: "Xã Nhân Mỹ",
					},
					{
						name: "Xã Nhân Nghĩa",
					},
					{
						name: "Xã Nhân Chính",
					},
					{
						name: "Xã Nhân Bình",
					},
					{
						name: "Xã Phú Phúc",
					},
					{
						name: "Xã Xuân Khê",
					},
					{
						name: "Xã Tiến Thắng",
					},
					{
						name: "Xã Hòa Hậu",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Nam Định",
		districts: [
			{
				name: "Thành phố Nam Định",
				wards: [
					{
						name: "Phường Hạ Long",
					},
					{
						name: "Phường Trần Tế Xương",
					},
					{
						name: "Phường Vị Hoàng",
					},
					{
						name: "Phường Vị Xuyên",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Cửa Bắc",
					},
					{
						name: "Phường Nguyễn Du",
					},
					{
						name: "Phường Bà Triệu",
					},
					{
						name: "Phường Trường Thi",
					},
					{
						name: "Phường Phan Đình Phùng",
					},
					{
						name: "Phường Ngô Quyền",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Trần Đăng Ninh",
					},
					{
						name: "Phường Năng Tĩnh",
					},
					{
						name: "Phường Văn Miếu",
					},
					{
						name: "Phường Trần Quang Khải",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Lộc Hạ",
					},
					{
						name: "Phường Lộc Vượng",
					},
					{
						name: "Phường Cửa Nam",
					},
					{
						name: "Phường Lộc Hòa",
					},
					{
						name: "Xã Nam Phong",
					},
					{
						name: "Phường Mỹ Xá",
					},
					{
						name: "Xã Lộc An",
					},
					{
						name: "Xã Nam Vân",
					},
				],
			},
			{
				name: "Huyện Mỹ Lộc",
				wards: [
					{
						name: "Thị trấn Mỹ Lộc",
					},
					{
						name: "Xã Mỹ Hà",
					},
					{
						name: "Xã Mỹ Tiến",
					},
					{
						name: "Xã Mỹ Thắng",
					},
					{
						name: "Xã Mỹ Trung",
					},
					{
						name: "Xã Mỹ Tân",
					},
					{
						name: "Xã Mỹ Phúc",
					},
					{
						name: "Xã Mỹ Hưng",
					},
					{
						name: "Xã Mỹ Thuận",
					},
					{
						name: "Xã Mỹ Thịnh",
					},
					{
						name: "Xã Mỹ Thành",
					},
				],
			},
			{
				name: "Huyện Vụ Bản",
				wards: [
					{
						name: "Thị trấn Gôi",
					},
					{
						name: "Xã Minh Thuận",
					},
					{
						name: "Xã Hiển Khánh",
					},
					{
						name: "Xã Tân Khánh",
					},
					{
						name: "Xã Hợp Hưng",
					},
					{
						name: "Xã Đại An",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Cộng Hòa",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Liên Bảo",
					},
					{
						name: "Xã Thành Lợi",
					},
					{
						name: "Xã Kim Thái",
					},
					{
						name: "Xã Liên Minh",
					},
					{
						name: "Xã Đại Thắng",
					},
					{
						name: "Xã Tam Thanh",
					},
					{
						name: "Xã Vĩnh Hào",
					},
				],
			},
			{
				name: "Huyện Ý Yên",
				wards: [
					{
						name: "Thị trấn Lâm",
					},
					{
						name: "Xã Yên Trung",
					},
					{
						name: "Xã Yên Thành",
					},
					{
						name: "Xã Yên Tân",
					},
					{
						name: "Xã Yên Lợi",
					},
					{
						name: "Xã Yên Thọ",
					},
					{
						name: "Xã Yên Nghĩa",
					},
					{
						name: "Xã Yên Minh",
					},
					{
						name: "Xã Yên Phương",
					},
					{
						name: "Xã Yên Chính",
					},
					{
						name: "Xã Yên Bình",
					},
					{
						name: "Xã Yên Phú",
					},
					{
						name: "Xã Yên Mỹ",
					},
					{
						name: "Xã Yên Dương",
					},
					{
						name: "Xã Yên Hưng",
					},
					{
						name: "Xã Yên Khánh",
					},
					{
						name: "Xã Yên Phong",
					},
					{
						name: "Xã Yên Ninh",
					},
					{
						name: "Xã Yên Lương",
					},
					{
						name: "Xã Yên Hồng",
					},
					{
						name: "Xã Yên Quang",
					},
					{
						name: "Xã Yên Tiến",
					},
					{
						name: "Xã Yên Thắng",
					},
					{
						name: "Xã Yên Phúc",
					},
					{
						name: "Xã Yên Cường",
					},
					{
						name: "Xã Yên Lộc",
					},
					{
						name: "Xã Yên Bằng",
					},
					{
						name: "Xã Yên Đồng",
					},
					{
						name: "Xã Yên Khang",
					},
					{
						name: "Xã Yên Nhân",
					},
					{
						name: "Xã Yên Trị",
					},
				],
			},
			{
				name: "Huyện Nghĩa Hưng",
				wards: [
					{
						name: "Thị trấn Liễu Đề",
					},
					{
						name: "Thị trấn Rạng Đông",
					},
					{
						name: "Xã Nghĩa Đồng",
					},
					{
						name: "Xã Nghĩa Thịnh",
					},
					{
						name: "Xã Nghĩa Minh",
					},
					{
						name: "Xã Nghĩa Thái",
					},
					{
						name: "Xã Hoàng Nam",
					},
					{
						name: "Xã Nghĩa Châu",
					},
					{
						name: "Xã Nghĩa Trung",
					},
					{
						name: "Xã Nghĩa Sơn",
					},
					{
						name: "Xã Nghĩa Lạc",
					},
					{
						name: "Xã Nghĩa Hồng",
					},
					{
						name: "Xã Nghĩa Phong",
					},
					{
						name: "Xã Nghĩa Phú",
					},
					{
						name: "Xã Nghĩa Bình",
					},
					{
						name: "Thị trấn Quỹ Nhất",
					},
					{
						name: "Xã Nghĩa Tân",
					},
					{
						name: "Xã Nghĩa Hùng",
					},
					{
						name: "Xã Nghĩa Lâm",
					},
					{
						name: "Xã Nghĩa Thành",
					},
					{
						name: "Xã Phúc Thắng",
					},
					{
						name: "Xã Nghĩa Lợi",
					},
					{
						name: "Xã Nghĩa Hải",
					},
					{
						name: "Xã Nam Điền",
					},
				],
			},
			{
				name: "Huyện Nam Trực",
				wards: [
					{
						name: "Thị trấn Nam Giang",
					},
					{
						name: "Xã Nam Mỹ",
					},
					{
						name: "Xã Điền Xá",
					},
					{
						name: "Xã Nghĩa An",
					},
					{
						name: "Xã Nam Thắng",
					},
					{
						name: "Xã Nam Toàn",
					},
					{
						name: "Xã Hồng Quang",
					},
					{
						name: "Xã Tân Thịnh",
					},
					{
						name: "Xã Nam Cường",
					},
					{
						name: "Xã Nam Hồng",
					},
					{
						name: "Xã Nam Hùng",
					},
					{
						name: "Xã Nam Hoa",
					},
					{
						name: "Xã Nam Dương",
					},
					{
						name: "Xã Nam Thanh",
					},
					{
						name: "Xã Nam Lợi",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Đồng Sơn",
					},
					{
						name: "Xã Nam Tiến",
					},
					{
						name: "Xã Nam Hải",
					},
					{
						name: "Xã Nam Thái",
					},
				],
			},
			{
				name: "Huyện Trực Ninh",
				wards: [
					{
						name: "Thị trấn Cổ Lễ",
					},
					{
						name: "Xã Phương Định",
					},
					{
						name: "Xã Trực Chính",
					},
					{
						name: "Xã Trung Đông",
					},
					{
						name: "Xã Liêm Hải",
					},
					{
						name: "Xã Trực Tuấn",
					},
					{
						name: "Xã Việt Hùng",
					},
					{
						name: "Xã Trực Đạo",
					},
					{
						name: "Xã Trực Hưng",
					},
					{
						name: "Xã Trực Nội",
					},
					{
						name: "Thị trấn Cát Thành",
					},
					{
						name: "Xã Trực Thanh",
					},
					{
						name: "Xã Trực Khang",
					},
					{
						name: "Xã Trực Thuận",
					},
					{
						name: "Xã Trực Mỹ",
					},
					{
						name: "Xã Trực Đại",
					},
					{
						name: "Xã Trực Cường",
					},
					{
						name: "Thị trấn Ninh Cường",
					},
					{
						name: "Xã Trực Thái",
					},
					{
						name: "Xã Trực Hùng",
					},
					{
						name: "Xã Trực Thắng",
					},
				],
			},
			{
				name: "Huyện Xuân Trường",
				wards: [
					{
						name: "Thị trấn Xuân Trường",
					},
					{
						name: "Xã Xuân Châu",
					},
					{
						name: "Xã Xuân Hồng",
					},
					{
						name: "Xã Xuân Thành",
					},
					{
						name: "Xã Xuân Thượng",
					},
					{
						name: "Xã Xuân Phong",
					},
					{
						name: "Xã Xuân Đài",
					},
					{
						name: "Xã Xuân Tân",
					},
					{
						name: "Xã Xuân Thủy",
					},
					{
						name: "Xã Xuân Ngọc",
					},
					{
						name: "Xã Xuân Bắc",
					},
					{
						name: "Xã Xuân Phương",
					},
					{
						name: "Xã Thọ Nghiệp",
					},
					{
						name: "Xã Xuân Phú",
					},
					{
						name: "Xã Xuân Trung",
					},
					{
						name: "Xã Xuân Vinh",
					},
					{
						name: "Xã Xuân Kiên",
					},
					{
						name: "Xã Xuân Tiến",
					},
					{
						name: "Xã Xuân Ninh",
					},
					{
						name: "Xã Xuân Hòa",
					},
				],
			},
			{
				name: "Huyện Giao Thủy",
				wards: [
					{
						name: "Thị trấn Ngô Đồng",
					},
					{
						name: "Thị trấn Quất Lâm",
					},
					{
						name: "Xã Giao Hương",
					},
					{
						name: "Xã Hồng Thuận",
					},
					{
						name: "Xã Giao Thiện",
					},
					{
						name: "Xã Giao Thanh",
					},
					{
						name: "Xã Hoành Sơn",
					},
					{
						name: "Xã Bình Hòa",
					},
					{
						name: "Xã Giao Tiến",
					},
					{
						name: "Xã Giao Hà",
					},
					{
						name: "Xã Giao Nhân",
					},
					{
						name: "Xã Giao An",
					},
					{
						name: "Xã Giao Lạc",
					},
					{
						name: "Xã Giao Châu",
					},
					{
						name: "Xã Giao Tân",
					},
					{
						name: "Xã Giao Yến",
					},
					{
						name: "Xã Giao Xuân",
					},
					{
						name: "Xã Giao Thịnh",
					},
					{
						name: "Xã Giao Hải",
					},
					{
						name: "Xã Bạch Long",
					},
					{
						name: "Xã Giao Long",
					},
					{
						name: "Xã Giao Phong",
					},
				],
			},
			{
				name: "Huyện Hải Hậu",
				wards: [
					{
						name: "Thị trấn Yên Định",
					},
					{
						name: "Thị trấn Cồn",
					},
					{
						name: "Thị trấn Thịnh Long",
					},
					{
						name: "Xã Hải Nam",
					},
					{
						name: "Xã Hải Trung",
					},
					{
						name: "Xã Hải Vân",
					},
					{
						name: "Xã Hải Minh",
					},
					{
						name: "Xã Hải Anh",
					},
					{
						name: "Xã Hải Hưng",
					},
					{
						name: "Xã Hải Bắc",
					},
					{
						name: "Xã Hải Phúc",
					},
					{
						name: "Xã Hải Thanh",
					},
					{
						name: "Xã Hải Hà",
					},
					{
						name: "Xã Hải Long",
					},
					{
						name: "Xã Hải Phương",
					},
					{
						name: "Xã Hải Đường",
					},
					{
						name: "Xã Hải Lộc",
					},
					{
						name: "Xã Hải Quang",
					},
					{
						name: "Xã Hải Đông",
					},
					{
						name: "Xã Hải Sơn",
					},
					{
						name: "Xã Hải Tân",
					},
					{
						name: "Xã Hải Phong",
					},
					{
						name: "Xã Hải An",
					},
					{
						name: "Xã Hải Tây",
					},
					{
						name: "Xã Hải Lý",
					},
					{
						name: "Xã Hải Phú",
					},
					{
						name: "Xã Hải Giang",
					},
					{
						name: "Xã Hải Cường",
					},
					{
						name: "Xã Hải Ninh",
					},
					{
						name: "Xã Hải Chính",
					},
					{
						name: "Xã Hải Xuân",
					},
					{
						name: "Xã Hải Châu",
					},
					{
						name: "Xã Hải Triều",
					},
					{
						name: "Xã Hải Hòa",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Ninh Bình",
		districts: [
			{
				name: "Thành phố Ninh Bình",
				wards: [
					{
						name: "Phường Đông Thành",
					},
					{
						name: "Phường Tân Thành",
					},
					{
						name: "Phường Thanh Bình",
					},
					{
						name: "Phường Vân Giang",
					},
					{
						name: "Phường Bích Đào",
					},
					{
						name: "Phường Phúc Thành",
					},
					{
						name: "Phường Nam Bình",
					},
					{
						name: "Phường Nam Thành",
					},
					{
						name: "Phường Ninh Khánh",
					},
					{
						name: "Xã Ninh Nhất",
					},
					{
						name: "Xã Ninh Tiến",
					},
					{
						name: "Xã Ninh Phúc",
					},
					{
						name: "Phường Ninh Sơn",
					},
					{
						name: "Phường Ninh Phong",
					},
				],
			},
			{
				name: "Thành phố Tam Điệp",
				wards: [
					{
						name: "Phường Bắc Sơn",
					},
					{
						name: "Phường Trung Sơn",
					},
					{
						name: "Phường Nam Sơn",
					},
					{
						name: "Phường Tây Sơn",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Phường Yên Bình",
					},
					{
						name: "Phường Tân Bình",
					},
					{
						name: "Xã Quang Sơn",
					},
					{
						name: "Xã Đông Sơn",
					},
				],
			},
			{
				name: "Huyện Nho Quan",
				wards: [
					{
						name: "Thị trấn Nho Quan",
					},
					{
						name: "Xã Xích Thổ",
					},
					{
						name: "Xã Gia Lâm",
					},
					{
						name: "Xã Gia Sơn",
					},
					{
						name: "Xã Thạch Bình",
					},
					{
						name: "Xã Gia Thủy",
					},
					{
						name: "Xã Gia Tường",
					},
					{
						name: "Xã Cúc Phương",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Đức Long",
					},
					{
						name: "Xã Lạc Vân",
					},
					{
						name: "Xã Đồng Phong",
					},
					{
						name: "Xã Yên Quang",
					},
					{
						name: "Xã Lạng Phong",
					},
					{
						name: "Xã Thượng Hòa",
					},
					{
						name: "Xã Văn Phong",
					},
					{
						name: "Xã Văn Phương",
					},
					{
						name: "Xã Thanh Lạc",
					},
					{
						name: "Xã Sơn Lai",
					},
					{
						name: "Xã Sơn Thành",
					},
					{
						name: "Xã Văn Phú",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Kỳ Phú",
					},
					{
						name: "Xã Quỳnh Lưu",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Phú Long",
					},
					{
						name: "Xã Quảng Lạc",
					},
				],
			},
			{
				name: "Huyện Gia Viễn",
				wards: [
					{
						name: "Thị trấn Me",
					},
					{
						name: "Xã Gia Hòa",
					},
					{
						name: "Xã Gia Hưng",
					},
					{
						name: "Xã Liên Sơn",
					},
					{
						name: "Xã Gia Thanh",
					},
					{
						name: "Xã Gia Vân",
					},
					{
						name: "Xã Gia Phú",
					},
					{
						name: "Xã Gia Xuân",
					},
					{
						name: "Xã Gia Lập",
					},
					{
						name: "Xã Gia Vượng",
					},
					{
						name: "Xã Gia Trấn",
					},
					{
						name: "Xã Gia Thịnh",
					},
					{
						name: "Xã Gia Phương",
					},
					{
						name: "Xã Gia Tân",
					},
					{
						name: "Xã Gia Thắng",
					},
					{
						name: "Xã Gia Trung",
					},
					{
						name: "Xã Gia Minh",
					},
					{
						name: "Xã Gia Lạc",
					},
					{
						name: "Xã Gia Tiến",
					},
					{
						name: "Xã Gia Sinh",
					},
					{
						name: "Xã Gia Phong",
					},
				],
			},
			{
				name: "Huyện Hoa Lư",
				wards: [
					{
						name: "Thị trấn Thiên Tôn",
					},
					{
						name: "Xã Ninh Giang",
					},
					{
						name: "Xã Trường Yên",
					},
					{
						name: "Xã Ninh Khang",
					},
					{
						name: "Xã Ninh Mỹ",
					},
					{
						name: "Xã Ninh Hòa",
					},
					{
						name: "Xã Ninh Xuân",
					},
					{
						name: "Xã Ninh Hải",
					},
					{
						name: "Xã Ninh Thắng",
					},
					{
						name: "Xã Ninh Vân",
					},
					{
						name: "Xã Ninh An",
					},
				],
			},
			{
				name: "Huyện Yên Khánh",
				wards: [
					{
						name: "Thị trấn Yên Ninh",
					},
					{
						name: "Xã Khánh Tiên",
					},
					{
						name: "Xã Khánh Phú",
					},
					{
						name: "Xã Khánh Hòa",
					},
					{
						name: "Xã Khánh Lợi",
					},
					{
						name: "Xã Khánh An",
					},
					{
						name: "Xã Khánh Cường",
					},
					{
						name: "Xã Khánh Cư",
					},
					{
						name: "Xã Khánh Thiện",
					},
					{
						name: "Xã Khánh Hải",
					},
					{
						name: "Xã Khánh Trung",
					},
					{
						name: "Xã Khánh Mậu",
					},
					{
						name: "Xã Khánh Vân",
					},
					{
						name: "Xã Khánh Hội",
					},
					{
						name: "Xã Khánh Công",
					},
					{
						name: "Xã Khánh Thành",
					},
					{
						name: "Xã Khánh Nhạc",
					},
					{
						name: "Xã Khánh Thủy",
					},
					{
						name: "Xã Khánh Hồng",
					},
				],
			},
			{
				name: "Huyện Kim Sơn",
				wards: [
					{
						name: "Thị trấn Phát Diệm",
					},
					{
						name: "Thị trấn Bình Minh",
					},
					{
						name: "Xã Hồi Ninh",
					},
					{
						name: "Xã Xuân Chính",
					},
					{
						name: "Xã Kim Định",
					},
					{
						name: "Xã Ân Hòa",
					},
					{
						name: "Xã Hùng Tiến",
					},
					{
						name: "Xã Quang Thiện",
					},
					{
						name: "Xã Như Hòa",
					},
					{
						name: "Xã Chất Bình",
					},
					{
						name: "Xã Đồng Hướng",
					},
					{
						name: "Xã Kim Chính",
					},
					{
						name: "Xã Thượng Kiệm",
					},
					{
						name: "Xã Lưu Phương",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Yên Lộc",
					},
					{
						name: "Xã Lai Thành",
					},
					{
						name: "Xã Định Hóa",
					},
					{
						name: "Xã Văn Hải",
					},
					{
						name: "Xã Kim Tân",
					},
					{
						name: "Xã Kim Mỹ",
					},
					{
						name: "Xã Cồn Thoi",
					},
					{
						name: "Xã Kim Hải",
					},
					{
						name: "Xã Kim Trung",
					},
					{
						name: "Xã Kim Đông",
					},
				],
			},
			{
				name: "Huyện Yên Mô",
				wards: [
					{
						name: "Thị trấn Yên Thịnh",
					},
					{
						name: "Xã Khánh Thượng",
					},
					{
						name: "Xã Khánh Dương",
					},
					{
						name: "Xã Mai Sơn",
					},
					{
						name: "Xã Khánh Thịnh",
					},
					{
						name: "Xã Yên Phong",
					},
					{
						name: "Xã Yên Hòa",
					},
					{
						name: "Xã Yên Thắng",
					},
					{
						name: "Xã Yên Từ",
					},
					{
						name: "Xã Yên Hưng",
					},
					{
						name: "Xã Yên Thành",
					},
					{
						name: "Xã Yên Nhân",
					},
					{
						name: "Xã Yên Mỹ",
					},
					{
						name: "Xã Yên Mạc",
					},
					{
						name: "Xã Yên Đồng",
					},
					{
						name: "Xã Yên Thái",
					},
					{
						name: "Xã Yên Lâm",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Thanh Hóa",
		districts: [
			{
				name: "Thành phố Thanh Hóa",
				wards: [
					{
						name: "Phường Hàm Rồng",
					},
					{
						name: "Phường Đông Thọ",
					},
					{
						name: "Phường Nam Ngạn",
					},
					{
						name: "Phường Trường Thi",
					},
					{
						name: "Phường Điện Biên",
					},
					{
						name: "Phường Phú Sơn",
					},
					{
						name: "Phường Lam Sơn",
					},
					{
						name: "Phường Ba Đình",
					},
					{
						name: "Phường Ngọc Trạo",
					},
					{
						name: "Phường Đông Vệ",
					},
					{
						name: "Phường Đông Sơn",
					},
					{
						name: "Phường Tân Sơn",
					},
					{
						name: "Phường Đông Cương",
					},
					{
						name: "Phường Đông Hương",
					},
					{
						name: "Phường Đông Hải",
					},
					{
						name: "Phường Quảng Hưng",
					},
					{
						name: "Phường Quảng Thắng",
					},
					{
						name: "Phường Quảng Thành",
					},
					{
						name: "Xã Thiệu Vân",
					},
					{
						name: "Phường Thiệu Khánh",
					},
					{
						name: "Phường Thiệu Dương",
					},
					{
						name: "Phường Tào Xuyên",
					},
					{
						name: "Phường Long Anh",
					},
					{
						name: "Xã Hoằng Quang",
					},
					{
						name: "Xã Hoằng Đại",
					},
					{
						name: "Phường Đông Lĩnh",
					},
					{
						name: "Xã Đông Vinh",
					},
					{
						name: "Phường Đông Tân",
					},
					{
						name: "Phường An Hưng",
					},
					{
						name: "Phường Quảng Thịnh",
					},
					{
						name: "Phường Quảng Đông",
					},
					{
						name: "Phường Quảng Cát",
					},
					{
						name: "Phường Quảng Phú",
					},
					{
						name: "Phường Quảng Tâm",
					},
				],
			},
			{
				name: "Thị xã Bỉm Sơn",
				wards: [
					{
						name: "Phường Bắc Sơn",
					},
					{
						name: "Phường Ba Đình",
					},
					{
						name: "Phường Lam Sơn",
					},
					{
						name: "Phường Ngọc Trạo",
					},
					{
						name: "Phường Đông Sơn",
					},
					{
						name: "Phường Phú Sơn",
					},
					{
						name: "Xã Quang Trung",
					},
				],
			},
			{
				name: "Thành phố Sầm Sơn",
				wards: [
					{
						name: "Phường Trung Sơn",
					},
					{
						name: "Phường Bắc Sơn",
					},
					{
						name: "Phường Trường Sơn",
					},
					{
						name: "Phường Quảng Cư",
					},
					{
						name: "Phường Quảng Tiến",
					},
					{
						name: "Xã Quảng Minh",
					},
					{
						name: "Xã Quảng Hùng",
					},
					{
						name: "Phường Quảng Thọ",
					},
					{
						name: "Phường Quảng Châu",
					},
					{
						name: "Phường Quảng Vinh",
					},
					{
						name: "Xã Quảng Đại",
					},
				],
			},
			{
				name: "Huyện Mường Lát",
				wards: [
					{
						name: "Thị trấn Mường Lát",
					},
					{
						name: "Xã Tam Chung",
					},
					{
						name: "Xã Mường Lý",
					},
					{
						name: "Xã Trung Lý",
					},
					{
						name: "Xã Quang Chiểu",
					},
					{
						name: "Xã Pù Nhi",
					},
					{
						name: "Xã Nhi Sơn",
					},
					{
						name: "Xã Mường Chanh",
					},
				],
			},
			{
				name: "Huyện Quan Hóa",
				wards: [
					{
						name: "Thị trấn Hồi Xuân",
					},
					{
						name: "Xã Thành Sơn",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Phú Thanh",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Phú Lệ",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Hiền Chung",
					},
					{
						name: "Xã Hiền Kiệt",
					},
					{
						name: "Xã Nam Tiến",
					},
					{
						name: "Xã Thiên Phủ",
					},
					{
						name: "Xã Phú Nghiêm",
					},
					{
						name: "Xã Nam Xuân",
					},
					{
						name: "Xã Nam Động",
					},
				],
			},
			{
				name: "Huyện Bá Thước",
				wards: [
					{
						name: "Thị trấn Cành Nàng",
					},
					{
						name: "Xã Điền Thượng",
					},
					{
						name: "Xã Điền Hạ",
					},
					{
						name: "Xã Điền Quang",
					},
					{
						name: "Xã Điền Trung",
					},
					{
						name: "Xã Thành Sơn",
					},
					{
						name: "Xã Lương Ngoại",
					},
					{
						name: "Xã Ái Thượng",
					},
					{
						name: "Xã Lương Nội",
					},
					{
						name: "Xã Điền Lư",
					},
					{
						name: "Xã Lương Trung",
					},
					{
						name: "Xã Lũng Niêm",
					},
					{
						name: "Xã Lũng Cao",
					},
					{
						name: "Xã Hạ Trung",
					},
					{
						name: "Xã Cổ Lũng",
					},
					{
						name: "Xã Thành Lâm",
					},
					{
						name: "Xã Ban Công",
					},
					{
						name: "Xã Kỳ Tân",
					},
					{
						name: "Xã Văn Nho",
					},
					{
						name: "Xã Thiết Ống",
					},
					{
						name: "Xã Thiết Kế",
					},
				],
			},
			{
				name: "Huyện Quan Sơn",
				wards: [
					{
						name: "Xã Trung Xuân",
					},
					{
						name: "Xã Trung Thượng",
					},
					{
						name: "Xã Trung Tiến",
					},
					{
						name: "Xã Trung Hạ",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Tam Thanh",
					},
					{
						name: "Xã Sơn Thủy",
					},
					{
						name: "Xã Na Mèo",
					},
					{
						name: "Thị trấn Sơn Lư",
					},
					{
						name: "Xã Tam Lư",
					},
					{
						name: "Xã Sơn Điện",
					},
					{
						name: "Xã Mường Mìn",
					},
				],
			},
			{
				name: "Huyện Lang Chánh",
				wards: [
					{
						name: "Xã Yên Khương",
					},
					{
						name: "Xã Yên Thắng",
					},
					{
						name: "Xã Trí Nang",
					},
					{
						name: "Xã Giao An",
					},
					{
						name: "Xã Giao Thiện",
					},
					{
						name: "Xã Tân Phúc",
					},
					{
						name: "Xã Tam Văn",
					},
					{
						name: "Xã Lâm Phú",
					},
					{
						name: "Thị trấn Lang Chánh",
					},
					{
						name: "Xã Đồng Lương",
					},
				],
			},
			{
				name: "Huyện Ngọc Lặc",
				wards: [
					{
						name: "Thị Trấn Ngọc Lặc",
					},
					{
						name: "Xã Lam Sơn",
					},
					{
						name: "Xã Mỹ Tân",
					},
					{
						name: "Xã Thúy Sơn",
					},
					{
						name: "Xã Thạch Lập",
					},
					{
						name: "Xã Vân Âm",
					},
					{
						name: "Xã Cao Ngọc",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Đồng Thịnh",
					},
					{
						name: "Xã Ngọc Liên",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Lộc Thịnh",
					},
					{
						name: "Xã Cao Thịnh",
					},
					{
						name: "Xã Ngọc Trung",
					},
					{
						name: "Xã Phùng Giáo",
					},
					{
						name: "Xã Phùng Minh",
					},
					{
						name: "Xã Phúc Thịnh",
					},
					{
						name: "Xã Nguyệt Ấn",
					},
					{
						name: "Xã Kiên Thọ",
					},
					{
						name: "Xã Minh Tiến",
					},
					{
						name: "Xã Minh Sơn",
					},
				],
			},
			{
				name: "Huyện Cẩm Thủy",
				wards: [
					{
						name: "Thị trấn Phong Sơn",
					},
					{
						name: "Xã Cẩm Thành",
					},
					{
						name: "Xã Cẩm Quý",
					},
					{
						name: "Xã Cẩm Lương",
					},
					{
						name: "Xã Cẩm Thạch",
					},
					{
						name: "Xã Cẩm Liên",
					},
					{
						name: "Xã Cẩm Giang",
					},
					{
						name: "Xã Cẩm Bình",
					},
					{
						name: "Xã Cẩm Tú",
					},
					{
						name: "Xã Cẩm Châu",
					},
					{
						name: "Xã Cẩm Tâm",
					},
					{
						name: "Xã Cẩm Ngọc",
					},
					{
						name: "Xã Cẩm Long",
					},
					{
						name: "Xã Cẩm Yên",
					},
					{
						name: "Xã Cẩm Tân",
					},
					{
						name: "Xã Cẩm Phú",
					},
					{
						name: "Xã Cẩm Vân",
					},
				],
			},
			{
				name: "Huyện Thạch Thành",
				wards: [
					{
						name: "Thị trấn Kim Tân",
					},
					{
						name: "Thị trấn Vân Du",
					},
					{
						name: "Xã Thạch Lâm",
					},
					{
						name: "Xã Thạch Quảng",
					},
					{
						name: "Xã Thạch Tượng",
					},
					{
						name: "Xã Thạch Cẩm",
					},
					{
						name: "Xã Thạch Sơn",
					},
					{
						name: "Xã Thạch Bình",
					},
					{
						name: "Xã Thạch Định",
					},
					{
						name: "Xã Thạch Đồng",
					},
					{
						name: "Xã Thạch Long",
					},
					{
						name: "Xã Thành Mỹ",
					},
					{
						name: "Xã Thành Yên",
					},
					{
						name: "Xã Thành Vinh",
					},
					{
						name: "Xã Thành Minh",
					},
					{
						name: "Xã Thành Công",
					},
					{
						name: "Xã Thành Tân",
					},
					{
						name: "Xã Thành Trực",
					},
					{
						name: "Xã Thành Tâm",
					},
					{
						name: "Xã Thành An",
					},
					{
						name: "Xã Thành Thọ",
					},
					{
						name: "Xã Thành Tiến",
					},
					{
						name: "Xã Thành Long",
					},
					{
						name: "Xã Thành Hưng",
					},
					{
						name: "Xã Ngọc Trạo",
					},
				],
			},
			{
				name: "Huyện Hà Trung",
				wards: [
					{
						name: "Thị trấn Hà Trung",
					},
					{
						name: "Xã Hà Long",
					},
					{
						name: "Xã Hà Vinh",
					},
					{
						name: "Xã Hà Bắc",
					},
					{
						name: "Xã Hoạt Giang",
					},
					{
						name: "Xã Yên Dương",
					},
					{
						name: "Xã Hà Giang",
					},
					{
						name: "Xã Lĩnh Toại",
					},
					{
						name: "Xã Hà Ngọc",
					},
					{
						name: "Xã Yến Sơn",
					},
					{
						name: "Xã Hà Sơn",
					},
					{
						name: "Xã Hà Lĩnh",
					},
					{
						name: "Xã Hà Đông",
					},
					{
						name: "Xã Hà Tân",
					},
					{
						name: "Xã Hà Tiến",
					},
					{
						name: "Xã Hà Bình",
					},
					{
						name: "Xã Hà Lai",
					},
					{
						name: "Xã Hà Châu",
					},
					{
						name: "Xã Hà Thái",
					},
					{
						name: "Xã Hà Hải",
					},
				],
			},
			{
				name: "Huyện Vĩnh Lộc",
				wards: [
					{
						name: "Thị trấn Vĩnh Lộc",
					},
					{
						name: "Xã Vĩnh Quang",
					},
					{
						name: "Xã Vĩnh Yên",
					},
					{
						name: "Xã Vĩnh Tiến",
					},
					{
						name: "Xã Vĩnh Long",
					},
					{
						name: "Xã Vĩnh Phúc",
					},
					{
						name: "Xã Vĩnh Hưng",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Vĩnh Hùng",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Ninh Khang",
					},
					{
						name: "Xã Vĩnh Thịnh",
					},
					{
						name: "Xã Vĩnh An",
					},
				],
			},
			{
				name: "Huyện Yên Định",
				wards: [
					{
						name: "Thị trấn Thống Nhất",
					},
					{
						name: "Xã Yên Lâm",
					},
					{
						name: "Xã Yên Tâm",
					},
					{
						name: "Xã Yên Phú",
					},
					{
						name: "Xã Quí Lộc",
					},
					{
						name: "Xã Yên Thọ",
					},
					{
						name: "Xã Yên Trung",
					},
					{
						name: "Xã Yên Trường",
					},
					{
						name: "Xã Yên Phong",
					},
					{
						name: "Xã Yên Thái",
					},
					{
						name: "Xã Yên Hùng",
					},
					{
						name: "Xã Yên Thịnh",
					},
					{
						name: "Xã Yên Ninh",
					},
					{
						name: "Xã Yên Lạc",
					},
					{
						name: "Xã Định Tăng",
					},
					{
						name: "Xã Định Hòa",
					},
					{
						name: "Xã Định Thành",
					},
					{
						name: "Xã Định Công",
					},
					{
						name: "Xã Định Tân",
					},
					{
						name: "Xã Định Tiến",
					},
					{
						name: "Xã Định Long",
					},
					{
						name: "Xã Định Liên",
					},
					{
						name: "Thị trấn Quán Lào",
					},
					{
						name: "Xã Định Hưng",
					},
					{
						name: "Xã Định Hải",
					},
					{
						name: "Xã Định Bình",
					},
				],
			},
			{
				name: "Huyện Thọ Xuân",
				wards: [
					{
						name: "Xã Xuân Hồng",
					},
					{
						name: "Thị trấn Thọ Xuân",
					},
					{
						name: "Xã Bắc Lương",
					},
					{
						name: "Xã Nam Giang",
					},
					{
						name: "Xã Xuân Phong",
					},
					{
						name: "Xã Thọ Lộc",
					},
					{
						name: "Xã Xuân Trường",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Thọ Hải",
					},
					{
						name: "Xã Tây Hồ",
					},
					{
						name: "Xã Xuân Giang",
					},
					{
						name: "Xã Xuân Sinh",
					},
					{
						name: "Xã Xuân Hưng",
					},
					{
						name: "Xã Thọ Diên",
					},
					{
						name: "Xã Thọ Lâm",
					},
					{
						name: "Xã Thọ Xương",
					},
					{
						name: "Xã Xuân Bái",
					},
					{
						name: "Xã Xuân Phú",
					},
					{
						name: "Thị trấn Sao Vàng",
					},
					{
						name: "Thị trấn Lam Sơn",
					},
					{
						name: "Xã Xuân Thiên",
					},
					{
						name: "Xã Thuận Minh",
					},
					{
						name: "Xã Thọ Lập",
					},
					{
						name: "Xã Quảng Phú",
					},
					{
						name: "Xã Xuân Tín",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Xuân Lai",
					},
					{
						name: "Xã Xuân Lập",
					},
					{
						name: "Xã Xuân Minh",
					},
					{
						name: "Xã Trường Xuân",
					},
				],
			},
			{
				name: "Huyện Thường Xuân",
				wards: [
					{
						name: "Xã Bát Mọt",
					},
					{
						name: "Xã Yên Nhân",
					},
					{
						name: "Xã Xuân Lẹ",
					},
					{
						name: "Xã Vạn Xuân",
					},
					{
						name: "Xã Lương Sơn",
					},
					{
						name: "Xã Xuân Cao",
					},
					{
						name: "Xã Luận Thành",
					},
					{
						name: "Xã Luận Khê",
					},
					{
						name: "Xã Xuân Thắng",
					},
					{
						name: "Xã Xuân Lộc",
					},
					{
						name: "Thị trấn Thường Xuân",
					},
					{
						name: "Xã Xuân Dương",
					},
					{
						name: "Xã Thọ Thanh",
					},
					{
						name: "Xã Ngọc Phụng",
					},
					{
						name: "Xã Xuân Chinh",
					},
					{
						name: "Xã Tân Thành",
					},
				],
			},
			{
				name: "Huyện Triệu Sơn",
				wards: [
					{
						name: "Thị trấn Triệu Sơn",
					},
					{
						name: "Xã Thọ Sơn",
					},
					{
						name: "Xã Thọ Bình",
					},
					{
						name: "Xã Thọ Tiến",
					},
					{
						name: "Xã Hợp Lý",
					},
					{
						name: "Xã Hợp Tiến",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Triệu Thành",
					},
					{
						name: "Xã Hợp Thắng",
					},
					{
						name: "Xã Minh Sơn",
					},
					{
						name: "Xã Dân Lực",
					},
					{
						name: "Xã Dân Lý",
					},
					{
						name: "Xã Dân Quyền",
					},
					{
						name: "Xã An Nông",
					},
					{
						name: "Xã Văn Sơn",
					},
					{
						name: "Xã Thái Hòa",
					},
					{
						name: "Thị trấn Nưa",
					},
					{
						name: "Xã Đồng Lợi",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Đồng Thắng",
					},
					{
						name: "Xã Tiến Nông",
					},
					{
						name: "Xã Khuyến Nông",
					},
					{
						name: "Xã Xuân Thịnh",
					},
					{
						name: "Xã Xuân Lộc",
					},
					{
						name: "Xã Thọ Dân",
					},
					{
						name: "Xã Xuân Thọ",
					},
					{
						name: "Xã Thọ Tân",
					},
					{
						name: "Xã Thọ Ngọc",
					},
					{
						name: "Xã Thọ Cường",
					},
					{
						name: "Xã Thọ Phú",
					},
					{
						name: "Xã Thọ Vực",
					},
					{
						name: "Xã Thọ Thế",
					},
					{
						name: "Xã Nông Trường",
					},
					{
						name: "Xã Bình Sơn",
					},
				],
			},
			{
				name: "Huyện Thiệu Hóa",
				wards: [
					{
						name: "Thị trấn Thiệu Hóa",
					},
					{
						name: "Xã Thiệu Ngọc",
					},
					{
						name: "Xã Thiệu Vũ",
					},
					{
						name: "Xã Thiệu Phúc",
					},
					{
						name: "Xã Thiệu Tiến",
					},
					{
						name: "Xã Thiệu Công",
					},
					{
						name: "Xã Thiệu Phú",
					},
					{
						name: "Xã Thiệu Long",
					},
					{
						name: "Xã Thiệu Giang",
					},
					{
						name: "Xã Thiệu Duy",
					},
					{
						name: "Xã Thiệu Nguyên",
					},
					{
						name: "Xã Thiệu Hợp",
					},
					{
						name: "Xã Thiệu Thịnh",
					},
					{
						name: "Xã Thiệu Quang",
					},
					{
						name: "Xã Thiệu Thành",
					},
					{
						name: "Xã Thiệu Toán",
					},
					{
						name: "Xã Thiệu Chính",
					},
					{
						name: "Xã Thiệu Hòa",
					},
					{
						name: "Xã Minh Tâm",
					},
					{
						name: "Xã Thiệu Viên",
					},
					{
						name: "Xã Thiệu Lý",
					},
					{
						name: "Xã Thiệu Vận",
					},
					{
						name: "Xã Thiệu Trung",
					},
					{
						name: "Xã Tân Châu",
					},
					{
						name: "Xã Thiệu Giao",
					},
				],
			},
			{
				name: "Huyện Hoằng Hóa",
				wards: [
					{
						name: "Thị trấn Bút Sơn",
					},
					{
						name: "Xã Hoằng Giang",
					},
					{
						name: "Xã Hoằng Xuân",
					},
					{
						name: "Xã Hoằng Phượng",
					},
					{
						name: "Xã Hoằng Phú",
					},
					{
						name: "Xã Hoằng Quỳ",
					},
					{
						name: "Xã Hoằng Kim",
					},
					{
						name: "Xã Hoằng Trung",
					},
					{
						name: "Xã Hoằng Trinh",
					},
					{
						name: "Xã Hoằng Sơn",
					},
					{
						name: "Xã Hoằng Cát",
					},
					{
						name: "Xã Hoằng Xuyên",
					},
					{
						name: "Xã Hoằng Quý",
					},
					{
						name: "Xã Hoằng Hợp",
					},
					{
						name: "Xã Hoằng Đức",
					},
					{
						name: "Xã Hoằng Hà",
					},
					{
						name: "Xã Hoằng Đạt",
					},
					{
						name: "Xã Hoằng Đạo",
					},
					{
						name: "Xã Hoằng Thắng",
					},
					{
						name: "Xã Hoằng Đồng",
					},
					{
						name: "Xã Hoằng Thái",
					},
					{
						name: "Xã Hoằng Thịnh",
					},
					{
						name: "Xã Hoằng Thành",
					},
					{
						name: "Xã Hoằng Lộc",
					},
					{
						name: "Xã Hoằng Trạch",
					},
					{
						name: "Xã Hoằng Phong",
					},
					{
						name: "Xã Hoằng Lưu",
					},
					{
						name: "Xã Hoằng Châu",
					},
					{
						name: "Xã Hoằng Tân",
					},
					{
						name: "Xã Hoằng Yến",
					},
					{
						name: "Xã Hoằng Tiến",
					},
					{
						name: "Xã Hoằng Hải",
					},
					{
						name: "Xã Hoằng Ngọc",
					},
					{
						name: "Xã Hoằng Đông",
					},
					{
						name: "Xã Hoằng Thanh",
					},
					{
						name: "Xã Hoằng Phụ",
					},
					{
						name: "Xã Hoằng Trường",
					},
				],
			},
			{
				name: "Huyện Hậu Lộc",
				wards: [
					{
						name: "Thị trấn Hậu Lộc",
					},
					{
						name: "Xã Đồng Lộc",
					},
					{
						name: "Xã Đại Lộc",
					},
					{
						name: "Xã Triệu Lộc",
					},
					{
						name: "Xã Tiến Lộc",
					},
					{
						name: "Xã Lộc Sơn",
					},
					{
						name: "Xã Cầu Lộc",
					},
					{
						name: "Xã Thành Lộc",
					},
					{
						name: "Xã Tuy Lộc",
					},
					{
						name: "Xã Phong Lộc",
					},
					{
						name: "Xã Mỹ Lộc",
					},
					{
						name: "Xã Thuần Lộc",
					},
					{
						name: "Xã Xuân Lộc",
					},
					{
						name: "Xã Hoa Lộc",
					},
					{
						name: "Xã Liên Lộc",
					},
					{
						name: "Xã Quang Lộc",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Hòa Lộc",
					},
					{
						name: "Xã Minh Lộc",
					},
					{
						name: "Xã Hưng Lộc",
					},
					{
						name: "Xã Hải Lộc",
					},
					{
						name: "Xã Đa Lộc",
					},
					{
						name: "Xã Ngư Lộc",
					},
				],
			},
			{
				name: "Huyện Nga Sơn",
				wards: [
					{
						name: "Thị trấn Nga Sơn",
					},
					{
						name: "Xã Ba Đình",
					},
					{
						name: "Xã Nga Vịnh",
					},
					{
						name: "Xã Nga Văn",
					},
					{
						name: "Xã Nga Thiện",
					},
					{
						name: "Xã Nga Tiến",
					},
					{
						name: "Xã Nga Phượng",
					},
					{
						name: "Xã Nga Trung",
					},
					{
						name: "Xã Nga Bạch",
					},
					{
						name: "Xã Nga Thanh",
					},
					{
						name: "Xã Nga Yên",
					},
					{
						name: "Xã Nga Giáp",
					},
					{
						name: "Xã Nga Hải",
					},
					{
						name: "Xã Nga Thành",
					},
					{
						name: "Xã Nga An",
					},
					{
						name: "Xã Nga Phú",
					},
					{
						name: "Xã Nga Điền",
					},
					{
						name: "Xã Nga Tân",
					},
					{
						name: "Xã Nga Thủy",
					},
					{
						name: "Xã Nga Liên",
					},
					{
						name: "Xã Nga Thái",
					},
					{
						name: "Xã Nga Thạch",
					},
					{
						name: "Xã Nga Thắng",
					},
					{
						name: "Xã Nga Trường",
					},
				],
			},
			{
				name: "Huyện Như Xuân",
				wards: [
					{
						name: "Thị trấn Yên Cát",
					},
					{
						name: "Xã Bãi Trành",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Xuân Bình",
					},
					{
						name: "Xã Hóa Quỳ",
					},
					{
						name: "Xã Cát Vân",
					},
					{
						name: "Xã Cát Tân",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Bình Lương",
					},
					{
						name: "Xã Thanh Quân",
					},
					{
						name: "Xã Thanh Xuân",
					},
					{
						name: "Xã Thanh Hòa",
					},
					{
						name: "Xã Thanh Phong",
					},
					{
						name: "Xã Thanh Lâm",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Thượng Ninh",
					},
				],
			},
			{
				name: "Huyện Như Thanh",
				wards: [
					{
						name: "Thị trấn Bến Sung",
					},
					{
						name: "Xã Cán Khê",
					},
					{
						name: "Xã Xuân Du",
					},
					{
						name: "Xã Phượng Nghi",
					},
					{
						name: "Xã Mậu Lâm",
					},
					{
						name: "Xã Xuân Khang",
					},
					{
						name: "Xã Phú Nhuận",
					},
					{
						name: "Xã Hải Long",
					},
					{
						name: "Xã Xuân Thái",
					},
					{
						name: "Xã Xuân Phúc",
					},
					{
						name: "Xã Yên Thọ",
					},
					{
						name: "Xã Yên Lạc",
					},
					{
						name: "Xã Thanh Tân",
					},
					{
						name: "Xã Thanh Kỳ",
					},
				],
			},
			{
				name: "Huyện Nông Cống",
				wards: [
					{
						name: "Thị trấn Nông Cống",
					},
					{
						name: "Xã Tân Phúc",
					},
					{
						name: "Xã Tân Thọ",
					},
					{
						name: "Xã Hoàng Sơn",
					},
					{
						name: "Xã Tân Khang",
					},
					{
						name: "Xã Hoàng Giang",
					},
					{
						name: "Xã Trung Chính",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Tế Thắng",
					},
					{
						name: "Xã Tế Lợi",
					},
					{
						name: "Xã Tế Nông",
					},
					{
						name: "Xã Minh Nghĩa",
					},
					{
						name: "Xã Minh Khôi",
					},
					{
						name: "Xã Vạn Hòa",
					},
					{
						name: "Xã Trường Trung",
					},
					{
						name: "Xã Vạn Thắng",
					},
					{
						name: "Xã Trường Giang",
					},
					{
						name: "Xã Vạn Thiện",
					},
					{
						name: "Xã Thăng Long",
					},
					{
						name: "Xã Trường Minh",
					},
					{
						name: "Xã Trường Sơn",
					},
					{
						name: "Xã Thăng Bình",
					},
					{
						name: "Xã Công Liêm",
					},
					{
						name: "Xã Tượng Văn",
					},
					{
						name: "Xã Thăng Thọ",
					},
					{
						name: "Xã Tượng Lĩnh",
					},
					{
						name: "Xã Tượng Sơn",
					},
					{
						name: "Xã Công Chính",
					},
					{
						name: "Xã Yên Mỹ",
					},
				],
			},
			{
				name: "Huyện Đông Sơn",
				wards: [
					{
						name: "Thị trấn Rừng Thông",
					},
					{
						name: "Xã Đông Hoàng",
					},
					{
						name: "Xã Đông Ninh",
					},
					{
						name: "Xã Đông Hòa",
					},
					{
						name: "Xã Đông Yên",
					},
					{
						name: "Xã Đông Minh",
					},
					{
						name: "Xã Đông Thanh",
					},
					{
						name: "Xã Đông Tiến",
					},
					{
						name: "Xã Đông Khê",
					},
					{
						name: "Xã Đông Thịnh",
					},
					{
						name: "Xã Đông Văn",
					},
					{
						name: "Xã Đông Phú",
					},
					{
						name: "Xã Đông Nam",
					},
					{
						name: "Xã Đông Quang",
					},
				],
			},
			{
				name: "Huyện Quảng Xương",
				wards: [
					{
						name: "Thị trấn Tân Phong",
					},
					{
						name: "Xã Quảng Trạch",
					},
					{
						name: "Xã Quảng Đức",
					},
					{
						name: "Xã Quảng Định",
					},
					{
						name: "Xã Quảng Nhân",
					},
					{
						name: "Xã Quảng Ninh",
					},
					{
						name: "Xã Quảng Bình",
					},
					{
						name: "Xã Quảng Hợp",
					},
					{
						name: "Xã Quảng Văn",
					},
					{
						name: "Xã Quảng Long",
					},
					{
						name: "Xã Quảng Yên",
					},
					{
						name: "Xã Quảng Hòa",
					},
					{
						name: "Xã Quảng Khê",
					},
					{
						name: "Xã Quảng Trung",
					},
					{
						name: "Xã Quảng Chính",
					},
					{
						name: "Xã Quảng Ngọc",
					},
					{
						name: "Xã Quảng Trường",
					},
					{
						name: "Xã Quảng Phúc",
					},
					{
						name: "Xã Quảng Giao",
					},
					{
						name: "Xã Quảng Hải",
					},
					{
						name: "Xã Quảng Lưu",
					},
					{
						name: "Xã Quảng Lộc",
					},
					{
						name: "Xã Tiên Trang",
					},
					{
						name: "Xã Quảng Nham",
					},
					{
						name: "Xã Quảng Thạch",
					},
					{
						name: "Xã Quảng Thái",
					},
				],
			},
			{
				name: "Thị xã Nghi Sơn",
				wards: [
					{
						name: "Phường Hải Hòa",
					},
					{
						name: "Phường Hải Châu",
					},
					{
						name: "Xã Thanh Thủy",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Phường Hải Ninh",
					},
					{
						name: "Xã Anh Sơn",
					},
					{
						name: "Xã Ngọc Lĩnh",
					},
					{
						name: "Phường Hải An",
					},
					{
						name: "Xã Các Sơn",
					},
					{
						name: "Phường Tân Dân",
					},
					{
						name: "Phường Hải Lĩnh",
					},
					{
						name: "Xã Định Hải",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Phường Ninh Hải",
					},
					{
						name: "Phường Nguyên Bình",
					},
					{
						name: "Xã Hải Nhân",
					},
					{
						name: "Phường Bình Minh",
					},
					{
						name: "Phường Hải Thanh",
					},
					{
						name: "Xã Phú Lâm",
					},
					{
						name: "Phường Xuân Lâm",
					},
					{
						name: "Phường Trúc Lâm",
					},
					{
						name: "Phường Hải Bình",
					},
					{
						name: "Xã Tân Trường",
					},
					{
						name: "Xã Tùng Lâm",
					},
					{
						name: "Phường Tĩnh Hải",
					},
					{
						name: "Phường Mai Lâm",
					},
					{
						name: "Xã Trường Lâm",
					},
					{
						name: "Xã Hải Yến",
					},
					{
						name: "Phường Hải Thượng",
					},
					{
						name: "Xã Nghi Sơn",
					},
					{
						name: "Xã Hải Hà",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Nghệ An",
		districts: [
			{
				name: "Thành phố Vinh",
				wards: [
					{
						name: "Phường Đông Vĩnh",
					},
					{
						name: "Phường Hà Huy Tập",
					},
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Phường Quán Bàu",
					},
					{
						name: "Phường Hưng Bình",
					},
					{
						name: "Phường Hưng Phúc",
					},
					{
						name: "Phường Hưng Dũng",
					},
					{
						name: "Phường Cửa Nam",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Đội Cung",
					},
					{
						name: "Phường Lê Mao",
					},
					{
						name: "Phường Trường Thi",
					},
					{
						name: "Phường Bến Thủy",
					},
					{
						name: "Phường Hồng Sơn",
					},
					{
						name: "Phường Trung Đô",
					},
					{
						name: "Xã Nghi Phú",
					},
					{
						name: "Xã Hưng Đông",
					},
					{
						name: "Xã Hưng Lộc",
					},
					{
						name: "Xã Hưng Hòa",
					},
					{
						name: "Phường Vinh Tân",
					},
					{
						name: "Xã Nghi Liên",
					},
					{
						name: "Xã Nghi Ân",
					},
					{
						name: "Xã Nghi Kim",
					},
					{
						name: "Xã Nghi Đức",
					},
					{
						name: "Xã Hưng Chính",
					},
				],
			},
			{
				name: "Thị xã Cửa Lò",
				wards: [
					{
						name: "Phường Nghi Thuỷ",
					},
					{
						name: "Phường Nghi Tân",
					},
					{
						name: "Phường Thu Thuỷ",
					},
					{
						name: "Phường Nghi Hòa",
					},
					{
						name: "Phường Nghi Hải",
					},
					{
						name: "Phường Nghi Hương",
					},
					{
						name: "Phường Nghi Thu",
					},
				],
			},
			{
				name: "Thị xã Thái Hoà",
				wards: [
					{
						name: "Phường Hoà Hiếu",
					},
					{
						name: "Phường Quang Phong",
					},
					{
						name: "Phường Quang Tiến",
					},
					{
						name: "Phường Long Sơn",
					},
					{
						name: "Xã Nghĩa Tiến",
					},
					{
						name: "Xã Nghĩa Mỹ",
					},
					{
						name: "Xã Tây Hiếu",
					},
					{
						name: "Xã Nghĩa Thuận",
					},
					{
						name: "Xã Đông Hiếu",
					},
				],
			},
			{
				name: "Huyện Quế Phong",
				wards: [
					{
						name: "Thị trấn Kim Sơn",
					},
					{
						name: "Xã Thông Thụ",
					},
					{
						name: "Xã Đồng Văn",
					},
					{
						name: "Xã Hạnh Dịch",
					},
					{
						name: "Xã Tiền Phong",
					},
					{
						name: "Xã Nậm Giải",
					},
					{
						name: "Xã Tri Lễ",
					},
					{
						name: "Xã Châu Kim",
					},
					{
						name: "Xã Mường Nọc",
					},
					{
						name: "Xã Châu Thôn",
					},
					{
						name: "Xã Nậm Nhoóng",
					},
					{
						name: "Xã Quang Phong",
					},
					{
						name: "Xã Căm Muộn",
					},
				],
			},
			{
				name: "Huyện Quỳ Châu",
				wards: [
					{
						name: "Thị trấn Tân Lạc",
					},
					{
						name: "Xã Châu Bính",
					},
					{
						name: "Xã Châu Thuận",
					},
					{
						name: "Xã Châu Hội",
					},
					{
						name: "Xã Châu Nga",
					},
					{
						name: "Xã Châu Tiến",
					},
					{
						name: "Xã Châu Hạnh",
					},
					{
						name: "Xã Châu Thắng",
					},
					{
						name: "Xã Châu Phong",
					},
					{
						name: "Xã Châu Bình",
					},
					{
						name: "Xã Châu Hoàn",
					},
					{
						name: "Xã Diên Lãm",
					},
				],
			},
			{
				name: "Huyện Kỳ Sơn",
				wards: [
					{
						name: "Thị trấn Mường Xén",
					},
					{
						name: "Xã Mỹ Lý",
					},
					{
						name: "Xã Bắc Lý",
					},
					{
						name: "Xã Keng Đu",
					},
					{
						name: "Xã Đoọc Mạy",
					},
					{
						name: "Xã Huồi Tụ",
					},
					{
						name: "Xã Mường Lống",
					},
					{
						name: "Xã Na Loi",
					},
					{
						name: "Xã Nậm Cắn",
					},
					{
						name: "Xã Bảo Nam",
					},
					{
						name: "Xã Phà Đánh",
					},
					{
						name: "Xã Bảo Thắng",
					},
					{
						name: "Xã Hữu Lập",
					},
					{
						name: "Xã Tà Cạ",
					},
					{
						name: "Xã Chiêu Lưu",
					},
					{
						name: "Xã Mường Típ",
					},
					{
						name: "Xã Hữu Kiệm",
					},
					{
						name: "Xã Tây Sơn",
					},
					{
						name: "Xã Mường Ải",
					},
					{
						name: "Xã Na Ngoi",
					},
					{
						name: "Xã Nậm Càn",
					},
				],
			},
			{
				name: "Huyện Tương Dương",
				wards: [
					{
						name: "Thị trấn Thạch Giám",
					},
					{
						name: "Xã Mai Sơn",
					},
					{
						name: "Xã Nhôn Mai",
					},
					{
						name: "Xã Hữu Khuông",
					},
					{
						name: "Xã Yên Tĩnh",
					},
					{
						name: "Xã Nga My",
					},
					{
						name: "Xã Xiêng My",
					},
					{
						name: "Xã Lưỡng Minh",
					},
					{
						name: "Xã Yên Hòa",
					},
					{
						name: "Xã Yên Na",
					},
					{
						name: "Xã Lưu Kiền",
					},
					{
						name: "Xã Xá Lượng",
					},
					{
						name: "Xã Tam Thái",
					},
					{
						name: "Xã Tam Đình",
					},
					{
						name: "Xã Yên Thắng",
					},
					{
						name: "Xã Tam Quang",
					},
					{
						name: "Xã Tam Hợp",
					},
				],
			},
			{
				name: "Huyện Nghĩa Đàn",
				wards: [
					{
						name: "Thị trấn Nghĩa Đàn",
					},
					{
						name: "Xã Nghĩa Mai",
					},
					{
						name: "Xã Nghĩa Yên",
					},
					{
						name: "Xã Nghĩa Lạc",
					},
					{
						name: "Xã Nghĩa Lâm",
					},
					{
						name: "Xã Nghĩa Sơn",
					},
					{
						name: "Xã Nghĩa Lợi",
					},
					{
						name: "Xã Nghĩa Bình",
					},
					{
						name: "Xã Nghĩa Thọ",
					},
					{
						name: "Xã Nghĩa Minh",
					},
					{
						name: "Xã Nghĩa Phú",
					},
					{
						name: "Xã Nghĩa Hưng",
					},
					{
						name: "Xã Nghĩa Hồng",
					},
					{
						name: "Xã Nghĩa Thịnh",
					},
					{
						name: "Xã Nghĩa Trung",
					},
					{
						name: "Xã Nghĩa Hội",
					},
					{
						name: "Xã Nghĩa Thành",
					},
					{
						name: "Xã Nghĩa Hiếu",
					},
					{
						name: "Xã Nghĩa Đức",
					},
					{
						name: "Xã Nghĩa An",
					},
					{
						name: "Xã Nghĩa Long",
					},
					{
						name: "Xã Nghĩa Lộc",
					},
					{
						name: "Xã Nghĩa Khánh",
					},
				],
			},
			{
				name: "Huyện Quỳ Hợp",
				wards: [
					{
						name: "Thị trấn Quỳ Hợp",
					},
					{
						name: "Xã Yên Hợp",
					},
					{
						name: "Xã Châu Tiến",
					},
					{
						name: "Xã Châu Hồng",
					},
					{
						name: "Xã Đồng Hợp",
					},
					{
						name: "Xã Châu Thành",
					},
					{
						name: "Xã Liên Hợp",
					},
					{
						name: "Xã Châu Lộc",
					},
					{
						name: "Xã Tam Hợp",
					},
					{
						name: "Xã Châu Cường",
					},
					{
						name: "Xã Châu Quang",
					},
					{
						name: "Xã Thọ Hợp",
					},
					{
						name: "Xã Minh Hợp",
					},
					{
						name: "Xã Nghĩa Xuân",
					},
					{
						name: "Xã Châu Thái",
					},
					{
						name: "Xã Châu Đình",
					},
					{
						name: "Xã Văn Lợi",
					},
					{
						name: "Xã Nam Sơn",
					},
					{
						name: "Xã Châu Lý",
					},
					{
						name: "Xã Hạ Sơn",
					},
					{
						name: "Xã Bắc Sơn",
					},
				],
			},
			{
				name: "Huyện Quỳnh Lưu",
				wards: [
					{
						name: "Thị trấn Cầu Giát",
					},
					{
						name: "Xã Quỳnh Thắng",
					},
					{
						name: "Xã Quỳnh Tân",
					},
					{
						name: "Xã Quỳnh Châu",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Quỳnh Văn",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Quỳnh Tam",
					},
					{
						name: "Xã Quỳnh Hoa",
					},
					{
						name: "Xã Quỳnh Thạch",
					},
					{
						name: "Xã Quỳnh Bảng",
					},
					{
						name: "Xã Quỳnh Mỹ",
					},
					{
						name: "Xã Quỳnh Thanh",
					},
					{
						name: "Xã Quỳnh Hậu",
					},
					{
						name: "Xã Quỳnh Lâm",
					},
					{
						name: "Xã Quỳnh Đôi",
					},
					{
						name: "Xã Quỳnh Lương",
					},
					{
						name: "Xã Quỳnh Hồng",
					},
					{
						name: "Xã Quỳnh Yên",
					},
					{
						name: "Xã Quỳnh Bá",
					},
					{
						name: "Xã Quỳnh Minh",
					},
					{
						name: "Xã Quỳnh Diễn",
					},
					{
						name: "Xã Quỳnh Hưng",
					},
					{
						name: "Xã Quỳnh Giang",
					},
					{
						name: "Xã Quỳnh Ngọc",
					},
					{
						name: "Xã Quỳnh Nghĩa",
					},
					{
						name: "Xã An Hòa",
					},
					{
						name: "Xã Tiến Thủy",
					},
					{
						name: "Xã Sơn Hải",
					},
					{
						name: "Xã Quỳnh Thọ",
					},
					{
						name: "Xã Quỳnh Thuận",
					},
					{
						name: "Xã Quỳnh Long",
					},
					{
						name: "Xã Tân Thắng",
					},
				],
			},
			{
				name: "Huyện Con Cuông",
				wards: [
					{
						name: "Thị trấn Con Cuông",
					},
					{
						name: "Xã Bình Chuẩn",
					},
					{
						name: "Xã Lạng Khê",
					},
					{
						name: "Xã Cam Lâm",
					},
					{
						name: "Xã Thạch Ngàn",
					},
					{
						name: "Xã Đôn Phục",
					},
					{
						name: "Xã Mậu Đức",
					},
					{
						name: "Xã Châu Khê",
					},
					{
						name: "Xã Chi Khê",
					},
					{
						name: "Xã Bồng Khê",
					},
					{
						name: "Xã Yên Khê",
					},
					{
						name: "Xã Lục Dạ",
					},
					{
						name: "Xã Môn Sơn",
					},
				],
			},
			{
				name: "Huyện Tân Kỳ",
				wards: [
					{
						name: "Thị trấn Tân Kỳ",
					},
					{
						name: "Xã Tân Hợp",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Tân Xuân",
					},
					{
						name: "Xã Giai Xuân",
					},
					{
						name: "Xã Nghĩa Bình",
					},
					{
						name: "Xã Nghĩa Đồng",
					},
					{
						name: "Xã Đồng Văn",
					},
					{
						name: "Xã Nghĩa Thái",
					},
					{
						name: "Xã Nghĩa Hợp",
					},
					{
						name: "Xã Nghĩa Hoàn",
					},
					{
						name: "Xã Nghĩa Phúc",
					},
					{
						name: "Xã Tiên Kỳ",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Nghĩa Dũng",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Kỳ Sơn",
					},
					{
						name: "Xã Hương Sơn",
					},
					{
						name: "Xã Kỳ Tân",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Tân Hương",
					},
					{
						name: "Xã Nghĩa Hành",
					},
				],
			},
			{
				name: "Huyện Anh Sơn",
				wards: [
					{
						name: "Thị trấn Anh Sơn",
					},
					{
						name: "Xã Thọ Sơn",
					},
					{
						name: "Xã Thành Sơn",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Tam Sơn",
					},
					{
						name: "Xã Đỉnh Sơn",
					},
					{
						name: "Xã Hùng Sơn",
					},
					{
						name: "Xã Cẩm Sơn",
					},
					{
						name: "Xã Đức Sơn",
					},
					{
						name: "Xã Tường Sơn",
					},
					{
						name: "Xã Hoa Sơn",
					},
					{
						name: "Xã Tào Sơn",
					},
					{
						name: "Xã Vĩnh Sơn",
					},
					{
						name: "Xã Lạng Sơn",
					},
					{
						name: "Xã Hội Sơn",
					},
					{
						name: "Xã Thạch Sơn",
					},
					{
						name: "Xã Phúc Sơn",
					},
					{
						name: "Xã Long Sơn",
					},
					{
						name: "Xã Khai Sơn",
					},
					{
						name: "Xã Lĩnh Sơn",
					},
					{
						name: "Xã Cao Sơn",
					},
				],
			},
			{
				name: "Huyện Diễn Châu",
				wards: [
					{
						name: "Thị trấn Diễn Châu",
					},
					{
						name: "Xã Diễn Lâm",
					},
					{
						name: "Xã Diễn Đoài",
					},
					{
						name: "Xã Diễn Trường",
					},
					{
						name: "Xã Diễn Yên",
					},
					{
						name: "Xã Diễn Hoàng",
					},
					{
						name: "Xã Diễn Hùng",
					},
					{
						name: "Xã Diễn Mỹ",
					},
					{
						name: "Xã Diễn Hồng",
					},
					{
						name: "Xã Diễn Phong",
					},
					{
						name: "Xã Diễn Hải",
					},
					{
						name: "Xã Diễn Tháp",
					},
					{
						name: "Xã Diễn Liên",
					},
					{
						name: "Xã Diễn Vạn",
					},
					{
						name: "Xã Diễn Kim",
					},
					{
						name: "Xã Diễn Kỷ",
					},
					{
						name: "Xã Diễn Xuân",
					},
					{
						name: "Xã Diễn Thái",
					},
					{
						name: "Xã Diễn Đồng",
					},
					{
						name: "Xã Diễn Bích",
					},
					{
						name: "Xã Diễn Hạnh",
					},
					{
						name: "Xã Diễn Ngọc",
					},
					{
						name: "Xã Diễn Quảng",
					},
					{
						name: "Xã Diễn Nguyên",
					},
					{
						name: "Xã Diễn Hoa",
					},
					{
						name: "Xã Diễn Thành",
					},
					{
						name: "Xã Diễn Phúc",
					},
					{
						name: "Xã Diễn Cát",
					},
					{
						name: "Xã Diễn Thịnh",
					},
					{
						name: "Xã Diễn Tân",
					},
					{
						name: "Xã Minh Châu",
					},
					{
						name: "Xã Diễn Thọ",
					},
					{
						name: "Xã Diễn Lợi",
					},
					{
						name: "Xã Diễn Lộc",
					},
					{
						name: "Xã Diễn Trung",
					},
					{
						name: "Xã Diễn An",
					},
					{
						name: "Xã Diễn Phú",
					},
				],
			},
			{
				name: "Huyện Yên Thành",
				wards: [
					{
						name: "Thị trấn Yên Thành",
					},
					{
						name: "Xã Mã Thành",
					},
					{
						name: "Xã Tiến Thành",
					},
					{
						name: "Xã Lăng Thành",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Đức Thành",
					},
					{
						name: "Xã Kim Thành",
					},
					{
						name: "Xã Hậu Thành",
					},
					{
						name: "Xã Hùng Thành",
					},
					{
						name: "Xã Đô Thành",
					},
					{
						name: "Xã Thọ Thành",
					},
					{
						name: "Xã Quang Thành",
					},
					{
						name: "Xã Tây Thành",
					},
					{
						name: "Xã Phúc Thành",
					},
					{
						name: "Xã Hồng Thành",
					},
					{
						name: "Xã Đồng Thành",
					},
					{
						name: "Xã Phú Thành",
					},
					{
						name: "Xã Hoa Thành",
					},
					{
						name: "Xã Tăng Thành",
					},
					{
						name: "Xã Văn Thành",
					},
					{
						name: "Xã Thịnh Thành",
					},
					{
						name: "Xã Hợp Thành",
					},
					{
						name: "Xã Xuân Thành",
					},
					{
						name: "Xã Bắc Thành",
					},
					{
						name: "Xã Nhân Thành",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Long Thành",
					},
					{
						name: "Xã Minh Thành",
					},
					{
						name: "Xã Nam Thành",
					},
					{
						name: "Xã Vĩnh Thành",
					},
					{
						name: "Xã Lý Thành",
					},
					{
						name: "Xã Khánh Thành",
					},
					{
						name: "Xã Viên Thành",
					},
					{
						name: "Xã Đại Thành",
					},
					{
						name: "Xã Liên Thành",
					},
					{
						name: "Xã Bảo Thành",
					},
					{
						name: "Xã Mỹ Thành",
					},
					{
						name: "Xã Công Thành",
					},
					{
						name: "Xã Sơn Thành",
					},
				],
			},
			{
				name: "Huyện Đô Lương",
				wards: [
					{
						name: "Thị trấn Đô Lương",
					},
					{
						name: "Xã Giang Sơn Đông",
					},
					{
						name: "Xã Giang Sơn Tây",
					},
					{
						name: "Xã Lam Sơn",
					},
					{
						name: "Xã Bồi Sơn",
					},
					{
						name: "Xã Hồng Sơn",
					},
					{
						name: "Xã Bài Sơn",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Tràng Sơn",
					},
					{
						name: "Xã Thượng Sơn",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Xã Đặng Sơn",
					},
					{
						name: "Xã Đông Sơn",
					},
					{
						name: "Xã Nam Sơn",
					},
					{
						name: "Xã Lưu Sơn",
					},
					{
						name: "Xã Yên Sơn",
					},
					{
						name: "Xã Văn Sơn",
					},
					{
						name: "Xã Đà Sơn",
					},
					{
						name: "Xã Lạc Sơn",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Thái Sơn",
					},
					{
						name: "Xã Quang Sơn",
					},
					{
						name: "Xã Thịnh Sơn",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Xuân Sơn",
					},
					{
						name: "Xã Minh Sơn",
					},
					{
						name: "Xã Thuận Sơn",
					},
					{
						name: "Xã Nhân Sơn",
					},
					{
						name: "Xã Hiến Sơn",
					},
					{
						name: "Xã Mỹ Sơn",
					},
					{
						name: "Xã Trù Sơn",
					},
					{
						name: "Xã Đại Sơn",
					},
				],
			},
			{
				name: "Huyện Thanh Chương",
				wards: [
					{
						name: "Thị trấn Thanh Chương",
					},
					{
						name: "Xã Cát Văn",
					},
					{
						name: "Xã Thanh Nho",
					},
					{
						name: "Xã Hạnh Lâm",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Thanh Hòa",
					},
					{
						name: "Xã Phong Thịnh",
					},
					{
						name: "Xã Thanh Phong",
					},
					{
						name: "Xã Thanh Mỹ",
					},
					{
						name: "Xã Thanh Tiên",
					},
					{
						name: "Xã Thanh Liên",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Thanh Đồng",
					},
					{
						name: "Xã Thanh Ngọc",
					},
					{
						name: "Xã Thanh Hương",
					},
					{
						name: "Xã Ngọc Lâm",
					},
					{
						name: "Xã Thanh Lĩnh",
					},
					{
						name: "Xã Đồng Văn",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Thanh Thịnh",
					},
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã Thanh Chi",
					},
					{
						name: "Xã Xuân Tường",
					},
					{
						name: "Xã Thanh Dương",
					},
					{
						name: "Xã Thanh Lương",
					},
					{
						name: "Xã Thanh Khê",
					},
					{
						name: "Xã Võ Liệt",
					},
					{
						name: "Xã Thanh Long",
					},
					{
						name: "Xã Thanh Thủy",
					},
					{
						name: "Xã Thanh Khai",
					},
					{
						name: "Xã Thanh Yên",
					},
					{
						name: "Xã Thanh Hà",
					},
					{
						name: "Xã Thanh Giang",
					},
					{
						name: "Xã Thanh Tùng",
					},
					{
						name: "Xã Thanh Lâm",
					},
					{
						name: "Xã Thanh Mai",
					},
					{
						name: "Xã Thanh Xuân",
					},
					{
						name: "Xã Thanh Đức",
					},
				],
			},
			{
				name: "Huyện Nghi Lộc",
				wards: [
					{
						name: "Thị trấn Quán Hành",
					},
					{
						name: "Xã Nghi Văn",
					},
					{
						name: "Xã Nghi Yên",
					},
					{
						name: "Xã Nghi Tiến",
					},
					{
						name: "Xã Nghi Hưng",
					},
					{
						name: "Xã Nghi Đồng",
					},
					{
						name: "Xã Nghi Thiết",
					},
					{
						name: "Xã Nghi Lâm",
					},
					{
						name: "Xã Nghi Quang",
					},
					{
						name: "Xã Nghi Kiều",
					},
					{
						name: "Xã Nghi Mỹ",
					},
					{
						name: "Xã Nghi Phương",
					},
					{
						name: "Xã Nghi Thuận",
					},
					{
						name: "Xã Nghi Long",
					},
					{
						name: "Xã Nghi Xá",
					},
					{
						name: "Xã Nghi Hoa",
					},
					{
						name: "Xã Khánh Hợp",
					},
					{
						name: "Xã Nghi Thịnh",
					},
					{
						name: "Xã Nghi Công Bắc",
					},
					{
						name: "Xã Nghi Công Nam",
					},
					{
						name: "Xã Nghi Thạch",
					},
					{
						name: "Xã Nghi Trung",
					},
					{
						name: "Xã Nghi Trường",
					},
					{
						name: "Xã Nghi Diên",
					},
					{
						name: "Xã Nghi Phong",
					},
					{
						name: "Xã Nghi Xuân",
					},
					{
						name: "Xã Nghi Vạn",
					},
					{
						name: "Xã Phúc Thọ",
					},
					{
						name: "Xã Nghi Thái",
					},
				],
			},
			{
				name: "Huyện Nam Đàn",
				wards: [
					{
						name: "Xã Nam Hưng",
					},
					{
						name: "Xã Nam Nghĩa",
					},
					{
						name: "Xã Nam Thanh",
					},
					{
						name: "Xã Nam Anh",
					},
					{
						name: "Xã Nam Xuân",
					},
					{
						name: "Xã Nam Thái",
					},
					{
						name: "Thị trấn Nam Đàn",
					},
					{
						name: "Xã Nam Lĩnh",
					},
					{
						name: "Xã Nam Giang",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Hùng Tiến",
					},
					{
						name: "Xã Thượng Tân Lộc",
					},
					{
						name: "Xã Kim Liên",
					},
					{
						name: "Xã Hồng Long",
					},
					{
						name: "Xã Xuân Lâm",
					},
					{
						name: "Xã Nam Cát",
					},
					{
						name: "Xã Khánh Sơn",
					},
					{
						name: "Xã Trung Phúc Cường",
					},
					{
						name: "Xã Nam Kim",
					},
				],
			},
			{
				name: "Huyện Hưng Nguyên",
				wards: [
					{
						name: "Thị trấn Hưng Nguyên",
					},
					{
						name: "Xã Hưng Trung",
					},
					{
						name: "Xã Hưng Yên",
					},
					{
						name: "Xã Hưng Yên Bắc",
					},
					{
						name: "Xã Hưng Tây",
					},
					{
						name: "Xã Hưng Đạo",
					},
					{
						name: "Xã Hưng Mỹ",
					},
					{
						name: "Xã Hưng Thịnh",
					},
					{
						name: "Xã Hưng Lĩnh",
					},
					{
						name: "Xã Hưng Thông",
					},
					{
						name: "Xã Hưng Tân",
					},
					{
						name: "Xã Hưng Lợi",
					},
					{
						name: "Xã Hưng Nghĩa",
					},
					{
						name: "Xã Hưng Phúc",
					},
					{
						name: "Xã Long Xá",
					},
					{
						name: "Xã Châu Nhân",
					},
					{
						name: "Xã Xuân Lam",
					},
					{
						name: "Xã Hưng Thành",
					},
				],
			},
			{
				name: "Thị xã Hoàng Mai",
				wards: [
					{
						name: "Xã Quỳnh Vinh",
					},
					{
						name: "Xã Quỳnh Lộc",
					},
					{
						name: "Phường Quỳnh Thiện",
					},
					{
						name: "Xã Quỳnh Lập",
					},
					{
						name: "Xã Quỳnh Trang",
					},
					{
						name: "Phường Mai Hùng",
					},
					{
						name: "Phường Quỳnh Dị",
					},
					{
						name: "Phường Quỳnh Xuân",
					},
					{
						name: "Phường Quỳnh Phương",
					},
					{
						name: "Xã Quỳnh Liên",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Hà Tĩnh",
		districts: [
			{
				name: "Thành phố Hà Tĩnh",
				wards: [
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Nam Hà",
					},
					{
						name: "Phường Bắc Hà",
					},
					{
						name: "Phường Nguyễn Du",
					},
					{
						name: "Phường Tân Giang",
					},
					{
						name: "Phường Đại Nài",
					},
					{
						name: "Phường Hà Huy Tập",
					},
					{
						name: "Xã Thạch Trung",
					},
					{
						name: "Phường Thạch Quý",
					},
					{
						name: "Phường Thạch Linh",
					},
					{
						name: "Phường Văn Yên",
					},
					{
						name: "Xã Thạch Hạ",
					},
					{
						name: "Xã Đồng Môn",
					},
					{
						name: "Xã Thạch Hưng",
					},
					{
						name: "Xã Thạch Bình",
					},
				],
			},
			{
				name: "Thị xã Hồng Lĩnh",
				wards: [
					{
						name: "Phường Bắc Hồng",
					},
					{
						name: "Phường Nam Hồng",
					},
					{
						name: "Phường Trung Lương",
					},
					{
						name: "Phường Đức Thuận",
					},
					{
						name: "Phường Đậu Liêu",
					},
					{
						name: "Xã Thuận Lộc",
					},
				],
			},
			{
				name: "Huyện Hương Sơn",
				wards: [
					{
						name: "Thị trấn Phố Châu",
					},
					{
						name: "Thị trấn Tây Sơn",
					},
					{
						name: "Xã Sơn Hồng",
					},
					{
						name: "Xã Sơn Tiến",
					},
					{
						name: "Xã Sơn Lâm",
					},
					{
						name: "Xã Sơn Lễ",
					},
					{
						name: "Xã Sơn Giang",
					},
					{
						name: "Xã Sơn Lĩnh",
					},
					{
						name: "Xã An Hòa Thịnh",
					},
					{
						name: "Xã Sơn Tây",
					},
					{
						name: "Xã Sơn Ninh",
					},
					{
						name: "Xã Sơn Châu",
					},
					{
						name: "Xã Tân Mỹ Hà",
					},
					{
						name: "Xã Quang Diệm",
					},
					{
						name: "Xã Sơn Trung",
					},
					{
						name: "Xã Sơn Bằng",
					},
					{
						name: "Xã Sơn Bình",
					},
					{
						name: "Xã Sơn Kim 1",
					},
					{
						name: "Xã Sơn Kim 2",
					},
					{
						name: "Xã Sơn Trà",
					},
					{
						name: "Xã Sơn Long",
					},
					{
						name: "Xã Kim Hoa",
					},
					{
						name: "Xã Sơn Hàm",
					},
					{
						name: "Xã Sơn Phú",
					},
					{
						name: "Xã Sơn Trường",
					},
				],
			},
			{
				name: "Huyện Đức Thọ",
				wards: [
					{
						name: "Thị trấn Đức Thọ",
					},
					{
						name: "Xã Quang Vĩnh",
					},
					{
						name: "Xã Tùng Châu",
					},
					{
						name: "Xã Trường Sơn",
					},
					{
						name: "Xã Liên Minh",
					},
					{
						name: "Xã Yên Hồ",
					},
					{
						name: "Xã Tùng Ảnh",
					},
					{
						name: "Xã Bùi La Nhân",
					},
					{
						name: "Xã Thanh Bình Thịnh",
					},
					{
						name: "Xã Lâm Trung Thủy",
					},
					{
						name: "Xã Hòa Lạc",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã An Dũng",
					},
					{
						name: "Xã Đức Đồng",
					},
					{
						name: "Xã Đức Lạng",
					},
					{
						name: "Xã Tân Hương",
					},
				],
			},
			{
				name: "Huyện Vũ Quang",
				wards: [
					{
						name: "Thị trấn Vũ Quang",
					},
					{
						name: "Xã Ân Phú",
					},
					{
						name: "Xã Đức Giang",
					},
					{
						name: "Xã Đức Lĩnh",
					},
					{
						name: "Xã Thọ Điền",
					},
					{
						name: "Xã Đức Hương",
					},
					{
						name: "Xã Đức Bồng",
					},
					{
						name: "Xã Đức Liên",
					},
					{
						name: "Xã Hương Minh",
					},
					{
						name: "Xã Quang Thọ",
					},
				],
			},
			{
				name: "Huyện Nghi Xuân",
				wards: [
					{
						name: "Thị trấn Xuân An",
					},
					{
						name: "Xã Xuân Hội",
					},
					{
						name: "Xã Đan Trường",
					},
					{
						name: "Xã Xuân Phổ",
					},
					{
						name: "Xã Xuân Hải",
					},
					{
						name: "Xã Xuân Giang",
					},
					{
						name: "Thị trấn Tiên Điền",
					},
					{
						name: "Xã Xuân Yên",
					},
					{
						name: "Xã Xuân Mỹ",
					},
					{
						name: "Xã Xuân Thành",
					},
					{
						name: "Xã Xuân Viên",
					},
					{
						name: "Xã Xuân Hồng",
					},
					{
						name: "Xã Cỗ Đạm",
					},
					{
						name: "Xã Xuân Liên",
					},
					{
						name: "Xã Xuân Lĩnh",
					},
					{
						name: "Xã Xuân Lam",
					},
					{
						name: "Xã Cương Gián",
					},
				],
			},
			{
				name: "Huyện Can Lộc",
				wards: [
					{
						name: "Thị trấn Nghèn",
					},
					{
						name: "Xã Thiên Lộc",
					},
					{
						name: "Xã Thuần Thiện",
					},
					{
						name: "Xã Vượng Lộc",
					},
					{
						name: "Xã Thanh Lộc",
					},
					{
						name: "Xã Kim Song Trường",
					},
					{
						name: "Xã Thường Nga",
					},
					{
						name: "Xã Tùng Lộc",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Gia Hanh",
					},
					{
						name: "Xã Khánh Vĩnh Yên",
					},
					{
						name: "Xã Trung Lộc",
					},
					{
						name: "Xã Xuân Lộc",
					},
					{
						name: "Xã Thượng Lộc",
					},
					{
						name: "Xã Quang Lộc",
					},
					{
						name: "Thị trấn Đồng Lộc",
					},
					{
						name: "Xã Mỹ Lộc",
					},
					{
						name: "Xã Sơn Lộc",
					},
				],
			},
			{
				name: "Huyện Hương Khê",
				wards: [
					{
						name: "Thị trấn Hương Khê",
					},
					{
						name: "Xã Điền Mỹ",
					},
					{
						name: "Xã Hà Linh",
					},
					{
						name: "Xã Hương Thủy",
					},
					{
						name: "Xã Hòa Hải",
					},
					{
						name: "Xã Phúc Đồng",
					},
					{
						name: "Xã Hương Giang",
					},
					{
						name: "Xã Lộc Yên",
					},
					{
						name: "Xã Hương Bình",
					},
					{
						name: "Xã Hương Long",
					},
					{
						name: "Xã Phú Gia",
					},
					{
						name: "Xã Gia Phố",
					},
					{
						name: "Xã Phú Phong",
					},
					{
						name: "Xã Hương Đô",
					},
					{
						name: "Xã Hương Vĩnh",
					},
					{
						name: "Xã Hương Xuân",
					},
					{
						name: "Xã Phúc Trạch",
					},
					{
						name: "Xã Hương Trà",
					},
					{
						name: "Xã Hương Trạch",
					},
					{
						name: "Xã Hương Lâm",
					},
					{
						name: "Xã Hương Liên",
					},
				],
			},
			{
				name: "Huyện Thạch Hà",
				wards: [
					{
						name: "Thị trấn Thạch Hà",
					},
					{
						name: "Xã Ngọc Sơn",
					},
					{
						name: "Xã Thạch Hải",
					},
					{
						name: "Xã Thạch Kênh",
					},
					{
						name: "Xã Thạch Sơn",
					},
					{
						name: "Xã Thạch Liên",
					},
					{
						name: "Xã Đỉnh Bàn",
					},
					{
						name: "Xã Việt Tiến",
					},
					{
						name: "Xã Thạch Khê",
					},
					{
						name: "Xã Thạch Long",
					},
					{
						name: "Xã Thạch Trị",
					},
					{
						name: "Xã Thạch Lạc",
					},
					{
						name: "Xã Thạch Ngọc",
					},
					{
						name: "Xã Tượng Sơn",
					},
					{
						name: "Xã Thạch Văn",
					},
					{
						name: "Xã Lưu Vĩnh Sơn",
					},
					{
						name: "Xã Thạch Thắng",
					},
					{
						name: "Xã Thạch Đài",
					},
					{
						name: "Xã Thạch Hội",
					},
					{
						name: "Xã Tân Lâm Hương",
					},
					{
						name: "Xã Thạch Xuân",
					},
					{
						name: "Xã Nam Điền",
					},
				],
			},
			{
				name: "Huyện Cẩm Xuyên",
				wards: [
					{
						name: "Thị trấn Cẩm Xuyên",
					},
					{
						name: "Thị trấn Thiên Cầm",
					},
					{
						name: "Xã Yên Hòa",
					},
					{
						name: "Xã Cẩm Dương",
					},
					{
						name: "Xã Cẩm Bình",
					},
					{
						name: "Xã Cẩm Vĩnh",
					},
					{
						name: "Xã Cẩm Thành",
					},
					{
						name: "Xã Cẩm Quang",
					},
					{
						name: "Xã Cẩm Thạch",
					},
					{
						name: "Xã Cẩm Nhượng",
					},
					{
						name: "Xã Nam Phúc Thăng",
					},
					{
						name: "Xã Cẩm Duệ",
					},
					{
						name: "Xã Cẩm Lĩnh",
					},
					{
						name: "Xã Cẩm Quan",
					},
					{
						name: "Xã Cẩm Hà",
					},
					{
						name: "Xã Cẩm Lộc",
					},
					{
						name: "Xã Cẩm Hưng",
					},
					{
						name: "Xã Cẩm Thịnh",
					},
					{
						name: "Xã Cẩm Mỹ",
					},
					{
						name: "Xã Cẩm Trung",
					},
					{
						name: "Xã Cẩm Sơn",
					},
					{
						name: "Xã Cẩm Lạc",
					},
					{
						name: "Xã Cẩm Minh",
					},
				],
			},
			{
				name: "Huyện Kỳ Anh",
				wards: [
					{
						name: "Xã Kỳ Xuân",
					},
					{
						name: "Xã Kỳ Bắc",
					},
					{
						name: "Xã Kỳ Phú",
					},
					{
						name: "Xã Kỳ Phong",
					},
					{
						name: "Xã Kỳ Tiến",
					},
					{
						name: "Xã Kỳ Giang",
					},
					{
						name: "Xã Kỳ Đồng",
					},
					{
						name: "Xã Kỳ Khang",
					},
					{
						name: "Xã Kỳ Văn",
					},
					{
						name: "Xã Kỳ Trung",
					},
					{
						name: "Xã Kỳ Thọ",
					},
					{
						name: "Xã Kỳ Tây",
					},
					{
						name: "Xã Kỳ Thượng",
					},
					{
						name: "Xã Kỳ Hải",
					},
					{
						name: "Xã Kỳ Thư",
					},
					{
						name: "Xã Kỳ Châu",
					},
					{
						name: "Xã Kỳ Tân",
					},
					{
						name: "Xã Lâm Hợp",
					},
					{
						name: "Xã Kỳ Sơn",
					},
					{
						name: "Xã Kỳ Lạc",
					},
				],
			},
			{
				name: "Huyện Lộc Hà",
				wards: [
					{
						name: "Xã Tân Lộc",
					},
					{
						name: "Xã Hồng Lộc",
					},
					{
						name: "Xã Thịnh Lộc",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Ích Hậu",
					},
					{
						name: "Xã Phù Lưu",
					},
					{
						name: "Thị trấn Lộc Hà",
					},
					{
						name: "Xã Thạch Mỹ",
					},
					{
						name: "Xã Thạch Kim",
					},
					{
						name: "Xã Thạch Châu",
					},
					{
						name: "Xã Hộ Độ",
					},
					{
						name: "Xã Mai Phụ",
					},
				],
			},
			{
				name: "Thị xã Kỳ Anh",
				wards: [
					{
						name: "Phường Hưng Trí",
					},
					{
						name: "Xã Kỳ Ninh",
					},
					{
						name: "Xã Kỳ Lợi",
					},
					{
						name: "Xã Kỳ Hà",
					},
					{
						name: "Phường Kỳ Trinh",
					},
					{
						name: "Phường Kỳ Thịnh",
					},
					{
						name: "Xã Kỳ Hoa",
					},
					{
						name: "Phường Kỳ Phương",
					},
					{
						name: "Phường Kỳ Long",
					},
					{
						name: "Phường Kỳ Liên",
					},
					{
						name: "Xã Kỳ Nam",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Quảng Bình",
		districts: [
			{
				name: "Thành Phố Đồng Hới",
				wards: [
					{
						name: "Phường Hải Thành",
					},
					{
						name: "Phường Đồng Phú",
					},
					{
						name: "Phường Bắc Lý",
					},
					{
						name: "Phường Nam Lý",
					},
					{
						name: "Phường Đồng Hải",
					},
					{
						name: "Phường Đồng Sơn",
					},
					{
						name: "Phường Phú Hải",
					},
					{
						name: "Phường Bắc Nghĩa",
					},
					{
						name: "Phường Đức Ninh Đông",
					},
					{
						name: "Xã Quang Phú",
					},
					{
						name: "Xã Lộc Ninh",
					},
					{
						name: "Xã Bảo Ninh",
					},
					{
						name: "Xã Nghĩa Ninh",
					},
					{
						name: "Xã Thuận Đức",
					},
					{
						name: "Xã Đức Ninh",
					},
				],
			},
			{
				name: "Huyện Minh Hóa",
				wards: [
					{
						name: "Thị trấn Quy Đạt",
					},
					{
						name: "Xã Dân Hóa",
					},
					{
						name: "Xã Trọng Hóa",
					},
					{
						name: "Xã Hóa Phúc",
					},
					{
						name: "Xã Hồng Hóa",
					},
					{
						name: "Xã Hóa Thanh",
					},
					{
						name: "Xã Hóa Tiến",
					},
					{
						name: "Xã Hóa Hợp",
					},
					{
						name: "Xã Xuân Hóa",
					},
					{
						name: "Xã Yên Hóa",
					},
					{
						name: "Xã Minh Hóa",
					},
					{
						name: "Xã Tân Hóa",
					},
					{
						name: "Xã Hóa Sơn",
					},
					{
						name: "Xã Trung Hóa",
					},
					{
						name: "Xã Thượng Hóa",
					},
				],
			},
			{
				name: "Huyện Tuyên Hóa",
				wards: [
					{
						name: "Thị trấn Đồng Lê",
					},
					{
						name: "Xã Hương Hóa",
					},
					{
						name: "Xã Kim Hóa",
					},
					{
						name: "Xã Thanh Hóa",
					},
					{
						name: "Xã Thanh Thạch",
					},
					{
						name: "Xã Thuận Hóa",
					},
					{
						name: "Xã Lâm Hóa",
					},
					{
						name: "Xã Lê Hóa",
					},
					{
						name: "Xã Sơn Hóa",
					},
					{
						name: "Xã Đồng Hóa",
					},
					{
						name: "Xã Ngư Hóa",
					},
					{
						name: "Xã Thạch Hóa",
					},
					{
						name: "Xã Đức Hóa",
					},
					{
						name: "Xã Phong Hóa",
					},
					{
						name: "Xã Mai Hóa",
					},
					{
						name: "Xã Tiến Hóa",
					},
					{
						name: "Xã Châu Hóa",
					},
					{
						name: "Xã Cao Quảng",
					},
					{
						name: "Xã Văn Hóa",
					},
				],
			},
			{
				name: "Huyện Quảng Trạch",
				wards: [
					{
						name: "Xã Quảng Hợp",
					},
					{
						name: "Xã Quảng Kim",
					},
					{
						name: "Xã Quảng Đông",
					},
					{
						name: "Xã Quảng Phú",
					},
					{
						name: "Xã Quảng Châu",
					},
					{
						name: "Xã Quảng Thạch",
					},
					{
						name: "Xã Quảng Lưu",
					},
					{
						name: "Xã Quảng Tùng",
					},
					{
						name: "Xã Cảnh Dương",
					},
					{
						name: "Xã Quảng Tiến",
					},
					{
						name: "Xã Quảng Hưng",
					},
					{
						name: "Xã Quảng Xuân",
					},
					{
						name: "Xã Cảnh Hóa",
					},
					{
						name: "Xã Liên Trường",
					},
					{
						name: "Xã Quảng Phương",
					},
					{
						name: "Xã Phù Hóa",
					},
					{
						name: "Xã Quảng Thanh",
					},
				],
			},
			{
				name: "Huyện Bố Trạch",
				wards: [
					{
						name: "Thị trấn Hoàn Lão",
					},
					{
						name: "Thị trấn NT Việt Trung",
					},
					{
						name: "Xã Xuân Trạch",
					},
					{
						name: "Xã Mỹ Trạch",
					},
					{
						name: "Xã Hạ Trạch",
					},
					{
						name: "Xã Bắc Trạch",
					},
					{
						name: "Xã Lâm Trạch",
					},
					{
						name: "Xã Thanh Trạch",
					},
					{
						name: "Xã Liên Trạch",
					},
					{
						name: "Xã Phúc Trạch",
					},
					{
						name: "Xã Cự Nẫm",
					},
					{
						name: "Xã Hải Phú",
					},
					{
						name: "Xã Thượng Trạch",
					},
					{
						name: "Xã Sơn Lộc",
					},
					{
						name: "Xã Hưng Trạch",
					},
					{
						name: "Xã Đồng Trạch",
					},
					{
						name: "Xã Đức Trạch",
					},
					{
						name: "Thị trấn Phong Nha",
					},
					{
						name: "Xã Vạn Trạch",
					},
					{
						name: "Xã Phú Định",
					},
					{
						name: "Xã Trung Trạch",
					},
					{
						name: "Xã Tây Trạch",
					},
					{
						name: "Xã Hòa Trạch",
					},
					{
						name: "Xã Đại Trạch",
					},
					{
						name: "Xã Nhân Trạch",
					},
					{
						name: "Xã Tân Trạch",
					},
					{
						name: "Xã Nam Trạch",
					},
					{
						name: "Xã Lý Trạch",
					},
				],
			},
			{
				name: "Huyện Quảng Ninh",
				wards: [
					{
						name: "Thị trấn Quán Hàu",
					},
					{
						name: "Xã Trường Sơn",
					},
					{
						name: "Xã Lương Ninh",
					},
					{
						name: "Xã Vĩnh Ninh",
					},
					{
						name: "Xã Võ Ninh",
					},
					{
						name: "Xã Hải Ninh",
					},
					{
						name: "Xã Hàm Ninh",
					},
					{
						name: "Xã Duy Ninh",
					},
					{
						name: "Xã Gia Ninh",
					},
					{
						name: "Xã Trường Xuân",
					},
					{
						name: "Xã Hiền Ninh",
					},
					{
						name: "Xã Tân Ninh",
					},
					{
						name: "Xã Xuân Ninh",
					},
					{
						name: "Xã An Ninh",
					},
					{
						name: "Xã Vạn Ninh",
					},
				],
			},
			{
				name: "Huyện Lệ Thủy",
				wards: [
					{
						name: "Thị trấn NT Lệ Ninh",
					},
					{
						name: "Thị trấn Kiến Giang",
					},
					{
						name: "Xã Hồng Thủy",
					},
					{
						name: "Xã Ngư Thủy Bắc",
					},
					{
						name: "Xã Hoa Thủy",
					},
					{
						name: "Xã Thanh Thủy",
					},
					{
						name: "Xã An Thủy",
					},
					{
						name: "Xã Phong Thủy",
					},
					{
						name: "Xã Cam Thủy",
					},
					{
						name: "Xã Ngân Thủy",
					},
					{
						name: "Xã Sơn Thủy",
					},
					{
						name: "Xã Lộc Thủy",
					},
					{
						name: "Xã Liên Thủy",
					},
					{
						name: "Xã Hưng Thủy",
					},
					{
						name: "Xã Dương Thủy",
					},
					{
						name: "Xã Tân Thủy",
					},
					{
						name: "Xã Phú Thủy",
					},
					{
						name: "Xã Xuân Thủy",
					},
					{
						name: "Xã Mỹ Thủy",
					},
					{
						name: "Xã Ngư Thủy",
					},
					{
						name: "Xã Mai Thủy",
					},
					{
						name: "Xã Sen Thủy",
					},
					{
						name: "Xã Thái Thủy",
					},
					{
						name: "Xã Kim Thủy",
					},
					{
						name: "Xã Trường Thủy",
					},
					{
						name: "Xã Lâm Thủy",
					},
				],
			},
			{
				name: "Thị xã Ba Đồn",
				wards: [
					{
						name: "Phường Ba Đồn",
					},
					{
						name: "Phường Quảng Long",
					},
					{
						name: "Phường Quảng Thọ",
					},
					{
						name: "Xã Quảng Tiên",
					},
					{
						name: "Xã Quảng Trung",
					},
					{
						name: "Phường Quảng Phong",
					},
					{
						name: "Phường Quảng Thuận",
					},
					{
						name: "Xã Quảng Tân",
					},
					{
						name: "Xã Quảng Hải",
					},
					{
						name: "Xã Quảng Sơn",
					},
					{
						name: "Xã Quảng Lộc",
					},
					{
						name: "Xã Quảng Thủy",
					},
					{
						name: "Xã Quảng Văn",
					},
					{
						name: "Phường Quảng Phúc",
					},
					{
						name: "Xã Quảng Hòa",
					},
					{
						name: "Xã Quảng Minh",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Quảng Trị",
		districts: [
			{
				name: "Thành phố Đông Hà",
				wards: [
					{
						name: "Phường Đông Giang",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường Đông Lễ",
					},
					{
						name: "Phường Đông Thanh",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường Đông Lương",
					},
					{
						name: "Phường 3",
					},
				],
			},
			{
				name: "Thị xã Quảng Trị",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường An Đôn",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Xã Hải Lệ",
					},
				],
			},
			{
				name: "Huyện Vĩnh Linh",
				wards: [
					{
						name: "Thị trấn Hồ Xá",
					},
					{
						name: "Thị trấn Bến Quan",
					},
					{
						name: "Xã Vĩnh Thái",
					},
					{
						name: "Xã Vĩnh Tú",
					},
					{
						name: "Xã Vĩnh Chấp",
					},
					{
						name: "Xã Trung Nam",
					},
					{
						name: "Xã Kim Thạch",
					},
					{
						name: "Xã Vĩnh Long",
					},
					{
						name: "Xã Vĩnh Khê",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Vĩnh Thủy",
					},
					{
						name: "Xã Vĩnh Lâm",
					},
					{
						name: "Xã Hiền Thành",
					},
					{
						name: "Thị trấn Cửa Tùng",
					},
					{
						name: "Xã Vĩnh Hà",
					},
					{
						name: "Xã Vĩnh Sơn",
					},
					{
						name: "Xã Vĩnh Giang",
					},
					{
						name: "Xã Vĩnh Ô",
					},
				],
			},
			{
				name: "Huyện Hướng Hóa",
				wards: [
					{
						name: "Thị trấn Khe Sanh",
					},
					{
						name: "Thị trấn Lao Bảo",
					},
					{
						name: "Xã Hướng Lập",
					},
					{
						name: "Xã Hướng Việt",
					},
					{
						name: "Xã Hướng Phùng",
					},
					{
						name: "Xã Hướng Sơn",
					},
					{
						name: "Xã Hướng Linh",
					},
					{
						name: "Xã Tân Hợp",
					},
					{
						name: "Xã Hướng Tân",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Tân Liên",
					},
					{
						name: "Xã Húc",
					},
					{
						name: "Xã Thuận",
					},
					{
						name: "Xã Hướng Lộc",
					},
					{
						name: "Xã Ba Tầng",
					},
					{
						name: "Xã Thanh",
					},
					{
						name: "Xã A Dơi",
					},
					{
						name: "Xã Lìa",
					},
					{
						name: "Xã Xy",
					},
				],
			},
			{
				name: "Huyện Gio Linh",
				wards: [
					{
						name: "Thị trấn Gio Linh",
					},
					{
						name: "Thị trấn Cửa Việt",
					},
					{
						name: "Xã Trung Giang",
					},
					{
						name: "Xã Trung Hải",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Phong Bình",
					},
					{
						name: "Xã Gio Mỹ",
					},
					{
						name: "Xã Gio Hải",
					},
					{
						name: "Xã Gio An",
					},
					{
						name: "Xã Gio Châu",
					},
					{
						name: "Xã Gio Việt",
					},
					{
						name: "Xã Linh Trường",
					},
					{
						name: "Xã Gio Sơn",
					},
					{
						name: "Xã Gio Mai",
					},
					{
						name: "Xã Hải Thái",
					},
					{
						name: "Xã Linh Hải",
					},
					{
						name: "Xã Gio Quang",
					},
				],
			},
			{
				name: "Huyện Đa Krông",
				wards: [
					{
						name: "Thị trấn Krông Klang",
					},
					{
						name: "Xã Mò Ó",
					},
					{
						name: "Xã Hướng Hiệp",
					},
					{
						name: "Xã Đa Krông",
					},
					{
						name: "Xã Triệu Nguyên",
					},
					{
						name: "Xã Ba Lòng",
					},
					{
						name: "Xã Ba Nang",
					},
					{
						name: "Xã Tà Long",
					},
					{
						name: "Xã Húc Nghì",
					},
					{
						name: "Xã A Vao",
					},
					{
						name: "Xã Tà Rụt",
					},
					{
						name: "Xã A Bung",
					},
					{
						name: "Xã A Ngo",
					},
				],
			},
			{
				name: "Huyện Cam Lộ",
				wards: [
					{
						name: "Thị trấn Cam Lộ",
					},
					{
						name: "Xã Cam Tuyền",
					},
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã Cam Thủy",
					},
					{
						name: "Xã Cam Thành",
					},
					{
						name: "Xã Cam Hiếu",
					},
					{
						name: "Xã Cam Chính",
					},
					{
						name: "Xã Cam Nghĩa",
					},
				],
			},
			{
				name: "Huyện Triệu Phong",
				wards: [
					{
						name: "Thị Trấn Ái Tử",
					},
					{
						name: "Xã Triệu An",
					},
					{
						name: "Xã Triệu Vân",
					},
					{
						name: "Xã Triệu Phước",
					},
					{
						name: "Xã Triệu Độ",
					},
					{
						name: "Xã Triệu Trạch",
					},
					{
						name: "Xã Triệu Thuận",
					},
					{
						name: "Xã Triệu Đại",
					},
					{
						name: "Xã Triệu Hòa",
					},
					{
						name: "Xã Triệu Lăng",
					},
					{
						name: "Xã Triệu Sơn",
					},
					{
						name: "Xã Triệu Long",
					},
					{
						name: "Xã Triệu Tài",
					},
					{
						name: "Xã Triệu Trung",
					},
					{
						name: "Xã Triệu Ái",
					},
					{
						name: "Xã Triệu Thượng",
					},
					{
						name: "Xã Triệu Giang",
					},
					{
						name: "Xã Triệu Thành",
					},
				],
			},
			{
				name: "Huyện Hải Lăng",
				wards: [
					{
						name: "Thị trấn Diên Sanh",
					},
					{
						name: "Xã Hải An",
					},
					{
						name: "Xã Hải Ba",
					},
					{
						name: "Xã Hải Quy",
					},
					{
						name: "Xã Hải Quế",
					},
					{
						name: "Xã Hải Hưng",
					},
					{
						name: "Xã Hải Phú",
					},
					{
						name: "Xã Hải Thượng",
					},
					{
						name: "Xã Hải Dương",
					},
					{
						name: "Xã Hải Định",
					},
					{
						name: "Xã Hải Lâm",
					},
					{
						name: "Xã Hải Phong",
					},
					{
						name: "Xã Hải Trường",
					},
					{
						name: "Xã Hải Sơn",
					},
					{
						name: "Xã Hải Chánh",
					},
					{
						name: "Xã Hải Khê",
					},
				],
			},
			{
				name: "Huyện Cồn Cỏ",
				wards: [],
			},
		],
	},
	{
		name: "Tỉnh Thừa Thiên Huế",
		districts: [
			{
				name: "Thành phố Huế",
				wards: [
					{
						name: "Phường Phú Thuận",
					},
					{
						name: "Phường Phú Bình",
					},
					{
						name: "Phường Tây Lộc",
					},
					{
						name: "Phường Thuận Lộc",
					},
					{
						name: "Phường Phú Hiệp",
					},
					{
						name: "Phường Phú Hậu",
					},
					{
						name: "Phường Thuận Hòa",
					},
					{
						name: "Phường Thuận Thành",
					},
					{
						name: "Phường Phú Hòa",
					},
					{
						name: "Phường Phú Cát",
					},
					{
						name: "Phường Kim Long",
					},
					{
						name: "Phường Vỹ Dạ",
					},
					{
						name: "Phường Phường Đúc",
					},
					{
						name: "Phường Vĩnh Ninh",
					},
					{
						name: "Phường Phú Hội",
					},
					{
						name: "Phường Phú Nhuận",
					},
					{
						name: "Phường Xuân Phú",
					},
					{
						name: "Phường Trường An",
					},
					{
						name: "Phường Phước Vĩnh",
					},
					{
						name: "Phường An Cựu",
					},
					{
						name: "Phường An Hòa",
					},
					{
						name: "Phường Hương Sơ",
					},
					{
						name: "Phường Thuỷ Biều",
					},
					{
						name: "Phường Hương Long",
					},
					{
						name: "Phường Thuỷ Xuân",
					},
					{
						name: "Phường An Đông",
					},
					{
						name: "Phường An Tây",
					},
				],
			},
			{
				name: "Huyện Phong Điền",
				wards: [
					{
						name: "Thị trấn Phong Điền",
					},
					{
						name: "Xã Điền Hương",
					},
					{
						name: "Xã Điền Môn",
					},
					{
						name: "Xã Điền Lộc",
					},
					{
						name: "Xã Phong Bình",
					},
					{
						name: "Xã Điền Hòa",
					},
					{
						name: "Xã Phong Chương",
					},
					{
						name: "Xã Phong Hải",
					},
					{
						name: "Xã Điền Hải",
					},
					{
						name: "Xã Phong Hòa",
					},
					{
						name: "Xã Phong Thu",
					},
					{
						name: "Xã Phong Hiền",
					},
					{
						name: "Xã Phong Mỹ",
					},
					{
						name: "Xã Phong An",
					},
					{
						name: "Xã Phong Xuân",
					},
					{
						name: "Xã Phong Sơn",
					},
				],
			},
			{
				name: "Huyện Quảng Điền",
				wards: [
					{
						name: "Thị trấn Sịa",
					},
					{
						name: "Xã Quảng Thái",
					},
					{
						name: "Xã Quảng Ngạn",
					},
					{
						name: "Xã Quảng Lợi",
					},
					{
						name: "Xã Quảng Công",
					},
					{
						name: "Xã Quảng Phước",
					},
					{
						name: "Xã Quảng Vinh",
					},
					{
						name: "Xã Quảng An",
					},
					{
						name: "Xã Quảng Thành",
					},
					{
						name: "Xã Quảng Thọ",
					},
					{
						name: "Xã Quảng Phú",
					},
				],
			},
			{
				name: "Huyện Phú Vang",
				wards: [
					{
						name: "Thị trấn Thuận An",
					},
					{
						name: "Xã Phú Thuận",
					},
					{
						name: "Xã Phú Dương",
					},
					{
						name: "Xã Phú Mậu",
					},
					{
						name: "Xã Phú An",
					},
					{
						name: "Xã Phú Hải",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Phú Diên",
					},
					{
						name: "Xã Phú Thanh",
					},
					{
						name: "Xã Phú Mỹ",
					},
					{
						name: "Xã Phú Thượng",
					},
					{
						name: "Xã Phú Hồ",
					},
					{
						name: "Xã Vinh Xuân",
					},
					{
						name: "Xã Phú Lương",
					},
					{
						name: "Thị trấn Phú Đa",
					},
					{
						name: "Xã Vinh Thanh",
					},
					{
						name: "Xã Vinh An",
					},
					{
						name: "Xã Phú Gia",
					},
					{
						name: "Xã Vinh Hà",
					},
				],
			},
			{
				name: "Thị xã Hương Thủy",
				wards: [
					{
						name: "Phường Phú Bài",
					},
					{
						name: "Xã Thủy Vân",
					},
					{
						name: "Xã Thủy Thanh",
					},
					{
						name: "Phường Thủy Dương",
					},
					{
						name: "Phường Thủy Phương",
					},
					{
						name: "Phường Thủy Châu",
					},
					{
						name: "Phường Thủy Lương",
					},
					{
						name: "Xã Thủy Bằng",
					},
					{
						name: "Xã Thủy Tân",
					},
					{
						name: "Xã Thủy Phù",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Dương Hòa",
					},
				],
			},
			{
				name: "Thị xã Hương Trà",
				wards: [
					{
						name: "Phường Tứ Hạ",
					},
					{
						name: "Xã Hải Dương",
					},
					{
						name: "Xã Hương Phong",
					},
					{
						name: "Xã Hương Toàn",
					},
					{
						name: "Phường Hương Vân",
					},
					{
						name: "Phường Hương Văn",
					},
					{
						name: "Xã Hương Vinh",
					},
					{
						name: "Phường Hương Xuân",
					},
					{
						name: "Phường Hương Chữ",
					},
					{
						name: "Phường Hương An",
					},
					{
						name: "Xã Hương Bình",
					},
					{
						name: "Phường Hương Hồ",
					},
					{
						name: "Xã Hương Thọ",
					},
					{
						name: "Xã Bình Tiến",
					},
					{
						name: "Xã Bình Thành",
					},
				],
			},
			{
				name: "Huyện A Lưới",
				wards: [
					{
						name: "Thị trấn A Lưới",
					},
					{
						name: "Xã Hồng Vân",
					},
					{
						name: "Xã Hồng Hạ",
					},
					{
						name: "Xã Hồng Kim",
					},
					{
						name: "Xã Trung Sơn",
					},
					{
						name: "Xã Hương Nguyên",
					},
					{
						name: "Xã Hồng Bắc",
					},
					{
						name: "Xã A Ngo",
					},
					{
						name: "Xã Sơn Thủy",
					},
					{
						name: "Xã Phú Vinh",
					},
					{
						name: "Xã Hương Phong",
					},
					{
						name: "Xã Quảng Nhâm",
					},
					{
						name: "Xã Hồng Thượng",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã A Roàng",
					},
					{
						name: "Xã Đông Sơn",
					},
					{
						name: "Xã Lâm Đớt",
					},
					{
						name: "Xã Hồng Thủy",
					},
				],
			},
			{
				name: "Huyện Phú Lộc",
				wards: [
					{
						name: "Thị trấn Phú Lộc",
					},
					{
						name: "Thị trấn Lăng Cô",
					},
					{
						name: "Xã Vinh Mỹ",
					},
					{
						name: "Xã Vinh Hưng",
					},
					{
						name: "Xã Giang Hải",
					},
					{
						name: "Xã Vinh Hiền",
					},
					{
						name: "Xã Lộc Bổn",
					},
					{
						name: "Xã Lộc Sơn",
					},
					{
						name: "Xã Lộc Bình",
					},
					{
						name: "Xã Lộc Vĩnh",
					},
					{
						name: "Xã Lộc An",
					},
					{
						name: "Xã Lộc Điền",
					},
					{
						name: "Xã Lộc Thủy",
					},
					{
						name: "Xã Lộc Trì",
					},
					{
						name: "Xã Lộc Tiến",
					},
					{
						name: "Xã Lộc Hòa",
					},
					{
						name: "Xã Xuân Lộc",
					},
				],
			},
			{
				name: "Huyện Nam Đông",
				wards: [
					{
						name: "Thị trấn Khe Tre",
					},
					{
						name: "Xã Hương Phú",
					},
					{
						name: "Xã Hương Sơn",
					},
					{
						name: "Xã Hương Lộc",
					},
					{
						name: "Xã Thượng Quảng",
					},
					{
						name: "Xã Hương Xuân",
					},
					{
						name: "Xã Hương Hữu",
					},
					{
						name: "Xã Thượng Lộ",
					},
					{
						name: "Xã Thượng Long",
					},
					{
						name: "Xã Thượng Nhật",
					},
				],
			},
		],
	},
	{
		name: "Thành phố Đà Nẵng",
		districts: [
			{
				name: "Quận Liên Chiểu",
				wards: [
					{
						name: "Phường Hòa Hiệp Bắc",
					},
					{
						name: "Phường Hòa Hiệp Nam",
					},
					{
						name: "Phường Hòa Khánh Bắc",
					},
					{
						name: "Phường Hòa Khánh Nam",
					},
					{
						name: "Phường Hòa Minh",
					},
				],
			},
			{
				name: "Quận Thanh Khê",
				wards: [
					{
						name: "Phường Tam Thuận",
					},
					{
						name: "Phường Thanh Khê Tây",
					},
					{
						name: "Phường Thanh Khê Đông",
					},
					{
						name: "Phường Xuân Hà",
					},
					{
						name: "Phường Tân Chính",
					},
					{
						name: "Phường Chính Gián",
					},
					{
						name: "Phường Vĩnh Trung",
					},
					{
						name: "Phường Thạc Gián",
					},
					{
						name: "Phường An Khê",
					},
					{
						name: "Phường Hòa Khê",
					},
				],
			},
			{
				name: "Quận Hải Châu",
				wards: [
					{
						name: "Phường Thanh Bình",
					},
					{
						name: "Phường Thuận Phước",
					},
					{
						name: "Phường Thạch Thang",
					},
					{
						name: "Phường Hải Châu I",
					},
					{
						name: "Phường Hải Châu II",
					},
					{
						name: "Phường Phước Ninh",
					},
					{
						name: "Phường Hòa Thuận Tây",
					},
					{
						name: "Phường Hòa Thuận Đông",
					},
					{
						name: "Phường Nam Dương",
					},
					{
						name: "Phường Bình Hiên",
					},
					{
						name: "Phường Bình Thuận",
					},
					{
						name: "Phường Hòa Cường Bắc",
					},
					{
						name: "Phường Hòa Cường Nam",
					},
				],
			},
			{
				name: "Quận Sơn Trà",
				wards: [
					{
						name: "Phường Thọ Quang",
					},
					{
						name: "Phường Nại Hiên Đông",
					},
					{
						name: "Phường Mân Thái",
					},
					{
						name: "Phường An Hải Bắc",
					},
					{
						name: "Phường Phước Mỹ",
					},
					{
						name: "Phường An Hải Tây",
					},
					{
						name: "Phường An Hải Đông",
					},
				],
			},
			{
				name: "Quận Ngũ Hành Sơn",
				wards: [
					{
						name: "Phường Mỹ An",
					},
					{
						name: "Phường Khuê Mỹ",
					},
					{
						name: "Phường Hoà Quý",
					},
					{
						name: "Phường Hoà Hải",
					},
				],
			},
			{
				name: "Quận Cẩm Lệ",
				wards: [
					{
						name: "Phường Khuê Trung",
					},
					{
						name: "Phường Hòa Phát",
					},
					{
						name: "Phường Hòa An",
					},
					{
						name: "Phường Hòa Thọ Tây",
					},
					{
						name: "Phường Hòa Thọ Đông",
					},
					{
						name: "Phường Hòa Xuân",
					},
				],
			},
			{
				name: "Huyện Hòa Vang",
				wards: [
					{
						name: "Xã Hòa Bắc",
					},
					{
						name: "Xã Hòa Liên",
					},
					{
						name: "Xã Hòa Ninh",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Xã Hòa Nhơn",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Hòa Phong",
					},
					{
						name: "Xã Hòa Châu",
					},
					{
						name: "Xã Hòa Tiến",
					},
					{
						name: "Xã Hòa Phước",
					},
					{
						name: "Xã Hòa Khương",
					},
				],
			},
			{
				name: "Huyện Hoàng Sa",
				wards: [],
			},
		],
	},
	{
		name: "Tỉnh Quảng Nam",
		districts: [
			{
				name: "Thành phố Tam Kỳ",
				wards: [
					{
						name: "Phường Tân Thạnh",
					},
					{
						name: "Phường Phước Hòa",
					},
					{
						name: "Phường An Mỹ",
					},
					{
						name: "Phường Hòa Hương",
					},
					{
						name: "Phường An Xuân",
					},
					{
						name: "Phường An Sơn",
					},
					{
						name: "Phường Trường Xuân",
					},
					{
						name: "Phường An Phú",
					},
					{
						name: "Xã Tam Thanh",
					},
					{
						name: "Xã Tam Thăng",
					},
					{
						name: "Xã Tam Phú",
					},
					{
						name: "Phường Hoà Thuận",
					},
					{
						name: "Xã Tam Ngọc",
					},
				],
			},
			{
				name: "Thành phố Hội An",
				wards: [
					{
						name: "Phường Minh An",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường Cẩm Phô",
					},
					{
						name: "Phường Thanh Hà",
					},
					{
						name: "Phường Sơn Phong",
					},
					{
						name: "Phường Cẩm Châu",
					},
					{
						name: "Phường Cửa Đại",
					},
					{
						name: "Phường Cẩm An",
					},
					{
						name: "Xã Cẩm Hà",
					},
					{
						name: "Xã Cẩm Kim",
					},
					{
						name: "Phường Cẩm Nam",
					},
					{
						name: "Xã Cẩm Thanh",
					},
					{
						name: "Xã Tân Hiệp",
					},
				],
			},
			{
				name: "Huyện Tây Giang",
				wards: [
					{
						name: "Xã Ch'ơm",
					},
					{
						name: "Xã Ga Ri",
					},
					{
						name: "Xã A Xan",
					},
					{
						name: "Xã Tr'Hy",
					},
					{
						name: "Xã Lăng",
					},
					{
						name: "Xã A Nông",
					},
					{
						name: "Xã A Tiêng",
					},
					{
						name: "Xã Bha Lê",
					},
					{
						name: "Xã A Vương",
					},
					{
						name: "Xã Dang",
					},
				],
			},
			{
				name: "Huyện Đông Giang",
				wards: [
					{
						name: "Thị trấn P Rao",
					},
					{
						name: "Xã Tà Lu",
					},
					{
						name: "Xã Sông Kôn",
					},
					{
						name: "Xã Jơ Ngây",
					},
					{
						name: "Xã A Ting",
					},
					{
						name: "Xã Tư",
					},
					{
						name: "Xã Ba",
					},
					{
						name: "Xã A Rooi",
					},
					{
						name: "Xã Za Hung",
					},
					{
						name: "Xã Mà Cooi",
					},
					{
						name: "Xã Ka Dăng",
					},
				],
			},
			{
				name: "Huyện Đại Lộc",
				wards: [
					{
						name: "Thị Trấn Ái Nghĩa",
					},
					{
						name: "Xã Đại Sơn",
					},
					{
						name: "Xã Đại Lãnh",
					},
					{
						name: "Xã Đại Hưng",
					},
					{
						name: "Xã Đại Hồng",
					},
					{
						name: "Xã Đại Đồng",
					},
					{
						name: "Xã Đại Quang",
					},
					{
						name: "Xã Đại Nghĩa",
					},
					{
						name: "Xã Đại Hiệp",
					},
					{
						name: "Xã Đại Thạnh",
					},
					{
						name: "Xã Đại Chánh",
					},
					{
						name: "Xã Đại Tân",
					},
					{
						name: "Xã Đại Phong",
					},
					{
						name: "Xã Đại Minh",
					},
					{
						name: "Xã Đại Thắng",
					},
					{
						name: "Xã Đại Cường",
					},
					{
						name: "Xã Đại An",
					},
					{
						name: "Xã Đại Hòa",
					},
				],
			},
			{
				name: "Thị xã Điện Bàn",
				wards: [
					{
						name: "Phường Vĩnh Điện",
					},
					{
						name: "Xã Điện Tiến",
					},
					{
						name: "Xã Điện Hòa",
					},
					{
						name: "Xã Điện Thắng Bắc",
					},
					{
						name: "Xã Điện Thắng Trung",
					},
					{
						name: "Xã Điện Thắng Nam",
					},
					{
						name: "Phường Điện Ngọc",
					},
					{
						name: "Xã Điện Hồng",
					},
					{
						name: "Xã Điện Thọ",
					},
					{
						name: "Xã Điện Phước",
					},
					{
						name: "Phường Điện An",
					},
					{
						name: "Phường Điện Nam Bắc",
					},
					{
						name: "Phường Điện Nam Trung",
					},
					{
						name: "Phường Điện Nam Đông",
					},
					{
						name: "Phường Điện Dương",
					},
					{
						name: "Xã Điện Quang",
					},
					{
						name: "Xã Điện Trung",
					},
					{
						name: "Xã Điện Phong",
					},
					{
						name: "Xã Điện Minh",
					},
					{
						name: "Xã Điện Phương",
					},
				],
			},
			{
				name: "Huyện Duy Xuyên",
				wards: [
					{
						name: "Thị trấn Nam Phước",
					},
					{
						name: "Xã Duy Thu",
					},
					{
						name: "Xã Duy Phú",
					},
					{
						name: "Xã Duy Tân",
					},
					{
						name: "Xã Duy Hòa",
					},
					{
						name: "Xã Duy Châu",
					},
					{
						name: "Xã Duy Trinh",
					},
					{
						name: "Xã Duy Sơn",
					},
					{
						name: "Xã Duy Trung",
					},
					{
						name: "Xã Duy Phước",
					},
					{
						name: "Xã Duy Thành",
					},
					{
						name: "Xã Duy Vinh",
					},
					{
						name: "Xã Duy Nghĩa",
					},
					{
						name: "Xã Duy Hải",
					},
				],
			},
			{
				name: "Huyện Quế Sơn",
				wards: [
					{
						name: "Thị trấn Đông Phú",
					},
					{
						name: "Xã Quế Xuân 1",
					},
					{
						name: "Xã Quế Xuân 2",
					},
					{
						name: "Xã Quế Phú",
					},
					{
						name: "Thị trấn Hương An",
					},
					{
						name: "Xã Quế Hiệp",
					},
					{
						name: "Xã Quế Thuận",
					},
					{
						name: "Xã Quế Mỹ",
					},
					{
						name: "Xã Quế Long",
					},
					{
						name: "Xã Quế Châu",
					},
					{
						name: "Xã Quế Phong",
					},
					{
						name: "Xã Quế An",
					},
					{
						name: "Xã Quế Minh",
					},
				],
			},
			{
				name: "Huyện Nam Giang",
				wards: [
					{
						name: "Thị trấn Thạnh Mỹ",
					},
					{
						name: "Xã Laêê",
					},
					{
						name: "Xã Chơ Chun",
					},
					{
						name: "Xã Zuôich",
					},
					{
						name: "Xã Tà Pơơ",
					},
					{
						name: "Xã La Dêê",
					},
					{
						name: "Xã Đắc Tôi",
					},
					{
						name: "Xã Chà Vàl",
					},
					{
						name: "Xã Tà Bhinh",
					},
					{
						name: "Xã Cà Dy",
					},
					{
						name: "Xã Đắc Pre",
					},
					{
						name: "Xã Đắc Pring",
					},
				],
			},
			{
				name: "Huyện Phước Sơn",
				wards: [
					{
						name: "Thị trấn Khâm Đức",
					},
					{
						name: "Xã Phước Xuân",
					},
					{
						name: "Xã Phước Hiệp",
					},
					{
						name: "Xã Phước Hoà",
					},
					{
						name: "Xã Phước Đức",
					},
					{
						name: "Xã Phước Năng",
					},
					{
						name: "Xã Phước Mỹ",
					},
					{
						name: "Xã Phước Chánh",
					},
					{
						name: "Xã Phước Công",
					},
					{
						name: "Xã Phước Kim",
					},
					{
						name: "Xã Phước Lộc",
					},
					{
						name: "Xã Phước Thành",
					},
				],
			},
			{
				name: "Huyện Hiệp Đức",
				wards: [
					{
						name: "Xã Hiệp Hòa",
					},
					{
						name: "Xã Hiệp Thuận",
					},
					{
						name: "Xã Quế Thọ",
					},
					{
						name: "Xã Bình Lâm",
					},
					{
						name: "Xã Sông Trà",
					},
					{
						name: "Xã Phước Trà",
					},
					{
						name: "Xã Phước Gia",
					},
					{
						name: "Thị trấn Tân Bình",
					},
					{
						name: "Xã Quế Lưu",
					},
					{
						name: "Xã Thăng Phước",
					},
					{
						name: "Xã Bình Sơn",
					},
				],
			},
			{
				name: "Huyện Thăng Bình",
				wards: [
					{
						name: "Thị trấn Hà Lam",
					},
					{
						name: "Xã Bình Dương",
					},
					{
						name: "Xã Bình Giang",
					},
					{
						name: "Xã Bình Nguyên",
					},
					{
						name: "Xã Bình Phục",
					},
					{
						name: "Xã Bình Triều",
					},
					{
						name: "Xã Bình Đào",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Bình Lãnh",
					},
					{
						name: "Xã Bình Trị",
					},
					{
						name: "Xã Bình Định Bắc",
					},
					{
						name: "Xã Bình Định Nam",
					},
					{
						name: "Xã Bình Quý",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Bình Chánh",
					},
					{
						name: "Xã Bình Tú",
					},
					{
						name: "Xã Bình Sa",
					},
					{
						name: "Xã Bình Hải",
					},
					{
						name: "Xã Bình Quế",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Bình Trung",
					},
					{
						name: "Xã Bình Nam",
					},
				],
			},
			{
				name: "Huyện Tiên Phước",
				wards: [
					{
						name: "Thị trấn Tiên Kỳ",
					},
					{
						name: "Xã Tiên Sơn",
					},
					{
						name: "Xã Tiên Hà",
					},
					{
						name: "Xã Tiên Cẩm",
					},
					{
						name: "Xã Tiên Châu",
					},
					{
						name: "Xã Tiên Lãnh",
					},
					{
						name: "Xã Tiên Ngọc",
					},
					{
						name: "Xã Tiên Hiệp",
					},
					{
						name: "Xã Tiên Cảnh",
					},
					{
						name: "Xã Tiên Mỹ",
					},
					{
						name: "Xã Tiên Phong",
					},
					{
						name: "Xã Tiên Thọ",
					},
					{
						name: "Xã Tiên An",
					},
					{
						name: "Xã Tiên Lộc",
					},
					{
						name: "Xã Tiên Lập",
					},
				],
			},
			{
				name: "Huyện Bắc Trà My",
				wards: [
					{
						name: "Thị trấn Trà My",
					},
					{
						name: "Xã Trà Sơn",
					},
					{
						name: "Xã Trà Kót",
					},
					{
						name: "Xã Trà Nú",
					},
					{
						name: "Xã Trà Đông",
					},
					{
						name: "Xã Trà Dương",
					},
					{
						name: "Xã Trà Giang",
					},
					{
						name: "Xã Trà Bui",
					},
					{
						name: "Xã Trà Đốc",
					},
					{
						name: "Xã Trà Tân",
					},
					{
						name: "Xã Trà Giác",
					},
					{
						name: "Xã Trà Giáp",
					},
					{
						name: "Xã Trà Ka",
					},
				],
			},
			{
				name: "Huyện Nam Trà My",
				wards: [
					{
						name: "Xã Trà Leng",
					},
					{
						name: "Xã Trà Dơn",
					},
					{
						name: "Xã Trà Tập",
					},
					{
						name: "Xã Trà Mai",
					},
					{
						name: "Xã Trà Cang",
					},
					{
						name: "Xã Trà Linh",
					},
					{
						name: "Xã Trà Nam",
					},
					{
						name: "Xã Trà Don",
					},
					{
						name: "Xã Trà Vân",
					},
					{
						name: "Xã Trà Vinh",
					},
				],
			},
			{
				name: "Huyện Núi Thành",
				wards: [
					{
						name: "Thị trấn Núi Thành",
					},
					{
						name: "Xã Tam Xuân I",
					},
					{
						name: "Xã Tam Xuân II",
					},
					{
						name: "Xã Tam Tiến",
					},
					{
						name: "Xã Tam Sơn",
					},
					{
						name: "Xã Tam Thạnh",
					},
					{
						name: "Xã Tam Anh Bắc",
					},
					{
						name: "Xã Tam Anh Nam",
					},
					{
						name: "Xã Tam Hòa",
					},
					{
						name: "Xã Tam Hiệp",
					},
					{
						name: "Xã Tam Hải",
					},
					{
						name: "Xã Tam Giang",
					},
					{
						name: "Xã Tam Quang",
					},
					{
						name: "Xã Tam Nghĩa",
					},
					{
						name: "Xã Tam Mỹ Tây",
					},
					{
						name: "Xã Tam Mỹ Đông",
					},
					{
						name: "Xã Tam Trà",
					},
				],
			},
			{
				name: "Huyện Phú Ninh",
				wards: [
					{
						name: "Thị trấn Phú Thịnh",
					},
					{
						name: "Xã Tam Thành",
					},
					{
						name: "Xã Tam An",
					},
					{
						name: "Xã Tam Đàn",
					},
					{
						name: "Xã Tam Lộc",
					},
					{
						name: "Xã Tam Phước",
					},
					{
						name: "Xã Tam Vinh",
					},
					{
						name: "Xã Tam Thái",
					},
					{
						name: "Xã Tam Đại",
					},
					{
						name: "Xã Tam Dân",
					},
					{
						name: "Xã Tam Lãnh",
					},
				],
			},
			{
				name: "Huyện Nông Sơn",
				wards: [
					{
						name: "Xã Quế Trung",
					},
					{
						name: "Xã Ninh Phước",
					},
					{
						name: "Xã Phước Ninh",
					},
					{
						name: "Xã Quế Lộc",
					},
					{
						name: "Xã Sơn Viên",
					},
					{
						name: "Xã Quế Lâm",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Quảng Ngãi",
		districts: [
			{
				name: "Thành phố Quảng Ngãi",
				wards: [
					{
						name: "Phường Lê Hồng Phong",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Quảng Phú",
					},
					{
						name: "Phường Nghĩa Chánh",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Nguyễn Nghiêm",
					},
					{
						name: "Phường Nghĩa Lộ",
					},
					{
						name: "Phường Chánh Lộ",
					},
					{
						name: "Xã Nghĩa Dũng",
					},
					{
						name: "Xã Nghĩa Dõng",
					},
					{
						name: "Phường Trương Quang Trọng",
					},
					{
						name: "Xã Tịnh Hòa",
					},
					{
						name: "Xã Tịnh Kỳ",
					},
					{
						name: "Xã Tịnh Thiện",
					},
					{
						name: "Xã Tịnh Ấn Đông",
					},
					{
						name: "Xã Tịnh Châu",
					},
					{
						name: "Xã Tịnh Khê",
					},
					{
						name: "Xã Tịnh Long",
					},
					{
						name: "Xã Tịnh Ấn Tây",
					},
					{
						name: "Xã Tịnh An",
					},
					{
						name: "Xã Nghĩa Phú",
					},
					{
						name: "Xã Nghĩa Hà",
					},
					{
						name: "Xã Nghĩa An",
					},
				],
			},
			{
				name: "Huyện Bình Sơn",
				wards: [
					{
						name: "Thị Trấn Châu Ổ",
					},
					{
						name: "Xã Bình Thuận",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Xã Bình Đông",
					},
					{
						name: "Xã Bình Chánh",
					},
					{
						name: "Xã Bình Nguyên",
					},
					{
						name: "Xã Bình Khương",
					},
					{
						name: "Xã Bình Trị",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Bình Hải",
					},
					{
						name: "Xã Bình Dương",
					},
					{
						name: "Xã Bình Phước",
					},
					{
						name: "Xã Bình Hòa",
					},
					{
						name: "Xã Bình Trung",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Bình Long",
					},
					{
						name: "Xã Bình Thanh",
					},
					{
						name: "Xã Bình Chương",
					},
					{
						name: "Xã Bình Hiệp",
					},
					{
						name: "Xã Bình Mỹ",
					},
					{
						name: "Xã Bình Tân Phú",
					},
					{
						name: "Xã Bình Châu",
					},
				],
			},
			{
				name: "Huyện Trà Bồng",
				wards: [
					{
						name: "Thị trấn Trà Xuân",
					},
					{
						name: "Xã Trà Giang",
					},
					{
						name: "Xã Trà Thủy",
					},
					{
						name: "Xã Trà Hiệp",
					},
					{
						name: "Xã Trà Bình",
					},
					{
						name: "Xã Trà Phú",
					},
					{
						name: "Xã Trà Lâm",
					},
					{
						name: "Xã Trà Tân",
					},
					{
						name: "Xã Trà Sơn",
					},
					{
						name: "Xã Trà Bùi",
					},
					{
						name: "Xã Trà Thanh",
					},
					{
						name: "Xã Sơn Trà",
					},
					{
						name: "Xã Trà Phong",
					},
					{
						name: "Xã Hương Trà",
					},
					{
						name: "Xã Trà Xinh",
					},
					{
						name: "Xã Trà Tây",
					},
				],
			},
			{
				name: "Huyện Sơn Tịnh",
				wards: [
					{
						name: "Xã Tịnh Thọ",
					},
					{
						name: "Xã Tịnh Trà",
					},
					{
						name: "Xã Tịnh Phong",
					},
					{
						name: "Xã Tịnh Hiệp",
					},
					{
						name: "Xã Tịnh Bình",
					},
					{
						name: "Xã Tịnh Đông",
					},
					{
						name: "Xã Tịnh Bắc",
					},
					{
						name: "Xã Tịnh Sơn",
					},
					{
						name: "Xã Tịnh Hà",
					},
					{
						name: "Xã Tịnh Giang",
					},
					{
						name: "Xã Tịnh Minh",
					},
				],
			},
			{
				name: "Huyện Tư Nghĩa",
				wards: [
					{
						name: "Thị trấn La Hà",
					},
					{
						name: "Thị trấn Sông Vệ",
					},
					{
						name: "Xã Nghĩa Lâm",
					},
					{
						name: "Xã Nghĩa Thắng",
					},
					{
						name: "Xã Nghĩa Thuận",
					},
					{
						name: "Xã Nghĩa Kỳ",
					},
					{
						name: "Xã Nghĩa Sơn",
					},
					{
						name: "Xã Nghĩa Hòa",
					},
					{
						name: "Xã Nghĩa Điền",
					},
					{
						name: "Xã Nghĩa Thương",
					},
					{
						name: "Xã Nghĩa Trung",
					},
					{
						name: "Xã Nghĩa Hiệp",
					},
					{
						name: "Xã Nghĩa Phương",
					},
					{
						name: "Xã Nghĩa Mỹ",
					},
				],
			},
			{
				name: "Huyện Sơn Hà",
				wards: [
					{
						name: "Thị trấn Di Lăng",
					},
					{
						name: "Xã Sơn Hạ",
					},
					{
						name: "Xã Sơn Thành",
					},
					{
						name: "Xã Sơn Nham",
					},
					{
						name: "Xã Sơn Bao",
					},
					{
						name: "Xã Sơn Linh",
					},
					{
						name: "Xã Sơn Giang",
					},
					{
						name: "Xã Sơn Trung",
					},
					{
						name: "Xã Sơn Thượng",
					},
					{
						name: "Xã Sơn Cao",
					},
					{
						name: "Xã Sơn Hải",
					},
					{
						name: "Xã Sơn Thủy",
					},
					{
						name: "Xã Sơn Kỳ",
					},
					{
						name: "Xã Sơn Ba",
					},
				],
			},
			{
				name: "Huyện Sơn Tây",
				wards: [
					{
						name: "Xã Sơn Bua",
					},
					{
						name: "Xã Sơn Mùa",
					},
					{
						name: "Xã Sơn Liên",
					},
					{
						name: "Xã Sơn Tân",
					},
					{
						name: "Xã Sơn Màu",
					},
					{
						name: "Xã Sơn Dung",
					},
					{
						name: "Xã Sơn Long",
					},
					{
						name: "Xã Sơn Tinh",
					},
					{
						name: "Xã Sơn Lập",
					},
				],
			},
			{
				name: "Huyện Minh Long",
				wards: [
					{
						name: "Xã Long Sơn",
					},
					{
						name: "Xã Long Mai",
					},
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã Long Môn",
					},
					{
						name: "Xã Long Hiệp",
					},
				],
			},
			{
				name: "Huyện Nghĩa Hành",
				wards: [
					{
						name: "Thị trấn Chợ Chùa",
					},
					{
						name: "Xã Hành Thuận",
					},
					{
						name: "Xã Hành Dũng",
					},
					{
						name: "Xã Hành Trung",
					},
					{
						name: "Xã Hành Nhân",
					},
					{
						name: "Xã Hành Đức",
					},
					{
						name: "Xã Hành Minh",
					},
					{
						name: "Xã Hành Phước",
					},
					{
						name: "Xã Hành Thiện",
					},
					{
						name: "Xã Hành Thịnh",
					},
					{
						name: "Xã Hành Tín Tây",
					},
					{
						name: "Xã Hành Tín Đông",
					},
				],
			},
			{
				name: "Huyện Mộ Đức",
				wards: [
					{
						name: "Thị trấn Mộ Đức",
					},
					{
						name: "Xã Đức Lợi",
					},
					{
						name: "Xã Đức Thắng",
					},
					{
						name: "Xã Đức Nhuận",
					},
					{
						name: "Xã Đức Chánh",
					},
					{
						name: "Xã Đức Hiệp",
					},
					{
						name: "Xã Đức Minh",
					},
					{
						name: "Xã Đức Thạnh",
					},
					{
						name: "Xã Đức Hòa",
					},
					{
						name: "Xã Đức Tân",
					},
					{
						name: "Xã Đức Phú",
					},
					{
						name: "Xã Đức Phong",
					},
					{
						name: "Xã Đức Lân",
					},
				],
			},
			{
				name: "Thị xã Đức Phổ",
				wards: [
					{
						name: "Phường Nguyễn Nghiêm",
					},
					{
						name: "Xã Phổ An",
					},
					{
						name: "Xã Phổ Phong",
					},
					{
						name: "Xã Phổ Thuận",
					},
					{
						name: "Phường Phổ Văn",
					},
					{
						name: "Phường Phổ Quang",
					},
					{
						name: "Xã Phổ Nhơn",
					},
					{
						name: "Phường Phổ Ninh",
					},
					{
						name: "Phường Phổ Minh",
					},
					{
						name: "Phường Phổ Vinh",
					},
					{
						name: "Phường Phổ Hòa",
					},
					{
						name: "Xã Phổ Cường",
					},
					{
						name: "Xã Phổ Khánh",
					},
					{
						name: "Phường Phổ Thạnh",
					},
					{
						name: "Xã Phổ Châu",
					},
				],
			},
			{
				name: "Huyện Ba Tơ",
				wards: [
					{
						name: "Thị trấn Ba Tơ",
					},
					{
						name: "Xã Ba Điền",
					},
					{
						name: "Xã Ba Vinh",
					},
					{
						name: "Xã Ba Thành",
					},
					{
						name: "Xã Ba Động",
					},
					{
						name: "Xã Ba Dinh",
					},
					{
						name: "Xã Ba Giang",
					},
					{
						name: "Xã Ba Liên",
					},
					{
						name: "Xã Ba Ngạc",
					},
					{
						name: "Xã Ba Khâm",
					},
					{
						name: "Xã Ba Cung",
					},
					{
						name: "Xã Ba Tiêu",
					},
					{
						name: "Xã Ba Trang",
					},
					{
						name: "Xã Ba Tô",
					},
					{
						name: "Xã Ba Bích",
					},
					{
						name: "Xã Ba Vì",
					},
					{
						name: "Xã Ba Lế",
					},
					{
						name: "Xã Ba Nam",
					},
					{
						name: "Xã Ba Xa",
					},
				],
			},
			{
				name: "Huyện Lý Sơn",
				wards: [],
			},
		],
	},
	{
		name: "Tỉnh Bình Định",
		districts: [
			{
				name: "Thành phố Quy Nhơn",
				wards: [
					{
						name: "Phường Nhơn Bình",
					},
					{
						name: "Phường Nhơn Phú",
					},
					{
						name: "Phường Đống Đa",
					},
					{
						name: "Phường Trần Quang Diệu",
					},
					{
						name: "Phường Hải Cảng",
					},
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Thị Nại",
					},
					{
						name: "Phường Lê Hồng Phong",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Phường Ngô Mây",
					},
					{
						name: "Phường Lý Thường Kiệt",
					},
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Phường Trần Phú",
					},
					{
						name: "Phường Bùi Thị Xuân",
					},
					{
						name: "Phường Nguyễn Văn Cừ",
					},
					{
						name: "Phường Ghềnh Ráng",
					},
					{
						name: "Xã Nhơn Lý",
					},
					{
						name: "Xã Nhơn Hội",
					},
					{
						name: "Xã Nhơn Hải",
					},
					{
						name: "Xã Nhơn Châu",
					},
					{
						name: "Xã Phước Mỹ",
					},
				],
			},
			{
				name: "Huyện An Lão",
				wards: [
					{
						name: "Thị trấn An Lão",
					},
					{
						name: "Xã An Hưng",
					},
					{
						name: "Xã An Trung",
					},
					{
						name: "Xã An Dũng",
					},
					{
						name: "Xã An Vinh",
					},
					{
						name: "Xã An Toàn",
					},
					{
						name: "Xã An Tân",
					},
					{
						name: "Xã An Hòa",
					},
					{
						name: "Xã An Quang",
					},
					{
						name: "Xã An Nghĩa",
					},
				],
			},
			{
				name: "Thị xã Hoài Nhơn",
				wards: [
					{
						name: "Phường Tam Quan",
					},
					{
						name: "Phường Bồng Sơn",
					},
					{
						name: "Xã Hoài Sơn",
					},
					{
						name: "Xã Hoài Châu Bắc",
					},
					{
						name: "Xã Hoài Châu",
					},
					{
						name: "Xã Hoài Phú",
					},
					{
						name: "Phường Tam Quan Bắc",
					},
					{
						name: "Phường Tam Quan Nam",
					},
					{
						name: "Phường Hoài Hảo",
					},
					{
						name: "Phường Hoài Thanh Tây",
					},
					{
						name: "Phường Hoài Thanh",
					},
					{
						name: "Phường Hoài Hương",
					},
					{
						name: "Phường Hoài Tân",
					},
					{
						name: "Xã Hoài Hải",
					},
					{
						name: "Phường Hoài Xuân",
					},
					{
						name: "Xã Hoài Mỹ",
					},
					{
						name: "Phường Hoài Đức",
					},
				],
			},
			{
				name: "Huyện Hoài Ân",
				wards: [
					{
						name: "Thị trấn Tăng Bạt Hổ",
					},
					{
						name: "Xã Ân Hảo Tây",
					},
					{
						name: "Xã Ân Hảo Đông",
					},
					{
						name: "Xã Ân Sơn",
					},
					{
						name: "Xã Ân Mỹ",
					},
					{
						name: "Xã Đak Mang",
					},
					{
						name: "Xã Ân Tín",
					},
					{
						name: "Xã Ân Thạnh",
					},
					{
						name: "Xã Ân Phong",
					},
					{
						name: "Xã Ân Đức",
					},
					{
						name: "Xã Ân Hữu",
					},
					{
						name: "Xã Bok Tới",
					},
					{
						name: "Xã Ân Tường Tây",
					},
					{
						name: "Xã Ân Tường Đông",
					},
					{
						name: "Xã Ân Nghĩa",
					},
				],
			},
			{
				name: "Huyện Phù Mỹ",
				wards: [
					{
						name: "Thị trấn Phù Mỹ",
					},
					{
						name: "Thị trấn Bình Dương",
					},
					{
						name: "Xã Mỹ Đức",
					},
					{
						name: "Xã Mỹ Châu",
					},
					{
						name: "Xã Mỹ Thắng",
					},
					{
						name: "Xã Mỹ Lộc",
					},
					{
						name: "Xã Mỹ Lợi",
					},
					{
						name: "Xã Mỹ An",
					},
					{
						name: "Xã Mỹ Phong",
					},
					{
						name: "Xã Mỹ Trinh",
					},
					{
						name: "Xã Mỹ Thọ",
					},
					{
						name: "Xã Mỹ Hòa",
					},
					{
						name: "Xã Mỹ Thành",
					},
					{
						name: "Xã Mỹ Chánh",
					},
					{
						name: "Xã Mỹ Quang",
					},
					{
						name: "Xã Mỹ Hiệp",
					},
					{
						name: "Xã Mỹ Tài",
					},
					{
						name: "Xã Mỹ Cát",
					},
					{
						name: "Xã Mỹ Chánh Tây",
					},
				],
			},
			{
				name: "Huyện Vĩnh Thạnh",
				wards: [
					{
						name: "Thị trấn Vĩnh Thạnh",
					},
					{
						name: "Xã Vĩnh Sơn",
					},
					{
						name: "Xã Vĩnh Kim",
					},
					{
						name: "Xã Vĩnh Hiệp",
					},
					{
						name: "Xã Vĩnh Hảo",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Vĩnh Thịnh",
					},
					{
						name: "Xã Vĩnh Thuận",
					},
					{
						name: "Xã Vĩnh Quang",
					},
				],
			},
			{
				name: "Huyện Tây Sơn",
				wards: [
					{
						name: "Thị trấn Phú Phong",
					},
					{
						name: "Xã Bình Tân",
					},
					{
						name: "Xã Tây Thuận",
					},
					{
						name: "Xã Bình Thuận",
					},
					{
						name: "Xã Tây Giang",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Tây An",
					},
					{
						name: "Xã Bình Hòa",
					},
					{
						name: "Xã Tây Bình",
					},
					{
						name: "Xã Bình Tường",
					},
					{
						name: "Xã Tây Vinh",
					},
					{
						name: "Xã Vĩnh An",
					},
					{
						name: "Xã Tây Xuân",
					},
					{
						name: "Xã Bình Nghi",
					},
					{
						name: "Xã Tây Phú",
					},
				],
			},
			{
				name: "Huyện Phù Cát",
				wards: [
					{
						name: "Thị trấn Ngô Mây",
					},
					{
						name: "Xã Cát Sơn",
					},
					{
						name: "Xã Cát Minh",
					},
					{
						name: "Xã Cát Khánh",
					},
					{
						name: "Xã Cát Tài",
					},
					{
						name: "Xã Cát Lâm",
					},
					{
						name: "Xã Cát Hanh",
					},
					{
						name: "Xã Cát Thành",
					},
					{
						name: "Xã Cát Trinh",
					},
					{
						name: "Xã Cát Hải",
					},
					{
						name: "Xã Cát Hiệp",
					},
					{
						name: "Xã Cát Nhơn",
					},
					{
						name: "Xã Cát Hưng",
					},
					{
						name: "Xã Cát Tường",
					},
					{
						name: "Xã Cát Tân",
					},
					{
						name: "Thị trấn Cát Tiến",
					},
					{
						name: "Xã Cát Thắng",
					},
					{
						name: "Xã Cát Chánh",
					},
				],
			},
			{
				name: "Thị xã An Nhơn",
				wards: [
					{
						name: "Phường Bình Định",
					},
					{
						name: "Phường Đập Đá",
					},
					{
						name: "Xã Nhơn Mỹ",
					},
					{
						name: "Phường Nhơn Thành",
					},
					{
						name: "Xã Nhơn Hạnh",
					},
					{
						name: "Xã Nhơn Hậu",
					},
					{
						name: "Xã Nhơn Phong",
					},
					{
						name: "Xã Nhơn An",
					},
					{
						name: "Xã Nhơn Phúc",
					},
					{
						name: "Phường Nhơn Hưng",
					},
					{
						name: "Xã Nhơn Khánh",
					},
					{
						name: "Xã Nhơn Lộc",
					},
					{
						name: "Phường Nhơn Hoà",
					},
					{
						name: "Xã Nhơn Tân",
					},
					{
						name: "Xã Nhơn Thọ",
					},
				],
			},
			{
				name: "Huyện Tuy Phước",
				wards: [
					{
						name: "Thị trấn Tuy Phước",
					},
					{
						name: "Thị trấn Diêu Trì",
					},
					{
						name: "Xã Phước Thắng",
					},
					{
						name: "Xã Phước Hưng",
					},
					{
						name: "Xã Phước Quang",
					},
					{
						name: "Xã Phước Hòa",
					},
					{
						name: "Xã Phước Sơn",
					},
					{
						name: "Xã Phước Hiệp",
					},
					{
						name: "Xã Phước Lộc",
					},
					{
						name: "Xã Phước Nghĩa",
					},
					{
						name: "Xã Phước Thuận",
					},
					{
						name: "Xã Phước An",
					},
					{
						name: "Xã Phước Thành",
					},
				],
			},
			{
				name: "Huyện Vân Canh",
				wards: [
					{
						name: "Thị trấn Vân Canh",
					},
					{
						name: "Xã Canh Liên",
					},
					{
						name: "Xã Canh Hiệp",
					},
					{
						name: "Xã Canh Vinh",
					},
					{
						name: "Xã Canh Hiển",
					},
					{
						name: "Xã Canh Thuận",
					},
					{
						name: "Xã Canh Hòa",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Phú Yên",
		districts: [
			{
				name: "Thành phố Tuy Hoà",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường Phú Thạnh",
					},
					{
						name: "Phường Phú Đông",
					},
					{
						name: "Xã Hòa Kiến",
					},
					{
						name: "Xã Bình Kiến",
					},
					{
						name: "Xã Bình Ngọc",
					},
					{
						name: "Xã An Phú",
					},
					{
						name: "Phường Phú Lâm",
					},
				],
			},
			{
				name: "Thị xã Sông Cầu",
				wards: [
					{
						name: "Phường Xuân Phú",
					},
					{
						name: "Xã Xuân Lâm",
					},
					{
						name: "Phường Xuân Thành",
					},
					{
						name: "Xã Xuân Hải",
					},
					{
						name: "Xã Xuân Lộc",
					},
					{
						name: "Xã Xuân Bình",
					},
					{
						name: "Xã Xuân Cảnh",
					},
					{
						name: "Xã Xuân Thịnh",
					},
					{
						name: "Xã Xuân Phương",
					},
					{
						name: "Phường Xuân Yên",
					},
					{
						name: "Xã Xuân Thọ 1",
					},
					{
						name: "Phường Xuân Đài",
					},
					{
						name: "Xã Xuân Thọ 2",
					},
				],
			},
			{
				name: "Huyện Đồng Xuân",
				wards: [
					{
						name: "Thị trấn La Hai",
					},
					{
						name: "Xã Đa Lộc",
					},
					{
						name: "Xã Phú Mỡ",
					},
					{
						name: "Xã Xuân Lãnh",
					},
					{
						name: "Xã Xuân Long",
					},
					{
						name: "Xã Xuân Quang 1",
					},
					{
						name: "Xã Xuân Sơn Bắc",
					},
					{
						name: "Xã Xuân Quang 2",
					},
					{
						name: "Xã Xuân Sơn Nam",
					},
					{
						name: "Xã Xuân Quang 3",
					},
					{
						name: "Xã Xuân Phước",
					},
				],
			},
			{
				name: "Huyện Tuy An",
				wards: [
					{
						name: "Thị trấn Chí Thạnh",
					},
					{
						name: "Xã An Dân",
					},
					{
						name: "Xã An Ninh Tây",
					},
					{
						name: "Xã An Ninh Đông",
					},
					{
						name: "Xã An Thạch",
					},
					{
						name: "Xã An Định",
					},
					{
						name: "Xã An Nghiệp",
					},
					{
						name: "Xã An Cư",
					},
					{
						name: "Xã An Xuân",
					},
					{
						name: "Xã An Lĩnh",
					},
					{
						name: "Xã An Hòa Hải",
					},
					{
						name: "Xã An Hiệp",
					},
					{
						name: "Xã An Mỹ",
					},
					{
						name: "Xã An Chấn",
					},
					{
						name: "Xã An Thọ",
					},
				],
			},
			{
				name: "Huyện Sơn Hòa",
				wards: [
					{
						name: "Thị trấn Củng Sơn",
					},
					{
						name: "Xã Phước Tân",
					},
					{
						name: "Xã Sơn Hội",
					},
					{
						name: "Xã Sơn Định",
					},
					{
						name: "Xã Sơn Long",
					},
					{
						name: "Xã Cà Lúi",
					},
					{
						name: "Xã Sơn Phước",
					},
					{
						name: "Xã Sơn Xuân",
					},
					{
						name: "Xã Sơn Nguyên",
					},
					{
						name: "Xã Eachà Rang",
					},
					{
						name: "Xã Krông Pa",
					},
					{
						name: "Xã Suối Bạc",
					},
					{
						name: "Xã Sơn Hà",
					},
					{
						name: "Xã Suối Trai",
					},
				],
			},
			{
				name: "Huyện Sông Hinh",
				wards: [
					{
						name: "Thị trấn Hai Riêng",
					},
					{
						name: "Xã Ea Lâm",
					},
					{
						name: "Xã Đức Bình Tây",
					},
					{
						name: "Xã Ea Bá",
					},
					{
						name: "Xã Sơn Giang",
					},
					{
						name: "Xã Đức Bình Đông",
					},
					{
						name: "Xã EaBar",
					},
					{
						name: "Xã EaBia",
					},
					{
						name: "Xã EaTrol",
					},
					{
						name: "Xã Sông Hinh",
					},
					{
						name: "Xã Ealy",
					},
				],
			},
			{
				name: "Huyện Tây Hoà",
				wards: [
					{
						name: "Xã Sơn Thành Tây",
					},
					{
						name: "Xã Sơn Thành Đông",
					},
					{
						name: "Xã Hòa Bình 1",
					},
					{
						name: "Thị trấn Phú Thứ",
					},
					{
						name: "Xã Hòa Phong",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Hòa Tân Tây",
					},
					{
						name: "Xã Hòa Đồng",
					},
					{
						name: "Xã Hòa Mỹ Đông",
					},
					{
						name: "Xã Hòa Mỹ Tây",
					},
					{
						name: "Xã Hòa Thịnh",
					},
				],
			},
			{
				name: "Huyện Phú Hoà",
				wards: [
					{
						name: "Xã Hòa Quang Bắc",
					},
					{
						name: "Xã Hòa Quang Nam",
					},
					{
						name: "Xã Hòa Hội",
					},
					{
						name: "Xã Hòa Trị",
					},
					{
						name: "Xã Hòa An",
					},
					{
						name: "Xã Hòa Định Đông",
					},
					{
						name: "Thị Trấn Phú Hoà",
					},
					{
						name: "Xã Hòa Định Tây",
					},
					{
						name: "Xã Hòa Thắng",
					},
				],
			},
			{
				name: "Thị xã Đông Hòa",
				wards: [
					{
						name: "Xã Hòa Thành",
					},
					{
						name: "Phường Hòa Hiệp Bắc",
					},
					{
						name: "Phường Hoà Vinh",
					},
					{
						name: "Phường Hoà Hiệp Trung",
					},
					{
						name: "Xã Hòa Tân Đông",
					},
					{
						name: "Phường Hòa Xuân Tây",
					},
					{
						name: "Phường Hòa Hiệp Nam",
					},
					{
						name: "Xã Hòa Xuân Đông",
					},
					{
						name: "Xã Hòa Tâm",
					},
					{
						name: "Xã Hòa Xuân Nam",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Khánh Hòa",
		districts: [
			{
				name: "Thành phố Nha Trang",
				wards: [
					{
						name: "Phường Vĩnh Hòa",
					},
					{
						name: "Phường Vĩnh Hải",
					},
					{
						name: "Phường Vĩnh Phước",
					},
					{
						name: "Phường Ngọc Hiệp",
					},
					{
						name: "Phường Vĩnh Thọ",
					},
					{
						name: "Phường Xương Huân",
					},
					{
						name: "Phường Vạn Thắng",
					},
					{
						name: "Phường Vạn Thạnh",
					},
					{
						name: "Phường Phương Sài",
					},
					{
						name: "Phường Phương Sơn",
					},
					{
						name: "Phường Phước Hải",
					},
					{
						name: "Phường Phước Tân",
					},
					{
						name: "Phường Lộc Thọ",
					},
					{
						name: "Phường Phước Tiến",
					},
					{
						name: "Phường Tân Lập",
					},
					{
						name: "Phường Phước Hòa",
					},
					{
						name: "Phường Vĩnh Nguyên",
					},
					{
						name: "Phường Phước Long",
					},
					{
						name: "Phường Vĩnh Trường",
					},
					{
						name: "Xã Vĩnh Lương",
					},
					{
						name: "Xã Vĩnh Phương",
					},
					{
						name: "Xã Vĩnh Ngọc",
					},
					{
						name: "Xã Vĩnh Thạnh",
					},
					{
						name: "Xã Vĩnh Trung",
					},
					{
						name: "Xã Vĩnh Hiệp",
					},
					{
						name: "Xã Vĩnh Thái",
					},
					{
						name: "Xã Phước Đồng",
					},
				],
			},
			{
				name: "Thành phố Cam Ranh",
				wards: [
					{
						name: "Phường Cam Nghĩa",
					},
					{
						name: "Phường Cam Phúc Bắc",
					},
					{
						name: "Phường Cam Phúc Nam",
					},
					{
						name: "Phường Cam Lộc",
					},
					{
						name: "Phường Cam Phú",
					},
					{
						name: "Phường Ba Ngòi",
					},
					{
						name: "Phường Cam Thuận",
					},
					{
						name: "Phường Cam Lợi",
					},
					{
						name: "Phường Cam Linh",
					},
					{
						name: "Xã Cam Thành Nam",
					},
					{
						name: "Xã Cam Phước Đông",
					},
					{
						name: "Xã Cam Thịnh Tây",
					},
					{
						name: "Xã Cam Thịnh Đông",
					},
					{
						name: "Xã Cam Lập",
					},
					{
						name: "Xã Cam Bình",
					},
				],
			},
			{
				name: "Huyện Cam Lâm",
				wards: [
					{
						name: "Xã Cam Tân",
					},
					{
						name: "Xã Cam Hòa",
					},
					{
						name: "Xã Cam Hải Đông",
					},
					{
						name: "Xã Cam Hải Tây",
					},
					{
						name: "Xã Sơn Tân",
					},
					{
						name: "Xã Cam Hiệp Bắc",
					},
					{
						name: "Thị trấn Cam Đức",
					},
					{
						name: "Xã Cam Hiệp Nam",
					},
					{
						name: "Xã Cam Phước Tây",
					},
					{
						name: "Xã Cam Thành Bắc",
					},
					{
						name: "Xã Cam An Bắc",
					},
					{
						name: "Xã Cam An Nam",
					},
					{
						name: "Xã Suối Cát",
					},
					{
						name: "Xã Suối Tân",
					},
				],
			},
			{
				name: "Huyện Vạn Ninh",
				wards: [
					{
						name: "Thị trấn Vạn Giã",
					},
					{
						name: "Xã Đại Lãnh",
					},
					{
						name: "Xã Vạn Phước",
					},
					{
						name: "Xã Vạn Long",
					},
					{
						name: "Xã Vạn Bình",
					},
					{
						name: "Xã Vạn Thọ",
					},
					{
						name: "Xã Vạn Khánh",
					},
					{
						name: "Xã Vạn Phú",
					},
					{
						name: "Xã Vạn Lương",
					},
					{
						name: "Xã Vạn Thắng",
					},
					{
						name: "Xã Vạn Thạnh",
					},
					{
						name: "Xã Xuân Sơn",
					},
					{
						name: "Xã Vạn Hưng",
					},
				],
			},
			{
				name: "Thị xã Ninh Hòa",
				wards: [
					{
						name: "Phường Ninh Hiệp",
					},
					{
						name: "Xã Ninh Sơn",
					},
					{
						name: "Xã Ninh Tây",
					},
					{
						name: "Xã Ninh Thượng",
					},
					{
						name: "Xã Ninh An",
					},
					{
						name: "Phường Ninh Hải",
					},
					{
						name: "Xã Ninh Thọ",
					},
					{
						name: "Xã Ninh Trung",
					},
					{
						name: "Xã Ninh Sim",
					},
					{
						name: "Xã Ninh Xuân",
					},
					{
						name: "Xã Ninh Thân",
					},
					{
						name: "Phường Ninh Diêm",
					},
					{
						name: "Xã Ninh Đông",
					},
					{
						name: "Phường Ninh Thủy",
					},
					{
						name: "Phường Ninh Đa",
					},
					{
						name: "Xã Ninh Phụng",
					},
					{
						name: "Xã Ninh Bình",
					},
					{
						name: "Xã Ninh Phước",
					},
					{
						name: "Xã Ninh Phú",
					},
					{
						name: "Xã Ninh Tân",
					},
					{
						name: "Xã Ninh Quang",
					},
					{
						name: "Phường Ninh Giang",
					},
					{
						name: "Phường Ninh Hà",
					},
					{
						name: "Xã Ninh Hưng",
					},
					{
						name: "Xã Ninh Lộc",
					},
					{
						name: "Xã Ninh Ích",
					},
					{
						name: "Xã Ninh Vân",
					},
				],
			},
			{
				name: "Huyện Khánh Vĩnh",
				wards: [
					{
						name: "Thị trấn Khánh Vĩnh",
					},
					{
						name: "Xã Khánh Hiệp",
					},
					{
						name: "Xã Khánh Bình",
					},
					{
						name: "Xã Khánh Trung",
					},
					{
						name: "Xã Khánh Đông",
					},
					{
						name: "Xã Khánh Thượng",
					},
					{
						name: "Xã Khánh Nam",
					},
					{
						name: "Xã Sông Cầu",
					},
					{
						name: "Xã Giang Ly",
					},
					{
						name: "Xã Cầu Bà",
					},
					{
						name: "Xã Liên Sang",
					},
					{
						name: "Xã Khánh Thành",
					},
					{
						name: "Xã Khánh Phú",
					},
					{
						name: "Xã Sơn Thái",
					},
				],
			},
			{
				name: "Huyện Diên Khánh",
				wards: [
					{
						name: "Thị trấn Diên Khánh",
					},
					{
						name: "Xã Diên Lâm",
					},
					{
						name: "Xã Diên Điền",
					},
					{
						name: "Xã Diên Xuân",
					},
					{
						name: "Xã Diên Sơn",
					},
					{
						name: "Xã Diên Đồng",
					},
					{
						name: "Xã Diên Phú",
					},
					{
						name: "Xã Diên Thọ",
					},
					{
						name: "Xã Diên Phước",
					},
					{
						name: "Xã Diên Lạc",
					},
					{
						name: "Xã Diên Tân",
					},
					{
						name: "Xã Diên Hòa",
					},
					{
						name: "Xã Diên Thạnh",
					},
					{
						name: "Xã Diên Toàn",
					},
					{
						name: "Xã Diên An",
					},
					{
						name: "Xã Bình Lộc",
					},
					{
						name: "Xã Suối Hiệp",
					},
					{
						name: "Xã Suối Tiên",
					},
				],
			},
			{
				name: "Huyện Khánh Sơn",
				wards: [
					{
						name: "Thị trấn Tô Hạp",
					},
					{
						name: "Xã Thành Sơn",
					},
					{
						name: "Xã Sơn Lâm",
					},
					{
						name: "Xã Sơn Hiệp",
					},
					{
						name: "Xã Sơn Bình",
					},
					{
						name: "Xã Sơn Trung",
					},
					{
						name: "Xã Ba Cụm Bắc",
					},
					{
						name: "Xã Ba Cụm Nam",
					},
				],
			},
			{
				name: "Huyện Trường Sa",
				wards: [
					{
						name: "Thị trấn Trường Sa",
					},
					{
						name: "Xã Song Tử Tây",
					},
					{
						name: "Xã Sinh Tồn",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Ninh Thuận",
		districts: [
			{
				name: "Thành phố Phan Rang-Tháp Chàm",
				wards: [
					{
						name: "Phường Đô Vinh",
					},
					{
						name: "Phường Phước Mỹ",
					},
					{
						name: "Phường Bảo An",
					},
					{
						name: "Phường Phủ Hà",
					},
					{
						name: "Phường Thanh Sơn",
					},
					{
						name: "Phường Mỹ Hương",
					},
					{
						name: "Phường Tấn Tài",
					},
					{
						name: "Phường Kinh Dinh",
					},
					{
						name: "Phường Đạo Long",
					},
					{
						name: "Phường Đài Sơn",
					},
					{
						name: "Phường Đông Hải",
					},
					{
						name: "Phường Mỹ Đông",
					},
					{
						name: "Xã Thành Hải",
					},
					{
						name: "Phường Văn Hải",
					},
					{
						name: "Phường Mỹ Bình",
					},
					{
						name: "Phường Mỹ Hải",
					},
				],
			},
			{
				name: "Huyện Bác Ái",
				wards: [
					{
						name: "Xã Phước Bình",
					},
					{
						name: "Xã Phước Hòa",
					},
					{
						name: "Xã Phước Tân",
					},
					{
						name: "Xã Phước Tiến",
					},
					{
						name: "Xã Phước Thắng",
					},
					{
						name: "Xã Phước Thành",
					},
					{
						name: "Xã Phước Đại",
					},
					{
						name: "Xã Phước Chính",
					},
					{
						name: "Xã Phước Trung",
					},
				],
			},
			{
				name: "Huyện Ninh Sơn",
				wards: [
					{
						name: "Thị trấn Tân Sơn",
					},
					{
						name: "Xã Lâm Sơn",
					},
					{
						name: "Xã Lương Sơn",
					},
					{
						name: "Xã Quảng Sơn",
					},
					{
						name: "Xã Mỹ Sơn",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Xã Ma Nới",
					},
					{
						name: "Xã Nhơn Sơn",
					},
				],
			},
			{
				name: "Huyện Ninh Hải",
				wards: [
					{
						name: "Thị trấn Khánh Hải",
					},
					{
						name: "Xã Vĩnh Hải",
					},
					{
						name: "Xã Phương Hải",
					},
					{
						name: "Xã Tân Hải",
					},
					{
						name: "Xã Xuân Hải",
					},
					{
						name: "Xã Hộ Hải",
					},
					{
						name: "Xã Tri Hải",
					},
					{
						name: "Xã Nhơn Hải",
					},
					{
						name: "Xã Thanh Hải",
					},
				],
			},
			{
				name: "Huyện Ninh Phước",
				wards: [
					{
						name: "Thị trấn Phước Dân",
					},
					{
						name: "Xã Phước Sơn",
					},
					{
						name: "Xã Phước Thái",
					},
					{
						name: "Xã Phước Hậu",
					},
					{
						name: "Xã Phước Thuận",
					},
					{
						name: "Xã An Hải",
					},
					{
						name: "Xã Phước Hữu",
					},
					{
						name: "Xã Phước Hải",
					},
					{
						name: "Xã Phước Vinh",
					},
				],
			},
			{
				name: "Huyện Thuận Bắc",
				wards: [
					{
						name: "Xã Phước Chiến",
					},
					{
						name: "Xã Công Hải",
					},
					{
						name: "Xã Phước Kháng",
					},
					{
						name: "Xã Lợi Hải",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Bắc Phong",
					},
				],
			},
			{
				name: "Huyện Thuận Nam",
				wards: [
					{
						name: "Xã Phước Hà",
					},
					{
						name: "Xã Phước Nam",
					},
					{
						name: "Xã Phước Ninh",
					},
					{
						name: "Xã Nhị Hà",
					},
					{
						name: "Xã Phước Dinh",
					},
					{
						name: "Xã Phước Minh",
					},
					{
						name: "Xã Phước Diêm",
					},
					{
						name: "Xã Cà Ná",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bình Thuận",
		districts: [
			{
				name: "Thành phố Phan Thiết",
				wards: [
					{
						name: "Phường Mũi Né",
					},
					{
						name: "Phường Hàm Tiến",
					},
					{
						name: "Phường Phú Hài",
					},
					{
						name: "Phường Phú Thủy",
					},
					{
						name: "Phường Phú Tài",
					},
					{
						name: "Phường Phú Trinh",
					},
					{
						name: "Phường Xuân An",
					},
					{
						name: "Phường Thanh Hải",
					},
					{
						name: "Phường Bình Hưng",
					},
					{
						name: "Phường Đức Nghĩa",
					},
					{
						name: "Phường Lạc Đạo",
					},
					{
						name: "Phường Đức Thắng",
					},
					{
						name: "Phường Hưng Long",
					},
					{
						name: "Phường Đức Long",
					},
					{
						name: "Xã Thiện Nghiệp",
					},
					{
						name: "Xã Phong Nẫm",
					},
					{
						name: "Xã Tiến Lợi",
					},
					{
						name: "Xã Tiến Thành",
					},
				],
			},
			{
				name: "Thị xã La Gi",
				wards: [
					{
						name: "Phường Phước Hội",
					},
					{
						name: "Phường Phước Lộc",
					},
					{
						name: "Phường Tân Thiện",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường Bình Tân",
					},
					{
						name: "Xã Tân Hải",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Tân Phước",
					},
				],
			},
			{
				name: "Huyện Tuy Phong",
				wards: [
					{
						name: "Thị trấn Liên Hương",
					},
					{
						name: "Thị trấn Phan Rí Cửa",
					},
					{
						name: "Xã Phan Dũng",
					},
					{
						name: "Xã Phong Phú",
					},
					{
						name: "Xã Vĩnh Hảo",
					},
					{
						name: "Xã Vĩnh Tân",
					},
					{
						name: "Xã Phú Lạc",
					},
					{
						name: "Xã Phước Thể",
					},
					{
						name: "Xã Hòa Minh",
					},
					{
						name: "Xã Chí Công",
					},
					{
						name: "Xã Bình Thạnh",
					},
				],
			},
			{
				name: "Huyện Bắc Bình",
				wards: [
					{
						name: "Thị trấn Chợ Lầu",
					},
					{
						name: "Xã Phan Sơn",
					},
					{
						name: "Xã Phan Lâm",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Phan Điền",
					},
					{
						name: "Xã Hải Ninh",
					},
					{
						name: "Xã Sông Lũy",
					},
					{
						name: "Xã Phan Tiến",
					},
					{
						name: "Xã Sông Bình",
					},
					{
						name: "Thị trấn Lương Sơn",
					},
					{
						name: "Xã Phan Hòa",
					},
					{
						name: "Xã Phan Thanh",
					},
					{
						name: "Xã Hồng Thái",
					},
					{
						name: "Xã Phan Hiệp",
					},
					{
						name: "Xã Bình Tân",
					},
					{
						name: "Xã Phan Rí Thành",
					},
					{
						name: "Xã Hòa Thắng",
					},
					{
						name: "Xã Hồng Phong",
					},
				],
			},
			{
				name: "Huyện Hàm Thuận Bắc",
				wards: [
					{
						name: "Thị trấn Ma Lâm",
					},
					{
						name: "Thị trấn Phú Long",
					},
					{
						name: "Xã La Dạ",
					},
					{
						name: "Xã Đông Tiến",
					},
					{
						name: "Xã Thuận Hòa",
					},
					{
						name: "Xã Đông Giang",
					},
					{
						name: "Xã Hàm Phú",
					},
					{
						name: "Xã Hồng Liêm",
					},
					{
						name: "Xã Thuận Minh",
					},
					{
						name: "Xã Hồng Sơn",
					},
					{
						name: "Xã Hàm Trí",
					},
					{
						name: "Xã Hàm Đức",
					},
					{
						name: "Xã Hàm Liêm",
					},
					{
						name: "Xã Hàm Chính",
					},
					{
						name: "Xã Hàm Hiệp",
					},
					{
						name: "Xã Hàm Thắng",
					},
					{
						name: "Xã Đa Mi",
					},
				],
			},
			{
				name: "Huyện Hàm Thuận Nam",
				wards: [
					{
						name: "Thị trấn Thuận Nam",
					},
					{
						name: "Xã Mỹ Thạnh",
					},
					{
						name: "Xã Hàm Cần",
					},
					{
						name: "Xã Mương Mán",
					},
					{
						name: "Xã Hàm Thạnh",
					},
					{
						name: "Xã Hàm Kiệm",
					},
					{
						name: "Xã Hàm Cường",
					},
					{
						name: "Xã Hàm Mỹ",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Hàm Minh",
					},
					{
						name: "Xã Thuận Quí",
					},
					{
						name: "Xã Tân Thuận",
					},
					{
						name: "Xã Tân Thành",
					},
				],
			},
			{
				name: "Huyện Tánh Linh",
				wards: [
					{
						name: "Thị trấn Lạc Tánh",
					},
					{
						name: "Xã Bắc Ruộng",
					},
					{
						name: "Xã Nghị Đức",
					},
					{
						name: "Xã La Ngâu",
					},
					{
						name: "Xã Huy Khiêm",
					},
					{
						name: "Xã Măng Tố",
					},
					{
						name: "Xã Đức Phú",
					},
					{
						name: "Xã Đồng Kho",
					},
					{
						name: "Xã Gia An",
					},
					{
						name: "Xã Đức Bình",
					},
					{
						name: "Xã Gia Huynh",
					},
					{
						name: "Xã Đức Thuận",
					},
					{
						name: "Xã Suối Kiết",
					},
				],
			},
			{
				name: "Huyện Đức Linh",
				wards: [
					{
						name: "Thị trấn Võ Xu",
					},
					{
						name: "Thị trấn Đức Tài",
					},
					{
						name: "Xã Đa Kai",
					},
					{
						name: "Xã Sùng Nhơn",
					},
					{
						name: "Xã Mê Pu",
					},
					{
						name: "Xã Nam Chính",
					},
					{
						name: "Xã Đức Hạnh",
					},
					{
						name: "Xã Đức Tín",
					},
					{
						name: "Xã Vũ Hoà",
					},
					{
						name: "Xã Tân Hà",
					},
					{
						name: "Xã Đông Hà",
					},
					{
						name: "Xã Trà Tân",
					},
				],
			},
			{
				name: "Huyện Hàm Tân",
				wards: [
					{
						name: "Thị trấn Tân Minh",
					},
					{
						name: "Thị trấn Tân Nghĩa",
					},
					{
						name: "Xã Sông Phan",
					},
					{
						name: "Xã Tân Phúc",
					},
					{
						name: "Xã Tân Đức",
					},
					{
						name: "Xã Tân Thắng",
					},
					{
						name: "Xã Thắng Hải",
					},
					{
						name: "Xã Tân Hà",
					},
					{
						name: "Xã Tân Xuân",
					},
					{
						name: "Xã Sơn Mỹ",
					},
				],
			},
			{
				name: "Huyện Phú Quí",
				wards: [
					{
						name: "Xã Ngũ Phụng",
					},
					{
						name: "Xã Long Hải",
					},
					{
						name: "Xã Tam Thanh",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Kon Tum",
		districts: [
			{
				name: "Thành phố Kon Tum",
				wards: [
					{
						name: "Phường Quang Trung",
					},
					{
						name: "Phường Duy Tân",
					},
					{
						name: "Phường Quyết Thắng",
					},
					{
						name: "Phường Trường Chinh",
					},
					{
						name: "Phường Thắng Lợi",
					},
					{
						name: "Phường Ngô Mây",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Lê Lợi",
					},
					{
						name: "Phường Nguyễn Trãi",
					},
					{
						name: "Phường Trần Hưng Đạo",
					},
					{
						name: "Xã Đắk Cấm",
					},
					{
						name: "Xã Kroong",
					},
					{
						name: "Xã Ngọk Bay",
					},
					{
						name: "Xã Vinh Quang",
					},
					{
						name: "Xã Đắk Blà",
					},
					{
						name: "Xã Ia Chim",
					},
					{
						name: "Xã Đăk Năng",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Chư Hreng",
					},
					{
						name: "Xã Đắk Rơ Wa",
					},
					{
						name: "Xã Hòa Bình",
					},
				],
			},
			{
				name: "Huyện Đắk Glei",
				wards: [
					{
						name: "Thị trấn Đắk Glei",
					},
					{
						name: "Xã Đắk Blô",
					},
					{
						name: "Xã Đắk Man",
					},
					{
						name: "Xã Đắk Nhoong",
					},
					{
						name: "Xã Đắk Pék",
					},
					{
						name: "Xã Đắk Choong",
					},
					{
						name: "Xã Xốp",
					},
					{
						name: "Xã Mường Hoong",
					},
					{
						name: "Xã Ngọc Linh",
					},
					{
						name: "Xã Đắk Long",
					},
					{
						name: "Xã Đắk KRoong",
					},
					{
						name: "Xã Đắk Môn",
					},
				],
			},
			{
				name: "Huyện Ngọc Hồi",
				wards: [
					{
						name: "Thị trấn Plei Kần",
					},
					{
						name: "Xã Đắk Ang",
					},
					{
						name: "Xã Đắk Dục",
					},
					{
						name: "Xã Đắk Nông",
					},
					{
						name: "Xã Đắk Xú",
					},
					{
						name: "Xã Đắk Kan",
					},
					{
						name: "Xã Bờ Y",
					},
					{
						name: "Xã Sa Loong",
					},
				],
			},
			{
				name: "Huyện Đắk Tô",
				wards: [
					{
						name: "Thị trấn Đắk Tô",
					},
					{
						name: "Xã Đắk Rơ Nga",
					},
					{
						name: "Xã Ngọk Tụ",
					},
					{
						name: "Xã Đắk Trăm",
					},
					{
						name: "Xã Văn Lem",
					},
					{
						name: "Xã Kon Đào",
					},
					{
						name: "Xã Tân Cảnh",
					},
					{
						name: "Xã Diên Bình",
					},
					{
						name: "Xã Pô Kô",
					},
				],
			},
			{
				name: "Huyện Kon Plông",
				wards: [
					{
						name: "Xã Đắk Nên",
					},
					{
						name: "Xã Đắk Ring",
					},
					{
						name: "Xã Măng Buk",
					},
					{
						name: "Xã Đắk Tăng",
					},
					{
						name: "Xã Ngok Tem",
					},
					{
						name: "Xã Pờ Ê",
					},
					{
						name: "Xã Măng Cành",
					},
					{
						name: "Thị trấn Măng Đen",
					},
					{
						name: "Xã Hiếu",
					},
				],
			},
			{
				name: "Huyện Kon Rẫy",
				wards: [
					{
						name: "Thị trấn Đắk Rve",
					},
					{
						name: "Xã Đắk Kôi",
					},
					{
						name: "Xã Đắk Tơ Lung",
					},
					{
						name: "Xã Đắk Ruồng",
					},
					{
						name: "Xã Đắk Pne",
					},
					{
						name: "Xã Đắk Tờ Re",
					},
					{
						name: "Xã Tân Lập",
					},
				],
			},
			{
				name: "Huyện Đắk Hà",
				wards: [
					{
						name: "Thị trấn Đắk Hà",
					},
					{
						name: "Xã Đắk PXi",
					},
					{
						name: "Xã Đăk Long",
					},
					{
						name: "Xã Đắk HRing",
					},
					{
						name: "Xã Đắk Ui",
					},
					{
						name: "Xã Đăk Ngọk",
					},
					{
						name: "Xã Đắk Mar",
					},
					{
						name: "Xã Ngok Wang",
					},
					{
						name: "Xã Ngok Réo",
					},
					{
						name: "Xã Hà Mòn",
					},
					{
						name: "Xã Đắk La",
					},
				],
			},
			{
				name: "Huyện Sa Thầy",
				wards: [
					{
						name: "Thị trấn Sa Thầy",
					},
					{
						name: "Xã Rơ Kơi",
					},
					{
						name: "Xã Sa Nhơn",
					},
					{
						name: "Xã Hơ Moong",
					},
					{
						name: "Xã Mô Rai",
					},
					{
						name: "Xã Sa Sơn",
					},
					{
						name: "Xã Sa Nghĩa",
					},
					{
						name: "Xã Sa Bình",
					},
					{
						name: "Xã Ya Xiêr",
					},
					{
						name: "Xã Ya Tăng",
					},
					{
						name: "Xã Ya ly",
					},
				],
			},
			{
				name: "Huyện Tu Mơ Rông",
				wards: [
					{
						name: "Xã Ngọc Lây",
					},
					{
						name: "Xã Đắk Na",
					},
					{
						name: "Xã Măng Ri",
					},
					{
						name: "Xã Ngọc Yêu",
					},
					{
						name: "Xã Đắk Sao",
					},
					{
						name: "Xã Đắk Rơ Ông",
					},
					{
						name: "Xã Đắk Tờ Kan",
					},
					{
						name: "Xã Tu Mơ Rông",
					},
					{
						name: "Xã Đắk Hà",
					},
					{
						name: "Xã Tê Xăng",
					},
					{
						name: "Xã Văn Xuôi",
					},
				],
			},
			{
				name: "Huyện Ia H' Drai",
				wards: [
					{
						name: "Xã Ia Đal",
					},
					{
						name: "Xã Ia Dom",
					},
					{
						name: "Xã Ia Tơi",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Gia Lai",
		districts: [
			{
				name: "Thành phố Pleiku",
				wards: [
					{
						name: "Phường Yên Đỗ",
					},
					{
						name: "Phường Diên Hồng",
					},
					{
						name: "Phường Ia Kring",
					},
					{
						name: "Phường Hội Thương",
					},
					{
						name: "Phường Hội Phú",
					},
					{
						name: "Phường Phù Đổng",
					},
					{
						name: "Phường Hoa Lư",
					},
					{
						name: "Phường Tây Sơn",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Đống Đa",
					},
					{
						name: "Phường Trà Bá",
					},
					{
						name: "Phường Thắng Lợi",
					},
					{
						name: "Phường Yên Thế",
					},
					{
						name: "Phường Chi Lăng",
					},
					{
						name: "Xã Biển Hồ",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã Trà Đa",
					},
					{
						name: "Xã Chư Á",
					},
					{
						name: "Xã An Phú",
					},
					{
						name: "Xã Diên Phú",
					},
					{
						name: "Xã Ia Kênh",
					},
					{
						name: "Xã Gào",
					},
				],
			},
			{
				name: "Thị xã An Khê",
				wards: [
					{
						name: "Phường An Bình",
					},
					{
						name: "Phường Tây Sơn",
					},
					{
						name: "Phường An Phú",
					},
					{
						name: "Phường An Tân",
					},
					{
						name: "Xã Tú An",
					},
					{
						name: "Xã Xuân An",
					},
					{
						name: "Xã Cửu An",
					},
					{
						name: "Phường An Phước",
					},
					{
						name: "Xã Song An",
					},
					{
						name: "Phường Ngô Mây",
					},
					{
						name: "Xã Thành An",
					},
				],
			},
			{
				name: "Thị xã Ayun Pa",
				wards: [
					{
						name: "Phường Cheo Reo",
					},
					{
						name: "Phường Hòa Bình",
					},
					{
						name: "Phường Đoàn Kết",
					},
					{
						name: "Phường Sông Bờ",
					},
					{
						name: "Xã Ia RBol",
					},
					{
						name: "Xã Chư Băh",
					},
					{
						name: "Xã Ia RTô",
					},
					{
						name: "Xã Ia Sao",
					},
				],
			},
			{
				name: "Huyện KBang",
				wards: [
					{
						name: "Thị trấn KBang",
					},
					{
						name: "Xã Kon Pne",
					},
					{
						name: "Xã Đăk Roong",
					},
					{
						name: "Xã Sơn Lang",
					},
					{
						name: "Xã KRong",
					},
					{
						name: "Xã Sơ Pai",
					},
					{
						name: "Xã Lơ Ku",
					},
					{
						name: "Xã Đông",
					},
					{
						name: "Xã Đak SMar",
					},
					{
						name: "Xã Nghĩa An",
					},
					{
						name: "Xã Tơ Tung",
					},
					{
						name: "Xã Kông Lơng Khơng",
					},
					{
						name: "Xã Kông Pla",
					},
					{
						name: "Xã Đăk HLơ",
					},
				],
			},
			{
				name: "Huyện Đăk Đoa",
				wards: [
					{
						name: "Thị trấn Đăk Đoa",
					},
					{
						name: "Xã Hà Đông",
					},
					{
						name: "Xã Đăk Sơmei",
					},
					{
						name: "Xã Đăk Krong",
					},
					{
						name: "Xã Hải Yang",
					},
					{
						name: "Xã Kon Gang",
					},
					{
						name: "Xã Hà Bầu",
					},
					{
						name: "Xã Nam Yang",
					},
					{
						name: "Xã K' Dang",
					},
					{
						name: "Xã H' Neng",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Glar",
					},
					{
						name: "Xã A Dơk",
					},
					{
						name: "Xã Trang",
					},
					{
						name: "Xã HNol",
					},
					{
						name: "Xã Ia Pết",
					},
					{
						name: "Xã Ia Băng",
					},
				],
			},
			{
				name: "Huyện Chư Păh",
				wards: [
					{
						name: "Thị trấn Phú Hòa",
					},
					{
						name: "Xã Hà Tây",
					},
					{
						name: "Xã Ia Khươl",
					},
					{
						name: "Xã Ia Phí",
					},
					{
						name: "Thị trấn Ia Ly",
					},
					{
						name: "Xã Ia Mơ Nông",
					},
					{
						name: "Xã Ia Kreng",
					},
					{
						name: "Xã Đăk Tơ Ver",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Chư Đăng Ya",
					},
					{
						name: "Xã Ia Ka",
					},
					{
						name: "Xã Ia Nhin",
					},
					{
						name: "Xã Nghĩa Hòa",
					},
					{
						name: "Xã Nghĩa Hưng",
					},
				],
			},
			{
				name: "Huyện Ia Grai",
				wards: [
					{
						name: "Thị trấn Ia Kha",
					},
					{
						name: "Xã Ia Sao",
					},
					{
						name: "Xã Ia Yok",
					},
					{
						name: "Xã Ia Hrung",
					},
					{
						name: "Xã Ia Bă",
					},
					{
						name: "Xã Ia Khai",
					},
					{
						name: "Xã Ia KRai",
					},
					{
						name: "Xã Ia Grăng",
					},
					{
						name: "Xã Ia Tô",
					},
					{
						name: "Xã Ia O",
					},
					{
						name: "Xã Ia Dêr",
					},
					{
						name: "Xã Ia Chia",
					},
					{
						name: "Xã Ia Pếch",
					},
				],
			},
			{
				name: "Huyện Mang Yang",
				wards: [
					{
						name: "Thị trấn Kon Dơng",
					},
					{
						name: "Xã Ayun",
					},
					{
						name: "Xã Đak Jơ Ta",
					},
					{
						name: "Xã Đak Ta Ley",
					},
					{
						name: "Xã Hra",
					},
					{
						name: "Xã Đăk Yă",
					},
					{
						name: "Xã Đăk Djrăng",
					},
					{
						name: "Xã Lơ Pang",
					},
					{
						name: "Xã Kon Thụp",
					},
					{
						name: "Xã Đê Ar",
					},
					{
						name: "Xã Kon Chiêng",
					},
					{
						name: "Xã Đăk Trôi",
					},
				],
			},
			{
				name: "Huyện Kông Chro",
				wards: [
					{
						name: "Thị trấn Kông Chro",
					},
					{
						name: "Xã Chư Krêy",
					},
					{
						name: "Xã An Trung",
					},
					{
						name: "Xã Kông Yang",
					},
					{
						name: "Xã Đăk Tơ Pang",
					},
					{
						name: "Xã SRó",
					},
					{
						name: "Xã Đắk Kơ Ning",
					},
					{
						name: "Xã Đăk Song",
					},
					{
						name: "Xã Đăk Pling",
					},
					{
						name: "Xã Yang Trung",
					},
					{
						name: "Xã Đăk Pơ Pho",
					},
					{
						name: "Xã Ya Ma",
					},
					{
						name: "Xã Chơ Long",
					},
					{
						name: "Xã Yang Nam",
					},
				],
			},
			{
				name: "Huyện Đức Cơ",
				wards: [
					{
						name: "Thị trấn Chư Ty",
					},
					{
						name: "Xã Ia Dơk",
					},
					{
						name: "Xã Ia Krêl",
					},
					{
						name: "Xã Ia Din",
					},
					{
						name: "Xã Ia Kla",
					},
					{
						name: "Xã Ia Dom",
					},
					{
						name: "Xã Ia Lang",
					},
					{
						name: "Xã Ia Kriêng",
					},
					{
						name: "Xã Ia Pnôn",
					},
					{
						name: "Xã Ia Nan",
					},
				],
			},
			{
				name: "Huyện Chư Prông",
				wards: [
					{
						name: "Thị trấn Chư Prông",
					},
					{
						name: "Xã Ia Kly",
					},
					{
						name: "Xã Bình Giáo",
					},
					{
						name: "Xã Ia Drăng",
					},
					{
						name: "Xã Thăng Hưng",
					},
					{
						name: "Xã Bàu Cạn",
					},
					{
						name: "Xã Ia Phìn",
					},
					{
						name: "Xã Ia Băng",
					},
					{
						name: "Xã Ia Tôr",
					},
					{
						name: "Xã Ia Boòng",
					},
					{
						name: "Xã Ia O",
					},
					{
						name: "Xã Ia Púch",
					},
					{
						name: "Xã Ia Me",
					},
					{
						name: "Xã Ia Vê",
					},
					{
						name: "Xã Ia Bang",
					},
					{
						name: "Xã Ia Pia",
					},
					{
						name: "Xã Ia Ga",
					},
					{
						name: "Xã Ia Lâu",
					},
					{
						name: "Xã Ia Piơr",
					},
					{
						name: "Xã Ia Mơ",
					},
				],
			},
			{
				name: "Huyện Chư Sê",
				wards: [
					{
						name: "Thị trấn Chư Sê",
					},
					{
						name: "Xã Ia Tiêm",
					},
					{
						name: "Xã Chư Pơng",
					},
					{
						name: "Xã Bar Măih",
					},
					{
						name: "Xã Bờ Ngoong",
					},
					{
						name: "Xã Ia Glai",
					},
					{
						name: "Xã AL Bá",
					},
					{
						name: "Xã Kông HTok",
					},
					{
						name: "Xã AYun",
					},
					{
						name: "Xã Ia HLốp",
					},
					{
						name: "Xã Ia Blang",
					},
					{
						name: "Xã Dun",
					},
					{
						name: "Xã Ia Pal",
					},
					{
						name: "Xã H Bông",
					},
					{
						name: "Xã Ia Ko",
					},
				],
			},
			{
				name: "Huyện Đăk Pơ",
				wards: [
					{
						name: "Xã Hà Tam",
					},
					{
						name: "Xã An Thành",
					},
					{
						name: "Thị trấn Đak Pơ",
					},
					{
						name: "Xã Yang Bắc",
					},
					{
						name: "Xã Cư An",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Phú An",
					},
					{
						name: "Xã Ya Hội",
					},
				],
			},
			{
				name: "Huyện Ia Pa",
				wards: [
					{
						name: "Xã Pờ Tó",
					},
					{
						name: "Xã Chư Răng",
					},
					{
						name: "Xã Ia KDăm",
					},
					{
						name: "Xã Kim Tân",
					},
					{
						name: "Xã Chư Mố",
					},
					{
						name: "Xã Ia Tul",
					},
					{
						name: "Xã Ia Ma Rơn",
					},
					{
						name: "Xã Ia Broăi",
					},
					{
						name: "Xã Ia Trok",
					},
				],
			},
			{
				name: "Huyện Krông Pa",
				wards: [
					{
						name: "Thị trấn Phú Túc",
					},
					{
						name: "Xã Ia RSai",
					},
					{
						name: "Xã Ia RSươm",
					},
					{
						name: "Xã Chư Gu",
					},
					{
						name: "Xã Đất Bằng",
					},
					{
						name: "Xã Ia Mláh",
					},
					{
						name: "Xã Chư Drăng",
					},
					{
						name: "Xã Phú Cần",
					},
					{
						name: "Xã Ia HDreh",
					},
					{
						name: "Xã Ia RMok",
					},
					{
						name: "Xã Chư Ngọc",
					},
					{
						name: "Xã Uar",
					},
					{
						name: "Xã Chư Rcăm",
					},
					{
						name: "Xã Krông Năng",
					},
				],
			},
			{
				name: "Huyện Phú Thiện",
				wards: [
					{
						name: "Thị trấn Phú Thiện",
					},
					{
						name: "Xã Chư A Thai",
					},
					{
						name: "Xã Ayun Hạ",
					},
					{
						name: "Xã Ia Ake",
					},
					{
						name: "Xã Ia Sol",
					},
					{
						name: "Xã Ia Piar",
					},
					{
						name: "Xã Ia Peng",
					},
					{
						name: "Xã Chrôh Pơnan",
					},
					{
						name: "Xã Ia Hiao",
					},
					{
						name: "Xã Ia Yeng",
					},
				],
			},
			{
				name: "Huyện Chư Pưh",
				wards: [
					{
						name: "Thị trấn Nhơn Hoà",
					},
					{
						name: "Xã Ia Hrú",
					},
					{
						name: "Xã Ia Rong",
					},
					{
						name: "Xã Ia Dreng",
					},
					{
						name: "Xã Ia Hla",
					},
					{
						name: "Xã Chư Don",
					},
					{
						name: "Xã Ia Phang",
					},
					{
						name: "Xã Ia Le",
					},
					{
						name: "Xã Ia BLứ",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Đắk Lắk",
		districts: [
			{
				name: "Thành phố Buôn Ma Thuột",
				wards: [
					{
						name: "Phường Tân Lập",
					},
					{
						name: "Phường Tân Hòa",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Thành Nhất",
					},
					{
						name: "Phường Thắng Lợi",
					},
					{
						name: "Phường Tân Lợi",
					},
					{
						name: "Phường Thành Công",
					},
					{
						name: "Phường Tân Thành",
					},
					{
						name: "Phường Tân Tiến",
					},
					{
						name: "Phường Tự An",
					},
					{
						name: "Phường Ea Tam",
					},
					{
						name: "Phường Khánh Xuân",
					},
					{
						name: "Xã Hòa Thuận",
					},
					{
						name: "Xã Cư ÊBur",
					},
					{
						name: "Xã Ea Tu",
					},
					{
						name: "Xã Hòa Thắng",
					},
					{
						name: "Xã Ea Kao",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Hòa Khánh",
					},
					{
						name: "Xã Hòa Xuân",
					},
				],
			},
			{
				name: "Thị Xã Buôn Hồ",
				wards: [
					{
						name: "Phường An Lạc",
					},
					{
						name: "Phường An Bình",
					},
					{
						name: "Phường Thiện An",
					},
					{
						name: "Phường Đạt Hiếu",
					},
					{
						name: "Phường Đoàn Kết",
					},
					{
						name: "Xã Ea Blang",
					},
					{
						name: "Xã Ea Drông",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Bình Tân",
					},
					{
						name: "Xã Ea Siên",
					},
					{
						name: "Xã Bình Thuận",
					},
					{
						name: "Xã Cư Bao",
					},
				],
			},
			{
				name: "Huyện Ea H'leo",
				wards: [
					{
						name: "Thị trấn Ea Drăng",
					},
					{
						name: "Xã Ea H'leo",
					},
					{
						name: "Xã Ea Sol",
					},
					{
						name: "Xã Ea Ral",
					},
					{
						name: "Xã Ea Wy",
					},
					{
						name: "Xã Cư A Mung",
					},
					{
						name: "Xã Cư Mốt",
					},
					{
						name: "Xã Ea Hiao",
					},
					{
						name: "Xã Ea Khal",
					},
					{
						name: "Xã Dliê Yang",
					},
					{
						name: "Xã Ea Tir",
					},
					{
						name: "Xã Ea Nam",
					},
				],
			},
			{
				name: "Huyện Ea Súp",
				wards: [
					{
						name: "Thị trấn Ea Súp",
					},
					{
						name: "Xã Ia Lốp",
					},
					{
						name: "Xã Ia JLơi",
					},
					{
						name: "Xã Ea Rốk",
					},
					{
						name: "Xã Ya Tờ Mốt",
					},
					{
						name: "Xã Ia RVê",
					},
					{
						name: "Xã Ea Lê",
					},
					{
						name: "Xã Cư KBang",
					},
					{
						name: "Xã Ea Bung",
					},
					{
						name: "Xã Cư M'Lan",
					},
				],
			},
			{
				name: "Huyện Buôn Đôn",
				wards: [
					{
						name: "Xã Krông Na",
					},
					{
						name: "Xã Ea Huar",
					},
					{
						name: "Xã Ea Wer",
					},
					{
						name: "Xã Tân Hoà",
					},
					{
						name: "Xã Cuôr KNia",
					},
					{
						name: "Xã Ea Bar",
					},
					{
						name: "Xã Ea Nuôl",
					},
				],
			},
			{
				name: "Huyện Cư M'gar",
				wards: [
					{
						name: "Thị trấn Ea Pốk",
					},
					{
						name: "Thị trấn Quảng Phú",
					},
					{
						name: "Xã Quảng Tiến",
					},
					{
						name: "Xã Ea Kuêh",
					},
					{
						name: "Xã Ea Kiết",
					},
					{
						name: "Xã Ea Tar",
					},
					{
						name: "Xã Cư Dliê M'nông",
					},
					{
						name: "Xã Ea H'đinh",
					},
					{
						name: "Xã Ea Tul",
					},
					{
						name: "Xã Ea KPam",
					},
					{
						name: "Xã Ea M'DRóh",
					},
					{
						name: "Xã Quảng Hiệp",
					},
					{
						name: "Xã Cư M'gar",
					},
					{
						name: "Xã Ea D'Rơng",
					},
					{
						name: "Xã Ea M'nang",
					},
					{
						name: "Xã Cư Suê",
					},
					{
						name: "Xã Cuor Đăng",
					},
				],
			},
			{
				name: "Huyện Krông Búk",
				wards: [
					{
						name: "Xã Cư Né",
					},
					{
						name: "Xã Chư KBô",
					},
					{
						name: "Xã Cư Pơng",
					},
					{
						name: "Xã Ea Sin",
					},
					{
						name: "Xã Pơng Drang",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Ea Ngai",
					},
				],
			},
			{
				name: "Huyện Krông Năng",
				wards: [
					{
						name: "Thị trấn Krông Năng",
					},
					{
						name: "Xã ĐLiê Ya",
					},
					{
						name: "Xã Ea Tóh",
					},
					{
						name: "Xã Ea Tam",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Tam Giang",
					},
					{
						name: "Xã Ea Puk",
					},
					{
						name: "Xã Ea Dăh",
					},
					{
						name: "Xã Ea Hồ",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Cư Klông",
					},
					{
						name: "Xã Ea Tân",
					},
				],
			},
			{
				name: "Huyện Ea Kar",
				wards: [
					{
						name: "Thị trấn Ea Kar",
					},
					{
						name: "Thị trấn Ea Knốp",
					},
					{
						name: "Xã Ea Sô",
					},
					{
						name: "Xã Ea Sar",
					},
					{
						name: "Xã Xuân Phú",
					},
					{
						name: "Xã Cư Huê",
					},
					{
						name: "Xã Ea Tih",
					},
					{
						name: "Xã Ea Đar",
					},
					{
						name: "Xã Ea Kmút",
					},
					{
						name: "Xã Cư Ni",
					},
					{
						name: "Xã Ea Păl",
					},
					{
						name: "Xã Cư Prông",
					},
					{
						name: "Xã Ea Ô",
					},
					{
						name: "Xã Cư ELang",
					},
					{
						name: "Xã Cư Bông",
					},
					{
						name: "Xã Cư Jang",
					},
				],
			},
			{
				name: "Huyện M'Đrắk",
				wards: [
					{
						name: "Thị trấn M'Đrắk",
					},
					{
						name: "Xã Cư Prao",
					},
					{
						name: "Xã Ea Pil",
					},
					{
						name: "Xã Ea Lai",
					},
					{
						name: "Xã Ea H'MLay",
					},
					{
						name: "Xã Krông Jing",
					},
					{
						name: "Xã Ea M' Doal",
					},
					{
						name: "Xã Ea Riêng",
					},
					{
						name: "Xã Cư M'ta",
					},
					{
						name: "Xã Cư K Róa",
					},
					{
						name: "Xã Krông Á",
					},
					{
						name: "Xã Cư San",
					},
					{
						name: "Xã Ea Trang",
					},
				],
			},
			{
				name: "Huyện Krông Bông",
				wards: [
					{
						name: "Thị trấn Krông Kmar",
					},
					{
						name: "Xã Dang Kang",
					},
					{
						name: "Xã Cư KTy",
					},
					{
						name: "Xã Hòa Thành",
					},
					{
						name: "Xã Hòa Tân",
					},
					{
						name: "Xã Hòa Phong",
					},
					{
						name: "Xã Hòa Lễ",
					},
					{
						name: "Xã Yang Reh",
					},
					{
						name: "Xã Ea Trul",
					},
					{
						name: "Xã Khuê Ngọc Điền",
					},
					{
						name: "Xã Cư Pui",
					},
					{
						name: "Xã Hòa Sơn",
					},
					{
						name: "Xã Cư Drăm",
					},
					{
						name: "Xã Yang Mao",
					},
				],
			},
			{
				name: "Huyện Krông Pắc",
				wards: [
					{
						name: "Thị trấn Phước An",
					},
					{
						name: "Xã KRông Búk",
					},
					{
						name: "Xã Ea Kly",
					},
					{
						name: "Xã Ea Kênh",
					},
					{
						name: "Xã Ea Phê",
					},
					{
						name: "Xã Ea KNuec",
					},
					{
						name: "Xã Ea Yông",
					},
					{
						name: "Xã Hòa An",
					},
					{
						name: "Xã Ea Kuăng",
					},
					{
						name: "Xã Hòa Đông",
					},
					{
						name: "Xã Ea Hiu",
					},
					{
						name: "Xã Hòa Tiến",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Vụ Bổn",
					},
					{
						name: "Xã Ea Uy",
					},
					{
						name: "Xã Ea Yiêng",
					},
				],
			},
			{
				name: "Huyện Krông A Na",
				wards: [
					{
						name: "Thị trấn Buôn Trấp",
					},
					{
						name: "Xã Dray Sáp",
					},
					{
						name: "Xã Ea Na",
					},
					{
						name: "Xã Ea Bông",
					},
					{
						name: "Xã Băng A Drênh",
					},
					{
						name: "Xã Dur KMăl",
					},
					{
						name: "Xã Bình Hòa",
					},
					{
						name: "Xã Quảng Điền",
					},
				],
			},
			{
				name: "Huyện Lắk",
				wards: [
					{
						name: "Thị trấn Liên Sơn",
					},
					{
						name: "Xã Yang Tao",
					},
					{
						name: "Xã Bông Krang",
					},
					{
						name: "Xã Đắk Liêng",
					},
					{
						name: "Xã Buôn Triết",
					},
					{
						name: "Xã Buôn Tría",
					},
					{
						name: "Xã Đắk Phơi",
					},
					{
						name: "Xã Đắk Nuê",
					},
					{
						name: "Xã Krông Nô",
					},
					{
						name: "Xã Nam Ka",
					},
					{
						name: "Xã Ea R'Bin",
					},
				],
			},
			{
				name: "Huyện Cư Kuin",
				wards: [
					{
						name: "Xã Ea Ning",
					},
					{
						name: "Xã Cư Ê Wi",
					},
					{
						name: "Xã Ea Ktur",
					},
					{
						name: "Xã Ea Tiêu",
					},
					{
						name: "Xã Ea BHốk",
					},
					{
						name: "Xã Ea Hu",
					},
					{
						name: "Xã Dray Bhăng",
					},
					{
						name: "Xã Hòa Hiệp",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Đắk Nông",
		districts: [
			{
				name: "Thành phố Gia Nghĩa",
				wards: [
					{
						name: "Phường Nghĩa Đức",
					},
					{
						name: "Phường Nghĩa Thành",
					},
					{
						name: "Phường Nghĩa Phú",
					},
					{
						name: "Phường Nghĩa Tân",
					},
					{
						name: "Phường Nghĩa Trung",
					},
					{
						name: "Xã Đăk R'Moan",
					},
					{
						name: "Phường Quảng Thành",
					},
					{
						name: "Xã Đắk Nia",
					},
				],
			},
			{
				name: "Huyện Đăk Glong",
				wards: [
					{
						name: "Xã Quảng Sơn",
					},
					{
						name: "Xã Quảng Hoà",
					},
					{
						name: "Xã Đắk Ha",
					},
					{
						name: "Xã Đắk R'Măng",
					},
					{
						name: "Xã Quảng Khê",
					},
					{
						name: "Xã Đắk Plao",
					},
					{
						name: "Xã Đắk Som",
					},
				],
			},
			{
				name: "Huyện Cư Jút",
				wards: [
					{
						name: "Thị trấn Ea T'Ling",
					},
					{
						name: "Xã Đắk Wil",
					},
					{
						name: "Xã Ea Pô",
					},
					{
						name: "Xã Nam Dong",
					},
					{
						name: "Xã Đắk DRông",
					},
					{
						name: "Xã Tâm Thắng",
					},
					{
						name: "Xã Cư Knia",
					},
					{
						name: "Xã Trúc Sơn",
					},
				],
			},
			{
				name: "Huyện Đắk Mil",
				wards: [
					{
						name: "Thị trấn Đắk Mil",
					},
					{
						name: "Xã Đắk Lao",
					},
					{
						name: "Xã Đắk R'La",
					},
					{
						name: "Xã Đắk Gằn",
					},
					{
						name: "Xã Đức Mạnh",
					},
					{
						name: "Xã Đắk N'Drót",
					},
					{
						name: "Xã Long Sơn",
					},
					{
						name: "Xã Đắk Sắk",
					},
					{
						name: "Xã Thuận An",
					},
					{
						name: "Xã Đức Minh",
					},
				],
			},
			{
				name: "Huyện Krông Nô",
				wards: [
					{
						name: "Thị trấn Đắk Mâm",
					},
					{
						name: "Xã Đắk Sôr",
					},
					{
						name: "Xã Nam Xuân",
					},
					{
						name: "Xã Buôn Choah",
					},
					{
						name: "Xã Nam Đà",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Đắk Drô",
					},
					{
						name: "Xã Nâm Nung",
					},
					{
						name: "Xã Đức Xuyên",
					},
					{
						name: "Xã Đắk Nang",
					},
					{
						name: "Xã Quảng Phú",
					},
					{
						name: "Xã Nâm N'Đir",
					},
				],
			},
			{
				name: "Huyện Đắk Song",
				wards: [
					{
						name: "Thị trấn Đức An",
					},
					{
						name: "Xã Đắk Môl",
					},
					{
						name: "Xã Đắk Hòa",
					},
					{
						name: "Xã Nam Bình",
					},
					{
						name: "Xã Thuận Hà",
					},
					{
						name: "Xã Thuận Hạnh",
					},
					{
						name: "Xã Đắk N'Dung",
					},
					{
						name: "Xã Nâm N'Jang",
					},
					{
						name: "Xã Trường Xuân",
					},
				],
			},
			{
				name: "Huyện Đắk R'Lấp",
				wards: [
					{
						name: "Thị trấn Kiến Đức",
					},
					{
						name: "Xã Quảng Tín",
					},
					{
						name: "Xã Đắk Wer",
					},
					{
						name: "Xã Nhân Cơ",
					},
					{
						name: "Xã Kiến Thành",
					},
					{
						name: "Xã Nghĩa Thắng",
					},
					{
						name: "Xã Đạo Nghĩa",
					},
					{
						name: "Xã Đắk Sin",
					},
					{
						name: "Xã Hưng Bình",
					},
					{
						name: "Xã Đắk Ru",
					},
					{
						name: "Xã Nhân Đạo",
					},
				],
			},
			{
				name: "Huyện Tuy Đức",
				wards: [
					{
						name: "Xã Quảng Trực",
					},
					{
						name: "Xã Đắk Búk So",
					},
					{
						name: "Xã Quảng Tâm",
					},
					{
						name: "Xã Đắk R'Tíh",
					},
					{
						name: "Xã Đắk Ngo",
					},
					{
						name: "Xã Quảng Tân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Lâm Đồng",
		districts: [
			{
				name: "Thành phố Đà Lạt",
				wards: [
					{
						name: "Phường 7",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Xã Xuân Thọ",
					},
					{
						name: "Xã Tà Nung",
					},
					{
						name: "Xã Trạm Hành",
					},
					{
						name: "Xã Xuân Trường",
					},
				],
			},
			{
				name: "Thành phố Bảo Lộc",
				wards: [
					{
						name: "Phường Lộc Phát",
					},
					{
						name: "Phường Lộc Tiến",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường B'lao",
					},
					{
						name: "Phường Lộc Sơn",
					},
					{
						name: "Xã Đạm Bri",
					},
					{
						name: "Xã Lộc Thanh",
					},
					{
						name: "Xã Lộc Nga",
					},
					{
						name: "Xã Lộc Châu",
					},
					{
						name: "Xã Đại Lào",
					},
				],
			},
			{
				name: "Huyện Đam Rông",
				wards: [
					{
						name: "Xã Đạ Tông",
					},
					{
						name: "Xã Đạ Long",
					},
					{
						name: "Xã Đạ M' Rong",
					},
					{
						name: "Xã Liêng Srônh",
					},
					{
						name: "Xã Đạ Rsal",
					},
					{
						name: "Xã Rô Men",
					},
					{
						name: "Xã Phi Liêng",
					},
					{
						name: "Xã Đạ K' Nàng",
					},
				],
			},
			{
				name: "Huyện Lạc Dương",
				wards: [
					{
						name: "Thị trấn Lạc Dương",
					},
					{
						name: "Xã Đạ Chais",
					},
					{
						name: "Xã Đạ Nhim",
					},
					{
						name: "Xã Đưng KNớ",
					},
					{
						name: "Xã Lát",
					},
					{
						name: "Xã Đạ Sar",
					},
				],
			},
			{
				name: "Huyện Lâm Hà",
				wards: [
					{
						name: "Thị trấn Nam Ban",
					},
					{
						name: "Thị trấn Đinh Văn",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Phi Tô",
					},
					{
						name: "Xã Mê Linh",
					},
					{
						name: "Xã Đạ Đờn",
					},
					{
						name: "Xã Phúc Thọ",
					},
					{
						name: "Xã Đông Thanh",
					},
					{
						name: "Xã Gia Lâm",
					},
					{
						name: "Xã Tân Thanh",
					},
					{
						name: "Xã Tân Văn",
					},
					{
						name: "Xã Hoài Đức",
					},
					{
						name: "Xã Tân Hà",
					},
					{
						name: "Xã Liên Hà",
					},
					{
						name: "Xã Đan Phượng",
					},
					{
						name: "Xã Nam Hà",
					},
				],
			},
			{
				name: "Huyện Đơn Dương",
				wards: [
					{
						name: "Thị trấn D'Ran",
					},
					{
						name: "Thị trấn Thạnh Mỹ",
					},
					{
						name: "Xã Lạc Xuân",
					},
					{
						name: "Xã Đạ Ròn",
					},
					{
						name: "Xã Lạc Lâm",
					},
					{
						name: "Xã Ka Đô",
					},
					{
						name: "Xã Quảng Lập",
					},
					{
						name: "Xã Ka Đơn",
					},
					{
						name: "Xã Tu Tra",
					},
					{
						name: "Xã Pró",
					},
				],
			},
			{
				name: "Huyện Đức Trọng",
				wards: [
					{
						name: "Thị trấn Liên Nghĩa",
					},
					{
						name: "Xã Hiệp An",
					},
					{
						name: "Xã Liên Hiệp",
					},
					{
						name: "Xã Hiệp Thạnh",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Xã N'Thol Hạ",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Phú Hội",
					},
					{
						name: "Xã Ninh Gia",
					},
					{
						name: "Xã Tà Năng",
					},
					{
						name: "Xã Đa Quyn",
					},
					{
						name: "Xã Tà Hine",
					},
					{
						name: "Xã Đà Loan",
					},
					{
						name: "Xã Ninh Loan",
					},
				],
			},
			{
				name: "Huyện Di Linh",
				wards: [
					{
						name: "Thị trấn Di Linh",
					},
					{
						name: "Xã Đinh Trang Thượng",
					},
					{
						name: "Xã Tân Thượng",
					},
					{
						name: "Xã Tân Lâm",
					},
					{
						name: "Xã Tân Châu",
					},
					{
						name: "Xã Tân Nghĩa",
					},
					{
						name: "Xã Gia Hiệp",
					},
					{
						name: "Xã Đinh Lạc",
					},
					{
						name: "Xã Tam Bố",
					},
					{
						name: "Xã Đinh Trang Hòa",
					},
					{
						name: "Xã Liên Đầm",
					},
					{
						name: "Xã Gung Ré",
					},
					{
						name: "Xã Bảo Thuận",
					},
					{
						name: "Xã Hòa Ninh",
					},
					{
						name: "Xã Hòa Trung",
					},
					{
						name: "Xã Hòa Nam",
					},
					{
						name: "Xã Hòa Bắc",
					},
					{
						name: "Xã Sơn Điền",
					},
					{
						name: "Xã Gia Bắc",
					},
				],
			},
			{
				name: "Huyện Bảo Lâm",
				wards: [
					{
						name: "Thị trấn Lộc Thắng",
					},
					{
						name: "Xã Lộc Bảo",
					},
					{
						name: "Xã Lộc Lâm",
					},
					{
						name: "Xã Lộc Phú",
					},
					{
						name: "Xã Lộc Bắc",
					},
					{
						name: "Xã B' Lá",
					},
					{
						name: "Xã Lộc Ngãi",
					},
					{
						name: "Xã Lộc Quảng",
					},
					{
						name: "Xã Lộc Tân",
					},
					{
						name: "Xã Lộc Đức",
					},
					{
						name: "Xã Lộc An",
					},
					{
						name: "Xã Tân Lạc",
					},
					{
						name: "Xã Lộc Thành",
					},
					{
						name: "Xã Lộc Nam",
					},
				],
			},
			{
				name: "Huyện Đạ Huoai",
				wards: [
					{
						name: "Thị trấn Đạ M'ri",
					},
					{
						name: "Thị trấn Ma Đa Guôi",
					},
					{
						name: "Xã Hà Lâm",
					},
					{
						name: "Xã Đạ Tồn",
					},
					{
						name: "Xã Đạ Oai",
					},
					{
						name: "Xã Đạ Ploa",
					},
					{
						name: "Xã Ma Đa Guôi",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Phước Lộc",
					},
				],
			},
			{
				name: "Huyện Đạ Tẻh",
				wards: [
					{
						name: "Thị trấn Đạ Tẻh",
					},
					{
						name: "Xã An Nhơn",
					},
					{
						name: "Xã Quốc Oai",
					},
					{
						name: "Xã Mỹ Đức",
					},
					{
						name: "Xã Quảng Trị",
					},
					{
						name: "Xã Đạ Lây",
					},
					{
						name: "Xã Triệu Hải",
					},
					{
						name: "Xã Đạ Kho",
					},
					{
						name: "Xã Đạ Pal",
					},
				],
			},
			{
				name: "Huyện Cát Tiên",
				wards: [
					{
						name: "Thị trấn Cát Tiên",
					},
					{
						name: "Xã Tiên Hoàng",
					},
					{
						name: "Xã Phước Cát 2",
					},
					{
						name: "Xã Gia Viễn",
					},
					{
						name: "Xã Nam Ninh",
					},
					{
						name: "Thị trấn Phước Cát",
					},
					{
						name: "Xã Đức Phổ",
					},
					{
						name: "Xã Quảng Ngãi",
					},
					{
						name: "Xã Đồng Nai Thượng",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bình Phước",
		districts: [
			{
				name: "Thị xã Phước Long",
				wards: [
					{
						name: "Phường Thác Mơ",
					},
					{
						name: "Phường Long Thủy",
					},
					{
						name: "Phường Phước Bình",
					},
					{
						name: "Phường Long Phước",
					},
					{
						name: "Phường Sơn Giang",
					},
					{
						name: "Xã Long Giang",
					},
					{
						name: "Xã Phước Tín",
					},
				],
			},
			{
				name: "Thành phố Đồng Xoài",
				wards: [
					{
						name: "Phường Tân Phú",
					},
					{
						name: "Phường Tân Đồng",
					},
					{
						name: "Phường Tân Bình",
					},
					{
						name: "Phường Tân Xuân",
					},
					{
						name: "Phường Tân Thiện",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Phường Tiến Thành",
					},
					{
						name: "Xã Tiến Hưng",
					},
				],
			},
			{
				name: "Thị xã Bình Long",
				wards: [
					{
						name: "Phường Hưng Chiến",
					},
					{
						name: "Phường An Lộc",
					},
					{
						name: "Phường Phú Thịnh",
					},
					{
						name: "Phường Phú Đức",
					},
					{
						name: "Xã Thanh Lương",
					},
					{
						name: "Xã Thanh Phú",
					},
				],
			},
			{
				name: "Huyện Bù Gia Mập",
				wards: [
					{
						name: "Xã Bù Gia Mập",
					},
					{
						name: "Xã Đak Ơ",
					},
					{
						name: "Xã Đức Hạnh",
					},
					{
						name: "Xã Phú Văn",
					},
					{
						name: "Xã Đa Kia",
					},
					{
						name: "Xã Phước Minh",
					},
					{
						name: "Xã Bình Thắng",
					},
					{
						name: "Xã Phú Nghĩa",
					},
				],
			},
			{
				name: "Huyện Lộc Ninh",
				wards: [
					{
						name: "Thị trấn Lộc Ninh",
					},
					{
						name: "Xã Lộc Hòa",
					},
					{
						name: "Xã Lộc An",
					},
					{
						name: "Xã Lộc Tấn",
					},
					{
						name: "Xã Lộc Thạnh",
					},
					{
						name: "Xã Lộc Hiệp",
					},
					{
						name: "Xã Lộc Thiện",
					},
					{
						name: "Xã Lộc Thuận",
					},
					{
						name: "Xã Lộc Quang",
					},
					{
						name: "Xã Lộc Phú",
					},
					{
						name: "Xã Lộc Thành",
					},
					{
						name: "Xã Lộc Thái",
					},
					{
						name: "Xã Lộc Điền",
					},
					{
						name: "Xã Lộc Hưng",
					},
					{
						name: "Xã Lộc Thịnh",
					},
					{
						name: "Xã Lộc Khánh",
					},
				],
			},
			{
				name: "Huyện Bù Đốp",
				wards: [
					{
						name: "Thị trấn Thanh Bình",
					},
					{
						name: "Xã Hưng Phước",
					},
					{
						name: "Xã Phước Thiện",
					},
					{
						name: "Xã Thiện Hưng",
					},
					{
						name: "Xã Thanh Hòa",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Tân Tiến",
					},
				],
			},
			{
				name: "Huyện Hớn Quản",
				wards: [
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã An Khương",
					},
					{
						name: "Xã An Phú",
					},
					{
						name: "Xã Tân Lợi",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Minh Đức",
					},
					{
						name: "Xã Minh Tâm",
					},
					{
						name: "Xã Phước An",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Thị trấn Tân Khai",
					},
					{
						name: "Xã Đồng Nơ",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Tân Quan",
					},
				],
			},
			{
				name: "Huyện Đồng Phú",
				wards: [
					{
						name: "Thị trấn Tân Phú",
					},
					{
						name: "Xã Thuận Lợi",
					},
					{
						name: "Xã Đồng Tâm",
					},
					{
						name: "Xã Tân Phước",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Tân Lợi",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Thuận Phú",
					},
					{
						name: "Xã Đồng Tiến",
					},
					{
						name: "Xã Tân Tiến",
					},
				],
			},
			{
				name: "Huyện Bù Đăng",
				wards: [
					{
						name: "Thị trấn Đức Phong",
					},
					{
						name: "Xã Đường 10",
					},
					{
						name: "Xã Đak Nhau",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Thọ Sơn",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Bom Bo",
					},
					{
						name: "Xã Minh Hưng",
					},
					{
						name: "Xã Đoàn Kết",
					},
					{
						name: "Xã Đồng Nai",
					},
					{
						name: "Xã Đức Liễu",
					},
					{
						name: "Xã Thống Nhất",
					},
					{
						name: "Xã Nghĩa Trung",
					},
					{
						name: "Xã Nghĩa Bình",
					},
					{
						name: "Xã Đăng Hà",
					},
					{
						name: "Xã Phước Sơn",
					},
				],
			},
			{
				name: "Huyện Chơn Thành",
				wards: [
					{
						name: "Thị trấn Chơn Thành",
					},
					{
						name: "Xã Thành Tâm",
					},
					{
						name: "Xã Minh Lập",
					},
					{
						name: "Xã Quang Minh",
					},
					{
						name: "Xã Minh Hưng",
					},
					{
						name: "Xã Minh Long",
					},
					{
						name: "Xã Minh Thành",
					},
					{
						name: "Xã Nha Bích",
					},
					{
						name: "Xã Minh Thắng",
					},
				],
			},
			{
				name: "Huyện Phú Riềng",
				wards: [
					{
						name: "Xã Long Bình",
					},
					{
						name: "Xã Bình Tân",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Long Hưng",
					},
					{
						name: "Xã Phước Tân",
					},
					{
						name: "Xã Bù Nho",
					},
					{
						name: "Xã Long Hà",
					},
					{
						name: "Xã Long Tân",
					},
					{
						name: "Xã Phú Trung",
					},
					{
						name: "Xã Phú Riềng",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Tây Ninh",
		districts: [
			{
				name: "Thành phố Tây Ninh",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường Hiệp Ninh",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Xã Thạnh Tân",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Phường Ninh Sơn",
					},
					{
						name: "Phường Ninh Thạnh",
					},
				],
			},
			{
				name: "Huyện Tân Biên",
				wards: [
					{
						name: "Thị trấn Tân Biên",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Thạnh Bắc",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Thạnh Bình",
					},
					{
						name: "Xã Thạnh Tây",
					},
					{
						name: "Xã Hòa Hiệp",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Mỏ Công",
					},
					{
						name: "Xã Trà Vong",
					},
				],
			},
			{
				name: "Huyện Tân Châu",
				wards: [
					{
						name: "Thị trấn Tân Châu",
					},
					{
						name: "Xã Tân Hà",
					},
					{
						name: "Xã Tân Đông",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Suối Ngô",
					},
					{
						name: "Xã Suối Dây",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Thạnh Đông",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Tân Hưng",
					},
				],
			},
			{
				name: "Huyện Dương Minh Châu",
				wards: [
					{
						name: "Thị trấn Dương Minh Châu",
					},
					{
						name: "Xã Suối Đá",
					},
					{
						name: "Xã Phan",
					},
					{
						name: "Xã Phước Ninh",
					},
					{
						name: "Xã Phước Minh",
					},
					{
						name: "Xã Bàu Năng",
					},
					{
						name: "Xã Chà Là",
					},
					{
						name: "Xã Cầu Khởi",
					},
					{
						name: "Xã Bến Củi",
					},
					{
						name: "Xã Lộc Ninh",
					},
					{
						name: "Xã Truông Mít",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Châu Thành",
					},
					{
						name: "Xã Hảo Đước",
					},
					{
						name: "Xã Phước Vinh",
					},
					{
						name: "Xã Đồng Khởi",
					},
					{
						name: "Xã Thái Bình",
					},
					{
						name: "Xã An Cơ",
					},
					{
						name: "Xã Biên Giới",
					},
					{
						name: "Xã Hòa Thạnh",
					},
					{
						name: "Xã Trí Bình",
					},
					{
						name: "Xã Hòa Hội",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Thanh Điền",
					},
					{
						name: "Xã Thành Long",
					},
					{
						name: "Xã Ninh Điền",
					},
					{
						name: "Xã Long Vĩnh",
					},
				],
			},
			{
				name: "Thị xã Hòa Thành",
				wards: [
					{
						name: "Phường Long Hoa",
					},
					{
						name: "Phường Hiệp Tân",
					},
					{
						name: "Phường Long Thành Bắc",
					},
					{
						name: "Xã Trường Hòa",
					},
					{
						name: "Xã Trường Đông",
					},
					{
						name: "Phường Long Thành Trung",
					},
					{
						name: "Xã Trường Tây",
					},
					{
						name: "Xã Long Thành Nam",
					},
				],
			},
			{
				name: "Huyện Gò Dầu",
				wards: [
					{
						name: "Thị trấn Gò Dầu",
					},
					{
						name: "Xã Thạnh Đức",
					},
					{
						name: "Xã Cẩm Giang",
					},
					{
						name: "Xã Hiệp Thạnh",
					},
					{
						name: "Xã Bàu Đồn",
					},
					{
						name: "Xã Phước Thạnh",
					},
					{
						name: "Xã Phước Đông",
					},
					{
						name: "Xã Phước Trạch",
					},
					{
						name: "Xã Thanh Phước",
					},
				],
			},
			{
				name: "Huyện Bến Cầu",
				wards: [
					{
						name: "Thị trấn Bến Cầu",
					},
					{
						name: "Xã Long Chữ",
					},
					{
						name: "Xã Long Phước",
					},
					{
						name: "Xã Long Giang",
					},
					{
						name: "Xã Tiên Thuận",
					},
					{
						name: "Xã Long Khánh",
					},
					{
						name: "Xã Lợi Thuận",
					},
					{
						name: "Xã Long Thuận",
					},
					{
						name: "Xã An Thạnh",
					},
				],
			},
			{
				name: "Thị xã Trảng Bàng",
				wards: [
					{
						name: "Phường Trảng Bàng",
					},
					{
						name: "Xã Đôn Thuận",
					},
					{
						name: "Xã Hưng Thuận",
					},
					{
						name: "Phường Lộc Hưng",
					},
					{
						name: "Phường Gia Lộc",
					},
					{
						name: "Phường Gia Bình",
					},
					{
						name: "Xã Phước Bình",
					},
					{
						name: "Phường An Tịnh",
					},
					{
						name: "Phường An Hòa",
					},
					{
						name: "Xã Phước Chỉ",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bình Dương",
		districts: [
			{
				name: "Thành phố Thủ Dầu Một",
				wards: [
					{
						name: "Phường Hiệp Thành",
					},
					{
						name: "Phường Phú Lợi",
					},
					{
						name: "Phường Phú Cường",
					},
					{
						name: "Phường Phú Hòa",
					},
					{
						name: "Phường Phú Thọ",
					},
					{
						name: "Phường Chánh Nghĩa",
					},
					{
						name: "Phường Định Hoà",
					},
					{
						name: "Phường Hoà Phú",
					},
					{
						name: "Phường Phú Mỹ",
					},
					{
						name: "Phường Phú Tân",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường Hiệp An",
					},
					{
						name: "Phường Tương Bình Hiệp",
					},
					{
						name: "Phường Chánh Mỹ",
					},
				],
			},
			{
				name: "Huyện Bàu Bàng",
				wards: [
					{
						name: "Xã Trừ Văn Thố",
					},
					{
						name: "Xã Cây Trường II",
					},
					{
						name: "Thị trấn Lai Uyên",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Long Nguyên",
					},
					{
						name: "Xã Hưng Hòa",
					},
					{
						name: "Xã Lai Hưng",
					},
				],
			},
			{
				name: "Huyện Dầu Tiếng",
				wards: [
					{
						name: "Thị trấn Dầu Tiếng",
					},
					{
						name: "Xã Minh Hoà",
					},
					{
						name: "Xã Minh Thạnh",
					},
					{
						name: "Xã Minh Tân",
					},
					{
						name: "Xã Định An",
					},
					{
						name: "Xã Long Hoà",
					},
					{
						name: "Xã Định Thành",
					},
					{
						name: "Xã Định Hiệp",
					},
					{
						name: "Xã An Lập",
					},
					{
						name: "Xã Long Tân",
					},
					{
						name: "Xã Thanh An",
					},
					{
						name: "Xã Thanh Tuyền",
					},
				],
			},
			{
				name: "Thị xã Bến Cát",
				wards: [
					{
						name: "Phường Mỹ Phước",
					},
					{
						name: "Phường Chánh Phú Hòa",
					},
					{
						name: "Xã An Điền",
					},
					{
						name: "Xã An Tây",
					},
					{
						name: "Phường Thới Hòa",
					},
					{
						name: "Phường Hòa Lợi",
					},
					{
						name: "Phường Tân Định",
					},
					{
						name: "Xã Phú An",
					},
				],
			},
			{
				name: "Huyện Phú Giáo",
				wards: [
					{
						name: "Thị trấn Phước Vĩnh",
					},
					{
						name: "Xã An Linh",
					},
					{
						name: "Xã Phước Sang",
					},
					{
						name: "Xã An Thái",
					},
					{
						name: "Xã An Long",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Tam Lập",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Vĩnh Hoà",
					},
					{
						name: "Xã Phước Hoà",
					},
				],
			},
			{
				name: "Thị xã Tân Uyên",
				wards: [
					{
						name: "Phường Uyên Hưng",
					},
					{
						name: "Phường Tân Phước Khánh",
					},
					{
						name: "Phường Vĩnh Tân",
					},
					{
						name: "Phường Hội Nghĩa",
					},
					{
						name: "Phường Tân Hiệp",
					},
					{
						name: "Phường Khánh Bình",
					},
					{
						name: "Phường Phú Chánh",
					},
					{
						name: "Xã Bạch Đằng",
					},
					{
						name: "Phường Tân Vĩnh Hiệp",
					},
					{
						name: "Phường Thạnh Phước",
					},
					{
						name: "Xã Thạnh Hội",
					},
					{
						name: "Phường Thái Hòa",
					},
				],
			},
			{
				name: "Thành phố Dĩ An",
				wards: [
					{
						name: "Phường Dĩ An",
					},
					{
						name: "Phường Tân Bình",
					},
					{
						name: "Phường Tân Đông Hiệp",
					},
					{
						name: "Phường Bình An",
					},
					{
						name: "Phường Bình Thắng",
					},
					{
						name: "Phường Đông Hòa",
					},
					{
						name: "Phường An Bình",
					},
				],
			},
			{
				name: "Thành phố Thuận An",
				wards: [
					{
						name: "Phường An Thạnh",
					},
					{
						name: "Phường Lái Thiêu",
					},
					{
						name: "Phường Bình Chuẩn",
					},
					{
						name: "Phường Thuận Giao",
					},
					{
						name: "Phường An Phú",
					},
					{
						name: "Phường Hưng Định",
					},
					{
						name: "Xã An Sơn",
					},
					{
						name: "Phường Bình Nhâm",
					},
					{
						name: "Phường Bình Hòa",
					},
					{
						name: "Phường Vĩnh Phú",
					},
				],
			},
			{
				name: "Huyện Bắc Tân Uyên",
				wards: [
					{
						name: "Xã Tân Định",
					},
					{
						name: "Xã Bình Mỹ",
					},
					{
						name: "Thị trấn Tân Bình",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Thị trấn Tân Thành",
					},
					{
						name: "Xã Đất Cuốc",
					},
					{
						name: "Xã Hiếu Liêm",
					},
					{
						name: "Xã Lạc An",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Thường Tân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Đồng Nai",
		districts: [
			{
				name: "Thành phố Biên Hòa",
				wards: [
					{
						name: "Phường Trảng Dài",
					},
					{
						name: "Phường Tân Phong",
					},
					{
						name: "Phường Tân Biên",
					},
					{
						name: "Phường Hố Nai",
					},
					{
						name: "Phường Tân Hòa",
					},
					{
						name: "Phường Tân Hiệp",
					},
					{
						name: "Phường Bửu Long",
					},
					{
						name: "Phường Tân Tiến",
					},
					{
						name: "Phường Tam Hiệp",
					},
					{
						name: "Phường Long Bình",
					},
					{
						name: "Phường Quang Vinh",
					},
					{
						name: "Phường Tân Mai",
					},
					{
						name: "Phường Thống Nhất",
					},
					{
						name: "Phường Trung Dũng",
					},
					{
						name: "Phường Tam Hòa",
					},
					{
						name: "Phường Hòa Bình",
					},
					{
						name: "Phường Quyết Thắng",
					},
					{
						name: "Phường Thanh Bình",
					},
					{
						name: "Phường Bình Đa",
					},
					{
						name: "Phường An Bình",
					},
					{
						name: "Phường Bửu Hòa",
					},
					{
						name: "Phường Long Bình Tân",
					},
					{
						name: "Phường Tân Vạn",
					},
					{
						name: "Phường Tân Hạnh",
					},
					{
						name: "Phường Hiệp Hòa",
					},
					{
						name: "Phường Hóa An",
					},
					{
						name: "Phường An Hòa",
					},
					{
						name: "Phường Tam Phước",
					},
					{
						name: "Phường Phước Tân",
					},
					{
						name: "Xã Long Hưng",
					},
				],
			},
			{
				name: "Thành phố Long Khánh",
				wards: [
					{
						name: "Phường Xuân Trung",
					},
					{
						name: "Phường Xuân Thanh",
					},
					{
						name: "Phường Xuân Bình",
					},
					{
						name: "Phường Xuân An",
					},
					{
						name: "Phường Xuân Hoà",
					},
					{
						name: "Phường Phú Bình",
					},
					{
						name: "Xã Bình Lộc",
					},
					{
						name: "Xã Bảo Quang",
					},
					{
						name: "Phường Suối Tre",
					},
					{
						name: "Phường Bảo Vinh",
					},
					{
						name: "Phường Xuân Lập",
					},
					{
						name: "Phường Bàu Sen",
					},
					{
						name: "Xã Bàu Trâm",
					},
					{
						name: "Phường Xuân Tân",
					},
					{
						name: "Xã Hàng Gòn",
					},
				],
			},
			{
				name: "Huyện Tân Phú",
				wards: [
					{
						name: "Thị trấn Tân Phú",
					},
					{
						name: "Xã Dak Lua",
					},
					{
						name: "Xã Nam Cát Tiên",
					},
					{
						name: "Xã Phú An",
					},
					{
						name: "Xã Núi Tượng",
					},
					{
						name: "Xã Tà Lài",
					},
					{
						name: "Xã Phú Lập",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Phú Thịnh",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Phú Trung",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Phú Lâm",
					},
					{
						name: "Xã Phú Bình",
					},
					{
						name: "Xã Phú Thanh",
					},
					{
						name: "Xã Trà Cổ",
					},
					{
						name: "Xã Phú Điền",
					},
				],
			},
			{
				name: "Huyện Vĩnh Cửu",
				wards: [
					{
						name: "Thị trấn Vĩnh An",
					},
					{
						name: "Xã Phú Lý",
					},
					{
						name: "Xã Trị An",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Vĩnh Tân",
					},
					{
						name: "Xã Bình Lợi",
					},
					{
						name: "Xã Thạnh Phú",
					},
					{
						name: "Xã Thiện Tân",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Bình Hòa",
					},
					{
						name: "Xã Mã Đà",
					},
					{
						name: "Xã Hiếu Liêm",
					},
				],
			},
			{
				name: "Huyện Định Quán",
				wards: [
					{
						name: "Thị trấn Định Quán",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Phú Tân",
					},
					{
						name: "Xã Phú Vinh",
					},
					{
						name: "Xã Phú Lợi",
					},
					{
						name: "Xã Phú Hòa",
					},
					{
						name: "Xã Ngọc Định",
					},
					{
						name: "Xã La Ngà",
					},
					{
						name: "Xã Gia Canh",
					},
					{
						name: "Xã Phú Ngọc",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Túc Trưng",
					},
					{
						name: "Xã Phú Túc",
					},
					{
						name: "Xã Suối Nho",
					},
				],
			},
			{
				name: "Huyện Trảng Bom",
				wards: [
					{
						name: "Thị trấn Trảng Bom",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Xã Cây Gáo",
					},
					{
						name: "Xã Bàu Hàm",
					},
					{
						name: "Xã Sông Thao",
					},
					{
						name: "Xã Sông Trầu",
					},
					{
						name: "Xã Đông Hoà",
					},
					{
						name: "Xã Bắc Sơn",
					},
					{
						name: "Xã Hố Nai 3",
					},
					{
						name: "Xã Tây Hoà",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Trung Hoà",
					},
					{
						name: "Xã Đồi 61",
					},
					{
						name: "Xã Hưng Thịnh",
					},
					{
						name: "Xã Quảng Tiến",
					},
					{
						name: "Xã Giang Điền",
					},
					{
						name: "Xã An Viễn",
					},
				],
			},
			{
				name: "Huyện Thống Nhất",
				wards: [
					{
						name: "Xã Gia Tân 1",
					},
					{
						name: "Xã Gia Tân 2",
					},
					{
						name: "Xã Gia Tân 3",
					},
					{
						name: "Xã Gia Kiệm",
					},
					{
						name: "Xã Quang Trung",
					},
					{
						name: "Xã Bàu Hàm 2",
					},
					{
						name: "Xã Hưng Lộc",
					},
					{
						name: "Xã Lộ 25",
					},
					{
						name: "Xã Xuân Thiện",
					},
					{
						name: "Thị trấn Dầu Giây",
					},
				],
			},
			{
				name: "Huyện Cẩm Mỹ",
				wards: [
					{
						name: "Xã Sông Nhạn",
					},
					{
						name: "Xã Xuân Quế",
					},
					{
						name: "Xã Nhân Nghĩa",
					},
					{
						name: "Xã Xuân Đường",
					},
					{
						name: "Xã Long Giao",
					},
					{
						name: "Xã Xuân Mỹ",
					},
					{
						name: "Xã Thừa Đức",
					},
					{
						name: "Xã Bảo Bình",
					},
					{
						name: "Xã Xuân Bảo",
					},
					{
						name: "Xã Xuân Tây",
					},
					{
						name: "Xã Xuân Đông",
					},
					{
						name: "Xã Sông Ray",
					},
					{
						name: "Xã Lâm San",
					},
				],
			},
			{
				name: "Huyện Long Thành",
				wards: [
					{
						name: "Thị trấn Long Thành",
					},
					{
						name: "Xã An Phước",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Long Đức",
					},
					{
						name: "Xã Lộc An",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Tam An",
					},
					{
						name: "Xã Cẩm Đường",
					},
					{
						name: "Xã Long An",
					},
					{
						name: "Xã Bàu Cạn",
					},
					{
						name: "Xã Long Phước",
					},
					{
						name: "Xã Phước Bình",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Phước Thái",
					},
				],
			},
			{
				name: "Huyện Xuân Lộc",
				wards: [
					{
						name: "Thị trấn Gia Ray",
					},
					{
						name: "Xã Xuân Bắc",
					},
					{
						name: "Xã Suối Cao",
					},
					{
						name: "Xã Xuân Thành",
					},
					{
						name: "Xã Xuân Thọ",
					},
					{
						name: "Xã Xuân Trường",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Xuân Hưng",
					},
					{
						name: "Xã Xuân Tâm",
					},
					{
						name: "Xã Suối Cát",
					},
					{
						name: "Xã Xuân Hiệp",
					},
					{
						name: "Xã Xuân Phú",
					},
					{
						name: "Xã Xuân Định",
					},
					{
						name: "Xã Bảo Hoà",
					},
					{
						name: "Xã Lang Minh",
					},
				],
			},
			{
				name: "Huyện Nhơn Trạch",
				wards: [
					{
						name: "Xã Phước Thiền",
					},
					{
						name: "Xã Long Tân",
					},
					{
						name: "Xã Đại Phước",
					},
					{
						name: "Thị trấn Hiệp Phước",
					},
					{
						name: "Xã Phú Hữu",
					},
					{
						name: "Xã Phú Hội",
					},
					{
						name: "Xã Phú Thạnh",
					},
					{
						name: "Xã Phú Đông",
					},
					{
						name: "Xã Long Thọ",
					},
					{
						name: "Xã Vĩnh Thanh",
					},
					{
						name: "Xã Phước Khánh",
					},
					{
						name: "Xã Phước An",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bà Rịa - Vũng Tàu",
		districts: [
			{
				name: "Thành phố Vũng Tàu",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường Thắng Tam",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường Thắng Nhì",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường Nguyễn An Ninh",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Phường Thắng Nhất",
					},
					{
						name: "Phường Rạch Dừa",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Xã Long Sơn",
					},
				],
			},
			{
				name: "Thành phố Bà Rịa",
				wards: [
					{
						name: "Phường Phước Hưng",
					},
					{
						name: "Phường Phước Hiệp",
					},
					{
						name: "Phường Phước Nguyên",
					},
					{
						name: "Phường Long Toàn",
					},
					{
						name: "Phường Long Tâm",
					},
					{
						name: "Phường Phước Trung",
					},
					{
						name: "Phường Long Hương",
					},
					{
						name: "Phường Kim Dinh",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Long Phước",
					},
					{
						name: "Xã Hoà Long",
					},
				],
			},
			{
				name: "Huyện Châu Đức",
				wards: [
					{
						name: "Xã Bàu Chinh",
					},
					{
						name: "Thị trấn Ngãi Giao",
					},
					{
						name: "Xã Bình Ba",
					},
					{
						name: "Xã Suối Nghệ",
					},
					{
						name: "Xã Xuân Sơn",
					},
					{
						name: "Xã Sơn Bình",
					},
					{
						name: "Xã Bình Giã",
					},
					{
						name: "Xã Bình Trung",
					},
					{
						name: "Xã Xà Bang",
					},
					{
						name: "Xã Cù Bị",
					},
					{
						name: "Xã Láng Lớn",
					},
					{
						name: "Xã Quảng Thành",
					},
					{
						name: "Xã Kim Long",
					},
					{
						name: "Xã Suối Rao",
					},
					{
						name: "Xã Đá Bạc",
					},
					{
						name: "Xã Nghĩa Thành",
					},
				],
			},
			{
				name: "Huyện Xuyên Mộc",
				wards: [
					{
						name: "Thị trấn Phước Bửu",
					},
					{
						name: "Xã Phước Thuận",
					},
					{
						name: "Xã Phước Tân",
					},
					{
						name: "Xã Xuyên Mộc",
					},
					{
						name: "Xã Bông Trang",
					},
					{
						name: "Xã Tân Lâm",
					},
					{
						name: "Xã Bàu Lâm",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Hòa Hưng",
					},
					{
						name: "Xã Hòa Hiệp",
					},
					{
						name: "Xã Hòa Hội",
					},
					{
						name: "Xã Bưng Riềng",
					},
					{
						name: "Xã Bình Châu",
					},
				],
			},
			{
				name: "Huyện Long Điền",
				wards: [
					{
						name: "Thị trấn Long Điền",
					},
					{
						name: "Thị trấn Long Hải",
					},
					{
						name: "Xã An Ngãi",
					},
					{
						name: "Xã Tam Phước",
					},
					{
						name: "Xã An Nhứt",
					},
					{
						name: "Xã Phước Tỉnh",
					},
					{
						name: "Xã Phước Hưng",
					},
				],
			},
			{
				name: "Huyện Đất Đỏ",
				wards: [
					{
						name: "Thị trấn Đất Đỏ",
					},
					{
						name: "Xã Phước Long Thọ",
					},
					{
						name: "Xã Phước Hội",
					},
					{
						name: "Xã Long Mỹ",
					},
					{
						name: "Thị trấn Phước Hải",
					},
					{
						name: "Xã Long Tân",
					},
					{
						name: "Xã Láng Dài",
					},
					{
						name: "Xã Lộc An",
					},
				],
			},
			{
				name: "Thị xã Phú Mỹ",
				wards: [
					{
						name: "Phường Phú Mỹ",
					},
					{
						name: "Xã Tân Hoà",
					},
					{
						name: "Xã Tân Hải",
					},
					{
						name: "Phường Phước Hoà",
					},
					{
						name: "Phường Tân Phước",
					},
					{
						name: "Phường Mỹ Xuân",
					},
					{
						name: "Xã Sông Xoài",
					},
					{
						name: "Phường Hắc Dịch",
					},
					{
						name: "Xã Châu Pha",
					},
					{
						name: "Xã Tóc Tiên",
					},
				],
			},
			{
				name: "Huyện Côn Đảo",
				wards: [],
			},
		],
	},
	{
		name: "Thành phố Hồ Chí Minh",
		districts: [
			{
				name: "Quận 1",
				wards: [
					{
						name: "Phường Tân Định",
					},
					{
						name: "Phường Đa Kao",
					},
					{
						name: "Phường Bến Nghé",
					},
					{
						name: "Phường Bến Thành",
					},
					{
						name: "Phường Nguyễn Thái Bình",
					},
					{
						name: "Phường Phạm Ngũ Lão",
					},
					{
						name: "Phường Cầu Ông Lãnh",
					},
					{
						name: "Phường Cô Giang",
					},
					{
						name: "Phường Nguyễn Cư Trinh",
					},
					{
						name: "Phường Cầu Kho",
					},
				],
			},
			{
				name: "Quận 12",
				wards: [
					{
						name: "Phường Thạnh Xuân",
					},
					{
						name: "Phường Thạnh Lộc",
					},
					{
						name: "Phường Hiệp Thành",
					},
					{
						name: "Phường Thới An",
					},
					{
						name: "Phường Tân Chánh Hiệp",
					},
					{
						name: "Phường An Phú Đông",
					},
					{
						name: "Phường Tân Thới Hiệp",
					},
					{
						name: "Phường Trung Mỹ Tây",
					},
					{
						name: "Phường Tân Hưng Thuận",
					},
					{
						name: "Phường Đông Hưng Thuận",
					},
					{
						name: "Phường Tân Thới Nhất",
					},
				],
			},
			{
				name: "Quận Gò Vấp",
				wards: [
					{
						name: "Phường 15",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường 17",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 16",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 03",
					},
				],
			},
			{
				name: "Quận Bình Thạnh",
				wards: [
					{
						name: "Phường 13",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 27",
					},
					{
						name: "Phường 26",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 25",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 24",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 15",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 17",
					},
					{
						name: "Phường 21",
					},
					{
						name: "Phường 22",
					},
					{
						name: "Phường 19",
					},
					{
						name: "Phường 28",
					},
				],
			},
			{
				name: "Quận Tân Bình",
				wards: [
					{
						name: "Phường 02",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 15",
					},
				],
			},
			{
				name: "Quận Tân Phú",
				wards: [
					{
						name: "Phường Tân Sơn Nhì",
					},
					{
						name: "Phường Tây Thạnh",
					},
					{
						name: "Phường Sơn Kỳ",
					},
					{
						name: "Phường Tân Quý",
					},
					{
						name: "Phường Tân Thành",
					},
					{
						name: "Phường Phú Thọ Hòa",
					},
					{
						name: "Phường Phú Thạnh",
					},
					{
						name: "Phường Phú Trung",
					},
					{
						name: "Phường Hòa Thạnh",
					},
					{
						name: "Phường Hiệp Tân",
					},
					{
						name: "Phường Tân Thới Hòa",
					},
				],
			},
			{
				name: "Quận Phú Nhuận",
				wards: [
					{
						name: "Phường 04",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 15",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 17",
					},
					{
						name: "Phường 13",
					},
				],
			},
			{
				name: "Thành phố Thủ Đức",
				wards: [
					{
						name: "Phường Linh Xuân",
					},
					{
						name: "Phường Bình Chiểu",
					},
					{
						name: "Phường Linh Trung",
					},
					{
						name: "Phường Tam Bình",
					},
					{
						name: "Phường Tam Phú",
					},
					{
						name: "Phường Hiệp Bình Phước",
					},
					{
						name: "Phường Hiệp Bình Chánh",
					},
					{
						name: "Phường Linh Chiểu",
					},
					{
						name: "Phường Linh Tây",
					},
					{
						name: "Phường Linh Đông",
					},
					{
						name: "Phường Bình Thọ",
					},
					{
						name: "Phường Trường Thọ",
					},
					{
						name: "Phường Long Bình",
					},
					{
						name: "Phường Long Thạnh Mỹ",
					},
					{
						name: "Phường Tân Phú",
					},
					{
						name: "Phường Hiệp Phú",
					},
					{
						name: "Phường Tăng Nhơn Phú A",
					},
					{
						name: "Phường Tăng Nhơn Phú B",
					},
					{
						name: "Phường Phước Long B",
					},
					{
						name: "Phường Phước Long A",
					},
					{
						name: "Phường Trường Thạnh",
					},
					{
						name: "Phường Long Phước",
					},
					{
						name: "Phường Long Trường",
					},
					{
						name: "Phường Phước Bình",
					},
					{
						name: "Phường Phú Hữu",
					},
					{
						name: "Phường Thảo Điền",
					},
					{
						name: "Phường An Phú",
					},
					{
						name: "Phường An Khánh",
					},
					{
						name: "Phường Bình Trưng Đông",
					},
					{
						name: "Phường Bình Trưng Tây",
					},
					{
						name: "Phường Cát Lái",
					},
					{
						name: "Phường Thạnh Mỹ Lợi",
					},
					{
						name: "Phường An Lợi Đông",
					},
					{
						name: "Phường Thủ Thiêm",
					},
				],
			},
			{
				name: "Quận 3",
				wards: [
					{
						name: "Phường 14",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường Võ Thị Sáu",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 01",
					},
				],
			},
			{
				name: "Quận 10",
				wards: [
					{
						name: "Phường 15",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 06",
					},
				],
			},
			{
				name: "Quận 11",
				wards: [
					{
						name: "Phường 15",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 16",
					},
				],
			},
			{
				name: "Quận 4",
				wards: [
					{
						name: "Phường 13",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 18",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 16",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 15",
					},
					{
						name: "Phường 01",
					},
				],
			},
			{
				name: "Quận 5",
				wards: [
					{
						name: "Phường 04",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 13",
					},
				],
			},
			{
				name: "Quận 6",
				wards: [
					{
						name: "Phường 14",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 08",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 07",
					},
					{
						name: "Phường 10",
					},
				],
			},
			{
				name: "Quận 8",
				wards: [
					{
						name: "Phường 08",
					},
					{
						name: "Phường 02",
					},
					{
						name: "Phường 01",
					},
					{
						name: "Phường 03",
					},
					{
						name: "Phường 11",
					},
					{
						name: "Phường 09",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường 04",
					},
					{
						name: "Phường 13",
					},
					{
						name: "Phường 12",
					},
					{
						name: "Phường 05",
					},
					{
						name: "Phường 14",
					},
					{
						name: "Phường 06",
					},
					{
						name: "Phường 15",
					},
					{
						name: "Phường 16",
					},
					{
						name: "Phường 07",
					},
				],
			},
			{
				name: "Quận Bình Tân",
				wards: [
					{
						name: "Phường Bình Hưng Hòa",
					},
					{
						name: "Phường Bình Hưng Hoà A",
					},
					{
						name: "Phường Bình Hưng Hoà B",
					},
					{
						name: "Phường Bình Trị Đông",
					},
					{
						name: "Phường Bình Trị Đông A",
					},
					{
						name: "Phường Bình Trị Đông B",
					},
					{
						name: "Phường Tân Tạo",
					},
					{
						name: "Phường Tân Tạo A",
					},
					{
						name: "Phường An Lạc",
					},
					{
						name: "Phường An Lạc A",
					},
				],
			},
			{
				name: "Quận 7",
				wards: [
					{
						name: "Phường Tân Thuận Đông",
					},
					{
						name: "Phường Tân Thuận Tây",
					},
					{
						name: "Phường Tân Kiểng",
					},
					{
						name: "Phường Tân Hưng",
					},
					{
						name: "Phường Bình Thuận",
					},
					{
						name: "Phường Tân Quy",
					},
					{
						name: "Phường Phú Thuận",
					},
					{
						name: "Phường Tân Phú",
					},
					{
						name: "Phường Tân Phong",
					},
					{
						name: "Phường Phú Mỹ",
					},
				],
			},
			{
				name: "Huyện Củ Chi",
				wards: [
					{
						name: "Thị trấn Củ Chi",
					},
					{
						name: "Xã Phú Mỹ Hưng",
					},
					{
						name: "Xã An Phú",
					},
					{
						name: "Xã Trung Lập Thượng",
					},
					{
						name: "Xã An Nhơn Tây",
					},
					{
						name: "Xã Nhuận Đức",
					},
					{
						name: "Xã Phạm Văn Cội",
					},
					{
						name: "Xã Phú Hòa Đông",
					},
					{
						name: "Xã Trung Lập Hạ",
					},
					{
						name: "Xã Trung An",
					},
					{
						name: "Xã Phước Thạnh",
					},
					{
						name: "Xã Phước Hiệp",
					},
					{
						name: "Xã Tân An Hội",
					},
					{
						name: "Xã Phước Vĩnh An",
					},
					{
						name: "Xã Thái Mỹ",
					},
					{
						name: "Xã Tân Thạnh Tây",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Tân Thạnh Đông",
					},
					{
						name: "Xã Bình Mỹ",
					},
					{
						name: "Xã Tân Phú Trung",
					},
					{
						name: "Xã Tân Thông Hội",
					},
				],
			},
			{
				name: "Huyện Hóc Môn",
				wards: [
					{
						name: "Thị trấn Hóc Môn",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Nhị Bình",
					},
					{
						name: "Xã Đông Thạnh",
					},
					{
						name: "Xã Tân Thới Nhì",
					},
					{
						name: "Xã Thới Tam Thôn",
					},
					{
						name: "Xã Xuân Thới Sơn",
					},
					{
						name: "Xã Tân Xuân",
					},
					{
						name: "Xã Xuân Thới Đông",
					},
					{
						name: "Xã Trung Chánh",
					},
					{
						name: "Xã Xuân Thới Thượng",
					},
					{
						name: "Xã Bà Điểm",
					},
				],
			},
			{
				name: "Huyện Bình Chánh",
				wards: [
					{
						name: "Thị trấn Tân Túc",
					},
					{
						name: "Xã Phạm Văn Hai",
					},
					{
						name: "Xã Vĩnh Lộc A",
					},
					{
						name: "Xã Vĩnh Lộc B",
					},
					{
						name: "Xã Bình Lợi",
					},
					{
						name: "Xã Lê Minh Xuân",
					},
					{
						name: "Xã Tân Nhựt",
					},
					{
						name: "Xã Tân Kiên",
					},
					{
						name: "Xã Bình Hưng",
					},
					{
						name: "Xã Phong Phú",
					},
					{
						name: "Xã An Phú Tây",
					},
					{
						name: "Xã Hưng Long",
					},
					{
						name: "Xã Đa Phước",
					},
					{
						name: "Xã Tân Quý Tây",
					},
					{
						name: "Xã Bình Chánh",
					},
					{
						name: "Xã Quy Đức",
					},
				],
			},
			{
				name: "Huyện Nhà Bè",
				wards: [
					{
						name: "Thị trấn Nhà Bè",
					},
					{
						name: "Xã Phước Kiển",
					},
					{
						name: "Xã Phước Lộc",
					},
					{
						name: "Xã Nhơn Đức",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Long Thới",
					},
					{
						name: "Xã Hiệp Phước",
					},
				],
			},
			{
				name: "Huyện Cần Giờ",
				wards: [
					{
						name: "Thị trấn Cần Thạnh",
					},
					{
						name: "Xã Bình Khánh",
					},
					{
						name: "Xã Tam Thôn Hiệp",
					},
					{
						name: "Xã An Thới Đông",
					},
					{
						name: "Xã Thạnh An",
					},
					{
						name: "Xã Long Hòa",
					},
					{
						name: "Xã Lý Nhơn",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Long An",
		districts: [
			{
				name: "Thành phố Tân An",
				wards: [
					{
						name: "Phường 5",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường Tân Khánh",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Xã Hướng Thọ Phú",
					},
					{
						name: "Xã Nhơn Thạnh Trung",
					},
					{
						name: "Xã Lợi Bình Nhơn",
					},
					{
						name: "Xã Bình Tâm",
					},
					{
						name: "Phường Khánh Hậu",
					},
					{
						name: "Xã An Vĩnh Ngãi",
					},
				],
			},
			{
				name: "Thị xã Kiến Tường",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Xã Thạnh Trị",
					},
					{
						name: "Xã Bình Hiệp",
					},
					{
						name: "Xã Bình Tân",
					},
					{
						name: "Xã Tuyên Thạnh",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Xã Thạnh Hưng",
					},
				],
			},
			{
				name: "Huyện Tân Hưng",
				wards: [
					{
						name: "Thị trấn Tân Hưng",
					},
					{
						name: "Xã Hưng Hà",
					},
					{
						name: "Xã Hưng Điền B",
					},
					{
						name: "Xã Hưng Điền",
					},
					{
						name: "Xã Thạnh Hưng",
					},
					{
						name: "Xã Hưng Thạnh",
					},
					{
						name: "Xã Vĩnh Thạnh",
					},
					{
						name: "Xã Vĩnh Châu B",
					},
					{
						name: "Xã Vĩnh Lợi",
					},
					{
						name: "Xã Vĩnh Đại",
					},
					{
						name: "Xã Vĩnh Châu A",
					},
					{
						name: "Xã Vĩnh Bửu",
					},
				],
			},
			{
				name: "Huyện Vĩnh Hưng",
				wards: [
					{
						name: "Thị trấn Vĩnh Hưng",
					},
					{
						name: "Xã Hưng Điền A",
					},
					{
						name: "Xã Khánh Hưng",
					},
					{
						name: "Xã Thái Trị",
					},
					{
						name: "Xã Vĩnh Trị",
					},
					{
						name: "Xã Thái Bình Trung",
					},
					{
						name: "Xã Vĩnh Bình",
					},
					{
						name: "Xã Vĩnh Thuận",
					},
					{
						name: "Xã Tuyên Bình",
					},
					{
						name: "Xã Tuyên Bình Tây",
					},
				],
			},
			{
				name: "Huyện Mộc Hóa",
				wards: [
					{
						name: "Xã Bình Hòa Tây",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Xã Bình Hòa Trung",
					},
					{
						name: "Xã Bình Hòa Đông",
					},
					{
						name: "Thị trấn Bình Phong Thạnh",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Tân Thành",
					},
				],
			},
			{
				name: "Huyện Tân Thạnh",
				wards: [
					{
						name: "Thị trấn Tân Thạnh",
					},
					{
						name: "Xã Bắc Hòa",
					},
					{
						name: "Xã Hậu Thạnh Tây",
					},
					{
						name: "Xã Nhơn Hòa Lập",
					},
					{
						name: "Xã Tân Lập",
					},
					{
						name: "Xã Hậu Thạnh Đông",
					},
					{
						name: "Xã Nhơn Hoà",
					},
					{
						name: "Xã Kiến Bình",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Tân Ninh",
					},
					{
						name: "Xã Nhơn Ninh",
					},
					{
						name: "Xã Tân Hòa",
					},
				],
			},
			{
				name: "Huyện Thạnh Hóa",
				wards: [
					{
						name: "Thị trấn Thạnh Hóa",
					},
					{
						name: "Xã Tân Hiệp",
					},
					{
						name: "Xã Thuận Bình",
					},
					{
						name: "Xã Thạnh Phước",
					},
					{
						name: "Xã Thạnh Phú",
					},
					{
						name: "Xã Thuận Nghĩa Hòa",
					},
					{
						name: "Xã Thủy Đông",
					},
					{
						name: "Xã Thủy Tây",
					},
					{
						name: "Xã Tân Tây",
					},
					{
						name: "Xã Tân Đông",
					},
					{
						name: "Xã Thạnh An",
					},
				],
			},
			{
				name: "Huyện Đức Huệ",
				wards: [
					{
						name: "Thị trấn Đông Thành",
					},
					{
						name: "Xã Mỹ Quý Đông",
					},
					{
						name: "Xã Mỹ Thạnh Bắc",
					},
					{
						name: "Xã Mỹ Quý Tây",
					},
					{
						name: "Xã Mỹ Thạnh Tây",
					},
					{
						name: "Xã Mỹ Thạnh Đông",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Bình Hòa Bắc",
					},
					{
						name: "Xã Bình Hòa Hưng",
					},
					{
						name: "Xã Bình Hòa Nam",
					},
					{
						name: "Xã Mỹ Bình",
					},
				],
			},
			{
				name: "Huyện Đức Hòa",
				wards: [
					{
						name: "Thị trấn Hậu Nghĩa",
					},
					{
						name: "Thị trấn Hiệp Hòa",
					},
					{
						name: "Thị trấn Đức Hòa",
					},
					{
						name: "Xã Lộc Giang",
					},
					{
						name: "Xã An Ninh Đông",
					},
					{
						name: "Xã An Ninh Tây",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Hiệp Hòa",
					},
					{
						name: "Xã Đức Lập Thượng",
					},
					{
						name: "Xã Đức Lập Hạ",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Mỹ Hạnh Bắc",
					},
					{
						name: "Xã Đức Hòa Thượng",
					},
					{
						name: "Xã Hòa Khánh Tây",
					},
					{
						name: "Xã Hòa Khánh Đông",
					},
					{
						name: "Xã Mỹ Hạnh Nam",
					},
					{
						name: "Xã Hòa Khánh Nam",
					},
					{
						name: "Xã Đức Hòa Đông",
					},
					{
						name: "Xã Đức Hòa Hạ",
					},
					{
						name: "Xã Hựu Thạnh",
					},
				],
			},
			{
				name: "Huyện Bến Lức",
				wards: [
					{
						name: "Thị trấn Bến Lức",
					},
					{
						name: "Xã Thạnh Lợi",
					},
					{
						name: "Xã Lương Bình",
					},
					{
						name: "Xã Thạnh Hòa",
					},
					{
						name: "Xã Lương Hòa",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Tân Bửu",
					},
					{
						name: "Xã An Thạnh",
					},
					{
						name: "Xã Bình Đức",
					},
					{
						name: "Xã Mỹ Yên",
					},
					{
						name: "Xã Thanh Phú",
					},
					{
						name: "Xã Long Hiệp",
					},
					{
						name: "Xã Thạnh Đức",
					},
					{
						name: "Xã Phước Lợi",
					},
					{
						name: "Xã Nhựt Chánh",
					},
				],
			},
			{
				name: "Huyện Thủ Thừa",
				wards: [
					{
						name: "Thị trấn Thủ Thừa",
					},
					{
						name: "Xã Long Thạnh",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Long Thuận",
					},
					{
						name: "Xã Mỹ Lạc",
					},
					{
						name: "Xã Mỹ Thạnh",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Nhị Thành",
					},
					{
						name: "Xã Mỹ An",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Xã Mỹ Phú",
					},
					{
						name: "Xã Tân Long",
					},
				],
			},
			{
				name: "Huyện Tân Trụ",
				wards: [
					{
						name: "Thị trấn Tân Trụ",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Quê Mỹ Thạnh",
					},
					{
						name: "Xã Lạc Tấn",
					},
					{
						name: "Xã Bình Trinh Đông",
					},
					{
						name: "Xã Tân Phước Tây",
					},
					{
						name: "Xã Bình Lãng",
					},
					{
						name: "Xã Bình Tịnh",
					},
					{
						name: "Xã Đức Tân",
					},
					{
						name: "Xã Nhựt Ninh",
					},
				],
			},
			{
				name: "Huyện Cần Đước",
				wards: [
					{
						name: "Thị trấn Cần Đước",
					},
					{
						name: "Xã Long Trạch",
					},
					{
						name: "Xã Long Khê",
					},
					{
						name: "Xã Long Định",
					},
					{
						name: "Xã Phước Vân",
					},
					{
						name: "Xã Long Hòa",
					},
					{
						name: "Xã Long Cang",
					},
					{
						name: "Xã Long Sơn",
					},
					{
						name: "Xã Tân Trạch",
					},
					{
						name: "Xã Mỹ Lệ",
					},
					{
						name: "Xã Tân Lân",
					},
					{
						name: "Xã Phước Tuy",
					},
					{
						name: "Xã Long Hựu Đông",
					},
					{
						name: "Xã Tân Ân",
					},
					{
						name: "Xã Phước Đông",
					},
					{
						name: "Xã Long Hựu Tây",
					},
					{
						name: "Xã Tân Chánh",
					},
				],
			},
			{
				name: "Huyện Cần Giuộc",
				wards: [
					{
						name: "Thị trấn Cần Giuộc",
					},
					{
						name: "Xã Phước Lý",
					},
					{
						name: "Xã Long Thượng",
					},
					{
						name: "Xã Long Hậu",
					},
					{
						name: "Xã Phước Hậu",
					},
					{
						name: "Xã Mỹ Lộc",
					},
					{
						name: "Xã Phước Lại",
					},
					{
						name: "Xã Phước Lâm",
					},
					{
						name: "Xã Thuận Thành",
					},
					{
						name: "Xã Phước Vĩnh Tây",
					},
					{
						name: "Xã Phước Vĩnh Đông",
					},
					{
						name: "Xã Long An",
					},
					{
						name: "Xã Long Phụng",
					},
					{
						name: "Xã Đông Thạnh",
					},
					{
						name: "Xã Tân Tập",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Tầm Vu",
					},
					{
						name: "Xã Bình Quới",
					},
					{
						name: "Xã Hòa Phú",
					},
					{
						name: "Xã Phú Ngãi Trị",
					},
					{
						name: "Xã Vĩnh Công",
					},
					{
						name: "Xã Thuận Mỹ",
					},
					{
						name: "Xã Hiệp Thạnh",
					},
					{
						name: "Xã Phước Tân Hưng",
					},
					{
						name: "Xã Thanh Phú Long",
					},
					{
						name: "Xã Dương Xuân Hội",
					},
					{
						name: "Xã An Lục Long",
					},
					{
						name: "Xã Long Trì",
					},
					{
						name: "Xã Thanh Vĩnh Đông",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Tiền Giang",
		districts: [
			{
				name: "Thành phố Mỹ Tho",
				wards: [
					{
						name: "Phường 5",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Phường 10",
					},
					{
						name: "Phường Tân Long",
					},
					{
						name: "Xã Đạo Thạnh",
					},
					{
						name: "Xã Trung An",
					},
					{
						name: "Xã Mỹ Phong",
					},
					{
						name: "Xã Tân Mỹ Chánh",
					},
					{
						name: "Xã Phước Thạnh",
					},
					{
						name: "Xã Thới Sơn",
					},
				],
			},
			{
				name: "Thị xã Gò Công",
				wards: [
					{
						name: "Phường 3",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Xã Long Hưng",
					},
					{
						name: "Xã Long Thuận",
					},
					{
						name: "Xã Long Chánh",
					},
					{
						name: "Xã Long Hòa",
					},
					{
						name: "Xã Bình Đông",
					},
					{
						name: "Xã Bình Xuân",
					},
					{
						name: "Xã Tân Trung",
					},
				],
			},
			{
				name: "Thị xã Cai Lậy",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Xã Mỹ Phước Tây",
					},
					{
						name: "Xã Mỹ Hạnh Đông",
					},
					{
						name: "Xã Mỹ Hạnh Trung",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Phường Nhị Mỹ",
					},
					{
						name: "Xã Nhị Quý",
					},
					{
						name: "Xã Thanh Hòa",
					},
					{
						name: "Xã Phú Quý",
					},
					{
						name: "Xã Long Khánh",
					},
				],
			},
			{
				name: "Huyện Tân Phước",
				wards: [
					{
						name: "Thị trấn Mỹ Phước",
					},
					{
						name: "Xã Tân Hòa Đông",
					},
					{
						name: "Xã Thạnh Tân",
					},
					{
						name: "Xã Thạnh Mỹ",
					},
					{
						name: "Xã Thạnh Hoà",
					},
					{
						name: "Xã Phú Mỹ",
					},
					{
						name: "Xã Tân Hòa Thành",
					},
					{
						name: "Xã Hưng Thạnh",
					},
					{
						name: "Xã Tân Lập 1",
					},
					{
						name: "Xã Tân Hòa Tây",
					},
					{
						name: "Xã Tân Lập 2",
					},
					{
						name: "Xã Phước Lập",
					},
				],
			},
			{
				name: "Huyện Cái Bè",
				wards: [
					{
						name: "Thị trấn Cái Bè",
					},
					{
						name: "Xã Hậu Mỹ Bắc B",
					},
					{
						name: "Xã Hậu Mỹ Bắc A",
					},
					{
						name: "Xã Mỹ Trung",
					},
					{
						name: "Xã Hậu Mỹ Trinh",
					},
					{
						name: "Xã Hậu Mỹ Phú",
					},
					{
						name: "Xã Mỹ Tân",
					},
					{
						name: "Xã Mỹ Lợi B",
					},
					{
						name: "Xã Thiện Trung",
					},
					{
						name: "Xã Mỹ Hội",
					},
					{
						name: "Xã An Cư",
					},
					{
						name: "Xã Hậu Thành",
					},
					{
						name: "Xã Mỹ Lợi A",
					},
					{
						name: "Xã Hòa Khánh",
					},
					{
						name: "Xã Thiện Trí",
					},
					{
						name: "Xã Mỹ Đức Đông",
					},
					{
						name: "Xã Mỹ Đức Tây",
					},
					{
						name: "Xã Đông Hòa Hiệp",
					},
					{
						name: "Xã An Thái Đông",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Mỹ Lương",
					},
					{
						name: "Xã Tân Thanh",
					},
					{
						name: "Xã An Thái Trung",
					},
					{
						name: "Xã An Hữu",
					},
					{
						name: "Xã Hòa Hưng",
					},
				],
			},
			{
				name: "Huyện Cai Lậy",
				wards: [
					{
						name: "Xã Thạnh Lộc",
					},
					{
						name: "Xã Mỹ Thành Bắc",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Mỹ Thành Nam",
					},
					{
						name: "Xã Phú Nhuận",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Cẩm Sơn",
					},
					{
						name: "Xã Phú An",
					},
					{
						name: "Xã Mỹ Long",
					},
					{
						name: "Xã Long Tiên",
					},
					{
						name: "Xã Hiệp Đức",
					},
					{
						name: "Xã Long Trung",
					},
					{
						name: "Xã Hội Xuân",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Tam Bình",
					},
					{
						name: "Xã Ngũ Hiệp",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Tân Hiệp",
					},
					{
						name: "Xã Tân Hội Đông",
					},
					{
						name: "Xã Tân Hương",
					},
					{
						name: "Xã Tân Lý Đông",
					},
					{
						name: "Xã Tân Lý Tây",
					},
					{
						name: "Xã Thân Cửu Nghĩa",
					},
					{
						name: "Xã Tam Hiệp",
					},
					{
						name: "Xã Điềm Hy",
					},
					{
						name: "Xã Nhị Bình",
					},
					{
						name: "Xã Dưỡng Điềm",
					},
					{
						name: "Xã Đông Hòa",
					},
					{
						name: "Xã Long Định",
					},
					{
						name: "Xã Hữu Đạo",
					},
					{
						name: "Xã Long An",
					},
					{
						name: "Xã Long Hưng",
					},
					{
						name: "Xã Bình Trưng",
					},
					{
						name: "Xã Thạnh Phú",
					},
					{
						name: "Xã Bàn Long",
					},
					{
						name: "Xã Vĩnh Kim",
					},
					{
						name: "Xã Bình Đức",
					},
					{
						name: "Xã Song Thuận",
					},
					{
						name: "Xã Kim Sơn",
					},
					{
						name: "Xã Phú Phong",
					},
				],
			},
			{
				name: "Huyện Chợ Gạo",
				wards: [
					{
						name: "Thị trấn Chợ Gạo",
					},
					{
						name: "Xã Trung Hòa",
					},
					{
						name: "Xã Hòa Tịnh",
					},
					{
						name: "Xã Mỹ Tịnh An",
					},
					{
						name: "Xã Tân Bình Thạnh",
					},
					{
						name: "Xã Phú Kiết",
					},
					{
						name: "Xã Lương Hòa Lạc",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Xã Quơn Long",
					},
					{
						name: "Xã Bình Phục Nhứt",
					},
					{
						name: "Xã Đăng Hưng Phước",
					},
					{
						name: "Xã Tân Thuận Bình",
					},
					{
						name: "Xã Song Bình",
					},
					{
						name: "Xã Bình Phan",
					},
					{
						name: "Xã Long Bình Điền",
					},
					{
						name: "Xã An Thạnh Thủy",
					},
					{
						name: "Xã Xuân Đông",
					},
					{
						name: "Xã Hòa Định",
					},
					{
						name: "Xã Bình Ninh",
					},
				],
			},
			{
				name: "Huyện Gò Công Tây",
				wards: [
					{
						name: "Thị trấn Vĩnh Bình",
					},
					{
						name: "Xã Đồng Sơn",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Đồng Thạnh",
					},
					{
						name: "Xã Thành Công",
					},
					{
						name: "Xã Bình Nhì",
					},
					{
						name: "Xã Yên Luông",
					},
					{
						name: "Xã Thạnh Trị",
					},
					{
						name: "Xã Thạnh Nhựt",
					},
					{
						name: "Xã Long Vĩnh",
					},
					{
						name: "Xã Bình Tân",
					},
					{
						name: "Xã Vĩnh Hựu",
					},
					{
						name: "Xã Long Bình",
					},
				],
			},
			{
				name: "Huyện Gò Công Đông",
				wards: [
					{
						name: "Thị trấn Tân Hòa",
					},
					{
						name: "Xã Tăng Hoà",
					},
					{
						name: "Xã Tân Phước",
					},
					{
						name: "Xã Gia Thuận",
					},
					{
						name: "Thị trấn Vàm Láng",
					},
					{
						name: "Xã Tân Tây",
					},
					{
						name: "Xã Kiểng Phước",
					},
					{
						name: "Xã Tân Đông",
					},
					{
						name: "Xã Bình Ân",
					},
					{
						name: "Xã Tân Điền",
					},
					{
						name: "Xã Bình Nghị",
					},
					{
						name: "Xã Phước Trung",
					},
					{
						name: "Xã Tân Thành",
					},
				],
			},
			{
				name: "Huyện Tân Phú Đông",
				wards: [
					{
						name: "Xã Tân Thới",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Phú Thạnh",
					},
					{
						name: "Xã Tân Thạnh",
					},
					{
						name: "Xã Phú Đông",
					},
					{
						name: "Xã Phú Tân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bến Tre",
		districts: [
			{
				name: "Thành phố Bến Tre",
				wards: [
					{
						name: "Phường Phú Khương",
					},
					{
						name: "Phường Phú Tân",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường An Hội",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Xã Sơn Đông",
					},
					{
						name: "Xã Phú Hưng",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Mỹ Thạnh An",
					},
					{
						name: "Xã Nhơn Thạnh",
					},
					{
						name: "Xã Phú Nhuận",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Châu Thành",
					},
					{
						name: "Xã Tân Thạch",
					},
					{
						name: "Xã Qưới Sơn",
					},
					{
						name: "Xã An Khánh",
					},
					{
						name: "Xã Giao Long",
					},
					{
						name: "Xã Phú Túc",
					},
					{
						name: "Xã Phú Đức",
					},
					{
						name: "Xã Phú An Hòa",
					},
					{
						name: "Xã An Phước",
					},
					{
						name: "Xã Tam Phước",
					},
					{
						name: "Xã Thành Triệu",
					},
					{
						name: "Xã Tường Đa",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Quới Thành",
					},
					{
						name: "Xã Phước Thạnh",
					},
					{
						name: "Xã An Hóa",
					},
					{
						name: "Xã Tiên Long",
					},
					{
						name: "Xã An Hiệp",
					},
					{
						name: "Xã Hữu Định",
					},
					{
						name: "Xã Tiên Thủy",
					},
					{
						name: "Xã Sơn Hòa",
					},
				],
			},
			{
				name: "Huyện Chợ Lách",
				wards: [
					{
						name: "Thị trấn Chợ Lách",
					},
					{
						name: "Xã Phú Phụng",
					},
					{
						name: "Xã Sơn Định",
					},
					{
						name: "Xã Vĩnh Bình",
					},
					{
						name: "Xã Hòa Nghĩa",
					},
					{
						name: "Xã Long Thới",
					},
					{
						name: "Xã Phú Sơn",
					},
					{
						name: "Xã Tân Thiềng",
					},
					{
						name: "Xã Vĩnh Thành",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Hưng Khánh Trung B",
					},
				],
			},
			{
				name: "Huyện Mỏ Cày Nam",
				wards: [
					{
						name: "Thị trấn Mỏ Cày",
					},
					{
						name: "Xã Định Thủy",
					},
					{
						name: "Xã Đa Phước Hội",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Xã Phước Hiệp",
					},
					{
						name: "Xã Bình Khánh",
					},
					{
						name: "Xã An Thạnh",
					},
					{
						name: "Xã An Định",
					},
					{
						name: "Xã Thành Thới B",
					},
					{
						name: "Xã Tân Trung",
					},
					{
						name: "Xã An Thới",
					},
					{
						name: "Xã Thành Thới A",
					},
					{
						name: "Xã Minh Đức",
					},
					{
						name: "Xã Ngãi Đăng",
					},
					{
						name: "Xã Cẩm Sơn",
					},
					{
						name: "Xã Hương Mỹ",
					},
				],
			},
			{
				name: "Huyện Giồng Trôm",
				wards: [
					{
						name: "Thị trấn Giồng Trôm",
					},
					{
						name: "Xã Phong Nẫm",
					},
					{
						name: "Xã Mỹ Thạnh",
					},
					{
						name: "Xã Châu Hòa",
					},
					{
						name: "Xã Lương Hòa",
					},
					{
						name: "Xã Lương Quới",
					},
					{
						name: "Xã Lương Phú",
					},
					{
						name: "Xã Châu Bình",
					},
					{
						name: "Xã Thuận Điền",
					},
					{
						name: "Xã Sơn Phú",
					},
					{
						name: "Xã Bình Hoà",
					},
					{
						name: "Xã Phước Long",
					},
					{
						name: "Xã Hưng Phong",
					},
					{
						name: "Xã Long Mỹ",
					},
					{
						name: "Xã Tân Hào",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Tân Thanh",
					},
					{
						name: "Xã Tân Lợi Thạnh",
					},
					{
						name: "Xã Thạnh Phú Đông",
					},
					{
						name: "Xã Hưng Nhượng",
					},
					{
						name: "Xã Hưng Lễ",
					},
				],
			},
			{
				name: "Huyện Bình Đại",
				wards: [
					{
						name: "Thị trấn Bình Đại",
					},
					{
						name: "Xã Tam Hiệp",
					},
					{
						name: "Xã Long Định",
					},
					{
						name: "Xã Long Hòa",
					},
					{
						name: "Xã Phú Thuận",
					},
					{
						name: "Xã Vang Quới Tây",
					},
					{
						name: "Xã Vang Quới Đông",
					},
					{
						name: "Xã Châu Hưng",
					},
					{
						name: "Xã Phú Vang",
					},
					{
						name: "Xã Lộc Thuận",
					},
					{
						name: "Xã Định Trung",
					},
					{
						name: "Xã Thới Lai",
					},
					{
						name: "Xã Bình Thới",
					},
					{
						name: "Xã Phú Long",
					},
					{
						name: "Xã Bình Thắng",
					},
					{
						name: "Xã Thạnh Trị",
					},
					{
						name: "Xã Đại Hòa Lộc",
					},
					{
						name: "Xã Thừa Đức",
					},
					{
						name: "Xã Thạnh Phước",
					},
					{
						name: "Xã Thới Thuận",
					},
				],
			},
			{
				name: "Huyện Ba Tri",
				wards: [
					{
						name: "Thị trấn Ba Tri",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Mỹ Hòa",
					},
					{
						name: "Xã Tân Xuân",
					},
					{
						name: "Xã Mỹ Chánh",
					},
					{
						name: "Xã Bảo Thạnh",
					},
					{
						name: "Xã An Phú Trung",
					},
					{
						name: "Xã Mỹ Thạnh",
					},
					{
						name: "Xã Mỹ Nhơn",
					},
					{
						name: "Xã Phước Ngãi",
					},
					{
						name: "Xã An Ngãi Trung",
					},
					{
						name: "Xã Phú Lễ",
					},
					{
						name: "Xã An Bình Tây",
					},
					{
						name: "Xã Bảo Thuận",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã An Ngãi Tây",
					},
					{
						name: "Xã An Hiệp",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Tân Thủy",
					},
					{
						name: "Xã Vĩnh An",
					},
					{
						name: "Xã An Đức",
					},
					{
						name: "Xã An Hòa Tây",
					},
					{
						name: "Xã An Thủy",
					},
				],
			},
			{
				name: "Huyện Thạnh Phú",
				wards: [
					{
						name: "Thị trấn Thạnh Phú",
					},
					{
						name: "Xã Phú Khánh",
					},
					{
						name: "Xã Đại Điền",
					},
					{
						name: "Xã Quới Điền",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Mỹ Hưng",
					},
					{
						name: "Xã An Thạnh",
					},
					{
						name: "Xã Thới Thạnh",
					},
					{
						name: "Xã Hòa Lợi",
					},
					{
						name: "Xã An Điền",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Xã An Thuận",
					},
					{
						name: "Xã An Quy",
					},
					{
						name: "Xã Thạnh Hải",
					},
					{
						name: "Xã An Nhơn",
					},
					{
						name: "Xã Giao Thạnh",
					},
					{
						name: "Xã Thạnh Phong",
					},
					{
						name: "Xã Mỹ An",
					},
				],
			},
			{
				name: "Huyện Mỏ Cày Bắc",
				wards: [
					{
						name: "Xã Phú Mỹ",
					},
					{
						name: "Xã Hưng Khánh Trung A",
					},
					{
						name: "Xã Thanh Tân",
					},
					{
						name: "Xã Thạnh Ngãi",
					},
					{
						name: "Xã Tân Phú Tây",
					},
					{
						name: "Xã Phước Mỹ Trung",
					},
					{
						name: "Xã Tân Thành Bình",
					},
					{
						name: "Xã Thành An",
					},
					{
						name: "Xã Hòa Lộc",
					},
					{
						name: "Xã Tân Thanh Tây",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Nhuận Phú Tân",
					},
					{
						name: "Xã Khánh Thạnh Tân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Trà Vinh",
		districts: [
			{
				name: "Thành phố Trà Vinh",
				wards: [
					{
						name: "Phường 4",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Xã Long Đức",
					},
				],
			},
			{
				name: "Huyện Càng Long",
				wards: [
					{
						name: "Thị trấn Càng Long",
					},
					{
						name: "Xã Mỹ Cẩm",
					},
					{
						name: "Xã An Trường A",
					},
					{
						name: "Xã An Trường",
					},
					{
						name: "Xã Huyền Hội",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Phương Thạnh",
					},
					{
						name: "Xã Đại Phúc",
					},
					{
						name: "Xã Đại Phước",
					},
					{
						name: "Xã Nhị Long Phú",
					},
					{
						name: "Xã Nhị Long",
					},
					{
						name: "Xã Đức Mỹ",
					},
				],
			},
			{
				name: "Huyện Cầu Kè",
				wards: [
					{
						name: "Thị trấn Cầu Kè",
					},
					{
						name: "Xã Hòa Ân",
					},
					{
						name: "Xã Châu Điền",
					},
					{
						name: "Xã An Phú Tân",
					},
					{
						name: "Xã Hoà Tân",
					},
					{
						name: "Xã Ninh Thới",
					},
					{
						name: "Xã Phong Phú",
					},
					{
						name: "Xã Phong Thạnh",
					},
					{
						name: "Xã Tam Ngãi",
					},
					{
						name: "Xã Thông Hòa",
					},
					{
						name: "Xã Thạnh Phú",
					},
				],
			},
			{
				name: "Huyện Tiểu Cần",
				wards: [
					{
						name: "Thị trấn Tiểu Cần",
					},
					{
						name: "Thị trấn Cầu Quan",
					},
					{
						name: "Xã Phú Cần",
					},
					{
						name: "Xã Hiếu Tử",
					},
					{
						name: "Xã Hiếu Trung",
					},
					{
						name: "Xã Long Thới",
					},
					{
						name: "Xã Hùng Hòa",
					},
					{
						name: "Xã Tân Hùng",
					},
					{
						name: "Xã Tập Ngãi",
					},
					{
						name: "Xã Ngãi Hùng",
					},
					{
						name: "Xã Tân Hòa",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Châu Thành",
					},
					{
						name: "Xã Đa Lộc",
					},
					{
						name: "Xã Mỹ Chánh",
					},
					{
						name: "Xã Thanh Mỹ",
					},
					{
						name: "Xã Lương Hoà A",
					},
					{
						name: "Xã Lương Hòa",
					},
					{
						name: "Xã Song Lộc",
					},
					{
						name: "Xã Nguyệt Hóa",
					},
					{
						name: "Xã Hòa Thuận",
					},
					{
						name: "Xã Hòa Lợi",
					},
					{
						name: "Xã Phước Hảo",
					},
					{
						name: "Xã Hưng Mỹ",
					},
					{
						name: "Xã Hòa Minh",
					},
					{
						name: "Xã Long Hòa",
					},
				],
			},
			{
				name: "Huyện Cầu Ngang",
				wards: [
					{
						name: "Thị trấn Cầu Ngang",
					},
					{
						name: "Thị trấn Mỹ Long",
					},
					{
						name: "Xã Mỹ Long Bắc",
					},
					{
						name: "Xã Mỹ Long Nam",
					},
					{
						name: "Xã Mỹ Hòa",
					},
					{
						name: "Xã Vĩnh Kim",
					},
					{
						name: "Xã Kim Hòa",
					},
					{
						name: "Xã Hiệp Hòa",
					},
					{
						name: "Xã Thuận Hòa",
					},
					{
						name: "Xã Long Sơn",
					},
					{
						name: "Xã Nhị Trường",
					},
					{
						name: "Xã Trường Thọ",
					},
					{
						name: "Xã Hiệp Mỹ Đông",
					},
					{
						name: "Xã Hiệp Mỹ Tây",
					},
					{
						name: "Xã Thạnh Hòa Sơn",
					},
				],
			},
			{
				name: "Huyện Trà Cú",
				wards: [
					{
						name: "Thị trấn Trà Cú",
					},
					{
						name: "Thị trấn Định An",
					},
					{
						name: "Xã Phước Hưng",
					},
					{
						name: "Xã Tập Sơn",
					},
					{
						name: "Xã Tân Sơn",
					},
					{
						name: "Xã An Quảng Hữu",
					},
					{
						name: "Xã Lưu Nghiệp Anh",
					},
					{
						name: "Xã Ngãi Xuyên",
					},
					{
						name: "Xã Kim Sơn",
					},
					{
						name: "Xã Thanh Sơn",
					},
					{
						name: "Xã Hàm Giang",
					},
					{
						name: "Xã Hàm Tân",
					},
					{
						name: "Xã Đại An",
					},
					{
						name: "Xã Định An",
					},
					{
						name: "Xã Ngọc Biên",
					},
					{
						name: "Xã Long Hiệp",
					},
					{
						name: "Xã Tân Hiệp",
					},
				],
			},
			{
				name: "Huyện Duyên Hải",
				wards: [
					{
						name: "Xã Đôn Xuân",
					},
					{
						name: "Xã Đôn Châu",
					},
					{
						name: "Thị trấn Long Thành",
					},
					{
						name: "Xã Long Khánh",
					},
					{
						name: "Xã Ngũ Lạc",
					},
					{
						name: "Xã Long Vĩnh",
					},
					{
						name: "Xã Đông Hải",
					},
				],
			},
			{
				name: "Thị xã Duyên Hải",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Xã Long Toàn",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Xã Long Hữu",
					},
					{
						name: "Xã Dân Thành",
					},
					{
						name: "Xã Trường Long Hòa",
					},
					{
						name: "Xã Hiệp Thạnh",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Vĩnh Long",
		districts: [
			{
				name: "Thành phố Vĩnh Long",
				wards: [
					{
						name: "Phường 9",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường Tân Ngãi",
					},
					{
						name: "Phường Tân Hòa",
					},
					{
						name: "Phường Tân Hội",
					},
					{
						name: "Phường Trường An",
					},
				],
			},
			{
				name: "Huyện Long Hồ",
				wards: [
					{
						name: "Thị trấn Long Hồ",
					},
					{
						name: "Xã Đồng Phú",
					},
					{
						name: "Xã Bình Hòa Phước",
					},
					{
						name: "Xã Hòa Ninh",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Thanh Đức",
					},
					{
						name: "Xã Tân Hạnh",
					},
					{
						name: "Xã Phước Hậu",
					},
					{
						name: "Xã Long Phước",
					},
					{
						name: "Xã Phú Đức",
					},
					{
						name: "Xã Lộc Hòa",
					},
					{
						name: "Xã Long An",
					},
					{
						name: "Xã Phú Quới",
					},
					{
						name: "Xã Thạnh Quới",
					},
					{
						name: "Xã Hòa Phú",
					},
				],
			},
			{
				name: "Huyện Mang Thít",
				wards: [
					{
						name: "Xã Mỹ An",
					},
					{
						name: "Xã Mỹ Phước",
					},
					{
						name: "Xã An Phước",
					},
					{
						name: "Xã Nhơn Phú",
					},
					{
						name: "Xã Long Mỹ",
					},
					{
						name: "Xã Hòa Tịnh",
					},
					{
						name: "Thị trấn Cái Nhum",
					},
					{
						name: "Xã Bình Phước",
					},
					{
						name: "Xã Chánh An",
					},
					{
						name: "Xã Tân An Hội",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Tân Long Hội",
					},
				],
			},
			{
				name: "Huyện Vũng Liêm",
				wards: [
					{
						name: "Thị trấn Vũng Liêm",
					},
					{
						name: "Xã Tân Quới Trung",
					},
					{
						name: "Xã Quới Thiện",
					},
					{
						name: "Xã Quới An",
					},
					{
						name: "Xã Trung Chánh",
					},
					{
						name: "Xã Tân An Luông",
					},
					{
						name: "Xã Thanh Bình",
					},
					{
						name: "Xã Trung Thành Tây",
					},
					{
						name: "Xã Trung Hiệp",
					},
					{
						name: "Xã Hiếu Phụng",
					},
					{
						name: "Xã Trung Thành Đông",
					},
					{
						name: "Xã Trung Thành",
					},
					{
						name: "Xã Trung Hiếu",
					},
					{
						name: "Xã Trung Ngãi",
					},
					{
						name: "Xã Hiếu Thuận",
					},
					{
						name: "Xã Trung Nghĩa",
					},
					{
						name: "Xã Trung An",
					},
					{
						name: "Xã Hiếu Nhơn",
					},
					{
						name: "Xã Hiếu Thành",
					},
					{
						name: "Xã Hiếu Nghĩa",
					},
				],
			},
			{
				name: "Huyện Tam Bình",
				wards: [
					{
						name: "Thị trấn Tam Bình",
					},
					{
						name: "Xã Tân Lộc",
					},
					{
						name: "Xã Phú Thịnh",
					},
					{
						name: "Xã Hậu Lộc",
					},
					{
						name: "Xã Hòa Thạnh",
					},
					{
						name: "Xã Hoà Lộc",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Song Phú",
					},
					{
						name: "Xã Hòa Hiệp",
					},
					{
						name: "Xã Mỹ Lộc",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Long Phú",
					},
					{
						name: "Xã Mỹ Thạnh Trung",
					},
					{
						name: "Xã Tường Lộc",
					},
					{
						name: "Xã Loan Mỹ",
					},
					{
						name: "Xã Ngãi Tứ",
					},
					{
						name: "Xã Bình Ninh",
					},
				],
			},
			{
				name: "Thị xã Bình Minh",
				wards: [
					{
						name: "Phường Cái Vồn",
					},
					{
						name: "Phường Thành Phước",
					},
					{
						name: "Xã Thuận An",
					},
					{
						name: "Xã Đông Thạnh",
					},
					{
						name: "Xã Đông Bình",
					},
					{
						name: "Phường Đông Thuận",
					},
					{
						name: "Xã Mỹ Hòa",
					},
					{
						name: "Xã Đông Thành",
					},
				],
			},
			{
				name: "Huyện Trà Ôn",
				wards: [
					{
						name: "Thị trấn Trà Ôn",
					},
					{
						name: "Xã Xuân Hiệp",
					},
					{
						name: "Xã Nhơn Bình",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Thới Hòa",
					},
					{
						name: "Xã Trà Côn",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Hựu Thành",
					},
					{
						name: "Xã Vĩnh Xuân",
					},
					{
						name: "Xã Thuận Thới",
					},
					{
						name: "Xã Phú Thành",
					},
					{
						name: "Xã Thiện Mỹ",
					},
					{
						name: "Xã Lục Sỹ Thành",
					},
					{
						name: "Xã Tích Thiện",
					},
				],
			},
			{
				name: "Huyện Bình Tân",
				wards: [
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Thành Trung",
					},
					{
						name: "Xã Tân An Thạnh",
					},
					{
						name: "Xã Tân Lược",
					},
					{
						name: "Xã Nguyễn Văn Thảnh",
					},
					{
						name: "Xã Thành Lợi",
					},
					{
						name: "Xã Mỹ Thuận",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Thị trấn Tân Quới",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Đồng Tháp",
		districts: [
			{
				name: "Thành phố Cao Lãnh",
				wards: [
					{
						name: "Phường 11",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Xã Mỹ Ngãi",
					},
					{
						name: "Xã Mỹ Tân",
					},
					{
						name: "Xã Mỹ Trà",
					},
					{
						name: "Phường Mỹ Phú",
					},
					{
						name: "Xã Tân Thuận Tây",
					},
					{
						name: "Phường Hoà Thuận",
					},
					{
						name: "Xã Hòa An",
					},
					{
						name: "Xã Tân Thuận Đông",
					},
					{
						name: "Xã Tịnh Thới",
					},
				],
			},
			{
				name: "Thành phố Sa Đéc",
				wards: [
					{
						name: "Phường 3",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Xã Tân Khánh Đông",
					},
					{
						name: "Phường Tân Quy Đông",
					},
					{
						name: "Phường An Hoà",
					},
					{
						name: "Xã Tân Quy Tây",
					},
					{
						name: "Xã Tân Phú Đông",
					},
				],
			},
			{
				name: "Thành phố Hồng Ngự",
				wards: [
					{
						name: "Phường An Lộc",
					},
					{
						name: "Phường An Thạnh",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Phường An Lạc",
					},
					{
						name: "Phường An Bình B",
					},
					{
						name: "Phường An Bình A",
					},
				],
			},
			{
				name: "Huyện Tân Hồng",
				wards: [
					{
						name: "Thị trấn Sa Rài",
					},
					{
						name: "Xã Tân Hộ Cơ",
					},
					{
						name: "Xã Thông Bình",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Tân Thành A",
					},
					{
						name: "Xã Tân Thành B",
					},
					{
						name: "Xã Tân Phước",
					},
					{
						name: "Xã Tân Công Chí",
					},
					{
						name: "Xã An Phước",
					},
				],
			},
			{
				name: "Huyện Hồng Ngự",
				wards: [
					{
						name: "Xã Thường Phước 1",
					},
					{
						name: "Xã Thường Thới Hậu A",
					},
					{
						name: "Thị trấn Thường Thới Tiền",
					},
					{
						name: "Xã Thường Phước 2",
					},
					{
						name: "Xã Thường Lạc",
					},
					{
						name: "Xã Long Khánh A",
					},
					{
						name: "Xã Long Khánh B",
					},
					{
						name: "Xã Long Thuận",
					},
					{
						name: "Xã Phú Thuận B",
					},
					{
						name: "Xã Phú Thuận A",
					},
				],
			},
			{
				name: "Huyện Tam Nông",
				wards: [
					{
						name: "Thị trấn Tràm Chim",
					},
					{
						name: "Xã Hoà Bình",
					},
					{
						name: "Xã Tân Công Sính",
					},
					{
						name: "Xã Phú Hiệp",
					},
					{
						name: "Xã Phú Đức",
					},
					{
						name: "Xã Phú Thành B",
					},
					{
						name: "Xã An Hòa",
					},
					{
						name: "Xã An Long",
					},
					{
						name: "Xã Phú Cường",
					},
					{
						name: "Xã Phú Ninh",
					},
					{
						name: "Xã Phú Thọ",
					},
					{
						name: "Xã Phú Thành A",
					},
				],
			},
			{
				name: "Huyện Tháp Mười",
				wards: [
					{
						name: "Thị trấn Mỹ An",
					},
					{
						name: "Xã Thạnh Lợi",
					},
					{
						name: "Xã Hưng Thạnh",
					},
					{
						name: "Xã Trường Xuân",
					},
					{
						name: "Xã Tân Kiều",
					},
					{
						name: "Xã Mỹ Hòa",
					},
					{
						name: "Xã Mỹ Quý",
					},
					{
						name: "Xã Mỹ Đông",
					},
					{
						name: "Xã Đốc Binh Kiều",
					},
					{
						name: "Xã Mỹ An",
					},
					{
						name: "Xã Phú Điền",
					},
					{
						name: "Xã Láng Biển",
					},
					{
						name: "Xã Thanh Mỹ",
					},
				],
			},
			{
				name: "Huyện Cao Lãnh",
				wards: [
					{
						name: "Thị trấn Mỹ Thọ",
					},
					{
						name: "Xã Gáo Giồng",
					},
					{
						name: "Xã Phương Thịnh",
					},
					{
						name: "Xã Ba Sao",
					},
					{
						name: "Xã Phong Mỹ",
					},
					{
						name: "Xã Tân Nghĩa",
					},
					{
						name: "Xã Phương Trà",
					},
					{
						name: "Xã Nhị Mỹ",
					},
					{
						name: "Xã Mỹ Thọ",
					},
					{
						name: "Xã Tân Hội Trung",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Mỹ Hội",
					},
					{
						name: "Xã Mỹ Hiệp",
					},
					{
						name: "Xã Mỹ Long",
					},
					{
						name: "Xã Bình Hàng Trung",
					},
					{
						name: "Xã Mỹ Xương",
					},
					{
						name: "Xã Bình Hàng Tây",
					},
					{
						name: "Xã Bình Thạnh",
					},
				],
			},
			{
				name: "Huyện Thanh Bình",
				wards: [
					{
						name: "Thị trấn Thanh Bình",
					},
					{
						name: "Xã Tân Quới",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã An Phong",
					},
					{
						name: "Xã Phú Lợi",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Bình Tấn",
					},
					{
						name: "Xã Tân Huề",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Tân Thạnh",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Tân Long",
					},
				],
			},
			{
				name: "Huyện Lấp Vò",
				wards: [
					{
						name: "Thị trấn Lấp Vò",
					},
					{
						name: "Xã Mỹ An Hưng A",
					},
					{
						name: "Xã Tân Mỹ",
					},
					{
						name: "Xã Mỹ An Hưng B",
					},
					{
						name: "Xã Tân Khánh Trung",
					},
					{
						name: "Xã Long Hưng A",
					},
					{
						name: "Xã Vĩnh Thạnh",
					},
					{
						name: "Xã Long Hưng B",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Định An",
					},
					{
						name: "Xã Định Yên",
					},
					{
						name: "Xã Hội An Đông",
					},
					{
						name: "Xã Bình Thạnh Trung",
					},
				],
			},
			{
				name: "Huyện Lai Vung",
				wards: [
					{
						name: "Thị trấn Lai Vung",
					},
					{
						name: "Xã Tân Dương",
					},
					{
						name: "Xã Hòa Thành",
					},
					{
						name: "Xã Long Hậu",
					},
					{
						name: "Xã Tân Phước",
					},
					{
						name: "Xã Hòa Long",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Long Thắng",
					},
					{
						name: "Xã Vĩnh Thới",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Định Hòa",
					},
					{
						name: "Xã Phong Hòa",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Cái Tàu Hạ",
					},
					{
						name: "Xã An Hiệp",
					},
					{
						name: "Xã An Nhơn",
					},
					{
						name: "Xã Tân Nhuận Đông",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Tân Phú Trung",
					},
					{
						name: "Xã Phú Long",
					},
					{
						name: "Xã An Phú Thuận",
					},
					{
						name: "Xã Phú Hựu",
					},
					{
						name: "Xã An Khánh",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Hòa Tân",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh An Giang",
		districts: [
			{
				name: "Thành phố Long Xuyên",
				wards: [
					{
						name: "Phường Mỹ Bình",
					},
					{
						name: "Phường Mỹ Long",
					},
					{
						name: "Phường Đông Xuyên",
					},
					{
						name: "Phường Mỹ Xuyên",
					},
					{
						name: "Phường Bình Đức",
					},
					{
						name: "Phường Bình Khánh",
					},
					{
						name: "Phường Mỹ Phước",
					},
					{
						name: "Phường Mỹ Quý",
					},
					{
						name: "Phường Mỹ Thới",
					},
					{
						name: "Phường Mỹ Thạnh",
					},
					{
						name: "Phường Mỹ Hòa",
					},
					{
						name: "Xã Mỹ Khánh",
					},
					{
						name: "Xã Mỹ Hoà Hưng",
					},
				],
			},
			{
				name: "Thành phố Châu Đốc",
				wards: [
					{
						name: "Phường Châu Phú B",
					},
					{
						name: "Phường Châu Phú A",
					},
					{
						name: "Phường Vĩnh Mỹ",
					},
					{
						name: "Phường Núi Sam",
					},
					{
						name: "Phường Vĩnh Ngươn",
					},
					{
						name: "Xã Vĩnh Tế",
					},
					{
						name: "Xã Vĩnh Châu",
					},
				],
			},
			{
				name: "Huyện An Phú",
				wards: [
					{
						name: "Thị trấn An Phú",
					},
					{
						name: "Xã Khánh An",
					},
					{
						name: "Thị Trấn Long Bình",
					},
					{
						name: "Xã Khánh Bình",
					},
					{
						name: "Xã Quốc Thái",
					},
					{
						name: "Xã Nhơn Hội",
					},
					{
						name: "Xã Phú Hữu",
					},
					{
						name: "Xã Phú Hội",
					},
					{
						name: "Xã Phước Hưng",
					},
					{
						name: "Xã Vĩnh Lộc",
					},
					{
						name: "Xã Vĩnh Hậu",
					},
					{
						name: "Xã Vĩnh Trường",
					},
					{
						name: "Xã Vĩnh Hội Đông",
					},
					{
						name: "Xã Đa Phước",
					},
				],
			},
			{
				name: "Thị xã Tân Châu",
				wards: [
					{
						name: "Phường Long Thạnh",
					},
					{
						name: "Phường Long Hưng",
					},
					{
						name: "Phường Long Châu",
					},
					{
						name: "Xã Phú Lộc",
					},
					{
						name: "Xã Vĩnh Xương",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Tân Thạnh",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Long An",
					},
					{
						name: "Phường Long Phú",
					},
					{
						name: "Xã Châu Phong",
					},
					{
						name: "Xã Phú Vĩnh",
					},
					{
						name: "Xã Lê Chánh",
					},
					{
						name: "Phường Long Sơn",
					},
				],
			},
			{
				name: "Huyện Phú Tân",
				wards: [
					{
						name: "Thị trấn Phú Mỹ",
					},
					{
						name: "Thị trấn Chợ Vàm",
					},
					{
						name: "Xã Long Hoà",
					},
					{
						name: "Xã Phú Long",
					},
					{
						name: "Xã Phú Lâm",
					},
					{
						name: "Xã Phú Hiệp",
					},
					{
						name: "Xã Phú Thạnh",
					},
					{
						name: "Xã Hoà Lạc",
					},
					{
						name: "Xã Phú Thành",
					},
					{
						name: "Xã Phú An",
					},
					{
						name: "Xã Phú Xuân",
					},
					{
						name: "Xã Hiệp Xương",
					},
					{
						name: "Xã Phú Bình",
					},
					{
						name: "Xã Phú Thọ",
					},
					{
						name: "Xã Phú Hưng",
					},
					{
						name: "Xã Bình Thạnh Đông",
					},
					{
						name: "Xã Tân Hòa",
					},
					{
						name: "Xã Tân Trung",
					},
				],
			},
			{
				name: "Huyện Châu Phú",
				wards: [
					{
						name: "Thị trấn Cái Dầu",
					},
					{
						name: "Xã Khánh Hòa",
					},
					{
						name: "Xã Mỹ Đức",
					},
					{
						name: "Xã Mỹ Phú",
					},
					{
						name: "Xã Ô Long Vỹ",
					},
					{
						name: "Thị trấn Vĩnh Thạnh Trung",
					},
					{
						name: "Xã Thạnh Mỹ Tây",
					},
					{
						name: "Xã Bình Long",
					},
					{
						name: "Xã Bình Mỹ",
					},
					{
						name: "Xã Bình Thủy",
					},
					{
						name: "Xã Đào Hữu Cảnh",
					},
					{
						name: "Xã Bình Phú",
					},
					{
						name: "Xã Bình Chánh",
					},
				],
			},
			{
				name: "Huyện Tịnh Biên",
				wards: [
					{
						name: "Thị trấn Nhà Bàng",
					},
					{
						name: "Thị trấn Chi Lăng",
					},
					{
						name: "Xã Núi Voi",
					},
					{
						name: "Xã Nhơn Hưng",
					},
					{
						name: "Xã An Phú",
					},
					{
						name: "Xã Thới Sơn",
					},
					{
						name: "Thị trấn Tịnh Biên",
					},
					{
						name: "Xã Văn Giáo",
					},
					{
						name: "Xã An Cư",
					},
					{
						name: "Xã An Nông",
					},
					{
						name: "Xã Vĩnh Trung",
					},
					{
						name: "Xã Tân Lợi",
					},
					{
						name: "Xã An Hảo",
					},
					{
						name: "Xã Tân Lập",
					},
				],
			},
			{
				name: "Huyện Tri Tôn",
				wards: [
					{
						name: "Thị trấn Tri Tôn",
					},
					{
						name: "Thị trấn Ba Chúc",
					},
					{
						name: "Xã Lạc Quới",
					},
					{
						name: "Xã Lê Trì",
					},
					{
						name: "Xã Vĩnh Gia",
					},
					{
						name: "Xã Vĩnh Phước",
					},
					{
						name: "Xã Châu Lăng",
					},
					{
						name: "Xã Lương Phi",
					},
					{
						name: "Xã Lương An Trà",
					},
					{
						name: "Xã Tà Đảnh",
					},
					{
						name: "Xã Núi Tô",
					},
					{
						name: "Xã An Tức",
					},
					{
						name: "Thị trấn Cô Tô",
					},
					{
						name: "Xã Tân Tuyến",
					},
					{
						name: "Xã Ô Lâm",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn An Châu",
					},
					{
						name: "Xã An Hòa",
					},
					{
						name: "Xã Cần Đăng",
					},
					{
						name: "Xã Vĩnh Hanh",
					},
					{
						name: "Xã Bình Thạnh",
					},
					{
						name: "Thị trấn Vĩnh Bình",
					},
					{
						name: "Xã Bình Hòa",
					},
					{
						name: "Xã Vĩnh An",
					},
					{
						name: "Xã Hòa Bình Thạnh",
					},
					{
						name: "Xã Vĩnh Lợi",
					},
					{
						name: "Xã Vĩnh Nhuận",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Vĩnh Thành",
					},
				],
			},
			{
				name: "Huyện Chợ Mới",
				wards: [
					{
						name: "Thị trấn Chợ Mới",
					},
					{
						name: "Thị trấn Mỹ Luông",
					},
					{
						name: "Xã Kiến An",
					},
					{
						name: "Xã Mỹ Hội Đông",
					},
					{
						name: "Xã Long Điền A",
					},
					{
						name: "Xã Tấn Mỹ",
					},
					{
						name: "Xã Long Điền B",
					},
					{
						name: "Xã Kiến Thành",
					},
					{
						name: "Xã Mỹ Hiệp",
					},
					{
						name: "Xã Mỹ An",
					},
					{
						name: "Xã Nhơn Mỹ",
					},
					{
						name: "Xã Long Giang",
					},
					{
						name: "Xã Long Kiến",
					},
					{
						name: "Xã Bình Phước Xuân",
					},
					{
						name: "Xã An Thạnh Trung",
					},
					{
						name: "Xã Hội An",
					},
					{
						name: "Xã Hòa Bình",
					},
					{
						name: "Xã Hòa An",
					},
				],
			},
			{
				name: "Huyện Thoại Sơn",
				wards: [
					{
						name: "Thị trấn Núi Sập",
					},
					{
						name: "Thị trấn Phú Hoà",
					},
					{
						name: "Thị Trấn Óc Eo",
					},
					{
						name: "Xã Tây Phú",
					},
					{
						name: "Xã An Bình",
					},
					{
						name: "Xã Vĩnh Phú",
					},
					{
						name: "Xã Vĩnh Trạch",
					},
					{
						name: "Xã Phú Thuận",
					},
					{
						name: "Xã Vĩnh Chánh",
					},
					{
						name: "Xã Định Mỹ",
					},
					{
						name: "Xã Định Thành",
					},
					{
						name: "Xã Mỹ Phú Đông",
					},
					{
						name: "Xã Vọng Đông",
					},
					{
						name: "Xã Vĩnh Khánh",
					},
					{
						name: "Xã Thoại Giang",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Vọng Thê",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Kiên Giang",
		districts: [
			{
				name: "Thành phố Rạch Giá",
				wards: [
					{
						name: "Phường Vĩnh Thanh Vân",
					},
					{
						name: "Phường Vĩnh Thanh",
					},
					{
						name: "Phường Vĩnh Quang",
					},
					{
						name: "Phường Vĩnh Hiệp",
					},
					{
						name: "Phường Vĩnh Bảo",
					},
					{
						name: "Phường Vĩnh Lạc",
					},
					{
						name: "Phường An Hòa",
					},
					{
						name: "Phường An Bình",
					},
					{
						name: "Phường Rạch Sỏi",
					},
					{
						name: "Phường Vĩnh Lợi",
					},
					{
						name: "Phường Vĩnh Thông",
					},
					{
						name: "Xã Phi Thông",
					},
				],
			},
			{
				name: "Thành phố Hà Tiên",
				wards: [
					{
						name: "Phường Tô Châu",
					},
					{
						name: "Phường Đông Hồ",
					},
					{
						name: "Phường Bình San",
					},
					{
						name: "Phường Pháo Đài",
					},
					{
						name: "Phường Mỹ Đức",
					},
					{
						name: "Xã Tiên Hải",
					},
					{
						name: "Xã Thuận Yên",
					},
				],
			},
			{
				name: "Huyện Kiên Lương",
				wards: [
					{
						name: "Thị trấn Kiên Lương",
					},
					{
						name: "Xã Kiên Bình",
					},
					{
						name: "Xã Hòa Điền",
					},
					{
						name: "Xã Dương Hòa",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Bình Trị",
					},
					{
						name: "Xã Sơn Hải",
					},
					{
						name: "Xã Hòn Nghệ",
					},
				],
			},
			{
				name: "Huyện Hòn Đất",
				wards: [
					{
						name: "Thị trấn Hòn Đất",
					},
					{
						name: "Thị trấn Sóc Sơn",
					},
					{
						name: "Xã Bình Sơn",
					},
					{
						name: "Xã Bình Giang",
					},
					{
						name: "Xã Mỹ Thái",
					},
					{
						name: "Xã Nam Thái Sơn",
					},
					{
						name: "Xã Mỹ Hiệp Sơn",
					},
					{
						name: "Xã Sơn Kiên",
					},
					{
						name: "Xã Sơn Bình",
					},
					{
						name: "Xã Mỹ Thuận",
					},
					{
						name: "Xã Lình Huỳnh",
					},
					{
						name: "Xã Thổ Sơn",
					},
					{
						name: "Xã Mỹ Lâm",
					},
					{
						name: "Xã Mỹ Phước",
					},
				],
			},
			{
				name: "Huyện Tân Hiệp",
				wards: [
					{
						name: "Thị trấn Tân Hiệp",
					},
					{
						name: "Xã Tân Hội",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Tân Hiệp B",
					},
					{
						name: "Xã Tân Hoà",
					},
					{
						name: "Xã Thạnh Đông B",
					},
					{
						name: "Xã Thạnh Đông",
					},
					{
						name: "Xã Tân Hiệp A",
					},
					{
						name: "Xã Tân An",
					},
					{
						name: "Xã Thạnh Đông A",
					},
					{
						name: "Xã Thạnh Trị",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Minh Lương",
					},
					{
						name: "Xã Mong Thọ A",
					},
					{
						name: "Xã Mong Thọ B",
					},
					{
						name: "Xã Mong Thọ",
					},
					{
						name: "Xã Giục Tượng",
					},
					{
						name: "Xã Vĩnh Hòa Hiệp",
					},
					{
						name: "Xã Vĩnh Hoà Phú",
					},
					{
						name: "Xã Minh Hòa",
					},
					{
						name: "Xã Bình An",
					},
					{
						name: "Xã Thạnh Lộc",
					},
				],
			},
			{
				name: "Huyện Giồng Riềng",
				wards: [
					{
						name: "Thị Trấn Giồng Riềng",
					},
					{
						name: "Xã Thạnh Hưng",
					},
					{
						name: "Xã Thạnh Phước",
					},
					{
						name: "Xã Thạnh Lộc",
					},
					{
						name: "Xã Thạnh Hòa",
					},
					{
						name: "Xã Thạnh Bình",
					},
					{
						name: "Xã Bàn Thạch",
					},
					{
						name: "Xã Bàn Tân Định",
					},
					{
						name: "Xã Ngọc Thành",
					},
					{
						name: "Xã Ngọc Chúc",
					},
					{
						name: "Xã Ngọc Thuận",
					},
					{
						name: "Xã Hòa Hưng",
					},
					{
						name: "Xã Hoà Lợi",
					},
					{
						name: "Xã Hoà An",
					},
					{
						name: "Xã Long Thạnh",
					},
					{
						name: "Xã Vĩnh Thạnh",
					},
					{
						name: "Xã Vĩnh Phú",
					},
					{
						name: "Xã Hòa Thuận",
					},
					{
						name: "Xã Ngọc Hoà",
					},
				],
			},
			{
				name: "Huyện Gò Quao",
				wards: [
					{
						name: "Thị trấn Gò Quao",
					},
					{
						name: "Xã Vĩnh Hòa Hưng Bắc",
					},
					{
						name: "Xã Định Hòa",
					},
					{
						name: "Xã Thới Quản",
					},
					{
						name: "Xã Định An",
					},
					{
						name: "Xã Thủy Liễu",
					},
					{
						name: "Xã Vĩnh Hòa Hưng Nam",
					},
					{
						name: "Xã Vĩnh Phước A",
					},
					{
						name: "Xã Vĩnh Phước B",
					},
					{
						name: "Xã Vĩnh Tuy",
					},
					{
						name: "Xã Vĩnh Thắng",
					},
				],
			},
			{
				name: "Huyện An Biên",
				wards: [
					{
						name: "Thị trấn Thứ Ba",
					},
					{
						name: "Xã Tây Yên",
					},
					{
						name: "Xã Tây Yên A",
					},
					{
						name: "Xã Nam Yên",
					},
					{
						name: "Xã Hưng Yên",
					},
					{
						name: "Xã Nam Thái",
					},
					{
						name: "Xã Nam Thái A",
					},
					{
						name: "Xã Đông Thái",
					},
					{
						name: "Xã Đông Yên",
					},
				],
			},
			{
				name: "Huyện An Minh",
				wards: [
					{
						name: "Thị trấn Thứ Mười Một",
					},
					{
						name: "Xã Thuận Hoà",
					},
					{
						name: "Xã Đông Hòa",
					},
					{
						name: "Xã Đông Thạnh",
					},
					{
						name: "Xã Tân Thạnh",
					},
					{
						name: "Xã Đông Hưng",
					},
					{
						name: "Xã Đông Hưng A",
					},
					{
						name: "Xã Đông Hưng B",
					},
					{
						name: "Xã Vân Khánh",
					},
					{
						name: "Xã Vân Khánh Đông",
					},
					{
						name: "Xã Vân Khánh Tây",
					},
				],
			},
			{
				name: "Huyện Vĩnh Thuận",
				wards: [
					{
						name: "Thị trấn Vĩnh Thuận",
					},
					{
						name: "Xã Vĩnh Bình Bắc",
					},
					{
						name: "Xã Vĩnh Bình Nam",
					},
					{
						name: "Xã Bình Minh",
					},
					{
						name: "Xã Vĩnh Thuận",
					},
					{
						name: "Xã Tân Thuận",
					},
					{
						name: "Xã Phong Đông",
					},
					{
						name: "Xã Vĩnh Phong",
					},
				],
			},
			{
				name: "Thành phố Phú Quốc",
				wards: [
					{
						name: "Phường Dương Đông",
					},
					{
						name: "Phường An Thới",
					},
					{
						name: "Xã Cửa Cạn",
					},
					{
						name: "Xã Gành Dầu",
					},
					{
						name: "Xã Cửa Dương",
					},
					{
						name: "Xã Hàm Ninh",
					},
					{
						name: "Xã Dương Tơ",
					},
					{
						name: "Xã Bãi Thơm",
					},
					{
						name: "Xã Thổ Châu",
					},
				],
			},
			{
				name: "Huyện Kiên Hải",
				wards: [
					{
						name: "Xã Hòn Tre",
					},
					{
						name: "Xã Lại Sơn",
					},
					{
						name: "Xã An Sơn",
					},
					{
						name: "Xã Nam Du",
					},
				],
			},
			{
				name: "Huyện U Minh Thượng",
				wards: [
					{
						name: "Xã Thạnh Yên",
					},
					{
						name: "Xã Thạnh Yên A",
					},
					{
						name: "Xã An Minh Bắc",
					},
					{
						name: "Xã Vĩnh Hòa",
					},
					{
						name: "Xã Hoà Chánh",
					},
					{
						name: "Xã Minh Thuận",
					},
				],
			},
			{
				name: "Huyện Giang Thành",
				wards: [
					{
						name: "Xã Vĩnh Phú",
					},
					{
						name: "Xã Vĩnh Điều",
					},
					{
						name: "Xã Tân Khánh Hòa",
					},
					{
						name: "Xã Phú Lợi",
					},
					{
						name: "Xã Phú Mỹ",
					},
				],
			},
		],
	},
	{
		name: "Thành phố Cần Thơ",
		districts: [
			{
				name: "Quận Ninh Kiều",
				wards: [
					{
						name: "Phường Cái Khế",
					},
					{
						name: "Phường An Hòa",
					},
					{
						name: "Phường Thới Bình",
					},
					{
						name: "Phường An Nghiệp",
					},
					{
						name: "Phường An Cư",
					},
					{
						name: "Phường Tân An",
					},
					{
						name: "Phường An Phú",
					},
					{
						name: "Phường Xuân Khánh",
					},
					{
						name: "Phường Hưng Lợi",
					},
					{
						name: "Phường An Khánh",
					},
					{
						name: "Phường An Bình",
					},
				],
			},
			{
				name: "Quận Ô Môn",
				wards: [
					{
						name: "Phường Châu Văn Liêm",
					},
					{
						name: "Phường Thới Hòa",
					},
					{
						name: "Phường Thới Long",
					},
					{
						name: "Phường Long Hưng",
					},
					{
						name: "Phường Thới An",
					},
					{
						name: "Phường Phước Thới",
					},
					{
						name: "Phường Trường Lạc",
					},
				],
			},
			{
				name: "Quận Bình Thuỷ",
				wards: [
					{
						name: "Phường Bình Thủy",
					},
					{
						name: "Phường Trà An",
					},
					{
						name: "Phường Trà Nóc",
					},
					{
						name: "Phường Thới An Đông",
					},
					{
						name: "Phường An Thới",
					},
					{
						name: "Phường Bùi Hữu Nghĩa",
					},
					{
						name: "Phường Long Hòa",
					},
					{
						name: "Phường Long Tuyền",
					},
				],
			},
			{
				name: "Quận Cái Răng",
				wards: [
					{
						name: "Phường Lê Bình",
					},
					{
						name: "Phường Hưng Phú",
					},
					{
						name: "Phường Hưng Thạnh",
					},
					{
						name: "Phường Ba Láng",
					},
					{
						name: "Phường Thường Thạnh",
					},
					{
						name: "Phường Phú Thứ",
					},
					{
						name: "Phường Tân Phú",
					},
				],
			},
			{
				name: "Quận Thốt Nốt",
				wards: [
					{
						name: "Phường Thốt Nốt",
					},
					{
						name: "Phường Thới Thuận",
					},
					{
						name: "Phường Thuận An",
					},
					{
						name: "Phường Tân Lộc",
					},
					{
						name: "Phường Trung Nhứt",
					},
					{
						name: "Phường Thạnh Hoà",
					},
					{
						name: "Phường Trung Kiên",
					},
					{
						name: "Phường Tân Hưng",
					},
					{
						name: "Phường Thuận Hưng",
					},
				],
			},
			{
				name: "Huyện Vĩnh Thạnh",
				wards: [
					{
						name: "Xã Vĩnh Bình",
					},
					{
						name: "Thị trấn Thanh An",
					},
					{
						name: "Thị trấn Vĩnh Thạnh",
					},
					{
						name: "Xã Thạnh Mỹ",
					},
					{
						name: "Xã Vĩnh Trinh",
					},
					{
						name: "Xã Thạnh An",
					},
					{
						name: "Xã Thạnh Tiến",
					},
					{
						name: "Xã Thạnh Thắng",
					},
					{
						name: "Xã Thạnh Lợi",
					},
					{
						name: "Xã Thạnh Qưới",
					},
					{
						name: "Xã Thạnh Lộc",
					},
				],
			},
			{
				name: "Huyện Cờ Đỏ",
				wards: [
					{
						name: "Xã Trung An",
					},
					{
						name: "Xã Trung Thạnh",
					},
					{
						name: "Xã Thạnh Phú",
					},
					{
						name: "Xã Trung Hưng",
					},
					{
						name: "Thị trấn Cờ Đỏ",
					},
					{
						name: "Xã Thới Hưng",
					},
					{
						name: "Xã Đông Hiệp",
					},
					{
						name: "Xã Đông Thắng",
					},
					{
						name: "Xã Thới Đông",
					},
					{
						name: "Xã Thới Xuân",
					},
				],
			},
			{
				name: "Huyện Phong Điền",
				wards: [
					{
						name: "Thị trấn Phong Điền",
					},
					{
						name: "Xã Nhơn Ái",
					},
					{
						name: "Xã Giai Xuân",
					},
					{
						name: "Xã Tân Thới",
					},
					{
						name: "Xã Trường Long",
					},
					{
						name: "Xã Mỹ Khánh",
					},
					{
						name: "Xã Nhơn Nghĩa",
					},
				],
			},
			{
				name: "Huyện Thới Lai",
				wards: [
					{
						name: "Thị trấn Thới Lai",
					},
					{
						name: "Xã Thới Thạnh",
					},
					{
						name: "Xã Tân Thạnh",
					},
					{
						name: "Xã Xuân Thắng",
					},
					{
						name: "Xã Đông Bình",
					},
					{
						name: "Xã Đông Thuận",
					},
					{
						name: "Xã Thới Tân",
					},
					{
						name: "Xã Trường Thắng",
					},
					{
						name: "Xã Định Môn",
					},
					{
						name: "Xã Trường Thành",
					},
					{
						name: "Xã Trường Xuân",
					},
					{
						name: "Xã Trường Xuân A",
					},
					{
						name: "Xã Trường Xuân B",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Hậu Giang",
		districts: [
			{
				name: "Thành phố Vị Thanh",
				wards: [
					{
						name: "Phường I",
					},
					{
						name: "Phường III",
					},
					{
						name: "Phường IV",
					},
					{
						name: "Phường V",
					},
					{
						name: "Phường VII",
					},
					{
						name: "Xã Vị Tân",
					},
					{
						name: "Xã Hoả Lựu",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Hoả Tiến",
					},
				],
			},
			{
				name: "Thành phố Ngã Bảy",
				wards: [
					{
						name: "Phường Ngã Bảy",
					},
					{
						name: "Phường Lái Hiếu",
					},
					{
						name: "Phường Hiệp Thành",
					},
					{
						name: "Phường Hiệp Lợi",
					},
					{
						name: "Xã Đại Thành",
					},
					{
						name: "Xã Tân Thành",
					},
				],
			},
			{
				name: "Huyện Châu Thành A",
				wards: [
					{
						name: "Thị trấn Một Ngàn",
					},
					{
						name: "Xã Tân Hoà",
					},
					{
						name: "Thị trấn Bảy Ngàn",
					},
					{
						name: "Xã Trường Long Tây",
					},
					{
						name: "Xã Trường Long A",
					},
					{
						name: "Xã Nhơn Nghĩa A",
					},
					{
						name: "Thị trấn Rạch Gòi",
					},
					{
						name: "Xã Thạnh Xuân",
					},
					{
						name: "Thị trấn Cái Tắc",
					},
					{
						name: "Xã Tân Phú Thạnh",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị Trấn Ngã Sáu",
					},
					{
						name: "Xã Đông Thạnh",
					},
					{
						name: "Xã Đông Phú",
					},
					{
						name: "Xã Phú Hữu",
					},
					{
						name: "Xã Phú Tân",
					},
					{
						name: "Thị trấn Mái Dầm",
					},
					{
						name: "Xã Đông Phước",
					},
					{
						name: "Xã Đông Phước A",
					},
				],
			},
			{
				name: "Huyện Phụng Hiệp",
				wards: [
					{
						name: "Thị trấn Kinh Cùng",
					},
					{
						name: "Thị trấn Cây Dương",
					},
					{
						name: "Xã Tân Bình",
					},
					{
						name: "Xã Bình Thành",
					},
					{
						name: "Xã Thạnh Hòa",
					},
					{
						name: "Xã Long Thạnh",
					},
					{
						name: "Xã Phụng Hiệp",
					},
					{
						name: "Xã Hòa Mỹ",
					},
					{
						name: "Xã Hòa An",
					},
					{
						name: "Xã Phương Bình",
					},
					{
						name: "Xã Hiệp Hưng",
					},
					{
						name: "Xã Tân Phước Hưng",
					},
					{
						name: "Thị trấn Búng Tàu",
					},
					{
						name: "Xã Phương Phú",
					},
					{
						name: "Xã Tân Long",
					},
				],
			},
			{
				name: "Huyện Vị Thuỷ",
				wards: [
					{
						name: "Thị trấn Nàng Mau",
					},
					{
						name: "Xã Vị Trung",
					},
					{
						name: "Xã Vị Thuỷ",
					},
					{
						name: "Xã Vị Thắng",
					},
					{
						name: "Xã Vĩnh Thuận Tây",
					},
					{
						name: "Xã Vĩnh Trung",
					},
					{
						name: "Xã Vĩnh Tường",
					},
					{
						name: "Xã Vị Đông",
					},
					{
						name: "Xã Vị Thanh",
					},
					{
						name: "Xã Vị Bình",
					},
				],
			},
			{
				name: "Huyện Long Mỹ",
				wards: [
					{
						name: "Xã Thuận Hưng",
					},
					{
						name: "Xã Thuận Hòa",
					},
					{
						name: "Xã Vĩnh Thuận Đông",
					},
					{
						name: "Thị trấn Vĩnh Viễn",
					},
					{
						name: "Xã Vĩnh Viễn A",
					},
					{
						name: "Xã Lương Tâm",
					},
					{
						name: "Xã Lương Nghĩa",
					},
					{
						name: "Xã Xà Phiên",
					},
				],
			},
			{
				name: "Thị xã Long Mỹ",
				wards: [
					{
						name: "Phường Thuận An",
					},
					{
						name: "Phường Trà Lồng",
					},
					{
						name: "Phường Bình Thạnh",
					},
					{
						name: "Xã Long Bình",
					},
					{
						name: "Phường Vĩnh Tường",
					},
					{
						name: "Xã Long Trị",
					},
					{
						name: "Xã Long Trị A",
					},
					{
						name: "Xã Long Phú",
					},
					{
						name: "Xã Tân Phú",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Sóc Trăng",
		districts: [
			{
				name: "Thành phố Sóc Trăng",
				wards: [
					{
						name: "Phường 5",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 9",
					},
					{
						name: "Phường 10",
					},
				],
			},
			{
				name: "Huyện Châu Thành",
				wards: [
					{
						name: "Thị trấn Châu Thành",
					},
					{
						name: "Xã Hồ Đắc Kiện",
					},
					{
						name: "Xã Phú Tâm",
					},
					{
						name: "Xã Thuận Hòa",
					},
					{
						name: "Xã Phú Tân",
					},
					{
						name: "Xã Thiện Mỹ",
					},
					{
						name: "Xã An Hiệp",
					},
					{
						name: "Xã An Ninh",
					},
				],
			},
			{
				name: "Huyện Kế Sách",
				wards: [
					{
						name: "Thị trấn Kế Sách",
					},
					{
						name: "Thị trấn An Lạc Thôn",
					},
					{
						name: "Xã Xuân Hòa",
					},
					{
						name: "Xã Phong Nẫm",
					},
					{
						name: "Xã An Lạc Tây",
					},
					{
						name: "Xã Trinh Phú",
					},
					{
						name: "Xã Ba Trinh",
					},
					{
						name: "Xã Thới An Hội",
					},
					{
						name: "Xã Nhơn Mỹ",
					},
					{
						name: "Xã Kế Thành",
					},
					{
						name: "Xã Kế An",
					},
					{
						name: "Xã Đại Hải",
					},
					{
						name: "Xã An Mỹ",
					},
				],
			},
			{
				name: "Huyện Mỹ Tú",
				wards: [
					{
						name: "Thị trấn Huỳnh Hữu Nghĩa",
					},
					{
						name: "Xã Long Hưng",
					},
					{
						name: "Xã Hưng Phú",
					},
					{
						name: "Xã Mỹ Hương",
					},
					{
						name: "Xã Mỹ Tú",
					},
					{
						name: "Xã Mỹ Phước",
					},
					{
						name: "Xã Thuận Hưng",
					},
					{
						name: "Xã Mỹ Thuận",
					},
					{
						name: "Xã Phú Mỹ",
					},
				],
			},
			{
				name: "Huyện Cù Lao Dung",
				wards: [
					{
						name: "Thị trấn Cù Lao Dung",
					},
					{
						name: "Xã An Thạnh 1",
					},
					{
						name: "Xã An Thạnh Tây",
					},
					{
						name: "Xã An Thạnh Đông",
					},
					{
						name: "Xã Đại Ân 1",
					},
					{
						name: "Xã An Thạnh 2",
					},
					{
						name: "Xã An Thạnh 3",
					},
					{
						name: "Xã An Thạnh Nam",
					},
				],
			},
			{
				name: "Huyện Long Phú",
				wards: [
					{
						name: "Thị trấn Long Phú",
					},
					{
						name: "Xã Song Phụng",
					},
					{
						name: "Thị trấn Đại Ngãi",
					},
					{
						name: "Xã Hậu Thạnh",
					},
					{
						name: "Xã Long Đức",
					},
					{
						name: "Xã Trường Khánh",
					},
					{
						name: "Xã Phú Hữu",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Châu Khánh",
					},
					{
						name: "Xã Tân Thạnh",
					},
					{
						name: "Xã Long Phú",
					},
				],
			},
			{
				name: "Huyện Mỹ Xuyên",
				wards: [
					{
						name: "Thị trấn Mỹ Xuyên",
					},
					{
						name: "Xã Đại Tâm",
					},
					{
						name: "Xã Tham Đôn",
					},
					{
						name: "Xã Thạnh Phú",
					},
					{
						name: "Xã Ngọc Đông",
					},
					{
						name: "Xã Thạnh Quới",
					},
					{
						name: "Xã Hòa Tú 1",
					},
					{
						name: "Xã Gia Hòa 1",
					},
					{
						name: "Xã Ngọc Tố",
					},
					{
						name: "Xã Gia Hòa 2",
					},
					{
						name: "Xã Hòa Tú II",
					},
				],
			},
			{
				name: "Thị xã Ngã Năm",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Xã Vĩnh Quới",
					},
					{
						name: "Xã Tân Long",
					},
					{
						name: "Xã Long Bình",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Xã Mỹ Bình",
					},
					{
						name: "Xã Mỹ Quới",
					},
				],
			},
			{
				name: "Huyện Thạnh Trị",
				wards: [
					{
						name: "Thị trấn Phú Lộc",
					},
					{
						name: "Thị trấn Hưng Lợi",
					},
					{
						name: "Xã Lâm Tân",
					},
					{
						name: "Xã Thạnh Tân",
					},
					{
						name: "Xã Lâm Kiết",
					},
					{
						name: "Xã Tuân Tức",
					},
					{
						name: "Xã Vĩnh Thành",
					},
					{
						name: "Xã Thạnh Trị",
					},
					{
						name: "Xã Vĩnh Lợi",
					},
					{
						name: "Xã Châu Hưng",
					},
				],
			},
			{
				name: "Thị xã Vĩnh Châu",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Xã Hòa Đông",
					},
					{
						name: "Phường Khánh Hòa",
					},
					{
						name: "Xã Vĩnh Hiệp",
					},
					{
						name: "Xã Vĩnh Hải",
					},
					{
						name: "Xã Lạc Hòa",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường Vĩnh Phước",
					},
					{
						name: "Xã Vĩnh Tân",
					},
					{
						name: "Xã Lai Hòa",
					},
				],
			},
			{
				name: "Huyện Trần Đề",
				wards: [
					{
						name: "Xã Đại Ân 2",
					},
					{
						name: "Thị trấn Trần Đề",
					},
					{
						name: "Xã Liêu Tú",
					},
					{
						name: "Xã Lịch Hội Thượng",
					},
					{
						name: "Thị trấn Lịch Hội Thượng",
					},
					{
						name: "Xã Trung Bình",
					},
					{
						name: "Xã Tài Văn",
					},
					{
						name: "Xã Viên An",
					},
					{
						name: "Xã Thạnh Thới An",
					},
					{
						name: "Xã Thạnh Thới Thuận",
					},
					{
						name: "Xã Viên Bình",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Bạc Liêu",
		districts: [
			{
				name: "Thành phố Bạc Liêu",
				wards: [
					{
						name: "Phường 2",
					},
					{
						name: "Phường 3",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường Nhà Mát",
					},
					{
						name: "Xã Vĩnh Trạch",
					},
					{
						name: "Xã Vĩnh Trạch Đông",
					},
					{
						name: "Xã Hiệp Thành",
					},
				],
			},
			{
				name: "Huyện Hồng Dân",
				wards: [
					{
						name: "Thị trấn Ngan Dừa",
					},
					{
						name: "Xã Ninh Quới",
					},
					{
						name: "Xã Ninh Quới A",
					},
					{
						name: "Xã Ninh Hòa",
					},
					{
						name: "Xã Lộc Ninh",
					},
					{
						name: "Xã Vĩnh Lộc",
					},
					{
						name: "Xã Vĩnh Lộc A",
					},
					{
						name: "Xã Ninh Thạnh Lợi A",
					},
					{
						name: "Xã Ninh Thạnh Lợi",
					},
				],
			},
			{
				name: "Huyện Phước Long",
				wards: [
					{
						name: "Thị trấn Phước Long",
					},
					{
						name: "Xã Vĩnh Phú Đông",
					},
					{
						name: "Xã Vĩnh Phú Tây",
					},
					{
						name: "Xã Phước Long",
					},
					{
						name: "Xã Hưng Phú",
					},
					{
						name: "Xã Vĩnh Thanh",
					},
					{
						name: "Xã Phong Thạnh Tây A",
					},
					{
						name: "Xã Phong Thạnh Tây B",
					},
				],
			},
			{
				name: "Huyện Vĩnh Lợi",
				wards: [
					{
						name: "Xã Vĩnh Hưng",
					},
					{
						name: "Xã Vĩnh Hưng A",
					},
					{
						name: "Thị trấn Châu Hưng",
					},
					{
						name: "Xã Châu Hưng A",
					},
					{
						name: "Xã Hưng Thành",
					},
					{
						name: "Xã Hưng Hội",
					},
					{
						name: "Xã Châu Thới",
					},
					{
						name: "Xã Long Thạnh",
					},
				],
			},
			{
				name: "Thị xã Giá Rai",
				wards: [
					{
						name: "Phường 1",
					},
					{
						name: "Phường Hộ Phòng",
					},
					{
						name: "Xã Phong Thạnh Đông",
					},
					{
						name: "Phường Láng Tròn",
					},
					{
						name: "Xã Phong Tân",
					},
					{
						name: "Xã Tân Phong",
					},
					{
						name: "Xã Phong Thạnh",
					},
					{
						name: "Xã Phong Thạnh A",
					},
					{
						name: "Xã Phong Thạnh Tây",
					},
					{
						name: "Xã Tân Thạnh",
					},
				],
			},
			{
				name: "Huyện Đông Hải",
				wards: [
					{
						name: "Thị trấn Gành Hào",
					},
					{
						name: "Xã Long Điền Đông",
					},
					{
						name: "Xã Long Điền Đông A",
					},
					{
						name: "Xã Long Điền",
					},
					{
						name: "Xã Long Điền Tây",
					},
					{
						name: "Xã Điền Hải",
					},
					{
						name: "Xã An Trạch",
					},
					{
						name: "Xã An Trạch A",
					},
					{
						name: "Xã An Phúc",
					},
					{
						name: "Xã Định Thành",
					},
					{
						name: "Xã Định Thành A",
					},
				],
			},
			{
				name: "Huyện Hoà Bình",
				wards: [
					{
						name: "Thị trấn Hòa Bình",
					},
					{
						name: "Xã Minh Diệu",
					},
					{
						name: "Xã Vĩnh Bình",
					},
					{
						name: "Xã Vĩnh Mỹ B",
					},
					{
						name: "Xã Vĩnh Hậu",
					},
					{
						name: "Xã Vĩnh Hậu A",
					},
					{
						name: "Xã Vĩnh Mỹ A",
					},
					{
						name: "Xã Vĩnh Thịnh",
					},
				],
			},
		],
	},
	{
		name: "Tỉnh Cà Mau",
		districts: [
			{
				name: "Thành phố Cà Mau",
				wards: [
					{
						name: "Phường 9",
					},
					{
						name: "Phường 4",
					},
					{
						name: "Phường 1",
					},
					{
						name: "Phường 5",
					},
					{
						name: "Phường 2",
					},
					{
						name: "Phường 8",
					},
					{
						name: "Phường 6",
					},
					{
						name: "Phường 7",
					},
					{
						name: "Phường Tân Xuyên",
					},
					{
						name: "Xã An Xuyên",
					},
					{
						name: "Phường Tân Thành",
					},
					{
						name: "Xã Tân Thành",
					},
					{
						name: "Xã Tắc Vân",
					},
					{
						name: "Xã Lý Văn Lâm",
					},
					{
						name: "Xã Định Bình",
					},
					{
						name: "Xã Hòa Thành",
					},
					{
						name: "Xã Hòa Tân",
					},
				],
			},
			{
				name: "Huyện U Minh",
				wards: [
					{
						name: "Thị trấn U Minh",
					},
					{
						name: "Xã Khánh Hòa",
					},
					{
						name: "Xã Khánh Thuận",
					},
					{
						name: "Xã Khánh Tiến",
					},
					{
						name: "Xã Nguyễn Phích",
					},
					{
						name: "Xã Khánh Lâm",
					},
					{
						name: "Xã Khánh An",
					},
					{
						name: "Xã Khánh Hội",
					},
				],
			},
			{
				name: "Huyện Thới Bình",
				wards: [
					{
						name: "Thị trấn Thới Bình",
					},
					{
						name: "Xã Biển Bạch",
					},
					{
						name: "Xã Tân Bằng",
					},
					{
						name: "Xã Trí Phải",
					},
					{
						name: "Xã Trí Lực",
					},
					{
						name: "Xã Biển Bạch Đông",
					},
					{
						name: "Xã Thới Bình",
					},
					{
						name: "Xã Tân Phú",
					},
					{
						name: "Xã Tân Lộc Bắc",
					},
					{
						name: "Xã Tân Lộc",
					},
					{
						name: "Xã Tân Lộc Đông",
					},
					{
						name: "Xã Hồ Thị Kỷ",
					},
				],
			},
			{
				name: "Huyện Trần Văn Thời",
				wards: [
					{
						name: "Thị trấn Trần Văn Thời",
					},
					{
						name: "Thị trấn Sông Đốc",
					},
					{
						name: "Xã Khánh Bình Tây Bắc",
					},
					{
						name: "Xã Khánh Bình Tây",
					},
					{
						name: "Xã Trần Hợi",
					},
					{
						name: "Xã Khánh Lộc",
					},
					{
						name: "Xã Khánh Bình",
					},
					{
						name: "Xã Khánh Hưng",
					},
					{
						name: "Xã Khánh Bình Đông",
					},
					{
						name: "Xã Khánh Hải",
					},
					{
						name: "Xã Lợi An",
					},
					{
						name: "Xã Phong Điền",
					},
					{
						name: "Xã Phong Lạc",
					},
				],
			},
			{
				name: "Huyện Cái Nước",
				wards: [
					{
						name: "Thị trấn Cái Nước",
					},
					{
						name: "Xã Thạnh Phú",
					},
					{
						name: "Xã Lương Thế Trân",
					},
					{
						name: "Xã Phú Hưng",
					},
					{
						name: "Xã Tân Hưng",
					},
					{
						name: "Xã Hưng Mỹ",
					},
					{
						name: "Xã Hoà Mỹ",
					},
					{
						name: "Xã Đông Hưng",
					},
					{
						name: "Xã Đông Thới",
					},
					{
						name: "Xã Tân Hưng Đông",
					},
					{
						name: "Xã Trần Thới",
					},
				],
			},
			{
				name: "Huyện Đầm Dơi",
				wards: [
					{
						name: "Thị trấn Đầm Dơi",
					},
					{
						name: "Xã Tạ An Khương",
					},
					{
						name: "Xã Tạ An Khương Đông",
					},
					{
						name: "Xã Trần Phán",
					},
					{
						name: "Xã Tân Trung",
					},
					{
						name: "Xã Tân Đức",
					},
					{
						name: "Xã Tân Thuận",
					},
					{
						name: "Xã Tạ An Khương Nam",
					},
					{
						name: "Xã Tân Duyệt",
					},
					{
						name: "Xã Tân Dân",
					},
					{
						name: "Xã Tân Tiến",
					},
					{
						name: "Xã Quách Phẩm Bắc",
					},
					{
						name: "Xã Quách Phẩm",
					},
					{
						name: "Xã Thanh Tùng",
					},
					{
						name: "Xã Ngọc Chánh",
					},
					{
						name: "Xã Nguyễn Huân",
					},
				],
			},
			{
				name: "Huyện Năm Căn",
				wards: [
					{
						name: "Thị Trấn Năm Căn",
					},
					{
						name: "Xã Hàm Rồng",
					},
					{
						name: "Xã Hiệp Tùng",
					},
					{
						name: "Xã Đất Mới",
					},
					{
						name: "Xã Lâm Hải",
					},
					{
						name: "Xã Hàng Vịnh",
					},
					{
						name: "Xã Tam Giang",
					},
					{
						name: "Xã Tam Giang Đông",
					},
				],
			},
			{
				name: "Huyện Phú Tân",
				wards: [
					{
						name: "Thị trấn Cái Đôi Vàm",
					},
					{
						name: "Xã Phú Thuận",
					},
					{
						name: "Xã Phú Mỹ",
					},
					{
						name: "Xã Phú Tân",
					},
					{
						name: "Xã Tân Hải",
					},
					{
						name: "Xã Việt Thắng",
					},
					{
						name: "Xã Tân Hưng Tây",
					},
					{
						name: "Xã Rạch Chèo",
					},
					{
						name: "Xã Nguyễn Việt Khái",
					},
				],
			},
			{
				name: "Huyện Ngọc Hiển",
				wards: [
					{
						name: "Xã Tam Giang Tây",
					},
					{
						name: "Xã Tân Ân Tây",
					},
					{
						name: "Xã Viên An Đông",
					},
					{
						name: "Xã Viên An",
					},
					{
						name: "Thị trấn Rạch Gốc",
					},
					{
						name: "Xã Tân Ân",
					},
					{
						name: "Xã Đất Mũi",
					},
				],
			},
		],
	},
];
